//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { DateTime, Duration } from "luxon";

export const P2_API_BASE_URL = new InjectionToken<string>('P2_API_BASE_URL');

@Injectable()
export class AccessManagementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional)
     * @return Success
     */
    requestOverview(projectId: number | undefined): Observable<AccessManagementOverviewDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/AccessManagement/RequestOverview?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccessManagementOverviewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccessManagementOverviewDto[]>;
        }));
    }

    protected processRequestOverview(response: HttpResponseBase): Observable<AccessManagementOverviewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccessManagementOverviewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional)
     * @return Success
     */
    getAllAvailableCountries(projectId: number | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/AccessManagement/GetAllAvailableCountries?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAvailableCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAvailableCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllAvailableCountries(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    requestUserOrOrganizatioUnitPermissions(body: GetUserOrOrganizationalUnitPermissionsInput | undefined): Observable<GetUserOrOrganizationalUnitPermissionsDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/AccessManagement/RequestUserOrOrganizatioUnitPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestUserOrOrganizatioUnitPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestUserOrOrganizatioUnitPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserOrOrganizationalUnitPermissionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserOrOrganizationalUnitPermissionsDto>;
        }));
    }

    protected processRequestUserOrOrganizatioUnitPermissions(response: HttpResponseBase): Observable<GetUserOrOrganizationalUnitPermissionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserOrOrganizationalUnitPermissionsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    requestUserOrOrganizatioUnitBulkPermissions(body: GetUserOrOrganizationalUnitBulkPermissionsInput | undefined): Observable<GetUserOrOrganizationalUnitPermissionsDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/AccessManagement/RequestUserOrOrganizatioUnitBulkPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestUserOrOrganizatioUnitBulkPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestUserOrOrganizatioUnitBulkPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserOrOrganizationalUnitPermissionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserOrOrganizationalUnitPermissionsDto>;
        }));
    }

    protected processRequestUserOrOrganizatioUnitBulkPermissions(response: HttpResponseBase): Observable<GetUserOrOrganizationalUnitPermissionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserOrOrganizationalUnitPermissionsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateAccessManagementInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/AccessManagement/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    bulkUpdate(body: BulkUpdateAccessManagementInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/AccessManagement/BulkUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BlendingCirclesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    requestOverview(body: BlendingCircleRequestOverviewInput | undefined): Observable<BlendingCircleOverviewDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/BlendingCircles/RequestOverview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BlendingCircleOverviewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BlendingCircleOverviewDto[]>;
        }));
    }

    protected processRequestOverview(response: HttpResponseBase): Observable<BlendingCircleOverviewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BlendingCircleOverviewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    bulkSetSuggestedBlendingCircleSubgroups(body: BulkSetSuggestedBlendingCircleSubgroupsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/BlendingCircles/BulkSetSuggestedBlendingCircleSubgroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkSetSuggestedBlendingCircleSubgroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkSetSuggestedBlendingCircleSubgroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkSetSuggestedBlendingCircleSubgroups(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    bulkSetEntityControllingInterests(body: BulkSetEntityControllingInterestsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/BlendingCircles/BulkSetEntityControllingInterests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkSetEntityControllingInterests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkSetEntityControllingInterests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkSetEntityControllingInterests(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    toggleFullScopeCalculation(body: ToggleFullScopeCalculationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/BlendingCircles/ToggleFullScopeCalculation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleFullScopeCalculation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleFullScopeCalculation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processToggleFullScopeCalculation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DataPointChangesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param dataPointId (optional)
     * @return Success
     */
    getValueDataPointChanges(dataPointId: number | undefined): Observable<EntityChangeDataDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/DataPointChanges/GetValueDataPointChanges?";
        if (dataPointId === null)
            throw new Error("The parameter 'dataPointId' cannot be null.");
        else if (dataPointId !== undefined)
            url_ += "dataPointId=" + encodeURIComponent("" + dataPointId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValueDataPointChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValueDataPointChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityChangeDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityChangeDataDto[]>;
        }));
    }

    protected processGetValueDataPointChanges(response: HttpResponseBase): Observable<EntityChangeDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityChangeDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dataPointId (optional)
     * @return Success
     */
    getShiftDataPointChanges(dataPointId: number | undefined): Observable<EntityChangeDataDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/DataPointChanges/GetShiftDataPointChanges?";
        if (dataPointId === null)
            throw new Error("The parameter 'dataPointId' cannot be null.");
        else if (dataPointId !== undefined)
            url_ += "dataPointId=" + encodeURIComponent("" + dataPointId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShiftDataPointChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShiftDataPointChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityChangeDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityChangeDataDto[]>;
        }));
    }

    protected processGetShiftDataPointChanges(response: HttpResponseBase): Observable<EntityChangeDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityChangeDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectCurrencyRateId (optional)
     * @return Success
     */
    getProjectCurrencyRateChanges(projectCurrencyRateId: number | undefined): Observable<EntityChangeDataDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/DataPointChanges/GetProjectCurrencyRateChanges?";
        if (projectCurrencyRateId === null)
            throw new Error("The parameter 'projectCurrencyRateId' cannot be null.");
        else if (projectCurrencyRateId !== undefined)
            url_ += "projectCurrencyRateId=" + encodeURIComponent("" + projectCurrencyRateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectCurrencyRateChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectCurrencyRateChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityChangeDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityChangeDataDto[]>;
        }));
    }

    protected processGetProjectCurrencyRateChanges(response: HttpResponseBase): Observable<EntityChangeDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityChangeDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ExportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    exportReportData(body: ProjectDataExcelExportInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Export/ExportReportData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportReportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportReportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportReportData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FileGeneratorServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param key (optional)
     * @param body (optional)
     * @return Success
     */
    generatePdf(key: string | undefined, body: SafeHarbourHistoryDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/pillar2/FileGeneratorService/GeneratePdf?";
        if (key === null)
            throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneratePdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneratePdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGeneratePdf(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FileUploadServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param file (optional)
     * @return Success
     */
    uploadFile(file: FileParameter | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/pillar2/FileUpload/UploadFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FinancialDataServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional)
     * @param safeHarbourGroupId (optional)
     * @param organizationalEntityId (optional)
     * @param traceId (optional)
     * @return Success
     */
    getFinancialValuePoint(projectId: number | undefined, safeHarbourGroupId: number | undefined, organizationalEntityId: number | undefined, traceId: number | undefined): Observable<FinancialValuePointDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/FinancialData/GetFinancialValuePoint?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (safeHarbourGroupId === null)
            throw new Error("The parameter 'safeHarbourGroupId' cannot be null.");
        else if (safeHarbourGroupId !== undefined)
            url_ += "SafeHarbourGroupId=" + encodeURIComponent("" + safeHarbourGroupId) + "&";
        if (organizationalEntityId === null)
            throw new Error("The parameter 'organizationalEntityId' cannot be null.");
        else if (organizationalEntityId !== undefined)
            url_ += "OrganizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        if (traceId === null)
            throw new Error("The parameter 'traceId' cannot be null.");
        else if (traceId !== undefined)
            url_ += "TraceId=" + encodeURIComponent("" + traceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinancialValuePoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialValuePoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialValuePointDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialValuePointDto>;
        }));
    }

    protected processGetFinancialValuePoint(response: HttpResponseBase): Observable<FinancialValuePointDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialValuePointDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional)
     * @param safeHarbourGroupId (optional)
     * @param organizationalEntityId (optional)
     * @param traceId (optional)
     * @param value (optional)
     * @return Success
     */
    getFinancialDataCurrencyConvertedFinal(projectId: number | undefined, safeHarbourGroupId: number | undefined, organizationalEntityId: number | undefined, traceId: number | undefined, value: string | undefined): Observable<FinancialDataCurrencyConvertedFinalDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/FinancialData/GetFinancialDataCurrencyConvertedFinal?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (safeHarbourGroupId === null)
            throw new Error("The parameter 'safeHarbourGroupId' cannot be null.");
        else if (safeHarbourGroupId !== undefined)
            url_ += "SafeHarbourGroupId=" + encodeURIComponent("" + safeHarbourGroupId) + "&";
        if (organizationalEntityId === null)
            throw new Error("The parameter 'organizationalEntityId' cannot be null.");
        else if (organizationalEntityId !== undefined)
            url_ += "OrganizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        if (traceId === null)
            throw new Error("The parameter 'traceId' cannot be null.");
        else if (traceId !== undefined)
            url_ += "TraceId=" + encodeURIComponent("" + traceId) + "&";
        if (value === null)
            throw new Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "Value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinancialDataCurrencyConvertedFinal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialDataCurrencyConvertedFinal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialDataCurrencyConvertedFinalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialDataCurrencyConvertedFinalDto>;
        }));
    }

    protected processGetFinancialDataCurrencyConvertedFinal(response: HttpResponseBase): Observable<FinancialDataCurrencyConvertedFinalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialDataCurrencyConvertedFinalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional)
     * @return Success
     */
    getProjectUserConfiguration(projectId: number | undefined): Observable<ProjectUserSettingsDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/FinancialData/GetProjectUserConfiguration?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectUserConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectUserConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectUserSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectUserSettingsDto>;
        }));
    }

    protected processGetProjectUserConfiguration(response: HttpResponseBase): Observable<ProjectUserSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectUserSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    saveProjectUserConfiguration(body: UpdateProjectUserConfigurationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/FinancialData/SaveProjectUserConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveProjectUserConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveProjectUserConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveProjectUserConfiguration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pointId (optional)
     * @return Success
     */
    getFinancialPointChanges(pointId: number | undefined): Observable<GetFinancialValuePointChangeDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/FinancialData/GetFinancialPointChanges?";
        if (pointId === null)
            throw new Error("The parameter 'pointId' cannot be null.");
        else if (pointId !== undefined)
            url_ += "pointId=" + encodeURIComponent("" + pointId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinancialPointChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialPointChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFinancialValuePointChangeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFinancialValuePointChangeDto[]>;
        }));
    }

    protected processGetFinancialPointChanges(response: HttpResponseBase): Observable<GetFinancialValuePointChangeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetFinancialValuePointChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createFinancialValuePointOrganizationalEntity(body: CreateFinancialValuePointOrganizationalEntityInput | undefined): Observable<FinancialValuePointDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/FinancialData/CreateFinancialValuePointOrganizationalEntity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFinancialValuePointOrganizationalEntity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFinancialValuePointOrganizationalEntity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialValuePointDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialValuePointDto>;
        }));
    }

    protected processCreateFinancialValuePointOrganizationalEntity(response: HttpResponseBase): Observable<FinancialValuePointDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialValuePointDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createFinancialValuePointSafeHarbourGroup(body: CreateFinancialValuePointSafeHarbourGroupInput | undefined): Observable<FinancialValuePointDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/FinancialData/CreateFinancialValuePointSafeHarbourGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFinancialValuePointSafeHarbourGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFinancialValuePointSafeHarbourGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialValuePointDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialValuePointDto>;
        }));
    }

    protected processCreateFinancialValuePointSafeHarbourGroup(response: HttpResponseBase): Observable<FinancialValuePointDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialValuePointDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateFinancialValuePoint(body: UpdateFinancialValuePointInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/FinancialData/UpdateFinancialValuePoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFinancialValuePoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFinancialValuePoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateFinancialValuePoint(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateFinancialValuePointStatus(body: UpdateFinancialValuePointStatusInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/FinancialData/UpdateFinancialValuePointStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFinancialValuePointStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFinancialValuePointStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateFinancialValuePointStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    bulkUpdateFinancialValuePoint(body: BulkUpdateFinancialValuePointInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/FinancialData/BulkUpdateFinancialValuePoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkUpdateFinancialValuePoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkUpdateFinancialValuePoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkUpdateFinancialValuePoint(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FinancialDataExportHistoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional)
     * @return Success
     */
    generatePdf(projectId: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/FinancialDataExportHistory/GeneratePdf?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneratePdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneratePdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processGeneratePdf(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FullScopeCalculationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    requestOverview(body: FinancialGroupDataOverviewInput | undefined): Observable<PagedResultDtoOfFullScopeCalculationsOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculations/RequestOverview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfFullScopeCalculationsOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfFullScopeCalculationsOverviewDto>;
        }));
    }

    protected processRequestOverview(response: HttpResponseBase): Observable<PagedResultDtoOfFullScopeCalculationsOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfFullScopeCalculationsOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getFullScopeCalculationsBlendingCircleSubgroupDetails(body: FinancialGroupDataOverviewByBlendingCircleSubgroupInput | undefined): Observable<FinancialGroupDataJurisdictionsOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculations/GetFullScopeCalculationsBlendingCircleSubgroupDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFullScopeCalculationsBlendingCircleSubgroupDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFullScopeCalculationsBlendingCircleSubgroupDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialGroupDataJurisdictionsOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialGroupDataJurisdictionsOverviewDto>;
        }));
    }

    protected processGetFullScopeCalculationsBlendingCircleSubgroupDetails(response: HttpResponseBase): Observable<FinancialGroupDataJurisdictionsOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialGroupDataJurisdictionsOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getFullScopeCalculationsOrganizationalEntities(body: FinancialGroupDataOverviewByBlendingCircleSubgroupInput | undefined): Observable<ListResultDtoOfFinancialGroupDataOrganizationalEntityOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculations/GetFullScopeCalculationsOrganizationalEntities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFullScopeCalculationsOrganizationalEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFullScopeCalculationsOrganizationalEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfFinancialGroupDataOrganizationalEntityOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfFinancialGroupDataOrganizationalEntityOverviewDto>;
        }));
    }

    protected processGetFullScopeCalculationsOrganizationalEntities(response: HttpResponseBase): Observable<ListResultDtoOfFinancialGroupDataOrganizationalEntityOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfFinancialGroupDataOrganizationalEntityOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taxJurisdictionCountry (optional)
     * @param projectId (optional)
     * @return Success
     */
    getFinancialGroupDataOverviewByJurisdiction(taxJurisdictionCountry: string | undefined, projectId: number | undefined): Observable<ListResultDtoOfFinancialGroupDataOrganizationalEntityOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculations/GetFinancialGroupDataOverviewByJurisdiction?";
        if (taxJurisdictionCountry === null)
            throw new Error("The parameter 'taxJurisdictionCountry' cannot be null.");
        else if (taxJurisdictionCountry !== undefined)
            url_ += "TaxJurisdictionCountry=" + encodeURIComponent("" + taxJurisdictionCountry) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinancialGroupDataOverviewByJurisdiction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialGroupDataOverviewByJurisdiction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfFinancialGroupDataOrganizationalEntityOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfFinancialGroupDataOrganizationalEntityOverviewDto>;
        }));
    }

    protected processGetFinancialGroupDataOverviewByJurisdiction(response: HttpResponseBase): Observable<ListResultDtoOfFinancialGroupDataOrganizationalEntityOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfFinancialGroupDataOrganizationalEntityOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional)
     * @param blendingCircleCountry (optional)
     * @param blendingCircleSubgroupId (optional)
     * @param organizationalEntityId (optional)
     * @param financialGroupType (optional)
     * @return Success
     */
    getFinancialGroupData(projectId: number | undefined, blendingCircleCountry: string | undefined, blendingCircleSubgroupId: number | undefined, organizationalEntityId: number | undefined, financialGroupType: FinancialGroupType | undefined): Observable<FinancialGroupDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculations/GetFinancialGroupData?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (blendingCircleCountry === null)
            throw new Error("The parameter 'blendingCircleCountry' cannot be null.");
        else if (blendingCircleCountry !== undefined)
            url_ += "BlendingCircleCountry=" + encodeURIComponent("" + blendingCircleCountry) + "&";
        if (blendingCircleSubgroupId === null)
            throw new Error("The parameter 'blendingCircleSubgroupId' cannot be null.");
        else if (blendingCircleSubgroupId !== undefined)
            url_ += "BlendingCircleSubgroupId=" + encodeURIComponent("" + blendingCircleSubgroupId) + "&";
        if (organizationalEntityId === null)
            throw new Error("The parameter 'organizationalEntityId' cannot be null.");
        else if (organizationalEntityId !== undefined)
            url_ += "OrganizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        if (financialGroupType === null)
            throw new Error("The parameter 'financialGroupType' cannot be null.");
        else if (financialGroupType !== undefined)
            url_ += "FinancialGroupType=" + encodeURIComponent("" + financialGroupType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinancialGroupData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialGroupData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialGroupDto>;
        }));
    }

    protected processGetFinancialGroupData(response: HttpResponseBase): Observable<FinancialGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional)
     * @param organizationalEntityId (optional)
     * @param blendingCircleCountry (optional)
     * @param blendingCircleSubgroupId (optional)
     * @return Success
     */
    getTutForOrganizationalEntity(projectId: number | undefined, organizationalEntityId: number | undefined, blendingCircleCountry: string | undefined, blendingCircleSubgroupId: number | undefined): Observable<TutForOrganizationalEntityDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculations/GetTutForOrganizationalEntity?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (organizationalEntityId === null)
            throw new Error("The parameter 'organizationalEntityId' cannot be null.");
        else if (organizationalEntityId !== undefined)
            url_ += "OrganizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        if (blendingCircleCountry === null)
            throw new Error("The parameter 'blendingCircleCountry' cannot be null.");
        else if (blendingCircleCountry !== undefined)
            url_ += "BlendingCircleCountry=" + encodeURIComponent("" + blendingCircleCountry) + "&";
        if (blendingCircleSubgroupId === null)
            throw new Error("The parameter 'blendingCircleSubgroupId' cannot be null.");
        else if (blendingCircleSubgroupId !== undefined)
            url_ += "BlendingCircleSubgroupId=" + encodeURIComponent("" + blendingCircleSubgroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTutForOrganizationalEntity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTutForOrganizationalEntity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TutForOrganizationalEntityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TutForOrganizationalEntityDto>;
        }));
    }

    protected processGetTutForOrganizationalEntity(response: HttpResponseBase): Observable<TutForOrganizationalEntityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TutForOrganizationalEntityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional)
     * @param blendingCircleCountry (optional)
     * @param blendingCircleSubgroupId (optional)
     * @return Success
     */
    getTutForBlendingCircleSubgroup(projectId: number | undefined, blendingCircleCountry: string | undefined, blendingCircleSubgroupId: number | undefined): Observable<TutForBlendingCircleSubgroupDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculations/GetTutForBlendingCircleSubgroup?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (blendingCircleCountry === null)
            throw new Error("The parameter 'blendingCircleCountry' cannot be null.");
        else if (blendingCircleCountry !== undefined)
            url_ += "BlendingCircleCountry=" + encodeURIComponent("" + blendingCircleCountry) + "&";
        if (blendingCircleSubgroupId === null)
            throw new Error("The parameter 'blendingCircleSubgroupId' cannot be null.");
        else if (blendingCircleSubgroupId !== undefined)
            url_ += "BlendingCircleSubgroupId=" + encodeURIComponent("" + blendingCircleSubgroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTutForBlendingCircleSubgroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTutForBlendingCircleSubgroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TutForBlendingCircleSubgroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TutForBlendingCircleSubgroupDto>;
        }));
    }

    protected processGetTutForBlendingCircleSubgroup(response: HttpResponseBase): Observable<TutForBlendingCircleSubgroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TutForBlendingCircleSubgroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateFinancialGroupConfirmation(body: UpdateFinancialGroupConfirmationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculations/UpdateFinancialGroupConfirmation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFinancialGroupConfirmation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFinancialGroupConfirmation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateFinancialGroupConfirmation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional)
     * @return Success
     */
    getBlendingCircles(projectId: number | undefined): Observable<BlendingCircleReferenceDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculations/GetBlendingCircles?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBlendingCircles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBlendingCircles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BlendingCircleReferenceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BlendingCircleReferenceDto[]>;
        }));
    }

    protected processGetBlendingCircles(response: HttpResponseBase): Observable<BlendingCircleReferenceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BlendingCircleReferenceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional)
     * @param taxJurisdictionCountry (optional)
     * @return Success
     */
    getBlendingCircleSubgroups(projectId: number | undefined, taxJurisdictionCountry: string | undefined): Observable<BlendingCircleReferenceSubgroupDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculations/GetBlendingCircleSubgroups?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (taxJurisdictionCountry === null)
            throw new Error("The parameter 'taxJurisdictionCountry' cannot be null.");
        else if (taxJurisdictionCountry !== undefined)
            url_ += "taxJurisdictionCountry=" + encodeURIComponent("" + taxJurisdictionCountry) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBlendingCircleSubgroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBlendingCircleSubgroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BlendingCircleReferenceSubgroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BlendingCircleReferenceSubgroupDto[]>;
        }));
    }

    protected processGetBlendingCircleSubgroups(response: HttpResponseBase): Observable<BlendingCircleReferenceSubgroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BlendingCircleReferenceSubgroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FullScopeCalculationsReferenceDataServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional)
     * @param blendingCircleSubgroupId (optional)
     * @return Success
     */
    getEntitiesByBlendingCircleSubgroupId(projectId: number | undefined, blendingCircleSubgroupId: number | undefined): Observable<OrganizationalEntityReferenceDataDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculationsReferenceData/GetEntitiesByBlendingCircleSubgroupId?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (blendingCircleSubgroupId === null)
            throw new Error("The parameter 'blendingCircleSubgroupId' cannot be null.");
        else if (blendingCircleSubgroupId !== undefined)
            url_ += "blendingCircleSubgroupId=" + encodeURIComponent("" + blendingCircleSubgroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntitiesByBlendingCircleSubgroupId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntitiesByBlendingCircleSubgroupId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationalEntityReferenceDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationalEntityReferenceDataDto[]>;
        }));
    }

    protected processGetEntitiesByBlendingCircleSubgroupId(response: HttpResponseBase): Observable<OrganizationalEntityReferenceDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationalEntityReferenceDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getBlendingCircleSubgroups(body: RequestBlendingCircleSubgroups | undefined): Observable<BlendingCircleSubgroupDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculationsReferenceData/GetBlendingCircleSubgroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBlendingCircleSubgroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBlendingCircleSubgroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BlendingCircleSubgroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BlendingCircleSubgroupDto[]>;
        }));
    }

    protected processGetBlendingCircleSubgroups(response: HttpResponseBase): Observable<BlendingCircleSubgroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BlendingCircleSubgroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional)
     * @return Success
     */
    getEntitiesByProjectId(projectId: number | undefined): Observable<OrganizationalEntityReferenceDataDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculationsReferenceData/GetEntitiesByProjectId?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntitiesByProjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntitiesByProjectId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationalEntityReferenceDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationalEntityReferenceDataDto[]>;
        }));
    }

    protected processGetEntitiesByProjectId(response: HttpResponseBase): Observable<OrganizationalEntityReferenceDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationalEntityReferenceDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getFinancialGroups(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeCalculationsReferenceData/GetFinancialGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinancialGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetFinancialGroups(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FullScopeElectionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional)
     * @param blendingCircleCountry (optional)
     * @param blendingCircleSubgroupId (optional)
     * @param organizationalEntityId (optional)
     * @return Success
     */
    getAll(projectId: number | undefined, blendingCircleCountry: string | undefined, blendingCircleSubgroupId: number | undefined, organizationalEntityId: number | undefined): Observable<ElectionNodeDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeElections/GetAll?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (blendingCircleCountry === null)
            throw new Error("The parameter 'blendingCircleCountry' cannot be null.");
        else if (blendingCircleCountry !== undefined)
            url_ += "BlendingCircleCountry=" + encodeURIComponent("" + blendingCircleCountry) + "&";
        if (blendingCircleSubgroupId === null)
            throw new Error("The parameter 'blendingCircleSubgroupId' cannot be null.");
        else if (blendingCircleSubgroupId !== undefined)
            url_ += "BlendingCircleSubgroupId=" + encodeURIComponent("" + blendingCircleSubgroupId) + "&";
        if (organizationalEntityId === null)
            throw new Error("The parameter 'organizationalEntityId' cannot be null.");
        else if (organizationalEntityId !== undefined)
            url_ += "OrganizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElectionNodeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElectionNodeDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ElectionNodeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ElectionNodeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    addOrUpdateBlendingCircleElection(body: BlendingCircleElectionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeElections/AddOrUpdateBlendingCircleElection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateBlendingCircleElection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateBlendingCircleElection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddOrUpdateBlendingCircleElection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    addOrUpdateOrganizationalEntityElection(body: OrganizationalEntityElectionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeElections/AddOrUpdateOrganizationalEntityElection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateOrganizationalEntityElection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateOrganizationalEntityElection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddOrUpdateOrganizationalEntityElection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FullScopeQuestionnaireServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional)
     * @param organizationalEntityId (optional)
     * @return Success
     */
    getPurchasePriceAccountingApplicable(projectId: number | undefined, organizationalEntityId: number | undefined): Observable<PurchasePriceAccountingApplicable> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeQuestionnaire/GetPurchasePriceAccountingApplicable?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (organizationalEntityId === null)
            throw new Error("The parameter 'organizationalEntityId' cannot be null.");
        else if (organizationalEntityId !== undefined)
            url_ += "OrganizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPurchasePriceAccountingApplicable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchasePriceAccountingApplicable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchasePriceAccountingApplicable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchasePriceAccountingApplicable>;
        }));
    }

    protected processGetPurchasePriceAccountingApplicable(response: HttpResponseBase): Observable<PurchasePriceAccountingApplicable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PurchasePriceAccountingApplicable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional)
     * @param organizationalEntityId (optional)
     * @return Success
     */
    getArmsLengthAdjustmentApplicable(projectId: number | undefined, organizationalEntityId: number | undefined): Observable<ArmsLengthAdjustmentApplicable> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeQuestionnaire/GetArmsLengthAdjustmentApplicable?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (organizationalEntityId === null)
            throw new Error("The parameter 'organizationalEntityId' cannot be null.");
        else if (organizationalEntityId !== undefined)
            url_ += "OrganizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArmsLengthAdjustmentApplicable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArmsLengthAdjustmentApplicable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArmsLengthAdjustmentApplicable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArmsLengthAdjustmentApplicable>;
        }));
    }

    protected processGetArmsLengthAdjustmentApplicable(response: HttpResponseBase): Observable<ArmsLengthAdjustmentApplicable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArmsLengthAdjustmentApplicable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional)
     * @param organizationalEntityId (optional)
     * @return Success
     */
    getTaxCreditApplicable(projectId: number | undefined, organizationalEntityId: number | undefined): Observable<TaxCreditApplicable> {
        let url_ = this.baseUrl + "/api/services/pillar2/FullScopeQuestionnaire/GetTaxCreditApplicable?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (organizationalEntityId === null)
            throw new Error("The parameter 'organizationalEntityId' cannot be null.");
        else if (organizationalEntityId !== undefined)
            url_ += "OrganizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaxCreditApplicable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaxCreditApplicable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxCreditApplicable>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxCreditApplicable>;
        }));
    }

    protected processGetTaxCreditApplicable(response: HttpResponseBase): Observable<TaxCreditApplicable> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxCreditApplicable.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
                }

@Injectable()
export class ImportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
        }

    /**
     * @param templateType (optional)
     * @param scopingType (optional)
     * @return Success
     */
    downloadExcelTemplate(templateType: ProjectTemplateType | undefined, scopingType: ProjectScopingDataType | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Import/DownloadExcelTemplate?";
        if (templateType === null)
            throw new Error("The parameter 'templateType' cannot be null.");
        else if (templateType !== undefined)
            url_ += "TemplateType=" + encodeURIComponent("" + templateType) + "&";
        if (scopingType === null)
            throw new Error("The parameter 'scopingType' cannot be null.");
        else if (scopingType !== undefined)
            url_ += "ScopingType=" + encodeURIComponent("" + scopingType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadExcelTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadExcelTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadExcelTemplate(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    importReport(body: ImportReportInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Import/ImportReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileToken (optional)
     * @return Success
     */
    checkImportFile(fileToken: string | undefined): Observable<ProjectImportType> {
        let url_ = this.baseUrl + "/api/services/pillar2/Import/CheckImportFile?";
        if (fileToken === null)
            throw new Error("The parameter 'fileToken' cannot be null.");
        else if (fileToken !== undefined)
            url_ += "FileToken=" + encodeURIComponent("" + fileToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckImportFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckImportFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectImportType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectImportType>;
        }));
    }

    protected processCheckImportFile(response: HttpResponseBase): Observable<ProjectImportType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional)
     * @param projectId (optional)
     * @return Success
     */
    downloadImport(id: number | undefined, projectId: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Import/DownloadImport?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadImport(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getImportsOverview(projectId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfImportOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Import/GetImportsOverview?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImportsOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImportsOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfImportOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfImportOverviewDto>;
        }));
    }

    protected processGetImportsOverview(response: HttpResponseBase): Observable<PagedResultDtoOfImportOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfImportOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional)
     * @param projectId (optional)
     * @return Success
     */
    delete(id: number | undefined, projectId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Import/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InsightsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional)
     * @return Success
     */
    getRiskIndicationData(projectId: number | undefined): Observable<RiskIndicationDataDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/Insights/GetRiskIndicationData?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRiskIndicationData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRiskIndicationData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RiskIndicationDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RiskIndicationDataDto[]>;
        }));
    }

    protected processGetRiskIndicationData(response: HttpResponseBase): Observable<RiskIndicationDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RiskIndicationDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional)
     * @param sorting (optional)
     * @return Success
     */
    getDeMinimisCheckData(projectId: number | undefined, sorting: string | undefined): Observable<RevenueToProfitLossCoparisonDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/Insights/GetDeMinimisCheckData?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeMinimisCheckData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeMinimisCheckData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevenueToProfitLossCoparisonDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevenueToProfitLossCoparisonDto[]>;
        }));
    }

    protected processGetDeMinimisCheckData(response: HttpResponseBase): Observable<RevenueToProfitLossCoparisonDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RevenueToProfitLossCoparisonDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional)
     * @param sorting (optional)
     * @return Success
     */
    getRptCheckData(projectId: number | undefined, sorting: string | undefined): Observable<FreeAllowanceToProfitDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/Insights/GetRptCheckData?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRptCheckData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRptCheckData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FreeAllowanceToProfitDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FreeAllowanceToProfitDto[]>;
        }));
    }

    protected processGetRptCheckData(response: HttpResponseBase): Observable<FreeAllowanceToProfitDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FreeAllowanceToProfitDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional)
     * @param sorting (optional)
     * @return Success
     */
    getSetrCheckData(projectId: number | undefined, sorting: string | undefined): Observable<SetrCheckDataDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/Insights/GetSetrCheckData?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSetrCheckData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSetrCheckData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetrCheckDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetrCheckDataDto[]>;
        }));
    }

    protected processGetSetrCheckData(response: HttpResponseBase): Observable<SetrCheckDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SetrCheckDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class Pillar2AdminSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getAll(): Observable<Pillar2AdminSettingsDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Pillar2AdminSettings/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Pillar2AdminSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Pillar2AdminSettingsDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<Pillar2AdminSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Pillar2AdminSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    saveAll(body: Pillar2AdminSettingsInput | undefined): Observable<Pillar2AdminSettingsDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Pillar2AdminSettings/SaveAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Pillar2AdminSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Pillar2AdminSettingsDto>;
        }));
    }

    protected processSaveAll(response: HttpResponseBase): Observable<Pillar2AdminSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Pillar2AdminSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class Pillar2ChancelleryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getClients(): Observable<ChancelleryClientDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/Pillar2Chancellery/GetClients";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChancelleryClientDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChancelleryClientDto[]>;
        }));
    }

    protected processGetClients(response: HttpResponseBase): Observable<ChancelleryClientDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChancelleryClientDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param clientNumber (optional)
     * @return Success
     */
    getProjects(clientNumber: string | undefined): Observable<ChancelleryProjectDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/Pillar2Chancellery/GetProjects?";
        if (clientNumber === null)
            throw new Error("The parameter 'clientNumber' cannot be null.");
        else if (clientNumber !== undefined)
            url_ += "ClientNumber=" + encodeURIComponent("" + clientNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChancelleryProjectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChancelleryProjectDto[]>;
        }));
    }

    protected processGetProjects(response: HttpResponseBase): Observable<ChancelleryProjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChancelleryProjectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class Pillar2UserGridConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    setColumnVisibilitySettings(body: MazarsGridDefinitionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Pillar2UserGridConfiguration/SetColumnVisibilitySettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetColumnVisibilitySettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetColumnVisibilitySettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetColumnVisibilitySettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param key (optional)
     * @return Success
     */
    getGridColumnSettings(key: string | undefined): Observable<MazarsGridDefinitionDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Pillar2UserGridConfiguration/GetGridColumnSettings?";
        if (key === null)
            throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGridColumnSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGridColumnSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MazarsGridDefinitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MazarsGridDefinitionDto>;
        }));
    }

    protected processGetGridColumnSettings(response: HttpResponseBase): Observable<MazarsGridDefinitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MazarsGridDefinitionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param key (optional)
     * @return Success
     */
    resetGridColumnSettings(key: string | undefined): Observable<MazarsGridDefinitionDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Pillar2UserGridConfiguration/ResetGridColumnSettings?";
        if (key === null)
            throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetGridColumnSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetGridColumnSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MazarsGridDefinitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MazarsGridDefinitionDto>;
        }));
    }

    protected processResetGridColumnSettings(response: HttpResponseBase): Observable<MazarsGridDefinitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MazarsGridDefinitionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class Pillar2UserManualsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param languageCode (optional)
     * @return Success
     */
    getUserManual(languageCode: string | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Pillar2UserManuals/GetUserManual?";
        if (languageCode === null)
            throw new Error("The parameter 'languageCode' cannot be null.");
        else if (languageCode !== undefined)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserManual(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserManual(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processGetUserManual(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class Pillar2WidgetServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getProjects(): Observable<ProjectDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/Pillar2Widget/GetProjects";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDto[]>;
        }));
    }

    protected processGetProjects(response: HttpResponseBase): Observable<ProjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getDataByProjectId(id: number | undefined): Observable<ProjectWidgetDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Pillar2Widget/GetDataByProjectId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataByProjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataByProjectId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectWidgetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectWidgetDto>;
        }));
    }

    protected processGetDataByProjectId(response: HttpResponseBase): Observable<ProjectWidgetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectWidgetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyProjectTasks(): Observable<TaskDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/Pillar2Widget/GetMyProjectTasks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyProjectTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyProjectTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskDto[]>;
        }));
    }

    protected processGetMyProjectTasks(response: HttpResponseBase): Observable<TaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectAttachmentsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getAll(body: AttachmentsFilterRequest | undefined): Observable<PagedResultDtoOfAttachmentOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectAttachments/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAttachmentOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAttachmentOverviewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfAttachmentOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAttachmentOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional)
     * @return Success
     */
    getTags(filter: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectAttachments/GetTags?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetTags(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllowedFileTypes(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectAttachments/GetAllowedFileTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllowedFileTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowedFileTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllowedFileTypes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param file (optional)
     * @return Success
     */
    uploadFile(file: FileParameter | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectAttachments/UploadFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional)
     * @param id (optional)
     * @return Success
     */
    downloadFile(referenceId: number | undefined, id: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectAttachments/DownloadFile?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "ReferenceId=" + encodeURIComponent("" + referenceId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional)
     * @param id (optional)
     * @return Success
     */
    getById(referenceId: number | undefined, id: number | undefined): Observable<AttachmentDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectAttachments/GetById?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "ReferenceId=" + encodeURIComponent("" + referenceId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttachmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttachmentDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<AttachmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttachmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body: CreateAttachmentInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectAttachments/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateAttachmentInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectAttachments/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional)
     * @param id (optional)
     * @return Success
     */
    delete(referenceId: number | undefined, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectAttachments/Delete?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "ReferenceId=" + encodeURIComponent("" + referenceId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional)
     * @return Success
     */
    getCreatedByUsers(referenceId: number | undefined): Observable<UserReferenceDataDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectAttachments/GetCreatedByUsers?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "referenceId=" + encodeURIComponent("" + referenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCreatedByUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCreatedByUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserReferenceDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserReferenceDataDto[]>;
        }));
    }

    protected processGetCreatedByUsers(response: HttpResponseBase): Observable<UserReferenceDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserReferenceDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectChannelServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body: CreateChannelInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectChannel/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional)
     * @param referenceId (optional)
     * @return Success
     */
    delete(id: number | undefined, referenceId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectChannel/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "ReferenceId=" + encodeURIComponent("" + referenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param rootId (optional)
     * @return Success
     */
    getAll(rootId: number | undefined): Observable<ChannelOverviewDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectChannel/GetAll?";
        if (rootId === null)
            throw new Error("The parameter 'rootId' cannot be null.");
        else if (rootId !== undefined)
            url_ += "rootId=" + encodeURIComponent("" + rootId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChannelOverviewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChannelOverviewDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ChannelOverviewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChannelOverviewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param rootId (optional)
     * @return Success
     */
    getNumberOfUnreadChannels(rootId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectChannel/GetNumberOfUnreadChannels?";
        if (rootId === null)
            throw new Error("The parameter 'rootId' cannot be null.");
        else if (rootId !== undefined)
            url_ += "rootId=" + encodeURIComponent("" + rootId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberOfUnreadChannels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberOfUnreadChannels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNumberOfUnreadChannels(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    initiateEmailConversation(body: InitiateEmailConversationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectChannel/InitiateEmailConversation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInitiateEmailConversation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInitiateEmailConversation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInitiateEmailConversation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: EditChannelInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectChannel/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectChannelWhiteListServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param channelId (optional)
     * @return Success
     */
    getAll(channelId: number | undefined): Observable<WhiteListOverviewDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectChannelWhiteList/GetAll?";
        if (channelId === null)
            throw new Error("The parameter 'channelId' cannot be null.");
        else if (channelId !== undefined)
            url_ += "channelId=" + encodeURIComponent("" + channelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WhiteListOverviewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WhiteListOverviewDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<WhiteListOverviewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WhiteListOverviewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    saveAll(body: SaveAllWhiteListInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectChannelWhiteList/SaveAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectCommunicationReferencesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getAuthors(): Observable<AuthorDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCommunicationReferences/GetAuthors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthorDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthorDto[]>;
        }));
    }

    protected processGetAuthors(response: HttpResponseBase): Observable<AuthorDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuthorDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectCommunicationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    search(body: CommunicationsFilterRequest | undefined): Observable<SearchCommunicationDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCommunications/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchCommunicationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchCommunicationDto[]>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<SearchCommunicationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchCommunicationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param channelId (optional)
     * @return Success
     */
    getAll(channelId: number | undefined): Observable<CommunicationDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCommunications/GetAll?";
        if (channelId === null)
            throw new Error("The parameter 'channelId' cannot be null.");
        else if (channelId !== undefined)
            url_ += "channelId=" + encodeURIComponent("" + channelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommunicationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommunicationDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CommunicationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommunicationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param channelId (optional)
     * @return Success
     */
    getAllChannelUserDetail(channelId: number | undefined): Observable<UserDetailsDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCommunications/GetAllChannelUserDetail?";
        if (channelId === null)
            throw new Error("The parameter 'channelId' cannot be null.");
        else if (channelId !== undefined)
            url_ += "channelId=" + encodeURIComponent("" + channelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllChannelUserDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllChannelUserDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDetailsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDetailsDto[]>;
        }));
    }

    protected processGetAllChannelUserDetail(response: HttpResponseBase): Observable<UserDetailsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDetailsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getById(id: number | undefined): Observable<CommunicationDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCommunications/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommunicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommunicationDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<CommunicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommunicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body: CreateCommunicationInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCommunications/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: EditCommunicationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCommunications/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCommunications/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectCurrencyRatesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    requestOverview(projectId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProjectCurrencyRateOverviewDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCurrencyRates/RequestOverview?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectCurrencyRateOverviewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectCurrencyRateOverviewDto[]>;
        }));
    }

    protected processRequestOverview(response: HttpResponseBase): Observable<ProjectCurrencyRateOverviewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectCurrencyRateOverviewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateProjectCurrencyRateInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCurrencyRates/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectCustomGrantsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional)
     * @return Success
     */
    getAll(projectId: number | undefined): Observable<EntityPermissionDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCustomGrants/GetAll?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityPermissionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityPermissionDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<EntityPermissionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityPermissionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getAllWithProvisionalData(body: CustomGrantsWithAccessRestrictionInput | undefined): Observable<EntityPermissionDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCustomGrants/GetAllWithProvisionalData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWithProvisionalData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWithProvisionalData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityPermissionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityPermissionDto[]>;
        }));
    }

    protected processGetAllWithProvisionalData(response: HttpResponseBase): Observable<EntityPermissionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityPermissionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional)
     * @param permissionName (optional)
     * @param excludeUsers (optional)
     * @return Success
     */
    getAllPossibleUsers(projectId: number | undefined, permissionName: string | undefined, excludeUsers: boolean | undefined): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCustomGrants/GetAllPossibleUsers?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (permissionName === null)
            throw new Error("The parameter 'permissionName' cannot be null.");
        else if (permissionName !== undefined)
            url_ += "permissionName=" + encodeURIComponent("" + permissionName) + "&";
        if (excludeUsers === null)
            throw new Error("The parameter 'excludeUsers' cannot be null.");
        else if (excludeUsers !== undefined)
            url_ += "excludeUsers=" + encodeURIComponent("" + excludeUsers) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPossibleUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPossibleUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
        }));
    }

    protected processGetAllPossibleUsers(response: HttpResponseBase): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserOrOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAccessRestrictedUsers(): Observable<ProjectAccessRestrictedUsersDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCustomGrants/GetAccessRestrictedUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccessRestrictedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccessRestrictedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectAccessRestrictedUsersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectAccessRestrictedUsersDto>;
        }));
    }

    protected processGetAccessRestrictedUsers(response: HttpResponseBase): Observable<ProjectAccessRestrictedUsersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectAccessRestrictedUsersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getAllPossibleUsersWithProvisionalData(body: CustomGrantsForPermissionWithAccessRestrictionDataInput | undefined): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCustomGrants/GetAllPossibleUsersWithProvisionalData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPossibleUsersWithProvisionalData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPossibleUsersWithProvisionalData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
        }));
    }

    protected processGetAllPossibleUsersWithProvisionalData(response: HttpResponseBase): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserOrOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param usersAndOrganizationUnits (optional)
     * @return Success
     */
    checkCurrentUserIsInList(usersAndOrganizationUnits: UserOrOrganizationUnitInput[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectCustomGrants/CheckCurrentUserIsInList?";
        if (usersAndOrganizationUnits === null)
            throw new Error("The parameter 'usersAndOrganizationUnits' cannot be null.");
        else if (usersAndOrganizationUnits !== undefined)
            usersAndOrganizationUnits && usersAndOrganizationUnits.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "usersAndOrganizationUnits[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckCurrentUserIsInList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCurrentUserIsInList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckCurrentUserIsInList(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectExcelExportableServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    exportOverviewToExcel(body: ExportOverviewToExcelInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectExcelExportableService/ExportOverviewToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportOverviewToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportOverviewToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportOverviewToExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectFileGeneratorServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectName (optional)
     * @param projectGroupName (optional)
     * @param tenantId (optional)
     * @param body (optional)
     * @return Success
     */
    generateSafeHarbourHistoryPdf(projectName: string | undefined, projectGroupName: string | undefined, tenantId: number | undefined, body: SafeHarbourHistoryDto[] | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectFileGeneratorService/GenerateSafeHarbourHistoryPdf?";
        if (projectName === null)
            throw new Error("The parameter 'projectName' cannot be null.");
        else if (projectName !== undefined)
            url_ += "projectName=" + encodeURIComponent("" + projectName) + "&";
        if (projectGroupName === null)
            throw new Error("The parameter 'projectGroupName' cannot be null.");
        else if (projectGroupName !== undefined)
            url_ += "projectGroupName=" + encodeURIComponent("" + projectGroupName) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateSafeHarbourHistoryPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateSafeHarbourHistoryPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processGenerateSafeHarbourHistoryPdf(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectLookupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param referenceId (optional)
     * @return Success
     */
    getSurveys(referenceId: number | undefined): Observable<SurveyLookupDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectLookup/GetSurveys?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "referenceId=" + encodeURIComponent("" + referenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSurveys(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveys(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyLookupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyLookupDto[]>;
        }));
    }

    protected processGetSurveys(response: HttpResponseBase): Observable<SurveyLookupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurveyLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional)
     * @return Success
     */
    getAttachments(referenceId: number | undefined): Observable<AttachmentLookupDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectLookup/GetAttachments?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "referenceId=" + encodeURIComponent("" + referenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttachmentLookupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttachmentLookupDto[]>;
        }));
    }

    protected processGetAttachments(response: HttpResponseBase): Observable<AttachmentLookupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getTenantUsers(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectLookup/GetTenantUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetTenantUsers(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional)
     * @param tagsFilter (optional)
     * @param assignedUsersFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getOverview(filter: string | undefined, tagsFilter: string[] | undefined, assignedUsersFilter: number[] | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfProjectOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Projects/GetOverview?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (tagsFilter === null)
            throw new Error("The parameter 'tagsFilter' cannot be null.");
        else if (tagsFilter !== undefined)
            tagsFilter && tagsFilter.forEach(item => { url_ += "TagsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (assignedUsersFilter === null)
            throw new Error("The parameter 'assignedUsersFilter' cannot be null.");
        else if (assignedUsersFilter !== undefined)
            assignedUsersFilter && assignedUsersFilter.forEach(item => { url_ += "AssignedUsersFilter=" + encodeURIComponent("" + item) + "&"; });
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfProjectOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfProjectOverviewDto>;
        }));
    }

    protected processGetOverview(response: HttpResponseBase): Observable<PagedResultDtoOfProjectOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfProjectOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body: CreateProjectInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/pillar2/Projects/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOutOfTemplate(body: CreateOutOfTemplateProjectInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/pillar2/Projects/CreateOutOfTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOutOfTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOutOfTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOutOfTemplate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateProjectInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Projects/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getById(id: number | undefined): Observable<ProjectDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Projects/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional)
     * @return Success
     */
    getTags(filter: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/Projects/GetTags?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetTags(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Projects/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional)
     * @return Success
     */
    getAssignedUser(referenceId: number | undefined): Observable<AssignableUserDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Projects/GetAssignedUser?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "referenceId=" + encodeURIComponent("" + referenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignedUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignedUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignableUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignableUserDto>;
        }));
    }

    protected processGetAssignedUser(response: HttpResponseBase): Observable<AssignableUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignableUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    setAssignedUser(body: SetAssignedUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Projects/SetAssignedUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAssignedUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAssignedUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAssignedUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional)
     * @param filter (optional)
     * @return Success
     */
    getAssignableUsers(referenceId: number | undefined, filter: string | undefined): Observable<AssignableUserDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/Projects/GetAssignableUsers?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "ReferenceId=" + encodeURIComponent("" + referenceId) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignableUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignableUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignableUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignableUserDto[]>;
        }));
    }

    protected processGetAssignableUsers(response: HttpResponseBase): Observable<AssignableUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssignableUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectsBulkServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param ids (optional)
     * @return Success
     */
    getManageTagsDetails(ids: number[] | undefined): Observable<ManageTagsDetailsDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectsBulk/GetManageTagsDetails?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManageTagsDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManageTagsDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ManageTagsDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ManageTagsDetailsDto>;
        }));
    }

    protected processGetManageTagsDetails(response: HttpResponseBase): Observable<ManageTagsDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ManageTagsDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    bulkUpdateTags(body: ManageTagsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectsBulk/BulkUpdateTags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkUpdateTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkUpdateTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkUpdateTags(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    checkBulkOperationsDetails(body: BulkInput | undefined): Observable<BulkProjectOperationDetailsDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectsBulk/CheckBulkOperationsDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckBulkOperationsDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckBulkOperationsDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BulkProjectOperationDetailsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BulkProjectOperationDetailsDto[]>;
        }));
    }

    protected processCheckBulkOperationsDetails(response: HttpResponseBase): Observable<BulkProjectOperationDetailsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BulkProjectOperationDetailsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    bulkDelete(body: BulkInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectsBulk/BulkDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    bulkCheckAccessRestriction(body: BulkChangeAccessRestrictionInput | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectsBulk/BulkCheckAccessRestriction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkCheckAccessRestriction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkCheckAccessRestriction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processBulkCheckAccessRestriction(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    bulkChangeAccessRestriction(body: BulkChangeAccessRestrictionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectsBulk/BulkChangeAccessRestriction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkChangeAccessRestriction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkChangeAccessRestriction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkChangeAccessRestriction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProjectsReferenceDataServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional)
     * @return Success
     */
    getJurisdictionsByProjectId(projectId: number | undefined): Observable<TaxJurisdictionCountryReferenceDataDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectsReferenceData/GetJurisdictionsByProjectId?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJurisdictionsByProjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJurisdictionsByProjectId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxJurisdictionCountryReferenceDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxJurisdictionCountryReferenceDataDto[]>;
        }));
    }

    protected processGetJurisdictionsByProjectId(response: HttpResponseBase): Observable<TaxJurisdictionCountryReferenceDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaxJurisdictionCountryReferenceDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional)
     * @return Success
     */
    getOrganizationalEntitiesByProjectId(projectId: number | undefined): Observable<OrganizationalEntityReferenceDataDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectsReferenceData/GetOrganizationalEntitiesByProjectId?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationalEntitiesByProjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationalEntitiesByProjectId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationalEntityReferenceDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationalEntityReferenceDataDto[]>;
        }));
    }

    protected processGetOrganizationalEntitiesByProjectId(response: HttpResponseBase): Observable<OrganizationalEntityReferenceDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationalEntityReferenceDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationalEntityId (optional)
     * @param projectId (optional)
     * @return Success
     */
    getOrganizationalEntitiesForControllingInterest(organizationalEntityId: number | undefined, projectId: number | undefined): Observable<OrganizationalEntityReferenceDataDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectsReferenceData/GetOrganizationalEntitiesForControllingInterest?";
        if (organizationalEntityId === null)
            throw new Error("The parameter 'organizationalEntityId' cannot be null.");
        else if (organizationalEntityId !== undefined)
            url_ += "OrganizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationalEntitiesForControllingInterest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationalEntitiesForControllingInterest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationalEntityReferenceDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationalEntityReferenceDataDto[]>;
        }));
    }

    protected processGetOrganizationalEntitiesForControllingInterest(response: HttpResponseBase): Observable<OrganizationalEntityReferenceDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationalEntityReferenceDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional)
     * @return Success
     */
    getAllTaxJurisdictionCountriesByProjectId(projectId: number | undefined): Observable<TaxJurisdictionCountryReferenceDataDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectsReferenceData/GetAllTaxJurisdictionCountriesByProjectId?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTaxJurisdictionCountriesByProjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTaxJurisdictionCountriesByProjectId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxJurisdictionCountryReferenceDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxJurisdictionCountryReferenceDataDto[]>;
        }));
    }

    protected processGetAllTaxJurisdictionCountriesByProjectId(response: HttpResponseBase): Observable<TaxJurisdictionCountryReferenceDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaxJurisdictionCountryReferenceDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getConsolidationMethods(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectsReferenceData/GetConsolidationMethods";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsolidationMethods(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsolidationMethods(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetConsolidationMethods(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getGloBEStatuses(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectsReferenceData/GetGloBEStatuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGloBEStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGloBEStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetGloBEStatuses(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional)
     * @param organizationalEntityId (optional)
     * @return Success
     */
    getOrganizationalEntityDetailsById(projectId: number | undefined, organizationalEntityId: number | undefined): Observable<OrganizationalEntityReferenceDataDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ProjectsReferenceData/GetOrganizationalEntityDetailsById?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (organizationalEntityId === null)
            throw new Error("The parameter 'organizationalEntityId' cannot be null.");
        else if (organizationalEntityId !== undefined)
            url_ += "organizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationalEntityDetailsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationalEntityDetailsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationalEntityReferenceDataDto>;
}
            } else
                return _observableThrow(response_) as any as Observable<OrganizationalEntityReferenceDataDto>;
        }));
    }

    protected processGetOrganizationalEntityDetailsById(response: HttpResponseBase): Observable<OrganizationalEntityReferenceDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationalEntityReferenceDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createReport(body: GenerateProjectReportInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Report/CreateReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getReportsOverview(projectId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfReportOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Report/GetReportsOverview?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportsOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportsOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfReportOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfReportOverviewDto>;
        }));
    }

    protected processGetReportsOverview(response: HttpResponseBase): Observable<PagedResultDtoOfReportOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfReportOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional)
     * @param projectId (optional)
     * @return Success
     */
    downloadReport(id: number | undefined, projectId: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Report/DownloadReport?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadReport(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional)
     * @param projectId (optional)
     * @return Success
     */
    delete(id: number | undefined, projectId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Report/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SafeHarbourTestsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    requestOverview(body: GetSafeHarbourGroupOverviewInput | undefined): Observable<PagedResultDtoOfSafeHarbourGroupOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/SafeHarbourTests/RequestOverview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSafeHarbourGroupOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSafeHarbourGroupOverviewDto>;
        }));
    }

    protected processRequestOverview(response: HttpResponseBase): Observable<PagedResultDtoOfSafeHarbourGroupOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSafeHarbourGroupOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getFinancialDataBySafeHarbourGroup(body: GetFinancialDataSafeHarbourGroupOverviewInput | undefined): Observable<FinancialDataSafeHarbourGroupOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/SafeHarbourTests/GetFinancialDataBySafeHarbourGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinancialDataBySafeHarbourGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialDataBySafeHarbourGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialDataSafeHarbourGroupOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialDataSafeHarbourGroupOverviewDto>;
        }));
    }

    protected processGetFinancialDataBySafeHarbourGroup(response: HttpResponseBase): Observable<FinancialDataSafeHarbourGroupOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialDataSafeHarbourGroupOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getFinancialDataOrganizationalEntityOverviewByIds(body: GetFinancialDataOrganizationalEntityByIdsOverviewInput | undefined): Observable<ListResultDtoOfFinancialDataOrganizationalEntityOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/SafeHarbourTests/GetFinancialDataOrganizationalEntityOverviewByIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinancialDataOrganizationalEntityOverviewByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialDataOrganizationalEntityOverviewByIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfFinancialDataOrganizationalEntityOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfFinancialDataOrganizationalEntityOverviewDto>;
        }));
    }

    protected processGetFinancialDataOrganizationalEntityOverviewByIds(response: HttpResponseBase): Observable<ListResultDtoOfFinancialDataOrganizationalEntityOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfFinancialDataOrganizationalEntityOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional)
     * @return Success
     */
    getSafeHarbourGroupTests(projectId: number | undefined): Observable<FinancialDataSafeHarbourGroupOverviewDto[]> {
        let url_ = this.baseUrl + "/api/services/pillar2/SafeHarbourTests/GetSafeHarbourGroupTests?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSafeHarbourGroupTests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSafeHarbourGroupTests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialDataSafeHarbourGroupOverviewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialDataSafeHarbourGroupOverviewDto[]>;
        }));
    }

    protected processGetSafeHarbourGroupTests(response: HttpResponseBase): Observable<FinancialDataSafeHarbourGroupOverviewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FinancialDataSafeHarbourGroupOverviewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ScopingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional)
     * @param filter (optional)
     * @param jurisdictionsFilter (optional)
     * @param consolidationMethodFilter (optional)
     * @param globeStatusFilter (optional)
     * @param accountingFunctionalCurrencyFilter (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getJurisdictionOverview(projectId: number | undefined, filter: string | undefined, jurisdictionsFilter: string[] | undefined, consolidationMethodFilter: string[] | undefined, globeStatusFilter: string[] | undefined, accountingFunctionalCurrencyFilter: string[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfJurisdictionOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/GetJurisdictionOverview?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (jurisdictionsFilter === null)
            throw new Error("The parameter 'jurisdictionsFilter' cannot be null.");
        else if (jurisdictionsFilter !== undefined)
            jurisdictionsFilter && jurisdictionsFilter.forEach(item => { url_ += "JurisdictionsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (consolidationMethodFilter === null)
            throw new Error("The parameter 'consolidationMethodFilter' cannot be null.");
        else if (consolidationMethodFilter !== undefined)
            consolidationMethodFilter && consolidationMethodFilter.forEach(item => { url_ += "ConsolidationMethodFilter=" + encodeURIComponent("" + item) + "&"; });
        if (globeStatusFilter === null)
            throw new Error("The parameter 'globeStatusFilter' cannot be null.");
        else if (globeStatusFilter !== undefined)
            globeStatusFilter && globeStatusFilter.forEach(item => { url_ += "GlobeStatusFilter=" + encodeURIComponent("" + item) + "&"; });
        if (accountingFunctionalCurrencyFilter === null)
            throw new Error("The parameter 'accountingFunctionalCurrencyFilter' cannot be null.");
        else if (accountingFunctionalCurrencyFilter !== undefined)
            accountingFunctionalCurrencyFilter && accountingFunctionalCurrencyFilter.forEach(item => { url_ += "AccountingFunctionalCurrencyFilter=" + encodeURIComponent("" + item) + "&"; });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJurisdictionOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJurisdictionOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfJurisdictionOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfJurisdictionOverviewDto>;
        }));
    }

    protected processGetJurisdictionOverview(response: HttpResponseBase): Observable<PagedResultDtoOfJurisdictionOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfJurisdictionOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taxJurisdictionCountry (optional)
     * @param consolidationMethodFilter (optional)
     * @param globeStatusFilter (optional)
     * @param accountingFunctionalCurrencyFilter (optional)
     * @param projectId (optional)
     * @return Success
     */
    getOrganizationalEntityOverviewByJurisdiction(taxJurisdictionCountry: string | undefined, consolidationMethodFilter: string[] | undefined, globeStatusFilter: string[] | undefined, accountingFunctionalCurrencyFilter: string[] | undefined, projectId: number | undefined): Observable<ListResultDtoOfOrganizationalEntityOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/GetOrganizationalEntityOverviewByJurisdiction?";
        if (taxJurisdictionCountry === null)
            throw new Error("The parameter 'taxJurisdictionCountry' cannot be null.");
        else if (taxJurisdictionCountry !== undefined)
            url_ += "TaxJurisdictionCountry=" + encodeURIComponent("" + taxJurisdictionCountry) + "&";
        if (consolidationMethodFilter === null)
            throw new Error("The parameter 'consolidationMethodFilter' cannot be null.");
        else if (consolidationMethodFilter !== undefined)
            consolidationMethodFilter && consolidationMethodFilter.forEach(item => { url_ += "ConsolidationMethodFilter=" + encodeURIComponent("" + item) + "&"; });
        if (globeStatusFilter === null)
            throw new Error("The parameter 'globeStatusFilter' cannot be null.");
        else if (globeStatusFilter !== undefined)
            globeStatusFilter && globeStatusFilter.forEach(item => { url_ += "GlobeStatusFilter=" + encodeURIComponent("" + item) + "&"; });
        if (accountingFunctionalCurrencyFilter === null)
            throw new Error("The parameter 'accountingFunctionalCurrencyFilter' cannot be null.");
        else if (accountingFunctionalCurrencyFilter !== undefined)
            accountingFunctionalCurrencyFilter && accountingFunctionalCurrencyFilter.forEach(item => { url_ += "AccountingFunctionalCurrencyFilter=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationalEntityOverviewByJurisdiction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationalEntityOverviewByJurisdiction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfOrganizationalEntityOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfOrganizationalEntityOverviewDto>;
        }));
    }

    protected processGetOrganizationalEntityOverviewByJurisdiction(response: HttpResponseBase): Observable<ListResultDtoOfOrganizationalEntityOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfOrganizationalEntityOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional)
     * @return Success
     */
    getAll(projectId: number | undefined): Observable<ListResultDtoOfOrganizationalEntityReferenceDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/GetAll?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfOrganizationalEntityReferenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfOrganizationalEntityReferenceDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListResultDtoOfOrganizationalEntityReferenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfOrganizationalEntityReferenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getOrganizationalChart(body: GetOrganizationalChartInput | undefined): Observable<OrganizationalChartDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/GetOrganizationalChart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationalChart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationalChart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationalChartDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationalChartDto>;
        }));
    }

    protected processGetOrganizationalChart(response: HttpResponseBase): Observable<OrganizationalChartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationalChartDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationalEntityId (optional)
     * @param projectId (optional)
     * @return Success
     */
    getById(organizationalEntityId: number | undefined, projectId: number | undefined): Observable<OrganizationalEntityDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/GetById?";
        if (organizationalEntityId === null)
            throw new Error("The parameter 'organizationalEntityId' cannot be null.");
        else if (organizationalEntityId !== undefined)
            url_ += "OrganizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationalEntityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationalEntityDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<OrganizationalEntityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationalEntityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationalEntityId (optional)
     * @param projectId (optional)
     * @return Success
     */
    isEntityWithTheOwnersJurisdiction(organizationalEntityId: number | undefined, projectId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/IsEntityWithTheOwnersJurisdiction?";
        if (organizationalEntityId === null)
            throw new Error("The parameter 'organizationalEntityId' cannot be null.");
        else if (organizationalEntityId !== undefined)
            url_ += "OrganizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsEntityWithTheOwnersJurisdiction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsEntityWithTheOwnersJurisdiction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsEntityWithTheOwnersJurisdiction(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body: CreateOrganizationalEntityInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateOrganizationalEntityInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateFieldStatus(body: UpdateOrganizationalEntityFieldStatusInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/UpdateFieldStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFieldStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFieldStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateFieldStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param organizationalEntityId (optional)
     * @param projectId (optional)
     * @return Success
     */
    delete(organizationalEntityId: number | undefined, projectId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/Delete?";
        if (organizationalEntityId === null)
            throw new Error("The parameter 'organizationalEntityId' cannot be null.");
        else if (organizationalEntityId !== undefined)
            url_ += "OrganizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getSuggestedBlendingCircle(body: UpdateOrganizationalEntityInput | undefined): Observable<BlendingCircleDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/GetSuggestedBlendingCircle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSuggestedBlendingCircle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuggestedBlendingCircle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BlendingCircleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BlendingCircleDto>;
        }));
    }

    protected processGetSuggestedBlendingCircle(response: HttpResponseBase): Observable<BlendingCircleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BlendingCircleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createEntityComment(body: CreateJurisdictionCommentInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/CreateEntityComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEntityComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEntityComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateEntityComment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional)
     * @param id (optional)
     * @return Success
     */
    getEntityComments(projectId: number | undefined, id: number | undefined): Observable<ProjectReferenceChannelDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/GetEntityComments?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectReferenceChannelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectReferenceChannelDto>;
        }));
    }

    protected processGetEntityComments(response: HttpResponseBase): Observable<ProjectReferenceChannelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectReferenceChannelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional)
     * @param excludedEntityId (optional)
     * @return Success
     */
    checkEntitiesForUpe(projectId: number | undefined, excludedEntityId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/pillar2/Scopings/CheckEntitiesForUpe?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (excludedEntityId === null)
            throw new Error("The parameter 'excludedEntityId' cannot be null.");
        else if (excludedEntityId !== undefined)
            url_ += "excludedEntityId=" + encodeURIComponent("" + excludedEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckEntitiesForUpe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckEntitiesForUpe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckEntitiesForUpe(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ShiftDataPointsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional)
     * @param organizationalEntityId (optional)
     * @param value (optional)
     * @param initialValue (optional)
     * @return Success
     */
    calculateFinalArticle434(projectId: number | undefined, organizationalEntityId: number | undefined, value: string | undefined, initialValue: string | undefined): Observable<CrossAllocationOfTaxes434RecalculationWarningDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ShiftDataPoints/CalculateFinalArticle434?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (organizationalEntityId === null)
            throw new Error("The parameter 'organizationalEntityId' cannot be null.");
        else if (organizationalEntityId !== undefined)
            url_ += "OrganizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        if (value === null)
            throw new Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "Value=" + encodeURIComponent("" + value) + "&";
        if (initialValue === null)
            throw new Error("The parameter 'initialValue' cannot be null.");
        else if (initialValue !== undefined)
            url_ += "InitialValue=" + encodeURIComponent("" + initialValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateFinalArticle434(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateFinalArticle434(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CrossAllocationOfTaxes434RecalculationWarningDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CrossAllocationOfTaxes434RecalculationWarningDto>;
        }));
    }

    protected processCalculateFinalArticle434(response: HttpResponseBase): Observable<CrossAllocationOfTaxes434RecalculationWarningDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CrossAllocationOfTaxes434RecalculationWarningDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    calculateFinalArticle432cOrArticle432d(body: RequestCalculateFinalArticle432Input | undefined): Observable<FinancialNodeDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ShiftDataPoints/CalculateFinalArticle432cOrArticle432d";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateFinalArticle432cOrArticle432d(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateFinalArticle432cOrArticle432d(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialNodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialNodeDto>;
        }));
    }

    protected processCalculateFinalArticle432cOrArticle432d(response: HttpResponseBase): Observable<FinancialNodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialNodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    calculateFinalFiscalYearAverage(body: CalculateFinalFiscalYearAverageShiftDataInput | undefined): Observable<FinancialNodeDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ShiftDataPoints/CalculateFinalFiscalYearAverage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateFinalFiscalYearAverage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateFinalFiscalYearAverage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialNodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialNodeDto>;
        }));
    }

    protected processCalculateFinalFiscalYearAverage(response: HttpResponseBase): Observable<FinancialNodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialNodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional)
     * @param organizationalEntityId (optional)
     * @param value (optional)
     * @param initialValue (optional)
     * @return Success
     */
    checkIfArticle345Exists(projectId: number | undefined, organizationalEntityId: number | undefined, value: string | undefined, initialValue: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/pillar2/ShiftDataPoints/CheckIfArticle345Exists?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (organizationalEntityId === null)
            throw new Error("The parameter 'organizationalEntityId' cannot be null.");
        else if (organizationalEntityId !== undefined)
            url_ += "OrganizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        if (value === null)
            throw new Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "Value=" + encodeURIComponent("" + value) + "&";
        if (initialValue === null)
            throw new Error("The parameter 'initialValue' cannot be null.");
        else if (initialValue !== undefined)
            url_ += "InitialValue=" + encodeURIComponent("" + initialValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfArticle345Exists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfArticle345Exists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckIfArticle345Exists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional)
     * @param organizationalEntityId (optional)
     * @param value (optional)
     * @param initialValue (optional)
     * @return Success
     */
    getArticle345TraceName(projectId: number | undefined, organizationalEntityId: number | undefined, value: string | undefined, initialValue: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/pillar2/ShiftDataPoints/GetArticle345TraceName?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (organizationalEntityId === null)
            throw new Error("The parameter 'organizationalEntityId' cannot be null.");
        else if (organizationalEntityId !== undefined)
            url_ += "OrganizationalEntityId=" + encodeURIComponent("" + organizationalEntityId) + "&";
        if (value === null)
            throw new Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "Value=" + encodeURIComponent("" + value) + "&";
        if (initialValue === null)
            throw new Error("The parameter 'initialValue' cannot be null.");
        else if (initialValue !== undefined)
            url_ += "InitialValue=" + encodeURIComponent("" + initialValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArticle345TraceName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticle345TraceName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetArticle345TraceName(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createShiftDataPoint(body: CreateFinancialShiftInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/pillar2/ShiftDataPoints/CreateShiftDataPoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateShiftDataPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateShiftDataPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateShiftDataPoint(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createMultipleShiftNodeGroupData(body: CreateMultipleShiftNodeGroupInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ShiftDataPoints/CreateMultipleShiftNodeGroupData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMultipleShiftNodeGroupData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMultipleShiftNodeGroupData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateMultipleShiftNodeGroupData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    deleteMultipleShiftNodeGroupData(body: DeleteMultipleShiftNodeGroupInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ShiftDataPoints/DeleteMultipleShiftNodeGroupData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMultipleShiftNodeGroupData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMultipleShiftNodeGroupData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteMultipleShiftNodeGroupData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateShiftDataPoint(body: UpdateFinancialShiftInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ShiftDataPoints/UpdateShiftDataPoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateShiftDataPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateShiftDataPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateShiftDataPoint(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    addOrUpdateShiftDataPoint(body: AddOrUpdateFinancialShiftInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/pillar2/ShiftDataPoints/AddOrUpdateShiftDataPoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateShiftDataPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateShiftDataPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdateShiftDataPoint(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateShiftDataPointStatus(body: UpdateDataPointStatusInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ShiftDataPoints/UpdateShiftDataPointStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateShiftDataPointStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateShiftDataPointStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateShiftDataPointStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional)
     * @param targetOrganizationalEntityId (optional)
     * @param id (optional)
     * @return Success
     */
    deleteShiftDataPoint(projectId: number | undefined, targetOrganizationalEntityId: number | undefined, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ShiftDataPoints/DeleteShiftDataPoint?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (targetOrganizationalEntityId === null)
            throw new Error("The parameter 'targetOrganizationalEntityId' cannot be null.");
        else if (targetOrganizationalEntityId !== undefined)
            url_ += "TargetOrganizationalEntityId=" + encodeURIComponent("" + targetOrganizationalEntityId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteShiftDataPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteShiftDataPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteShiftDataPoint(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TaxJurisdictionCountriesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createJurisdictionComment(body: CreateJurisdictionCommentInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/TaxJurisdictionCountries/CreateJurisdictionComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateJurisdictionComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateJurisdictionComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateJurisdictionComment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional)
     * @param taxJurisdictionCountry (optional)
     * @param id (optional)
     * @return Success
     */
    getJurisdictionComments(projectId: number | undefined, taxJurisdictionCountry: string | undefined, id: number | undefined): Observable<ProjectReferenceChannelDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/TaxJurisdictionCountries/GetJurisdictionComments?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (taxJurisdictionCountry === null)
            throw new Error("The parameter 'taxJurisdictionCountry' cannot be null.");
        else if (taxJurisdictionCountry !== undefined)
            url_ += "TaxJurisdictionCountry=" + encodeURIComponent("" + taxJurisdictionCountry) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJurisdictionComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJurisdictionComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectReferenceChannelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectReferenceChannelDto>;
        }));
    }

    protected processGetJurisdictionComments(response: HttpResponseBase): Observable<ProjectReferenceChannelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectReferenceChannelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
            }
        return _observableOf(null as any);
            }
}

@Injectable()
export class TopupTaxServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional)
     * @return Success
     */
    requestTutOverview(projectId: number | undefined): Observable<TutBlendingCirclesOverviewDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/TopupTax/RequestTutOverview?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestTutOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestTutOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TutBlendingCirclesOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TutBlendingCirclesOverviewDto>;
        }));
    }

    protected processRequestTutOverview(response: HttpResponseBase): Observable<TutBlendingCirclesOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TutBlendingCirclesOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TopUpTaxDistributionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param projectId (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    calculateTopUpTaxDistribution(projectId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfTopUpTaxAssignmentDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/TopUpTaxDistribution/CalculateTopUpTaxDistribution?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateTopUpTaxDistribution(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateTopUpTaxDistribution(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTopUpTaxAssignmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTopUpTaxAssignmentDto>;
        }));
    }

    protected processCalculateTopUpTaxDistribution(response: HttpResponseBase): Observable<PagedResultDtoOfTopUpTaxAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTopUpTaxAssignmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ValueDataPointsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(P2_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    calculateFinalFiscalYearAverage(body: CalculateFinalFiscalYearAverageValueDataInput | undefined): Observable<FinancialNodeDto> {
        let url_ = this.baseUrl + "/api/services/pillar2/ValueDataPoints/CalculateFinalFiscalYearAverage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateFinalFiscalYearAverage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateFinalFiscalYearAverage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialNodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialNodeDto>;
        }));
    }

    protected processCalculateFinalFiscalYearAverage(response: HttpResponseBase): Observable<FinancialNodeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialNodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    addOrUpdateValueDataPoint(body: UpdateFinancialValueInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/pillar2/ValueDataPoints/AddOrUpdateValueDataPoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateValueDataPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateValueDataPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdateValueDataPoint(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createMultipleNodeGroupData(body: CreateMultipleNodeGroupInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ValueDataPoints/CreateMultipleNodeGroupData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMultipleNodeGroupData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMultipleNodeGroupData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateMultipleNodeGroupData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    deleteMultipleNodeGroupData(body: DeleteMultipleNodeGroupInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ValueDataPoints/DeleteMultipleNodeGroupData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMultipleNodeGroupData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMultipleNodeGroupData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteMultipleNodeGroupData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createValueDataPoint(body: CreateFinancialValueInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/pillar2/ValueDataPoints/CreateValueDataPoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateValueDataPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateValueDataPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateValueDataPoint(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateValueDataPoint(body: UpdateFinancialValueInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ValueDataPoints/UpdateValueDataPoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateValueDataPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateValueDataPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateValueDataPoint(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateValueDataPointStatus(body: UpdateDataPointStatusInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ValueDataPoints/UpdateValueDataPointStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateValueDataPointStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateValueDataPointStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateValueDataPointStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param projectId (optional)
     * @param id (optional)
     * @return Success
     */
    deleteValueDataPoint(projectId: number | undefined, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pillar2/ValueDataPoints/DeleteValueDataPoint?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteValueDataPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteValueDataPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteValueDataPoint(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AccessManagementOverviewDto implements IAccessManagementOverviewDto {
    taxJurisdictionName!: string | undefined;
    countryCode!: string | undefined;
    organizationalEntityId!: number | undefined;
    name!: string | undefined;
    hasSpecialPermission!: boolean;

    constructor(data?: IAccessManagementOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxJurisdictionName = _data["taxJurisdictionName"];
            this.countryCode = _data["countryCode"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.name = _data["name"];
            this.hasSpecialPermission = _data["hasSpecialPermission"];
        }
    }

    static fromJS(data: any): AccessManagementOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccessManagementOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxJurisdictionName"] = this.taxJurisdictionName;
        data["countryCode"] = this.countryCode;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["name"] = this.name;
        data["hasSpecialPermission"] = this.hasSpecialPermission;
        return data;
    }
}

export interface IAccessManagementOverviewDto {
    taxJurisdictionName: string | undefined;
    countryCode: string | undefined;
    organizationalEntityId: number | undefined;
    name: string | undefined;
    hasSpecialPermission: boolean;
}

export class AddOrUpdateFinancialShiftInput implements IAddOrUpdateFinancialShiftInput {
    projectId!: number;
    value!: string | undefined;
    comment!: string | undefined;
    isConfirmed!: boolean;
    financialShiftType!: FinancialShiftType;
    targetOrganizationalEntityId!: number | undefined;
    basisForAdjustments!: BasisForAdjustmentsType;
    maxTaxRateOfMainEntityJurisdiction!: string | undefined;
    passiveIncomeOfCEOrHybridEntity!: string | undefined;
    fiscalYearBeginning!: string | undefined;
    fiscalYearEnd!: string | undefined;
    sourceOrganizationalEntityId!: number;
    id!: number;
    isManualCorrectionIncoming!: boolean;

    constructor(data?: IAddOrUpdateFinancialShiftInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.value = _data["value"];
            this.comment = _data["comment"];
            this.isConfirmed = _data["isConfirmed"];
            this.financialShiftType = _data["financialShiftType"];
            this.targetOrganizationalEntityId = _data["targetOrganizationalEntityId"];
            this.basisForAdjustments = _data["basisForAdjustments"];
            this.maxTaxRateOfMainEntityJurisdiction = _data["maxTaxRateOfMainEntityJurisdiction"];
            this.passiveIncomeOfCEOrHybridEntity = _data["passiveIncomeOfCEOrHybridEntity"];
            this.fiscalYearBeginning = _data["fiscalYearBeginning"];
            this.fiscalYearEnd = _data["fiscalYearEnd"];
            this.sourceOrganizationalEntityId = _data["sourceOrganizationalEntityId"];
            this.id = _data["id"];
            this.isManualCorrectionIncoming = _data["isManualCorrectionIncoming"];
        }
    }

    static fromJS(data: any): AddOrUpdateFinancialShiftInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrUpdateFinancialShiftInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["value"] = this.value;
        data["comment"] = this.comment;
        data["isConfirmed"] = this.isConfirmed;
        data["financialShiftType"] = this.financialShiftType;
        data["targetOrganizationalEntityId"] = this.targetOrganizationalEntityId;
        data["basisForAdjustments"] = this.basisForAdjustments;
        data["maxTaxRateOfMainEntityJurisdiction"] = this.maxTaxRateOfMainEntityJurisdiction;
        data["passiveIncomeOfCEOrHybridEntity"] = this.passiveIncomeOfCEOrHybridEntity;
        data["fiscalYearBeginning"] = this.fiscalYearBeginning;
        data["fiscalYearEnd"] = this.fiscalYearEnd;
        data["sourceOrganizationalEntityId"] = this.sourceOrganizationalEntityId;
        data["id"] = this.id;
        data["isManualCorrectionIncoming"] = this.isManualCorrectionIncoming;
        return data;
    }
}

export interface IAddOrUpdateFinancialShiftInput {
    projectId: number;
    value: string | undefined;
    comment: string | undefined;
    isConfirmed: boolean;
    financialShiftType: FinancialShiftType;
    targetOrganizationalEntityId: number | undefined;
    basisForAdjustments: BasisForAdjustmentsType;
    maxTaxRateOfMainEntityJurisdiction: string | undefined;
    passiveIncomeOfCEOrHybridEntity: string | undefined;
    fiscalYearBeginning: string | undefined;
    fiscalYearEnd: string | undefined;
    sourceOrganizationalEntityId: number;
    id: number;
    isManualCorrectionIncoming: boolean;
}

export class ArmsLengthAdjustmentApplicable implements IArmsLengthAdjustmentApplicable {
    armsLengthAdjustment!: boolean | undefined;
    readonly isApplicable!: boolean;

    constructor(data?: IArmsLengthAdjustmentApplicable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.armsLengthAdjustment = _data["armsLengthAdjustment"];
            (<any>this).isApplicable = _data["isApplicable"];
        }
    }

    static fromJS(data: any): ArmsLengthAdjustmentApplicable {
        data = typeof data === 'object' ? data : {};
        let result = new ArmsLengthAdjustmentApplicable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["armsLengthAdjustment"] = this.armsLengthAdjustment;
        data["isApplicable"] = this.isApplicable;
        return data;
    }
}

export interface IArmsLengthAdjustmentApplicable {
    armsLengthAdjustment: boolean | undefined;
    isApplicable: boolean;
}

export class AssignableUserDto implements IAssignableUserDto {
    id!: number;
    fullName!: string | undefined;
    userName!: string | undefined;

    constructor(data?: IAssignableUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): AssignableUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignableUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IAssignableUserDto {
    id: number;
    fullName: string | undefined;
    userName: string | undefined;
}

export class AssignableUserInput implements IAssignableUserInput {
    id!: number | undefined;

    constructor(data?: IAssignableUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AssignableUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new AssignableUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IAssignableUserInput {
    id: number | undefined;
}

export class AttachmentDto implements IAttachmentDto {
    id!: number;
    name!: string | undefined;
    note!: string | undefined;
    type!: string | undefined;
    fileName!: string | undefined;
    fileUrl!: string | undefined;
    url!: string | undefined;
    dateOfAttachment!: DateTime | undefined;
    tags!: TagDto[] | undefined;

    constructor(data?: IAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.note = _data["note"];
            this.type = _data["type"];
            this.fileName = _data["fileName"];
            this.fileUrl = _data["fileUrl"];
            this.url = _data["url"];
            this.dateOfAttachment = _data["dateOfAttachment"] ? DateTime.fromISO(_data["dateOfAttachment"].toString()) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["note"] = this.note;
        data["type"] = this.type;
        data["fileName"] = this.fileName;
        data["fileUrl"] = this.fileUrl;
        data["url"] = this.url;
        data["dateOfAttachment"] = this.dateOfAttachment ? this.dateOfAttachment.toString() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAttachmentDto {
    id: number;
    name: string | undefined;
    note: string | undefined;
    type: string | undefined;
    fileName: string | undefined;
    fileUrl: string | undefined;
    url: string | undefined;
    dateOfAttachment: DateTime | undefined;
    tags: TagDto[] | undefined;
}

export class AttachmentLookupDto implements IAttachmentLookupDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IAttachmentLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AttachmentLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IAttachmentLookupDto {
    id: number;
    name: string | undefined;
}

export class AttachmentOverviewDto implements IAttachmentOverviewDto {
    id!: number;
    name!: string | undefined;
    note!: string | undefined;
    type!: string | undefined;
    fileName!: string | undefined;
    fileUrl!: string | undefined;
    url!: string | undefined;
    hasPreview!: boolean;
    creationDate!: DateTime;
    dateOfAttachment!: DateTime | undefined;
    tags!: TagDto[] | undefined;
    fileContributionInfos!: FileContributionInfoDto[] | undefined;
    lastModifier!: string | undefined;
    lastModifierUserId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    creatorUserId!: number;
    createdByModifier!: string | undefined;

    constructor(data?: IAttachmentOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.note = _data["note"];
            this.type = _data["type"];
            this.fileName = _data["fileName"];
            this.fileUrl = _data["fileUrl"];
            this.url = _data["url"];
            this.hasPreview = _data["hasPreview"];
            this.creationDate = _data["creationDate"] ? DateTime.fromISO(_data["creationDate"].toString()) : <any>undefined;
            this.dateOfAttachment = _data["dateOfAttachment"] ? DateTime.fromISO(_data["dateOfAttachment"].toString()) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            if (Array.isArray(_data["fileContributionInfos"])) {
                this.fileContributionInfos = [] as any;
                for (let item of _data["fileContributionInfos"])
                    this.fileContributionInfos!.push(FileContributionInfoDto.fromJS(item));
            }
            this.lastModifier = _data["lastModifier"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.createdByModifier = _data["createdByModifier"];
        }
    }

    static fromJS(data: any): AttachmentOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["note"] = this.note;
        data["type"] = this.type;
        data["fileName"] = this.fileName;
        data["fileUrl"] = this.fileUrl;
        data["url"] = this.url;
        data["hasPreview"] = this.hasPreview;
        data["creationDate"] = this.creationDate ? this.creationDate.toString() : <any>undefined;
        data["dateOfAttachment"] = this.dateOfAttachment ? this.dateOfAttachment.toString() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        if (Array.isArray(this.fileContributionInfos)) {
            data["fileContributionInfos"] = [];
            for (let item of this.fileContributionInfos)
                data["fileContributionInfos"].push(item.toJSON());
        }
        data["lastModifier"] = this.lastModifier;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["createdByModifier"] = this.createdByModifier;
        return data;
    }
}

export interface IAttachmentOverviewDto {
    id: number;
    name: string | undefined;
    note: string | undefined;
    type: string | undefined;
    fileName: string | undefined;
    fileUrl: string | undefined;
    url: string | undefined;
    hasPreview: boolean;
    creationDate: DateTime;
    dateOfAttachment: DateTime | undefined;
    tags: TagDto[] | undefined;
    fileContributionInfos: FileContributionInfoDto[] | undefined;
    lastModifier: string | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: DateTime | undefined;
    creatorUserId: number;
    createdByModifier: string | undefined;
}

export class AttachmentsFilterRequest implements IAttachmentsFilterRequest {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    referenceId!: number;
    filter!: string | undefined;
    typeFilter!: string[] | undefined;
    tagsFilter!: string[] | undefined;
    createdByFilter!: number[] | undefined;

    constructor(data?: IAttachmentsFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.referenceId = _data["referenceId"];
            this.filter = _data["filter"];
            if (Array.isArray(_data["typeFilter"])) {
                this.typeFilter = [] as any;
                for (let item of _data["typeFilter"])
                    this.typeFilter!.push(item);
            }
            if (Array.isArray(_data["tagsFilter"])) {
                this.tagsFilter = [] as any;
                for (let item of _data["tagsFilter"])
                    this.tagsFilter!.push(item);
            }
            if (Array.isArray(_data["createdByFilter"])) {
                this.createdByFilter = [] as any;
                for (let item of _data["createdByFilter"])
                    this.createdByFilter!.push(item);
            }
        }
    }

    static fromJS(data: any): AttachmentsFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentsFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["referenceId"] = this.referenceId;
        data["filter"] = this.filter;
        if (Array.isArray(this.typeFilter)) {
            data["typeFilter"] = [];
            for (let item of this.typeFilter)
                data["typeFilter"].push(item);
        }
        if (Array.isArray(this.tagsFilter)) {
            data["tagsFilter"] = [];
            for (let item of this.tagsFilter)
                data["tagsFilter"].push(item);
        }
        if (Array.isArray(this.createdByFilter)) {
            data["createdByFilter"] = [];
            for (let item of this.createdByFilter)
                data["createdByFilter"].push(item);
        }
        return data;
    }
}

export interface IAttachmentsFilterRequest {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    referenceId: number;
    filter: string | undefined;
    typeFilter: string[] | undefined;
    tagsFilter: string[] | undefined;
    createdByFilter: number[] | undefined;
}

export class AuthorDto implements IAuthorDto {
    id!: number;
    text!: string | undefined;

    constructor(data?: IAuthorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): AuthorDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        return data;
    }
}

export interface IAuthorDto {
    id: number;
    text: string | undefined;
}

export enum BasisForAdjustmentsType {
    Article34 = 1,
    Article353 = 2,
    Article351a = 3,
    Article351b = 4,
    Article345 = 5,
    Article432a = 11,
    Article432b = 12,
    Article432c = 13,
    Article432d = 14,
    Article432e = 15,
    Article434 = 16,
    Article326 = 100,
    Article444 = 101,
    Article461 = 102,
    Article464 = 103,
    Article735 = 104,
    Article737 = 105,
}

export class BlendingCircleDto implements IBlendingCircleDto {
    id!: number | undefined;
    taxJurisdictionCountry!: string | undefined;
    subgroupType!: BlendingCircleSubgroupType;
    number!: number | undefined;
    isConfirmed!: boolean;

    constructor(data?: IBlendingCircleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taxJurisdictionCountry = _data["taxJurisdictionCountry"];
            this.subgroupType = _data["subgroupType"];
            this.number = _data["number"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): BlendingCircleDto {
        data = typeof data === 'object' ? data : {};
        let result = new BlendingCircleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taxJurisdictionCountry"] = this.taxJurisdictionCountry;
        data["subgroupType"] = this.subgroupType;
        data["number"] = this.number;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IBlendingCircleDto {
    id: number | undefined;
    taxJurisdictionCountry: string | undefined;
    subgroupType: BlendingCircleSubgroupType;
    number: number | undefined;
    isConfirmed: boolean;
}

export class BlendingCircleElectionInput implements IBlendingCircleElectionInput {
    id!: number;
    projectId!: number;
    electionType!: ElectionType;
    value!: boolean | undefined;
    year!: number | undefined;
    blendingCircleCountry!: string | undefined;
    blendingCircleSubgroupId!: number | undefined;

    constructor(data?: IBlendingCircleElectionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.electionType = _data["electionType"];
            this.value = _data["value"];
            this.year = _data["year"];
            this.blendingCircleCountry = _data["blendingCircleCountry"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
        }
    }

    static fromJS(data: any): BlendingCircleElectionInput {
        data = typeof data === 'object' ? data : {};
        let result = new BlendingCircleElectionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["electionType"] = this.electionType;
        data["value"] = this.value;
        data["year"] = this.year;
        data["blendingCircleCountry"] = this.blendingCircleCountry;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        return data;
    }
}

export interface IBlendingCircleElectionInput {
    id: number;
    projectId: number;
    electionType: ElectionType;
    value: boolean | undefined;
    year: number | undefined;
    blendingCircleCountry: string | undefined;
    blendingCircleSubgroupId: number | undefined;
}

export class BlendingCircleInput implements IBlendingCircleInput {
    id!: number | undefined;
    projectId!: number;
    taxJurisdictionCountry!: string | undefined;
    organizationalEntityId!: number;
    isConfirmed!: boolean;
    subgroupType!: BlendingCircleSubgroupType;
    number!: number | undefined;

    constructor(data?: IBlendingCircleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.taxJurisdictionCountry = _data["taxJurisdictionCountry"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.isConfirmed = _data["isConfirmed"];
            this.subgroupType = _data["subgroupType"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): BlendingCircleInput {
        data = typeof data === 'object' ? data : {};
        let result = new BlendingCircleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["taxJurisdictionCountry"] = this.taxJurisdictionCountry;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["isConfirmed"] = this.isConfirmed;
        data["subgroupType"] = this.subgroupType;
        data["number"] = this.number;
        return data;
    }
}

export interface IBlendingCircleInput {
    id: number | undefined;
    projectId: number;
    taxJurisdictionCountry: string | undefined;
    organizationalEntityId: number;
    isConfirmed: boolean;
    subgroupType: BlendingCircleSubgroupType;
    number: number | undefined;
}

export class BlendingCircleOverviewDto implements IBlendingCircleOverviewDto {
    taxJurisdictionCountry!: string | undefined;
    organizationalEntityId!: number;
    legalName!: string | undefined;
    entityNumber!: string | undefined;
    currency!: string | undefined;
    gloBEStatus!: string | undefined;
    blendingCircleSubgroup!: BlendingCircleDto;

    constructor(data?: IBlendingCircleOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxJurisdictionCountry = _data["taxJurisdictionCountry"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.legalName = _data["legalName"];
            this.entityNumber = _data["entityNumber"];
            this.currency = _data["currency"];
            this.gloBEStatus = _data["gloBEStatus"];
            this.blendingCircleSubgroup = _data["blendingCircleSubgroup"] ? BlendingCircleDto.fromJS(_data["blendingCircleSubgroup"]) : <any>undefined;
            }
        }

    static fromJS(data: any): BlendingCircleOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new BlendingCircleOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxJurisdictionCountry"] = this.taxJurisdictionCountry;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["legalName"] = this.legalName;
        data["entityNumber"] = this.entityNumber;
        data["currency"] = this.currency;
        data["gloBEStatus"] = this.gloBEStatus;
        data["blendingCircleSubgroup"] = this.blendingCircleSubgroup ? this.blendingCircleSubgroup.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBlendingCircleOverviewDto {
    taxJurisdictionCountry: string | undefined;
    organizationalEntityId: number;
    legalName: string | undefined;
    entityNumber: string | undefined;
    currency: string | undefined;
    gloBEStatus: string | undefined;
    blendingCircleSubgroup: BlendingCircleDto;
}

export class BlendingCircleReferenceDto implements IBlendingCircleReferenceDto {
    id!: string | undefined;
    text!: string | undefined;

    constructor(data?: IBlendingCircleReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): BlendingCircleReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new BlendingCircleReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        return data;
    }
}

export interface IBlendingCircleReferenceDto {
    id: string | undefined;
    text: string | undefined;
}

export class BlendingCircleReferenceSubgroupDto implements IBlendingCircleReferenceSubgroupDto {
    id!: number;
    text!: string | undefined;

    constructor(data?: IBlendingCircleReferenceSubgroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): BlendingCircleReferenceSubgroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new BlendingCircleReferenceSubgroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        return data;
    }
}

export interface IBlendingCircleReferenceSubgroupDto {
    id: number;
    text: string | undefined;
}

export class BlendingCircleRequestOverviewInput implements IBlendingCircleRequestOverviewInput {
    projectId!: number;

    constructor(data?: IBlendingCircleRequestOverviewInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): BlendingCircleRequestOverviewInput {
        data = typeof data === 'object' ? data : {};
        let result = new BlendingCircleRequestOverviewInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IBlendingCircleRequestOverviewInput {
    projectId: number;
}

export class BlendingCircleSubgroupDto implements IBlendingCircleSubgroupDto {
    id!: BlendingCircleSubgroupType;
    text!: string | undefined;
    number!: number | undefined;
    isDisabled!: boolean;

    constructor(data?: IBlendingCircleSubgroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.number = _data["number"];
            this.isDisabled = _data["isDisabled"];
        }
    }

    static fromJS(data: any): BlendingCircleSubgroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new BlendingCircleSubgroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["number"] = this.number;
        data["isDisabled"] = this.isDisabled;
        return data;
    }
}

export interface IBlendingCircleSubgroupDto {
    id: BlendingCircleSubgroupType;
    text: string | undefined;
    number: number | undefined;
    isDisabled: boolean;
}

export enum BlendingCircleSubgroupType {
    Standard = 1,
    InsuranceInvestment = 2,
    MinorityOwnedSubgroup = 3,
    MinorityOwnedConstituentEntity = 4,
    JointVenture = 5,
    Stateless = 6,
}

export class BulkChangeAccessRestrictionInput implements IBulkChangeAccessRestrictionInput {
    ids!: number[] | undefined;
    usersAndOrganizationUnits!: UserOrOrganizationUnitInput[] | undefined;

    constructor(data?: IBulkChangeAccessRestrictionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            if (Array.isArray(_data["usersAndOrganizationUnits"])) {
                this.usersAndOrganizationUnits = [] as any;
                for (let item of _data["usersAndOrganizationUnits"])
                    this.usersAndOrganizationUnits!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BulkChangeAccessRestrictionInput {
        data = typeof data === 'object' ? data : {};
        let result = new BulkChangeAccessRestrictionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        if (Array.isArray(this.usersAndOrganizationUnits)) {
            data["usersAndOrganizationUnits"] = [];
            for (let item of this.usersAndOrganizationUnits)
                data["usersAndOrganizationUnits"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBulkChangeAccessRestrictionInput {
    ids: number[] | undefined;
    usersAndOrganizationUnits: UserOrOrganizationUnitInput[] | undefined;
}

export class BulkDetailsDto implements IBulkDetailsDto {
    possible!: number;
    total!: number;

    constructor(data?: IBulkDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.possible = _data["possible"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): BulkDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["possible"] = this.possible;
        data["total"] = this.total;
        return data;
    }
}

export interface IBulkDetailsDto {
    possible: number;
    total: number;
}

export class BulkInput implements IBulkInput {
    ids!: number[] | undefined;

    constructor(data?: IBulkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): BulkInput {
        data = typeof data === 'object' ? data : {};
        let result = new BulkInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IBulkInput {
    ids: number[] | undefined;
}

export enum BulkProjectOperation {
    ChangeAccessRestriction = 4,
    Delete = 5,
}

export class BulkProjectOperationDetailsDto implements IBulkProjectOperationDetailsDto {
    bulkOperation!: BulkProjectOperation;
    bulkDetails!: BulkDetailsDto;

    constructor(data?: IBulkProjectOperationDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bulkOperation = _data["bulkOperation"];
            this.bulkDetails = _data["bulkDetails"] ? BulkDetailsDto.fromJS(_data["bulkDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BulkProjectOperationDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkProjectOperationDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bulkOperation"] = this.bulkOperation;
        data["bulkDetails"] = this.bulkDetails ? this.bulkDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBulkProjectOperationDetailsDto {
    bulkOperation: BulkProjectOperation;
    bulkDetails: BulkDetailsDto;
}

export class BulkSetEntityControllingInterestsInput implements IBulkSetEntityControllingInterestsInput {
    ids!: number[] | undefined;
    projectId!: number;
    overwriteAll!: boolean;

    constructor(data?: IBulkSetEntityControllingInterestsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.projectId = _data["projectId"];
            this.overwriteAll = _data["overwriteAll"];
        }
    }

    static fromJS(data: any): BulkSetEntityControllingInterestsInput {
        data = typeof data === 'object' ? data : {};
        let result = new BulkSetEntityControllingInterestsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["projectId"] = this.projectId;
        data["overwriteAll"] = this.overwriteAll;
        return data;
    }
}

export interface IBulkSetEntityControllingInterestsInput {
    ids: number[] | undefined;
    projectId: number;
    overwriteAll: boolean;
}

export class BulkSetSuggestedBlendingCircleSubgroupsInput implements IBulkSetSuggestedBlendingCircleSubgroupsInput {
    ids!: number[] | undefined;
    projectId!: number;
    overwriteExisting!: boolean;
    confirmSuggested!: boolean;

    constructor(data?: IBulkSetSuggestedBlendingCircleSubgroupsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.projectId = _data["projectId"];
            this.overwriteExisting = _data["overwriteExisting"];
            this.confirmSuggested = _data["confirmSuggested"];
        }
    }

    static fromJS(data: any): BulkSetSuggestedBlendingCircleSubgroupsInput {
        data = typeof data === 'object' ? data : {};
        let result = new BulkSetSuggestedBlendingCircleSubgroupsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["projectId"] = this.projectId;
        data["overwriteExisting"] = this.overwriteExisting;
        data["confirmSuggested"] = this.confirmSuggested;
        return data;
    }
}

export interface IBulkSetSuggestedBlendingCircleSubgroupsInput {
    ids: number[] | undefined;
    projectId: number;
    overwriteExisting: boolean;
    confirmSuggested: boolean;
}

export class BulkUpdateAccessManagementInput implements IBulkUpdateAccessManagementInput {
    projectId!: number;
    isReadingActivated!: boolean;
    readingCountryCodeInherited!: string | undefined;
    readingUsersAndOrganizationUnits!: UserOrOrganizationUnitInput[] | undefined;
    isWritingActivated!: boolean;
    writingCountryCodeInherited!: string | undefined;
    writingUsersAndOrganizationUnits!: UserOrOrganizationUnitInput[] | undefined;
    organizationalEntityIds!: number[] | undefined;
    countryCodes!: string[] | undefined;

    constructor(data?: IBulkUpdateAccessManagementInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.isReadingActivated = _data["isReadingActivated"];
            this.readingCountryCodeInherited = _data["readingCountryCodeInherited"];
            if (Array.isArray(_data["readingUsersAndOrganizationUnits"])) {
                this.readingUsersAndOrganizationUnits = [] as any;
                for (let item of _data["readingUsersAndOrganizationUnits"])
                    this.readingUsersAndOrganizationUnits!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
            this.isWritingActivated = _data["isWritingActivated"];
            this.writingCountryCodeInherited = _data["writingCountryCodeInherited"];
            if (Array.isArray(_data["writingUsersAndOrganizationUnits"])) {
                this.writingUsersAndOrganizationUnits = [] as any;
                for (let item of _data["writingUsersAndOrganizationUnits"])
                    this.writingUsersAndOrganizationUnits!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
            if (Array.isArray(_data["organizationalEntityIds"])) {
                this.organizationalEntityIds = [] as any;
                for (let item of _data["organizationalEntityIds"])
                    this.organizationalEntityIds!.push(item);
            }
            if (Array.isArray(_data["countryCodes"])) {
                this.countryCodes = [] as any;
                for (let item of _data["countryCodes"])
                    this.countryCodes!.push(item);
            }
        }
    }

    static fromJS(data: any): BulkUpdateAccessManagementInput {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUpdateAccessManagementInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["isReadingActivated"] = this.isReadingActivated;
        data["readingCountryCodeInherited"] = this.readingCountryCodeInherited;
        if (Array.isArray(this.readingUsersAndOrganizationUnits)) {
            data["readingUsersAndOrganizationUnits"] = [];
            for (let item of this.readingUsersAndOrganizationUnits)
                data["readingUsersAndOrganizationUnits"].push(item.toJSON());
        }
        data["isWritingActivated"] = this.isWritingActivated;
        data["writingCountryCodeInherited"] = this.writingCountryCodeInherited;
        if (Array.isArray(this.writingUsersAndOrganizationUnits)) {
            data["writingUsersAndOrganizationUnits"] = [];
            for (let item of this.writingUsersAndOrganizationUnits)
                data["writingUsersAndOrganizationUnits"].push(item.toJSON());
        }
        if (Array.isArray(this.organizationalEntityIds)) {
            data["organizationalEntityIds"] = [];
            for (let item of this.organizationalEntityIds)
                data["organizationalEntityIds"].push(item);
        }
        if (Array.isArray(this.countryCodes)) {
            data["countryCodes"] = [];
            for (let item of this.countryCodes)
                data["countryCodes"].push(item);
        }
        return data;
    }
}

export interface IBulkUpdateAccessManagementInput {
    projectId: number;
    isReadingActivated: boolean;
    readingCountryCodeInherited: string | undefined;
    readingUsersAndOrganizationUnits: UserOrOrganizationUnitInput[] | undefined;
    isWritingActivated: boolean;
    writingCountryCodeInherited: string | undefined;
    writingUsersAndOrganizationUnits: UserOrOrganizationUnitInput[] | undefined;
    organizationalEntityIds: number[] | undefined;
    countryCodes: string[] | undefined;
}

export class BulkUpdateFinancialValuePointInput implements IBulkUpdateFinancialValuePointInput {
    projectId!: number;
    safeHarbourGroupId!: number | undefined;
    safeHarbourGroupType!: SafeHarbourGroupType;
    blendingCircleSubgroupCountryName!: string | undefined;
    blendingCircleSubgroupId!: number | undefined;
    organizationalEntityId!: number | undefined;
    comment!: string | undefined;
    isConfirmed!: boolean;
    traces!: FinancialValuePointWithFlatValueInput[] | undefined;

    constructor(data?: IBulkUpdateFinancialValuePointInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.safeHarbourGroupId = _data["safeHarbourGroupId"];
            this.safeHarbourGroupType = _data["safeHarbourGroupType"];
            this.blendingCircleSubgroupCountryName = _data["blendingCircleSubgroupCountryName"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.comment = _data["comment"];
            this.isConfirmed = _data["isConfirmed"];
            if (Array.isArray(_data["traces"])) {
                this.traces = [] as any;
                for (let item of _data["traces"])
                    this.traces!.push(FinancialValuePointWithFlatValueInput.fromJS(item));
        }
    }
    }

    static fromJS(data: any): BulkUpdateFinancialValuePointInput {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUpdateFinancialValuePointInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["safeHarbourGroupId"] = this.safeHarbourGroupId;
        data["safeHarbourGroupType"] = this.safeHarbourGroupType;
        data["blendingCircleSubgroupCountryName"] = this.blendingCircleSubgroupCountryName;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["comment"] = this.comment;
        data["isConfirmed"] = this.isConfirmed;
        if (Array.isArray(this.traces)) {
            data["traces"] = [];
            for (let item of this.traces)
                data["traces"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBulkUpdateFinancialValuePointInput {
    projectId: number;
    safeHarbourGroupId: number | undefined;
    safeHarbourGroupType: SafeHarbourGroupType;
    blendingCircleSubgroupCountryName: string | undefined;
    blendingCircleSubgroupId: number | undefined;
    organizationalEntityId: number | undefined;
    comment: string | undefined;
    isConfirmed: boolean;
    traces: FinancialValuePointWithFlatValueInput[] | undefined;
}

export class CalculateFinalFiscalYearAverageShiftDataInput implements ICalculateFinalFiscalYearAverageShiftDataInput {
    projectId!: number;
    organizationalEntityId!: number;
    targetOrganizationalEntityId!: number | undefined;
    pointId!: number | undefined;
    financialType!: FinancialShiftType;
    fiscalYearBeginning!: string | undefined;
    fiscalYearEnd!: string | undefined;

    constructor(data?: ICalculateFinalFiscalYearAverageShiftDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.targetOrganizationalEntityId = _data["targetOrganizationalEntityId"];
            this.pointId = _data["pointId"];
            this.financialType = _data["financialType"];
            this.fiscalYearBeginning = _data["fiscalYearBeginning"];
            this.fiscalYearEnd = _data["fiscalYearEnd"];
        }
    }

    static fromJS(data: any): CalculateFinalFiscalYearAverageShiftDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateFinalFiscalYearAverageShiftDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["targetOrganizationalEntityId"] = this.targetOrganizationalEntityId;
        data["pointId"] = this.pointId;
        data["financialType"] = this.financialType;
        data["fiscalYearBeginning"] = this.fiscalYearBeginning;
        data["fiscalYearEnd"] = this.fiscalYearEnd;
        return data;
    }
}

export interface ICalculateFinalFiscalYearAverageShiftDataInput {
    projectId: number;
    organizationalEntityId: number;
    targetOrganizationalEntityId: number | undefined;
    pointId: number | undefined;
    financialType: FinancialShiftType;
    fiscalYearBeginning: string | undefined;
    fiscalYearEnd: string | undefined;
}

export class CalculateFinalFiscalYearAverageValueDataInput implements ICalculateFinalFiscalYearAverageValueDataInput {
    projectId!: number;
    organizationalEntityId!: number;
    pointId!: number | undefined;
    financialType!: FinancialValueType;
    fiscalYearBeginning!: string | undefined;
    fiscalYearEnd!: string | undefined;
    percentageRateOfLocationTimeInJurisdiction!: string | undefined;

    constructor(data?: ICalculateFinalFiscalYearAverageValueDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.pointId = _data["pointId"];
            this.financialType = _data["financialType"];
            this.fiscalYearBeginning = _data["fiscalYearBeginning"];
            this.fiscalYearEnd = _data["fiscalYearEnd"];
            this.percentageRateOfLocationTimeInJurisdiction = _data["percentageRateOfLocationTimeInJurisdiction"];
        }
    }

    static fromJS(data: any): CalculateFinalFiscalYearAverageValueDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateFinalFiscalYearAverageValueDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["pointId"] = this.pointId;
        data["financialType"] = this.financialType;
        data["fiscalYearBeginning"] = this.fiscalYearBeginning;
        data["fiscalYearEnd"] = this.fiscalYearEnd;
        data["percentageRateOfLocationTimeInJurisdiction"] = this.percentageRateOfLocationTimeInJurisdiction;
        return data;
    }
}

export interface ICalculateFinalFiscalYearAverageValueDataInput {
    projectId: number;
    organizationalEntityId: number;
    pointId: number | undefined;
    financialType: FinancialValueType;
    fiscalYearBeginning: string | undefined;
    fiscalYearEnd: string | undefined;
    percentageRateOfLocationTimeInJurisdiction: string | undefined;
}

export class ChancelleryClientDto implements IChancelleryClientDto {
    clientNumber!: string | undefined;
    clientName!: string | undefined;

    constructor(data?: IChancelleryClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientNumber = _data["clientNumber"];
            this.clientName = _data["clientName"];
        }
    }

    static fromJS(data: any): ChancelleryClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChancelleryClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientNumber"] = this.clientNumber;
        data["clientName"] = this.clientName;
        return data;
    }
}

export interface IChancelleryClientDto {
    clientNumber: string | undefined;
    clientName: string | undefined;
}

export class ChancelleryDetailsDto implements IChancelleryDetailsDto {
    clientNumber!: string | undefined;
    clientName!: string | undefined;
    projectNumber!: string | undefined;
    projectName!: string | undefined;

    constructor(data?: IChancelleryDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientNumber = _data["clientNumber"];
            this.clientName = _data["clientName"];
            this.projectNumber = _data["projectNumber"];
            this.projectName = _data["projectName"];
        }
    }

    static fromJS(data: any): ChancelleryDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChancelleryDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientNumber"] = this.clientNumber;
        data["clientName"] = this.clientName;
        data["projectNumber"] = this.projectNumber;
        data["projectName"] = this.projectName;
        return data;
    }
}

export interface IChancelleryDetailsDto {
    clientNumber: string | undefined;
    clientName: string | undefined;
    projectNumber: string | undefined;
    projectName: string | undefined;
}

export class ChancelleryDetailsInput implements IChancelleryDetailsInput {
    clientNumber!: string | undefined;
    clientName!: string | undefined;
    projectNumber!: string | undefined;
    projectName!: string | undefined;

    constructor(data?: IChancelleryDetailsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientNumber = _data["clientNumber"];
            this.clientName = _data["clientName"];
            this.projectNumber = _data["projectNumber"];
            this.projectName = _data["projectName"];
        }
    }

    static fromJS(data: any): ChancelleryDetailsInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChancelleryDetailsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientNumber"] = this.clientNumber;
        data["clientName"] = this.clientName;
        data["projectNumber"] = this.projectNumber;
        data["projectName"] = this.projectName;
        return data;
    }
}

export interface IChancelleryDetailsInput {
    clientNumber: string | undefined;
    clientName: string | undefined;
    projectNumber: string | undefined;
    projectName: string | undefined;
}

export class ChancelleryProjectDto implements IChancelleryProjectDto {
    projectNumber!: string | undefined;
    projectName!: string | undefined;

    constructor(data?: IChancelleryProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectNumber = _data["projectNumber"];
            this.projectName = _data["projectName"];
        }
    }

    static fromJS(data: any): ChancelleryProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChancelleryProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectNumber"] = this.projectNumber;
        data["projectName"] = this.projectName;
        return data;
    }
}

export interface IChancelleryProjectDto {
    projectNumber: string | undefined;
    projectName: string | undefined;
}

export class ChancelleryViewAdminSettings implements IChancelleryViewAdminSettings {
    isChancelleryViewActive!: boolean;
    chancelleryViewClientsEndpointUrl!: string | undefined;
    chancelleryViewProjectsEndpointUrl!: string | undefined;
    chancelleryViewUsername!: string | undefined;
    chancelleryViewPassword!: string | undefined;
    chancelleryViewIsClientRequired!: boolean;
    chancelleryViewIsProjectRequired!: boolean;

    constructor(data?: IChancelleryViewAdminSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isChancelleryViewActive = _data["isChancelleryViewActive"];
            this.chancelleryViewClientsEndpointUrl = _data["chancelleryViewClientsEndpointUrl"];
            this.chancelleryViewProjectsEndpointUrl = _data["chancelleryViewProjectsEndpointUrl"];
            this.chancelleryViewUsername = _data["chancelleryViewUsername"];
            this.chancelleryViewPassword = _data["chancelleryViewPassword"];
            this.chancelleryViewIsClientRequired = _data["chancelleryViewIsClientRequired"];
            this.chancelleryViewIsProjectRequired = _data["chancelleryViewIsProjectRequired"];
        }
    }

    static fromJS(data: any): ChancelleryViewAdminSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ChancelleryViewAdminSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isChancelleryViewActive"] = this.isChancelleryViewActive;
        data["chancelleryViewClientsEndpointUrl"] = this.chancelleryViewClientsEndpointUrl;
        data["chancelleryViewProjectsEndpointUrl"] = this.chancelleryViewProjectsEndpointUrl;
        data["chancelleryViewUsername"] = this.chancelleryViewUsername;
        data["chancelleryViewPassword"] = this.chancelleryViewPassword;
        data["chancelleryViewIsClientRequired"] = this.chancelleryViewIsClientRequired;
        data["chancelleryViewIsProjectRequired"] = this.chancelleryViewIsProjectRequired;
        return data;
    }
}

export interface IChancelleryViewAdminSettings {
    isChancelleryViewActive: boolean;
    chancelleryViewClientsEndpointUrl: string | undefined;
    chancelleryViewProjectsEndpointUrl: string | undefined;
    chancelleryViewUsername: string | undefined;
    chancelleryViewPassword: string | undefined;
    chancelleryViewIsClientRequired: boolean;
    chancelleryViewIsProjectRequired: boolean;
}

export class ChannelOverviewDto implements IChannelOverviewDto {
    id!: number;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    title!: string | undefined;
    isRead!: boolean;

    constructor(data?: IChannelOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.isRead = _data["isRead"];
        }
    }

    static fromJS(data: any): ChannelOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["title"] = this.title;
        data["isRead"] = this.isRead;
        return data;
    }
}

export interface IChannelOverviewDto {
    id: number;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    title: string | undefined;
    isRead: boolean;
}

export enum CheckResultStatus {
    Passed = 0,
    Failed = 1,
    NotComputable = 2,
    NotRequired = 3,
}

export class CommunicationDto implements ICommunicationDto {
    id!: number;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    referenceId!: number;
    content!: string | undefined;
    hasOriginalMailSourceCode!: boolean;
    userDetails!: UserDetailsDto[] | undefined;

    constructor(data?: ICommunicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.referenceId = _data["referenceId"];
            this.content = _data["content"];
            this.hasOriginalMailSourceCode = _data["hasOriginalMailSourceCode"];
            if (Array.isArray(_data["userDetails"])) {
                this.userDetails = [] as any;
                for (let item of _data["userDetails"])
                    this.userDetails!.push(UserDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommunicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["referenceId"] = this.referenceId;
        data["content"] = this.content;
        data["hasOriginalMailSourceCode"] = this.hasOriginalMailSourceCode;
        if (Array.isArray(this.userDetails)) {
            data["userDetails"] = [];
            for (let item of this.userDetails)
                data["userDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICommunicationDto {
    id: number;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    referenceId: number;
    content: string | undefined;
    hasOriginalMailSourceCode: boolean;
    userDetails: UserDetailsDto[] | undefined;
}

export class CommunicationsFilterRequest implements ICommunicationsFilterRequest {
    referenceId!: number;
    filter!: string | undefined;

    constructor(data?: ICommunicationsFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceId = _data["referenceId"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): CommunicationsFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationsFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceId"] = this.referenceId;
        data["filter"] = this.filter;
        return data;
    }
}

export interface ICommunicationsFilterRequest {
    referenceId: number;
    filter: string | undefined;
}

export class ConfirmableDtoOfFinancialValueDto implements IConfirmableDtoOfFinancialValueDto {
    value!: FinancialValueDto;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableDtoOfFinancialValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? FinancialValueDto.fromJS(_data["value"]) : <any>undefined;
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableDtoOfFinancialValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableDtoOfFinancialValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableDtoOfFinancialValueDto {
    value: FinancialValueDto;
    isConfirmed: boolean;
}

export class ConfirmableDtoOfIListOfGloBEStatus implements IConfirmableDtoOfIListOfGloBEStatus {
    value!: GloBEStatus[] | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableDtoOfIListOfGloBEStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableDtoOfIListOfGloBEStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableDtoOfIListOfGloBEStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableDtoOfIListOfGloBEStatus {
    value: GloBEStatus[] | undefined;
    isConfirmed: boolean;
}

export class ConfirmableDtoOfInt32 implements IConfirmableDtoOfInt32 {
    value!: number;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableDtoOfInt32) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableDtoOfInt32 {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableDtoOfInt32();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableDtoOfInt32 {
    value: number;
    isConfirmed: boolean;
}

export class ConfirmableDtoOfInt64 implements IConfirmableDtoOfInt64 {
    value!: number;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableDtoOfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableDtoOfInt64 {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableDtoOfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableDtoOfInt64 {
    value: number;
    isConfirmed: boolean;
}

export class ConfirmableDtoOfNullableOfBoolean implements IConfirmableDtoOfNullableOfBoolean {
    value!: boolean | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableDtoOfNullableOfBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableDtoOfNullableOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableDtoOfNullableOfBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableDtoOfNullableOfBoolean {
    value: boolean | undefined;
    isConfirmed: boolean;
}

export class ConfirmableDtoOfNullableOfConsolidationMethod implements IConfirmableDtoOfNullableOfConsolidationMethod {
    value!: ConsolidationMethod;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableDtoOfNullableOfConsolidationMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableDtoOfNullableOfConsolidationMethod {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableDtoOfNullableOfConsolidationMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableDtoOfNullableOfConsolidationMethod {
    value: ConsolidationMethod;
    isConfirmed: boolean;
}

export class ConfirmableDtoOfNullableOfFinancialAccountingStandard implements IConfirmableDtoOfNullableOfFinancialAccountingStandard {
    value!: FinancialAccountingStandard;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableDtoOfNullableOfFinancialAccountingStandard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableDtoOfNullableOfFinancialAccountingStandard {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableDtoOfNullableOfFinancialAccountingStandard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableDtoOfNullableOfFinancialAccountingStandard {
    value: FinancialAccountingStandard;
    isConfirmed: boolean;
}

export class ConfirmableDtoOfNullableOfInt64 implements IConfirmableDtoOfNullableOfInt64 {
    value!: number | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableDtoOfNullableOfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableDtoOfNullableOfInt64 {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableDtoOfNullableOfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableDtoOfNullableOfInt64 {
    value: number | undefined;
    isConfirmed: boolean;
}

export class ConfirmableDtoOfNullableOfInvestmentElectionType implements IConfirmableDtoOfNullableOfInvestmentElectionType {
    value!: InvestmentElectionType;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableDtoOfNullableOfInvestmentElectionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableDtoOfNullableOfInvestmentElectionType {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableDtoOfNullableOfInvestmentElectionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableDtoOfNullableOfInvestmentElectionType {
    value: InvestmentElectionType;
    isConfirmed: boolean;
}

export class ConfirmableDtoOfNullableOfTaxTreatment implements IConfirmableDtoOfNullableOfTaxTreatment {
    value!: TaxTreatment;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableDtoOfNullableOfTaxTreatment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableDtoOfNullableOfTaxTreatment {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableDtoOfNullableOfTaxTreatment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableDtoOfNullableOfTaxTreatment {
    value: TaxTreatment;
    isConfirmed: boolean;
}

export class ConfirmableDtoOfString implements IConfirmableDtoOfString {
    value!: string | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableDtoOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableDtoOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableDtoOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableDtoOfString {
    value: string | undefined;
    isConfirmed: boolean;
}

export class ConfirmableInputOfIListOfGloBEStatus implements IConfirmableInputOfIListOfGloBEStatus {
    value!: GloBEStatus[] | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableInputOfIListOfGloBEStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableInputOfIListOfGloBEStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableInputOfIListOfGloBEStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableInputOfIListOfGloBEStatus {
    value: GloBEStatus[] | undefined;
    isConfirmed: boolean;
}

export class ConfirmableInputOfInt32 implements IConfirmableInputOfInt32 {
    value!: number;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableInputOfInt32) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableInputOfInt32 {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableInputOfInt32();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableInputOfInt32 {
    value: number;
    isConfirmed: boolean;
}

export class ConfirmableInputOfInt64 implements IConfirmableInputOfInt64 {
    value!: number;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableInputOfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableInputOfInt64 {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableInputOfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableInputOfInt64 {
    value: number;
    isConfirmed: boolean;
}

export class ConfirmableInputOfNullableOfBoolean implements IConfirmableInputOfNullableOfBoolean {
    value!: boolean | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableInputOfNullableOfBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableInputOfNullableOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableInputOfNullableOfBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableInputOfNullableOfBoolean {
    value: boolean | undefined;
    isConfirmed: boolean;
}

export class ConfirmableInputOfNullableOfConsolidationMethod implements IConfirmableInputOfNullableOfConsolidationMethod {
    value!: ConsolidationMethod;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableInputOfNullableOfConsolidationMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableInputOfNullableOfConsolidationMethod {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableInputOfNullableOfConsolidationMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableInputOfNullableOfConsolidationMethod {
    value: ConsolidationMethod;
    isConfirmed: boolean;
}

export class ConfirmableInputOfNullableOfFinancialAccountingStandard implements IConfirmableInputOfNullableOfFinancialAccountingStandard {
    value!: FinancialAccountingStandard;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableInputOfNullableOfFinancialAccountingStandard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableInputOfNullableOfFinancialAccountingStandard {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableInputOfNullableOfFinancialAccountingStandard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableInputOfNullableOfFinancialAccountingStandard {
    value: FinancialAccountingStandard;
    isConfirmed: boolean;
}

export class ConfirmableInputOfNullableOfInt64 implements IConfirmableInputOfNullableOfInt64 {
    value!: number | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableInputOfNullableOfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableInputOfNullableOfInt64 {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableInputOfNullableOfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableInputOfNullableOfInt64 {
    value: number | undefined;
    isConfirmed: boolean;
}

export class ConfirmableInputOfNullableOfInvestmentElectionType implements IConfirmableInputOfNullableOfInvestmentElectionType {
    value!: InvestmentElectionType;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableInputOfNullableOfInvestmentElectionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableInputOfNullableOfInvestmentElectionType {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableInputOfNullableOfInvestmentElectionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableInputOfNullableOfInvestmentElectionType {
    value: InvestmentElectionType;
    isConfirmed: boolean;
}

export class ConfirmableInputOfNullableOfTaxTreatment implements IConfirmableInputOfNullableOfTaxTreatment {
    value!: TaxTreatment;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableInputOfNullableOfTaxTreatment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableInputOfNullableOfTaxTreatment {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableInputOfNullableOfTaxTreatment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableInputOfNullableOfTaxTreatment {
    value: TaxTreatment;
    isConfirmed: boolean;
}

export class ConfirmableInputOfString implements IConfirmableInputOfString {
    value!: string | undefined;
    isConfirmed!: boolean;

    constructor(data?: IConfirmableInputOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): ConfirmableInputOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmableInputOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IConfirmableInputOfString {
    value: string | undefined;
    isConfirmed: boolean;
}

export enum ConsolidationMethod {
    ConsolidatingEntity = 1,
    FullConsolidation = 2,
    Proportionate = 3,
    AtEquity = 4,
    NotConsolidatedDueToMateriality = 5,
    NotConsolidatedGeneral = 6,
    NotConsolidatedHeldForSale = 7,
}

export class CreateAttachmentInput implements ICreateAttachmentInput {
    note!: string | undefined;
    dateOfAttachment!: DateTime | undefined;
    tags!: TagDto[] | undefined;
    referenceId!: number;
    type!: string;
    fileToken!: string | undefined;
    url!: string | undefined;

    constructor(data?: ICreateAttachmentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.note = _data["note"];
            this.dateOfAttachment = _data["dateOfAttachment"] ? DateTime.fromISO(_data["dateOfAttachment"].toString()) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            this.referenceId = _data["referenceId"];
            this.type = _data["type"];
            this.fileToken = _data["fileToken"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): CreateAttachmentInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAttachmentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note;
        data["dateOfAttachment"] = this.dateOfAttachment ? this.dateOfAttachment.toString() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["referenceId"] = this.referenceId;
        data["type"] = this.type;
        data["fileToken"] = this.fileToken;
        data["url"] = this.url;
        return data;
    }
}

export interface ICreateAttachmentInput {
    note: string | undefined;
    dateOfAttachment: DateTime | undefined;
    tags: TagDto[] | undefined;
    referenceId: number;
    type: string;
    fileToken: string | undefined;
    url: string | undefined;
}

export class CreateChannelInput implements ICreateChannelInput {
    referenceId!: number;
    title!: string | undefined;

    constructor(data?: ICreateChannelInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceId = _data["referenceId"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): CreateChannelInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateChannelInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceId"] = this.referenceId;
        data["title"] = this.title;
        return data;
    }
}

export interface ICreateChannelInput {
    referenceId: number;
    title: string | undefined;
}

export class CreateCommunicationInput implements ICreateCommunicationInput {
    content!: string | undefined;
    referenceId!: number;

    constructor(data?: ICreateCommunicationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"];
            this.referenceId = _data["referenceId"];
        }
    }

    static fromJS(data: any): CreateCommunicationInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCommunicationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["referenceId"] = this.referenceId;
        return data;
    }
}

export interface ICreateCommunicationInput {
    content: string | undefined;
    referenceId: number;
}

export class CreateFinancialShiftInput implements ICreateFinancialShiftInput {
    projectId!: number;
    value!: string | undefined;
    comment!: string | undefined;
    isConfirmed!: boolean;
    financialShiftType!: FinancialShiftType;
    targetOrganizationalEntityId!: number | undefined;
    basisForAdjustments!: BasisForAdjustmentsType;
    maxTaxRateOfMainEntityJurisdiction!: string | undefined;
    passiveIncomeOfCEOrHybridEntity!: string | undefined;
    fiscalYearBeginning!: string | undefined;
    fiscalYearEnd!: string | undefined;
    sourceOrganizationalEntityId!: number;

    constructor(data?: ICreateFinancialShiftInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.value = _data["value"];
            this.comment = _data["comment"];
            this.isConfirmed = _data["isConfirmed"];
            this.financialShiftType = _data["financialShiftType"];
            this.targetOrganizationalEntityId = _data["targetOrganizationalEntityId"];
            this.basisForAdjustments = _data["basisForAdjustments"];
            this.maxTaxRateOfMainEntityJurisdiction = _data["maxTaxRateOfMainEntityJurisdiction"];
            this.passiveIncomeOfCEOrHybridEntity = _data["passiveIncomeOfCEOrHybridEntity"];
            this.fiscalYearBeginning = _data["fiscalYearBeginning"];
            this.fiscalYearEnd = _data["fiscalYearEnd"];
            this.sourceOrganizationalEntityId = _data["sourceOrganizationalEntityId"];
        }
    }

    static fromJS(data: any): CreateFinancialShiftInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFinancialShiftInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["value"] = this.value;
        data["comment"] = this.comment;
        data["isConfirmed"] = this.isConfirmed;
        data["financialShiftType"] = this.financialShiftType;
        data["targetOrganizationalEntityId"] = this.targetOrganizationalEntityId;
        data["basisForAdjustments"] = this.basisForAdjustments;
        data["maxTaxRateOfMainEntityJurisdiction"] = this.maxTaxRateOfMainEntityJurisdiction;
        data["passiveIncomeOfCEOrHybridEntity"] = this.passiveIncomeOfCEOrHybridEntity;
        data["fiscalYearBeginning"] = this.fiscalYearBeginning;
        data["fiscalYearEnd"] = this.fiscalYearEnd;
        data["sourceOrganizationalEntityId"] = this.sourceOrganizationalEntityId;
        return data;
    }
}

export interface ICreateFinancialShiftInput {
    projectId: number;
    value: string | undefined;
    comment: string | undefined;
    isConfirmed: boolean;
    financialShiftType: FinancialShiftType;
    targetOrganizationalEntityId: number | undefined;
    basisForAdjustments: BasisForAdjustmentsType;
    maxTaxRateOfMainEntityJurisdiction: string | undefined;
    passiveIncomeOfCEOrHybridEntity: string | undefined;
    fiscalYearBeginning: string | undefined;
    fiscalYearEnd: string | undefined;
    sourceOrganizationalEntityId: number;
}

export class CreateFinancialValueInput implements ICreateFinancialValueInput {
    projectId!: number;
    organizationalEntityId!: number | undefined;
    blendingCircleSubgroupId!: number | undefined;
    financialValueType!: FinancialValueType;
    value!: string | undefined;
    isConfirmed!: boolean;
    comment!: string | undefined;
    financialYear!: FinancialYearType;
    lossCarryBack!: string | undefined;
    domesticTaxRate!: string | undefined;
    nonEligibleEmployeeCostsPreliminary!: string | undefined;
    percentageRateWorkingTimeInJurisdiction!: number | undefined;
    percentageRateOfLocationTimeInJurisdiction!: number | undefined;
    fiscalYearBeginning!: string | undefined;
    fiscalYearEnd!: string | undefined;
    financialNodeGroupType!: FinancialNodeGroupType;
    multipleNodeGroupId!: number | undefined;
    financialValueTracePointAdditionalInput!: UpdateFinancialValueTracePointAdditionalInput;

    constructor(data?: ICreateFinancialValueInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.financialValueType = _data["financialValueType"];
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
            this.comment = _data["comment"];
            this.financialYear = _data["financialYear"];
            this.lossCarryBack = _data["lossCarryBack"];
            this.domesticTaxRate = _data["domesticTaxRate"];
            this.nonEligibleEmployeeCostsPreliminary = _data["nonEligibleEmployeeCostsPreliminary"];
            this.percentageRateWorkingTimeInJurisdiction = _data["percentageRateWorkingTimeInJurisdiction"];
            this.percentageRateOfLocationTimeInJurisdiction = _data["percentageRateOfLocationTimeInJurisdiction"];
            this.fiscalYearBeginning = _data["fiscalYearBeginning"];
            this.fiscalYearEnd = _data["fiscalYearEnd"];
            this.financialNodeGroupType = _data["financialNodeGroupType"];
            this.multipleNodeGroupId = _data["multipleNodeGroupId"];
            this.financialValueTracePointAdditionalInput = _data["financialValueTracePointAdditionalInput"] ? UpdateFinancialValueTracePointAdditionalInput.fromJS(_data["financialValueTracePointAdditionalInput"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateFinancialValueInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFinancialValueInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["financialValueType"] = this.financialValueType;
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        data["comment"] = this.comment;
        data["financialYear"] = this.financialYear;
        data["lossCarryBack"] = this.lossCarryBack;
        data["domesticTaxRate"] = this.domesticTaxRate;
        data["nonEligibleEmployeeCostsPreliminary"] = this.nonEligibleEmployeeCostsPreliminary;
        data["percentageRateWorkingTimeInJurisdiction"] = this.percentageRateWorkingTimeInJurisdiction;
        data["percentageRateOfLocationTimeInJurisdiction"] = this.percentageRateOfLocationTimeInJurisdiction;
        data["fiscalYearBeginning"] = this.fiscalYearBeginning;
        data["fiscalYearEnd"] = this.fiscalYearEnd;
        data["financialNodeGroupType"] = this.financialNodeGroupType;
        data["multipleNodeGroupId"] = this.multipleNodeGroupId;
        data["financialValueTracePointAdditionalInput"] = this.financialValueTracePointAdditionalInput ? this.financialValueTracePointAdditionalInput.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateFinancialValueInput {
    projectId: number;
    organizationalEntityId: number | undefined;
    blendingCircleSubgroupId: number | undefined;
    financialValueType: FinancialValueType;
    value: string | undefined;
    isConfirmed: boolean;
    comment: string | undefined;
    financialYear: FinancialYearType;
    lossCarryBack: string | undefined;
    domesticTaxRate: string | undefined;
    nonEligibleEmployeeCostsPreliminary: string | undefined;
    percentageRateWorkingTimeInJurisdiction: number | undefined;
    percentageRateOfLocationTimeInJurisdiction: number | undefined;
    fiscalYearBeginning: string | undefined;
    fiscalYearEnd: string | undefined;
    financialNodeGroupType: FinancialNodeGroupType;
    multipleNodeGroupId: number | undefined;
    financialValueTracePointAdditionalInput: UpdateFinancialValueTracePointAdditionalInput;
}

export class CreateFinancialValuePointOrganizationalEntityInput implements ICreateFinancialValuePointOrganizationalEntityInput {
    projectId!: number;
    financialType!: FinancialType;
    comment!: string | undefined;
    organizationalEntityId!: number;

    constructor(data?: ICreateFinancialValuePointOrganizationalEntityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.financialType = _data["financialType"];
            this.comment = _data["comment"];
            this.organizationalEntityId = _data["organizationalEntityId"];
        }
    }

    static fromJS(data: any): CreateFinancialValuePointOrganizationalEntityInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFinancialValuePointOrganizationalEntityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["financialType"] = this.financialType;
        data["comment"] = this.comment;
        data["organizationalEntityId"] = this.organizationalEntityId;
        return data;
    }
}

export interface ICreateFinancialValuePointOrganizationalEntityInput {
    projectId: number;
    financialType: FinancialType;
    comment: string | undefined;
    organizationalEntityId: number;
}

export class CreateFinancialValuePointSafeHarbourGroupInput implements ICreateFinancialValuePointSafeHarbourGroupInput {
    projectId!: number;
    financialType!: FinancialType;
    comment!: string | undefined;
    blendingCircleCountry!: string | undefined;
    blendingCircleSubgroupId!: number | undefined;
    safeHarbourGroupId!: number | undefined;
    safeHarbourGroupType!: SafeHarbourGroupType;

    constructor(data?: ICreateFinancialValuePointSafeHarbourGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.financialType = _data["financialType"];
            this.comment = _data["comment"];
            this.blendingCircleCountry = _data["blendingCircleCountry"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.safeHarbourGroupId = _data["safeHarbourGroupId"];
            this.safeHarbourGroupType = _data["safeHarbourGroupType"];
        }
    }

    static fromJS(data: any): CreateFinancialValuePointSafeHarbourGroupInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFinancialValuePointSafeHarbourGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["financialType"] = this.financialType;
        data["comment"] = this.comment;
        data["blendingCircleCountry"] = this.blendingCircleCountry;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["safeHarbourGroupId"] = this.safeHarbourGroupId;
        data["safeHarbourGroupType"] = this.safeHarbourGroupType;
        return data;
    }
}

export interface ICreateFinancialValuePointSafeHarbourGroupInput {
    projectId: number;
    financialType: FinancialType;
    comment: string | undefined;
    blendingCircleCountry: string | undefined;
    blendingCircleSubgroupId: number | undefined;
    safeHarbourGroupId: number | undefined;
    safeHarbourGroupType: SafeHarbourGroupType;
}

export class CreateJurisdictionCommentInput implements ICreateJurisdictionCommentInput {
    referenceId!: number;
    itemId!: number;
    taxJurisdictionCountry!: string | undefined;
    content!: string | undefined;

    constructor(data?: ICreateJurisdictionCommentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceId = _data["referenceId"];
            this.itemId = _data["itemId"];
            this.taxJurisdictionCountry = _data["taxJurisdictionCountry"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): CreateJurisdictionCommentInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateJurisdictionCommentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceId"] = this.referenceId;
        data["itemId"] = this.itemId;
        data["taxJurisdictionCountry"] = this.taxJurisdictionCountry;
        data["content"] = this.content;
        return data;
    }
}

export interface ICreateJurisdictionCommentInput {
    referenceId: number;
    itemId: number;
    taxJurisdictionCountry: string | undefined;
    content: string | undefined;
}

export class CreateMultipleNodeGroupInput implements ICreateMultipleNodeGroupInput {
    projectId!: number;
    organizationalEntityId!: number | undefined;
    blendingCircleSubgroupId!: number | undefined;
    multipleNodeGroupType!: FinancialNodeGroupType;

    constructor(data?: ICreateMultipleNodeGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.multipleNodeGroupType = _data["multipleNodeGroupType"];
        }
    }

    static fromJS(data: any): CreateMultipleNodeGroupInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMultipleNodeGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["multipleNodeGroupType"] = this.multipleNodeGroupType;
        return data;
    }
}

export interface ICreateMultipleNodeGroupInput {
    projectId: number;
    organizationalEntityId: number | undefined;
    blendingCircleSubgroupId: number | undefined;
    multipleNodeGroupType: FinancialNodeGroupType;
}

export class CreateMultipleShiftNodeGroupInput implements ICreateMultipleShiftNodeGroupInput {
    projectId!: number;
    value!: string | undefined;
    comment!: string | undefined;
    isConfirmed!: boolean;
    financialShiftType!: FinancialShiftType;
    targetOrganizationalEntityId!: number | undefined;
    basisForAdjustments!: BasisForAdjustmentsType;
    maxTaxRateOfMainEntityJurisdiction!: string | undefined;
    passiveIncomeOfCEOrHybridEntity!: string | undefined;
    fiscalYearBeginning!: string | undefined;
    fiscalYearEnd!: string | undefined;
    sourceOrganizationalEntityId!: number;
    multipleNodeGroupType!: FinancialNodeGroupType;

    constructor(data?: ICreateMultipleShiftNodeGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.value = _data["value"];
            this.comment = _data["comment"];
            this.isConfirmed = _data["isConfirmed"];
            this.financialShiftType = _data["financialShiftType"];
            this.targetOrganizationalEntityId = _data["targetOrganizationalEntityId"];
            this.basisForAdjustments = _data["basisForAdjustments"];
            this.maxTaxRateOfMainEntityJurisdiction = _data["maxTaxRateOfMainEntityJurisdiction"];
            this.passiveIncomeOfCEOrHybridEntity = _data["passiveIncomeOfCEOrHybridEntity"];
            this.fiscalYearBeginning = _data["fiscalYearBeginning"];
            this.fiscalYearEnd = _data["fiscalYearEnd"];
            this.sourceOrganizationalEntityId = _data["sourceOrganizationalEntityId"];
            this.multipleNodeGroupType = _data["multipleNodeGroupType"];
        }
    }

    static fromJS(data: any): CreateMultipleShiftNodeGroupInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMultipleShiftNodeGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["value"] = this.value;
        data["comment"] = this.comment;
        data["isConfirmed"] = this.isConfirmed;
        data["financialShiftType"] = this.financialShiftType;
        data["targetOrganizationalEntityId"] = this.targetOrganizationalEntityId;
        data["basisForAdjustments"] = this.basisForAdjustments;
        data["maxTaxRateOfMainEntityJurisdiction"] = this.maxTaxRateOfMainEntityJurisdiction;
        data["passiveIncomeOfCEOrHybridEntity"] = this.passiveIncomeOfCEOrHybridEntity;
        data["fiscalYearBeginning"] = this.fiscalYearBeginning;
        data["fiscalYearEnd"] = this.fiscalYearEnd;
        data["sourceOrganizationalEntityId"] = this.sourceOrganizationalEntityId;
        data["multipleNodeGroupType"] = this.multipleNodeGroupType;
        return data;
    }
}

export interface ICreateMultipleShiftNodeGroupInput {
    projectId: number;
    value: string | undefined;
    comment: string | undefined;
    isConfirmed: boolean;
    financialShiftType: FinancialShiftType;
    targetOrganizationalEntityId: number | undefined;
    basisForAdjustments: BasisForAdjustmentsType;
    maxTaxRateOfMainEntityJurisdiction: string | undefined;
    passiveIncomeOfCEOrHybridEntity: string | undefined;
    fiscalYearBeginning: string | undefined;
    fiscalYearEnd: string | undefined;
    sourceOrganizationalEntityId: number;
    multipleNodeGroupType: FinancialNodeGroupType;
}

export class CreateOrganizationalEntityInput implements ICreateOrganizationalEntityInput {
    projectId!: number;
    entityNumber!: ConfirmableInputOfString;
    legalName!: ConfirmableInputOfString;
    gloBEStatus!: ConfirmableInputOfIListOfGloBEStatus;
    tin!: ConfirmableInputOfString;
    taxJurisdictionCountry!: ConfirmableInputOfString;
    taxTreatment!: ConfirmableInputOfNullableOfTaxTreatment;
    isInvestmentEntity!: ConfirmableInputOfNullableOfBoolean;
    isConsideredAsExcluded!: ConfirmableInputOfNullableOfBoolean;
    isHeldForSale!: ConfirmableInputOfNullableOfBoolean;
    isJointVenture!: ConfirmableInputOfNullableOfBoolean;
    isPermanentEstablishment!: ConfirmableInputOfNullableOfBoolean;
    isInsuranceEntity!: ConfirmableInputOfNullableOfBoolean;
    isNMCE!: ConfirmableInputOfNullableOfBoolean;
    isCeInCFCRegime!: ConfirmableInputOfNullableOfBoolean;
    mainEntityId!: ConfirmableInputOfNullableOfInt64;
    cfcOwnerId!: ConfirmableInputOfNullableOfInt64;
    taxFunctionalCurrency!: ConfirmableInputOfString;
    accountingFunctionalCurrency!: ConfirmableInputOfString;
    numberOfMonthsOfOwnership!: ConfirmableInputOfInt32;
    designatedLocalEntityId!: ConfirmableInputOfNullableOfInt64;
    isMemberOfAFiscalUnity!: ConfirmableInputOfNullableOfBoolean;
    financialAccountingStandard!: ConfirmableInputOfNullableOfFinancialAccountingStandard;
    consolidationMethod!: ConfirmableInputOfNullableOfConsolidationMethod;
    isElectionRightTaxTransparency!: ConfirmableInputOfNullableOfBoolean;
    controllingInterestEntityId!: number | undefined;
    shareholders!: ShareholderInput;
    blendingCircleInput!: BlendingCircleInput;

    constructor(data?: ICreateOrganizationalEntityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.entityNumber = _data["entityNumber"] ? ConfirmableInputOfString.fromJS(_data["entityNumber"]) : <any>undefined;
            this.legalName = _data["legalName"] ? ConfirmableInputOfString.fromJS(_data["legalName"]) : <any>undefined;
            this.gloBEStatus = _data["gloBEStatus"] ? ConfirmableInputOfIListOfGloBEStatus.fromJS(_data["gloBEStatus"]) : <any>undefined;
            this.tin = _data["tin"] ? ConfirmableInputOfString.fromJS(_data["tin"]) : <any>undefined;
            this.taxJurisdictionCountry = _data["taxJurisdictionCountry"] ? ConfirmableInputOfString.fromJS(_data["taxJurisdictionCountry"]) : <any>undefined;
            this.taxTreatment = _data["taxTreatment"] ? ConfirmableInputOfNullableOfTaxTreatment.fromJS(_data["taxTreatment"]) : <any>undefined;
            this.isInvestmentEntity = _data["isInvestmentEntity"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isInvestmentEntity"]) : <any>undefined;
            this.isConsideredAsExcluded = _data["isConsideredAsExcluded"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isConsideredAsExcluded"]) : <any>undefined;
            this.isHeldForSale = _data["isHeldForSale"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isHeldForSale"]) : <any>undefined;
            this.isJointVenture = _data["isJointVenture"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isJointVenture"]) : <any>undefined;
            this.isPermanentEstablishment = _data["isPermanentEstablishment"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isPermanentEstablishment"]) : <any>undefined;
            this.isInsuranceEntity = _data["isInsuranceEntity"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isInsuranceEntity"]) : <any>undefined;
            this.isNMCE = _data["isNMCE"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isNMCE"]) : <any>undefined;
            this.isCeInCFCRegime = _data["isCeInCFCRegime"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isCeInCFCRegime"]) : <any>undefined;
            this.mainEntityId = _data["mainEntityId"] ? ConfirmableInputOfNullableOfInt64.fromJS(_data["mainEntityId"]) : <any>undefined;
            this.cfcOwnerId = _data["cfcOwnerId"] ? ConfirmableInputOfNullableOfInt64.fromJS(_data["cfcOwnerId"]) : <any>undefined;
            this.taxFunctionalCurrency = _data["taxFunctionalCurrency"] ? ConfirmableInputOfString.fromJS(_data["taxFunctionalCurrency"]) : <any>undefined;
            this.accountingFunctionalCurrency = _data["accountingFunctionalCurrency"] ? ConfirmableInputOfString.fromJS(_data["accountingFunctionalCurrency"]) : <any>undefined;
            this.numberOfMonthsOfOwnership = _data["numberOfMonthsOfOwnership"] ? ConfirmableInputOfInt32.fromJS(_data["numberOfMonthsOfOwnership"]) : <any>undefined;
            this.designatedLocalEntityId = _data["designatedLocalEntityId"] ? ConfirmableInputOfNullableOfInt64.fromJS(_data["designatedLocalEntityId"]) : <any>undefined;
            this.isMemberOfAFiscalUnity = _data["isMemberOfAFiscalUnity"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isMemberOfAFiscalUnity"]) : <any>undefined;
            this.financialAccountingStandard = _data["financialAccountingStandard"] ? ConfirmableInputOfNullableOfFinancialAccountingStandard.fromJS(_data["financialAccountingStandard"]) : <any>undefined;
            this.consolidationMethod = _data["consolidationMethod"] ? ConfirmableInputOfNullableOfConsolidationMethod.fromJS(_data["consolidationMethod"]) : <any>undefined;
            this.isElectionRightTaxTransparency = _data["isElectionRightTaxTransparency"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isElectionRightTaxTransparency"]) : <any>undefined;
            this.controllingInterestEntityId = _data["controllingInterestEntityId"];
            this.shareholders = _data["shareholders"] ? ShareholderInput.fromJS(_data["shareholders"]) : <any>undefined;
            this.blendingCircleInput = _data["blendingCircleInput"] ? BlendingCircleInput.fromJS(_data["blendingCircleInput"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrganizationalEntityInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrganizationalEntityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["entityNumber"] = this.entityNumber ? this.entityNumber.toJSON() : <any>undefined;
        data["legalName"] = this.legalName ? this.legalName.toJSON() : <any>undefined;
        data["gloBEStatus"] = this.gloBEStatus ? this.gloBEStatus.toJSON() : <any>undefined;
        data["tin"] = this.tin ? this.tin.toJSON() : <any>undefined;
        data["taxJurisdictionCountry"] = this.taxJurisdictionCountry ? this.taxJurisdictionCountry.toJSON() : <any>undefined;
        data["taxTreatment"] = this.taxTreatment ? this.taxTreatment.toJSON() : <any>undefined;
        data["isInvestmentEntity"] = this.isInvestmentEntity ? this.isInvestmentEntity.toJSON() : <any>undefined;
        data["isConsideredAsExcluded"] = this.isConsideredAsExcluded ? this.isConsideredAsExcluded.toJSON() : <any>undefined;
        data["isHeldForSale"] = this.isHeldForSale ? this.isHeldForSale.toJSON() : <any>undefined;
        data["isJointVenture"] = this.isJointVenture ? this.isJointVenture.toJSON() : <any>undefined;
        data["isPermanentEstablishment"] = this.isPermanentEstablishment ? this.isPermanentEstablishment.toJSON() : <any>undefined;
        data["isInsuranceEntity"] = this.isInsuranceEntity ? this.isInsuranceEntity.toJSON() : <any>undefined;
        data["isNMCE"] = this.isNMCE ? this.isNMCE.toJSON() : <any>undefined;
        data["isCeInCFCRegime"] = this.isCeInCFCRegime ? this.isCeInCFCRegime.toJSON() : <any>undefined;
        data["mainEntityId"] = this.mainEntityId ? this.mainEntityId.toJSON() : <any>undefined;
        data["cfcOwnerId"] = this.cfcOwnerId ? this.cfcOwnerId.toJSON() : <any>undefined;
        data["taxFunctionalCurrency"] = this.taxFunctionalCurrency ? this.taxFunctionalCurrency.toJSON() : <any>undefined;
        data["accountingFunctionalCurrency"] = this.accountingFunctionalCurrency ? this.accountingFunctionalCurrency.toJSON() : <any>undefined;
        data["numberOfMonthsOfOwnership"] = this.numberOfMonthsOfOwnership ? this.numberOfMonthsOfOwnership.toJSON() : <any>undefined;
        data["designatedLocalEntityId"] = this.designatedLocalEntityId ? this.designatedLocalEntityId.toJSON() : <any>undefined;
        data["isMemberOfAFiscalUnity"] = this.isMemberOfAFiscalUnity ? this.isMemberOfAFiscalUnity.toJSON() : <any>undefined;
        data["financialAccountingStandard"] = this.financialAccountingStandard ? this.financialAccountingStandard.toJSON() : <any>undefined;
        data["consolidationMethod"] = this.consolidationMethod ? this.consolidationMethod.toJSON() : <any>undefined;
        data["isElectionRightTaxTransparency"] = this.isElectionRightTaxTransparency ? this.isElectionRightTaxTransparency.toJSON() : <any>undefined;
        data["controllingInterestEntityId"] = this.controllingInterestEntityId;
        data["shareholders"] = this.shareholders ? this.shareholders.toJSON() : <any>undefined;
        data["blendingCircleInput"] = this.blendingCircleInput ? this.blendingCircleInput.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrganizationalEntityInput {
    projectId: number;
    entityNumber: ConfirmableInputOfString;
    legalName: ConfirmableInputOfString;
    gloBEStatus: ConfirmableInputOfIListOfGloBEStatus;
    tin: ConfirmableInputOfString;
    taxJurisdictionCountry: ConfirmableInputOfString;
    taxTreatment: ConfirmableInputOfNullableOfTaxTreatment;
    isInvestmentEntity: ConfirmableInputOfNullableOfBoolean;
    isConsideredAsExcluded: ConfirmableInputOfNullableOfBoolean;
    isHeldForSale: ConfirmableInputOfNullableOfBoolean;
    isJointVenture: ConfirmableInputOfNullableOfBoolean;
    isPermanentEstablishment: ConfirmableInputOfNullableOfBoolean;
    isInsuranceEntity: ConfirmableInputOfNullableOfBoolean;
    isNMCE: ConfirmableInputOfNullableOfBoolean;
    isCeInCFCRegime: ConfirmableInputOfNullableOfBoolean;
    mainEntityId: ConfirmableInputOfNullableOfInt64;
    cfcOwnerId: ConfirmableInputOfNullableOfInt64;
    taxFunctionalCurrency: ConfirmableInputOfString;
    accountingFunctionalCurrency: ConfirmableInputOfString;
    numberOfMonthsOfOwnership: ConfirmableInputOfInt32;
    designatedLocalEntityId: ConfirmableInputOfNullableOfInt64;
    isMemberOfAFiscalUnity: ConfirmableInputOfNullableOfBoolean;
    financialAccountingStandard: ConfirmableInputOfNullableOfFinancialAccountingStandard;
    consolidationMethod: ConfirmableInputOfNullableOfConsolidationMethod;
    isElectionRightTaxTransparency: ConfirmableInputOfNullableOfBoolean;
    controllingInterestEntityId: number | undefined;
    shareholders: ShareholderInput;
    blendingCircleInput: BlendingCircleInput;
}

export class CreateOutOfTemplateProjectInput implements ICreateOutOfTemplateProjectInput {
    general!: GeneraInput;
    accessAndPermission!: ProjectAccessAndPermissionInput;
    projectManagement!: FullProjectManagementInput;
    specifics!: ProjectSpecificInput;
    referenceId!: number;
    includeJurisdictions!: boolean;
    includeEntities!: boolean;
    includeFinancialDataOfJurisdictions!: boolean;
    includeFinancialDataOfEntities!: boolean;

    constructor(data?: ICreateOutOfTemplateProjectInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneraInput.fromJS(_data["general"]) : <any>undefined;
            this.accessAndPermission = _data["accessAndPermission"] ? ProjectAccessAndPermissionInput.fromJS(_data["accessAndPermission"]) : <any>undefined;
            this.projectManagement = _data["projectManagement"] ? FullProjectManagementInput.fromJS(_data["projectManagement"]) : <any>undefined;
            this.specifics = _data["specifics"] ? ProjectSpecificInput.fromJS(_data["specifics"]) : <any>undefined;
            this.referenceId = _data["referenceId"];
            this.includeJurisdictions = _data["includeJurisdictions"];
            this.includeEntities = _data["includeEntities"];
            this.includeFinancialDataOfJurisdictions = _data["includeFinancialDataOfJurisdictions"];
            this.includeFinancialDataOfEntities = _data["includeFinancialDataOfEntities"];
        }
    }

    static fromJS(data: any): CreateOutOfTemplateProjectInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOutOfTemplateProjectInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["accessAndPermission"] = this.accessAndPermission ? this.accessAndPermission.toJSON() : <any>undefined;
        data["projectManagement"] = this.projectManagement ? this.projectManagement.toJSON() : <any>undefined;
        data["specifics"] = this.specifics ? this.specifics.toJSON() : <any>undefined;
        data["referenceId"] = this.referenceId;
        data["includeJurisdictions"] = this.includeJurisdictions;
        data["includeEntities"] = this.includeEntities;
        data["includeFinancialDataOfJurisdictions"] = this.includeFinancialDataOfJurisdictions;
        data["includeFinancialDataOfEntities"] = this.includeFinancialDataOfEntities;
        return data;
    }
}

export interface ICreateOutOfTemplateProjectInput {
    general: GeneraInput;
    accessAndPermission: ProjectAccessAndPermissionInput;
    projectManagement: FullProjectManagementInput;
    specifics: ProjectSpecificInput;
    referenceId: number;
    includeJurisdictions: boolean;
    includeEntities: boolean;
    includeFinancialDataOfJurisdictions: boolean;
    includeFinancialDataOfEntities: boolean;
}

export class CreateProjectInput implements ICreateProjectInput {
    general!: GeneraInput;
    accessAndPermission!: ProjectAccessAndPermissionInput;
    projectManagement!: FullProjectManagementInput;
    specifics!: ProjectSpecificInput;

    constructor(data?: ICreateProjectInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneraInput.fromJS(_data["general"]) : <any>undefined;
            this.accessAndPermission = _data["accessAndPermission"] ? ProjectAccessAndPermissionInput.fromJS(_data["accessAndPermission"]) : <any>undefined;
            this.projectManagement = _data["projectManagement"] ? FullProjectManagementInput.fromJS(_data["projectManagement"]) : <any>undefined;
            this.specifics = _data["specifics"] ? ProjectSpecificInput.fromJS(_data["specifics"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateProjectInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["accessAndPermission"] = this.accessAndPermission ? this.accessAndPermission.toJSON() : <any>undefined;
        data["projectManagement"] = this.projectManagement ? this.projectManagement.toJSON() : <any>undefined;
        data["specifics"] = this.specifics ? this.specifics.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateProjectInput {
    general: GeneraInput;
    accessAndPermission: ProjectAccessAndPermissionInput;
    projectManagement: FullProjectManagementInput;
    specifics: ProjectSpecificInput;
}

export enum Criticality {
    VeryLow = 1,
    Low = 2,
    Medium = 3,
    High = 4,
}

export class CrossAllocationOfTaxes434RecalculationWarningDto implements ICrossAllocationOfTaxes434RecalculationWarningDto {
    relatedGloBEAllocation!: FinancialValueDto;
    maxTaxRatePercentage!: string | undefined;
    initialValue!: FinancialValueDto;
    calculatedFinal!: FinancialValueDto;

    constructor(data?: ICrossAllocationOfTaxes434RecalculationWarningDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.relatedGloBEAllocation = _data["relatedGloBEAllocation"] ? FinancialValueDto.fromJS(_data["relatedGloBEAllocation"]) : <any>undefined;
            this.maxTaxRatePercentage = _data["maxTaxRatePercentage"];
            this.initialValue = _data["initialValue"] ? FinancialValueDto.fromJS(_data["initialValue"]) : <any>undefined;
            this.calculatedFinal = _data["calculatedFinal"] ? FinancialValueDto.fromJS(_data["calculatedFinal"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CrossAllocationOfTaxes434RecalculationWarningDto {
        data = typeof data === 'object' ? data : {};
        let result = new CrossAllocationOfTaxes434RecalculationWarningDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["relatedGloBEAllocation"] = this.relatedGloBEAllocation ? this.relatedGloBEAllocation.toJSON() : <any>undefined;
        data["maxTaxRatePercentage"] = this.maxTaxRatePercentage;
        data["initialValue"] = this.initialValue ? this.initialValue.toJSON() : <any>undefined;
        data["calculatedFinal"] = this.calculatedFinal ? this.calculatedFinal.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICrossAllocationOfTaxes434RecalculationWarningDto {
    relatedGloBEAllocation: FinancialValueDto;
    maxTaxRatePercentage: string | undefined;
    initialValue: FinancialValueDto;
    calculatedFinal: FinancialValueDto;
}

export class CrossAllocationOfTaxesRecalculationWarningDto implements ICrossAllocationOfTaxesRecalculationWarningDto {
    legalName!: string | undefined;
    desiredAmount!: FinancialValueDto;
    totalAllocations!: FinancialValueDto;
    sharePercentage!: string | undefined;
    calculatedAmount!: FinancialValueDto;
    allocationAllowance!: FinancialValueDto;

    constructor(data?: ICrossAllocationOfTaxesRecalculationWarningDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalName = _data["legalName"];
            this.desiredAmount = _data["desiredAmount"] ? FinancialValueDto.fromJS(_data["desiredAmount"]) : <any>undefined;
            this.totalAllocations = _data["totalAllocations"] ? FinancialValueDto.fromJS(_data["totalAllocations"]) : <any>undefined;
            this.sharePercentage = _data["sharePercentage"];
            this.calculatedAmount = _data["calculatedAmount"] ? FinancialValueDto.fromJS(_data["calculatedAmount"]) : <any>undefined;
            this.allocationAllowance = _data["allocationAllowance"] ? FinancialValueDto.fromJS(_data["allocationAllowance"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CrossAllocationOfTaxesRecalculationWarningDto {
        data = typeof data === 'object' ? data : {};
        let result = new CrossAllocationOfTaxesRecalculationWarningDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["desiredAmount"] = this.desiredAmount ? this.desiredAmount.toJSON() : <any>undefined;
        data["totalAllocations"] = this.totalAllocations ? this.totalAllocations.toJSON() : <any>undefined;
        data["sharePercentage"] = this.sharePercentage;
        data["calculatedAmount"] = this.calculatedAmount ? this.calculatedAmount.toJSON() : <any>undefined;
        data["allocationAllowance"] = this.allocationAllowance ? this.allocationAllowance.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICrossAllocationOfTaxesRecalculationWarningDto {
    legalName: string | undefined;
    desiredAmount: FinancialValueDto;
    totalAllocations: FinancialValueDto;
    sharePercentage: string | undefined;
    calculatedAmount: FinancialValueDto;
    allocationAllowance: FinancialValueDto;
}

export class CustomGrantsForPermissionInput implements ICustomGrantsForPermissionInput {
    entityId!: number;
    usersAndOrganizationUnits!: UserOrOrganizationUnitInput[] | undefined;
    permissionName!: string | undefined;
    excludeUsers!: boolean;

    constructor(data?: ICustomGrantsForPermissionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            if (Array.isArray(_data["usersAndOrganizationUnits"])) {
                this.usersAndOrganizationUnits = [] as any;
                for (let item of _data["usersAndOrganizationUnits"])
                    this.usersAndOrganizationUnits!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
            this.permissionName = _data["permissionName"];
            this.excludeUsers = _data["excludeUsers"];
        }
    }

    static fromJS(data: any): CustomGrantsForPermissionInput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomGrantsForPermissionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        if (Array.isArray(this.usersAndOrganizationUnits)) {
            data["usersAndOrganizationUnits"] = [];
            for (let item of this.usersAndOrganizationUnits)
                data["usersAndOrganizationUnits"].push(item.toJSON());
        }
        data["permissionName"] = this.permissionName;
        data["excludeUsers"] = this.excludeUsers;
        return data;
    }
}

export interface ICustomGrantsForPermissionInput {
    entityId: number;
    usersAndOrganizationUnits: UserOrOrganizationUnitInput[] | undefined;
    permissionName: string | undefined;
    excludeUsers: boolean;
}

export class CustomGrantsForPermissionWithAccessRestrictionDataInput implements ICustomGrantsForPermissionWithAccessRestrictionDataInput {
    entityId!: number;
    usersAndOrganizationUnits!: UserOrOrganizationUnitInput[] | undefined;
    permissionName!: string | undefined;
    excludeUsers!: boolean;
    accessRestrictionProvisionalData!: UserOrOrganizationUnitInput[] | undefined;

    constructor(data?: ICustomGrantsForPermissionWithAccessRestrictionDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            if (Array.isArray(_data["usersAndOrganizationUnits"])) {
                this.usersAndOrganizationUnits = [] as any;
                for (let item of _data["usersAndOrganizationUnits"])
                    this.usersAndOrganizationUnits!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
            this.permissionName = _data["permissionName"];
            this.excludeUsers = _data["excludeUsers"];
            if (Array.isArray(_data["accessRestrictionProvisionalData"])) {
                this.accessRestrictionProvisionalData = [] as any;
                for (let item of _data["accessRestrictionProvisionalData"])
                    this.accessRestrictionProvisionalData!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomGrantsForPermissionWithAccessRestrictionDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomGrantsForPermissionWithAccessRestrictionDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        if (Array.isArray(this.usersAndOrganizationUnits)) {
            data["usersAndOrganizationUnits"] = [];
            for (let item of this.usersAndOrganizationUnits)
                data["usersAndOrganizationUnits"].push(item.toJSON());
        }
        data["permissionName"] = this.permissionName;
        data["excludeUsers"] = this.excludeUsers;
        if (Array.isArray(this.accessRestrictionProvisionalData)) {
            data["accessRestrictionProvisionalData"] = [];
            for (let item of this.accessRestrictionProvisionalData)
                data["accessRestrictionProvisionalData"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomGrantsForPermissionWithAccessRestrictionDataInput {
    entityId: number;
    usersAndOrganizationUnits: UserOrOrganizationUnitInput[] | undefined;
    permissionName: string | undefined;
    excludeUsers: boolean;
    accessRestrictionProvisionalData: UserOrOrganizationUnitInput[] | undefined;
}

export class CustomGrantsWithAccessRestrictionInput implements ICustomGrantsWithAccessRestrictionInput {
    entityId!: number;
    accessRestrictionProvisionalData!: UserOrOrganizationUnitInput[] | undefined;
    customGrantsForPermissions!: CustomGrantsForPermissionInput[] | undefined;

    constructor(data?: ICustomGrantsWithAccessRestrictionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            if (Array.isArray(_data["accessRestrictionProvisionalData"])) {
                this.accessRestrictionProvisionalData = [] as any;
                for (let item of _data["accessRestrictionProvisionalData"])
                    this.accessRestrictionProvisionalData!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
            if (Array.isArray(_data["customGrantsForPermissions"])) {
                this.customGrantsForPermissions = [] as any;
                for (let item of _data["customGrantsForPermissions"])
                    this.customGrantsForPermissions!.push(CustomGrantsForPermissionInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomGrantsWithAccessRestrictionInput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomGrantsWithAccessRestrictionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        if (Array.isArray(this.accessRestrictionProvisionalData)) {
            data["accessRestrictionProvisionalData"] = [];
            for (let item of this.accessRestrictionProvisionalData)
                data["accessRestrictionProvisionalData"].push(item.toJSON());
        }
        if (Array.isArray(this.customGrantsForPermissions)) {
            data["customGrantsForPermissions"] = [];
            for (let item of this.customGrantsForPermissions)
                data["customGrantsForPermissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomGrantsWithAccessRestrictionInput {
    entityId: number;
    accessRestrictionProvisionalData: UserOrOrganizationUnitInput[] | undefined;
    customGrantsForPermissions: CustomGrantsForPermissionInput[] | undefined;
}

export class DeleteMultipleNodeGroupInput implements IDeleteMultipleNodeGroupInput {
    projectId!: number;
    organizationalEntityId!: number | undefined;
    blendingCircleSubgroupId!: number | undefined;
    multipleNodeGroupType!: FinancialNodeGroupType;
    nodeGroupId!: number;

    constructor(data?: IDeleteMultipleNodeGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.multipleNodeGroupType = _data["multipleNodeGroupType"];
            this.nodeGroupId = _data["nodeGroupId"];
        }
    }

    static fromJS(data: any): DeleteMultipleNodeGroupInput {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMultipleNodeGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["multipleNodeGroupType"] = this.multipleNodeGroupType;
        data["nodeGroupId"] = this.nodeGroupId;
        return data;
    }
}

export interface IDeleteMultipleNodeGroupInput {
    projectId: number;
    organizationalEntityId: number | undefined;
    blendingCircleSubgroupId: number | undefined;
    multipleNodeGroupType: FinancialNodeGroupType;
    nodeGroupId: number;
}

export class DeleteMultipleShiftNodeGroupInput implements IDeleteMultipleShiftNodeGroupInput {
    projectId!: number;
    sourceOrganizationalEntityId!: number;
    targetOrganizationalEntityId!: number | undefined;
    multipleNodeGroupType!: FinancialNodeGroupType;
    nodeGroupId!: number;

    constructor(data?: IDeleteMultipleShiftNodeGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.sourceOrganizationalEntityId = _data["sourceOrganizationalEntityId"];
            this.targetOrganizationalEntityId = _data["targetOrganizationalEntityId"];
            this.multipleNodeGroupType = _data["multipleNodeGroupType"];
            this.nodeGroupId = _data["nodeGroupId"];
        }
    }

    static fromJS(data: any): DeleteMultipleShiftNodeGroupInput {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMultipleShiftNodeGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["sourceOrganizationalEntityId"] = this.sourceOrganizationalEntityId;
        data["targetOrganizationalEntityId"] = this.targetOrganizationalEntityId;
        data["multipleNodeGroupType"] = this.multipleNodeGroupType;
        data["nodeGroupId"] = this.nodeGroupId;
        return data;
    }
}

export interface IDeleteMultipleShiftNodeGroupInput {
    projectId: number;
    sourceOrganizationalEntityId: number;
    targetOrganizationalEntityId: number | undefined;
    multipleNodeGroupType: FinancialNodeGroupType;
    nodeGroupId: number;
}

export class EditChannelInput implements IEditChannelInput {
    referenceId!: number;
    title!: string | undefined;
    id!: number;

    constructor(data?: IEditChannelInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceId = _data["referenceId"];
            this.title = _data["title"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EditChannelInput {
        data = typeof data === 'object' ? data : {};
        let result = new EditChannelInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceId"] = this.referenceId;
        data["title"] = this.title;
        data["id"] = this.id;
        return data;
    }
}

export interface IEditChannelInput {
    referenceId: number;
    title: string | undefined;
    id: number;
}

export class EditCommunicationInput implements IEditCommunicationInput {
    content!: string | undefined;
    id!: number;

    constructor(data?: IEditCommunicationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EditCommunicationInput {
        data = typeof data === 'object' ? data : {};
        let result = new EditCommunicationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["id"] = this.id;
        return data;
    }
}

export interface IEditCommunicationInput {
    content: string | undefined;
    id: number;
}

export class ElectionNodeDto implements IElectionNodeDto {
    id!: number;
    blendingCircleSubgroupId!: number | undefined;
    organizationalEntityId!: number | undefined;
    electionType!: ElectionType;
    value!: boolean | undefined;
    hasYear!: boolean;
    year!: number | undefined;
    isDisabled!: boolean;
    hasReadPermission!: boolean;
    hasWritePermission!: boolean;

    constructor(data?: IElectionNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.electionType = _data["electionType"];
            this.value = _data["value"];
            this.hasYear = _data["hasYear"];
            this.year = _data["year"];
            this.isDisabled = _data["isDisabled"];
            this.hasReadPermission = _data["hasReadPermission"];
            this.hasWritePermission = _data["hasWritePermission"];
        }
    }

    static fromJS(data: any): ElectionNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectionNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["electionType"] = this.electionType;
        data["value"] = this.value;
        data["hasYear"] = this.hasYear;
        data["year"] = this.year;
        data["isDisabled"] = this.isDisabled;
        data["hasReadPermission"] = this.hasReadPermission;
        data["hasWritePermission"] = this.hasWritePermission;
        return data;
    }
}

export interface IElectionNodeDto {
    id: number;
    blendingCircleSubgroupId: number | undefined;
    organizationalEntityId: number | undefined;
    electionType: ElectionType;
    value: boolean | undefined;
    hasYear: boolean;
    year: number | undefined;
    isDisabled: boolean;
    hasReadPermission: boolean;
    hasWritePermission: boolean;
}

export enum ElectionType {
    AggregateAssetGainElection = 1,
    RealisationPrincipleElection = 2,
    EquityInvestmentInclusionElection = 3,
    StockBasedCompensationElection = 4,
    IntraGroupTransactionsElection = 5,
    ApplicationOfTheSubstanceBasedIncomeExclusionRuleForachJurisdiction = 6,
    AdditionalCurrentTutAccToMr415Election = 7,
    DeptReleaseElection = 51,
    InclusionOfAllDividendsWithRespectToPortfolioShareholdings = 52,
    ЕxpenseRelatedUnclaimedAccElection = 53,
    GlobeLossElection = 101,
}

export class EntityChangeDataDto implements IEntityChangeDataDto {
    id!: number;
    changeTime!: DateTime;
    changeType!: EntityChangeType;
    entityChangeSetId!: number;
    entityId!: string | undefined;
    entityTypeFullName!: string | undefined;
    tenantId!: number | undefined;
    entityEntry!: any | undefined;
    propertyChanges!: EntityPropertyChangeDto[] | undefined;
    user!: UserDetailsDto;

    constructor(data?: IEntityChangeDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.changeTime = _data["changeTime"] ? DateTime.fromISO(_data["changeTime"].toString()) : <any>undefined;
            this.changeType = _data["changeType"];
            this.entityChangeSetId = _data["entityChangeSetId"];
            this.entityId = _data["entityId"];
            this.entityTypeFullName = _data["entityTypeFullName"];
            this.tenantId = _data["tenantId"];
            this.entityEntry = _data["entityEntry"];
            if (Array.isArray(_data["propertyChanges"])) {
                this.propertyChanges = [] as any;
                for (let item of _data["propertyChanges"])
                    this.propertyChanges!.push(EntityPropertyChangeDto.fromJS(item));
            }
            this.user = _data["user"] ? UserDetailsDto.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EntityChangeDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityChangeDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["changeTime"] = this.changeTime ? this.changeTime.toString() : <any>undefined;
        data["changeType"] = this.changeType;
        data["entityChangeSetId"] = this.entityChangeSetId;
        data["entityId"] = this.entityId;
        data["entityTypeFullName"] = this.entityTypeFullName;
        data["tenantId"] = this.tenantId;
        data["entityEntry"] = this.entityEntry;
        if (Array.isArray(this.propertyChanges)) {
            data["propertyChanges"] = [];
            for (let item of this.propertyChanges)
                data["propertyChanges"].push(item.toJSON());
        }
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEntityChangeDataDto {
    id: number;
    changeTime: DateTime;
    changeType: EntityChangeType;
    entityChangeSetId: number;
    entityId: string | undefined;
    entityTypeFullName: string | undefined;
    tenantId: number | undefined;
    entityEntry: any | undefined;
    propertyChanges: EntityPropertyChangeDto[] | undefined;
    user: UserDetailsDto;
}

export enum EntityChangeType {
    Created = 0,
    Updated = 1,
    Deleted = 2,
}

export class EntityPermissionDto implements IEntityPermissionDto {
    referenceId!: number;
    permissionName!: string | undefined;
    isActive!: boolean;
    possibleUsers!: ListResultDtoOfUserOrOrganizationUnitDto;
    usersOrOrganizationUnits!: ListResultDtoOfUserOrOrganizationUnitDto;
    availableUsersOrOrganizationUnits!: ListResultDtoOfUserOrOrganizationUnitDto;

    constructor(data?: IEntityPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceId = _data["referenceId"];
            this.permissionName = _data["permissionName"];
            this.isActive = _data["isActive"];
            this.possibleUsers = _data["possibleUsers"] ? ListResultDtoOfUserOrOrganizationUnitDto.fromJS(_data["possibleUsers"]) : <any>undefined;
            this.usersOrOrganizationUnits = _data["usersOrOrganizationUnits"] ? ListResultDtoOfUserOrOrganizationUnitDto.fromJS(_data["usersOrOrganizationUnits"]) : <any>undefined;
            this.availableUsersOrOrganizationUnits = _data["availableUsersOrOrganizationUnits"] ? ListResultDtoOfUserOrOrganizationUnitDto.fromJS(_data["availableUsersOrOrganizationUnits"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EntityPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceId"] = this.referenceId;
        data["permissionName"] = this.permissionName;
        data["isActive"] = this.isActive;
        data["possibleUsers"] = this.possibleUsers ? this.possibleUsers.toJSON() : <any>undefined;
        data["usersOrOrganizationUnits"] = this.usersOrOrganizationUnits ? this.usersOrOrganizationUnits.toJSON() : <any>undefined;
        data["availableUsersOrOrganizationUnits"] = this.availableUsersOrOrganizationUnits ? this.availableUsersOrOrganizationUnits.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEntityPermissionDto {
    referenceId: number;
    permissionName: string | undefined;
    isActive: boolean;
    possibleUsers: ListResultDtoOfUserOrOrganizationUnitDto;
    usersOrOrganizationUnits: ListResultDtoOfUserOrOrganizationUnitDto;
    availableUsersOrOrganizationUnits: ListResultDtoOfUserOrOrganizationUnitDto;
}

export class EntityPropertyChangeDto implements IEntityPropertyChangeDto {
    id!: number;
    entityChangeId!: number;
    newValue!: string | undefined;
    originalValue!: string | undefined;
    propertyName!: string | undefined;
    propertyTypeFullName!: string | undefined;
    tenantId!: number | undefined;

    constructor(data?: IEntityPropertyChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityChangeId = _data["entityChangeId"];
            this.newValue = _data["newValue"];
            this.originalValue = _data["originalValue"];
            this.propertyName = _data["propertyName"];
            this.propertyTypeFullName = _data["propertyTypeFullName"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): EntityPropertyChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityPropertyChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityChangeId"] = this.entityChangeId;
        data["newValue"] = this.newValue;
        data["originalValue"] = this.originalValue;
        data["propertyName"] = this.propertyName;
        data["propertyTypeFullName"] = this.propertyTypeFullName;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IEntityPropertyChangeDto {
    id: number;
    entityChangeId: number;
    newValue: string | undefined;
    originalValue: string | undefined;
    propertyName: string | undefined;
    propertyTypeFullName: string | undefined;
    tenantId: number | undefined;
}

export class ExportOverviewToExcelInput implements IExportOverviewToExcelInput {
    exportAllEntries!: boolean;
    columns!: string[] | undefined;
    type!: string | undefined;
    settings!: string | undefined;

    constructor(data?: IExportOverviewToExcelInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exportAllEntries = _data["exportAllEntries"];
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(item);
            }
            this.type = _data["type"];
            this.settings = _data["settings"];
        }
    }

    static fromJS(data: any): ExportOverviewToExcelInput {
        data = typeof data === 'object' ? data : {};
        let result = new ExportOverviewToExcelInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exportAllEntries"] = this.exportAllEntries;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item);
        }
        data["type"] = this.type;
        data["settings"] = this.settings;
        return data;
    }
}

export interface IExportOverviewToExcelInput {
    exportAllEntries: boolean;
    columns: string[] | undefined;
    type: string | undefined;
    settings: string | undefined;
}

export class FileContributionInfoDto implements IFileContributionInfoDto {
    fileId!: number;
    isModifiable!: boolean;
    refType!: string | undefined;
    refId!: number;
    refName!: string | undefined;

    constructor(data?: IFileContributionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.isModifiable = _data["isModifiable"];
            this.refType = _data["refType"];
            this.refId = _data["refId"];
            this.refName = _data["refName"];
        }
    }

    static fromJS(data: any): FileContributionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileContributionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["isModifiable"] = this.isModifiable;
        data["refType"] = this.refType;
        data["refId"] = this.refId;
        data["refName"] = this.refName;
        return data;
    }
}

export interface IFileContributionInfoDto {
    fileId: number;
    isModifiable: boolean;
    refType: string | undefined;
    refId: number;
    refName: string | undefined;
}

export class FileDownloadDto implements IFileDownloadDto {
    fileName!: string | undefined;
    readonly content!: string | undefined;
    readonly mimeType!: string | undefined;

    constructor(data?: IFileDownloadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            (<any>this).content = _data["content"];
            (<any>this).mimeType = _data["mimeType"];
        }
    }

    static fromJS(data: any): FileDownloadDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDownloadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["content"] = this.content;
        data["mimeType"] = this.mimeType;
        return data;
    }
}

export interface IFileDownloadDto {
    fileName: string | undefined;
    content: string | undefined;
    mimeType: string | undefined;
}

export enum FinancialAccountingStandard {
    IRFS = 1,
    HGB = 2,
    GAAP = 3,
}

export class FinancialDataCurrencyConvertedFinalDto implements IFinancialDataCurrencyConvertedFinalDto {
    currencyConvertedValue!: string | undefined;
    presentationCurrency!: string | undefined;

    constructor(data?: IFinancialDataCurrencyConvertedFinalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyConvertedValue = _data["currencyConvertedValue"];
            this.presentationCurrency = _data["presentationCurrency"];
            }
        }

    static fromJS(data: any): FinancialDataCurrencyConvertedFinalDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialDataCurrencyConvertedFinalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyConvertedValue"] = this.currencyConvertedValue;
        data["presentationCurrency"] = this.presentationCurrency;
        return data;
    }
}

export interface IFinancialDataCurrencyConvertedFinalDto {
    currencyConvertedValue: string | undefined;
    presentationCurrency: string | undefined;
}

export class FinancialDataHistoryDto implements IFinancialDataHistoryDto {
    financialType!: FinancialType;
    traces!: FinancialDataTraceRevisionDto[] | undefined;

    constructor(data?: IFinancialDataHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financialType = _data["financialType"];
            if (Array.isArray(_data["traces"])) {
                this.traces = [] as any;
                for (let item of _data["traces"])
                    this.traces!.push(FinancialDataTraceRevisionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FinancialDataHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialDataHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialType"] = this.financialType;
        if (Array.isArray(this.traces)) {
            data["traces"] = [];
            for (let item of this.traces)
                data["traces"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFinancialDataHistoryDto {
    financialType: FinancialType;
    traces: FinancialDataTraceRevisionDto[] | undefined;
}

export class FinancialDataOrganizationalEntityOverviewDto implements IFinancialDataOrganizationalEntityOverviewDto {
    points!: FinancialValuePointOverviewDto[] | undefined;
    hasWritePermission!: boolean;
    rowExpandDisabled!: boolean;
    organizationalEntityId!: number;
    legalName!: string | undefined;
    currency!: string | undefined;
    isNotConsidered!: boolean;
    canAddOrUpdateFinancialData!: boolean;

    constructor(data?: IFinancialDataOrganizationalEntityOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["points"])) {
                this.points = [] as any;
                for (let item of _data["points"])
                    this.points!.push(FinancialValuePointOverviewDto.fromJS(item));
            }
            this.hasWritePermission = _data["hasWritePermission"];
            this.rowExpandDisabled = _data["rowExpandDisabled"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.legalName = _data["legalName"];
            this.currency = _data["currency"];
            this.isNotConsidered = _data["isNotConsidered"];
            this.canAddOrUpdateFinancialData = _data["canAddOrUpdateFinancialData"];
        }
    }

    static fromJS(data: any): FinancialDataOrganizationalEntityOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialDataOrganizationalEntityOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.points)) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item.toJSON());
        }
        data["hasWritePermission"] = this.hasWritePermission;
        data["rowExpandDisabled"] = this.rowExpandDisabled;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["legalName"] = this.legalName;
        data["currency"] = this.currency;
        data["isNotConsidered"] = this.isNotConsidered;
        data["canAddOrUpdateFinancialData"] = this.canAddOrUpdateFinancialData;
        return data;
    }
}

export interface IFinancialDataOrganizationalEntityOverviewDto {
    points: FinancialValuePointOverviewDto[] | undefined;
    hasWritePermission: boolean;
    rowExpandDisabled: boolean;
    organizationalEntityId: number;
    legalName: string | undefined;
    currency: string | undefined;
    isNotConsidered: boolean;
    canAddOrUpdateFinancialData: boolean;
}

export class FinancialDataSafeHarbourGroupOverviewDto implements IFinancialDataSafeHarbourGroupOverviewDto {
    points!: FinancialValuePointOverviewDto[] | undefined;
    hasWritePermission!: boolean;
    rowExpandDisabled!: boolean;
    safeHarbourGroupId!: number | undefined;
    deMinimisCheckResult!: SafeHarbourCheckResultDto;
    setrCheckResult!: SafeHarbourCheckResultDto;
    routineProfitsCheckResult!: SafeHarbourCheckResultDto;
    testsStatus!: TestsStatus;
    hasReadPermission!: boolean;
    countryCode!: string | undefined;
    currency!: string | undefined;

    constructor(data?: IFinancialDataSafeHarbourGroupOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["points"])) {
                this.points = [] as any;
                for (let item of _data["points"])
                    this.points!.push(FinancialValuePointOverviewDto.fromJS(item));
        }
            this.hasWritePermission = _data["hasWritePermission"];
            this.rowExpandDisabled = _data["rowExpandDisabled"];
            this.safeHarbourGroupId = _data["safeHarbourGroupId"];
            this.deMinimisCheckResult = _data["deMinimisCheckResult"] ? SafeHarbourCheckResultDto.fromJS(_data["deMinimisCheckResult"]) : <any>undefined;
            this.setrCheckResult = _data["setrCheckResult"] ? SafeHarbourCheckResultDto.fromJS(_data["setrCheckResult"]) : <any>undefined;
            this.routineProfitsCheckResult = _data["routineProfitsCheckResult"] ? SafeHarbourCheckResultDto.fromJS(_data["routineProfitsCheckResult"]) : <any>undefined;
            this.testsStatus = _data["testsStatus"];
            this.hasReadPermission = _data["hasReadPermission"];
            this.countryCode = _data["countryCode"];
            this.currency = _data["currency"];
    }
    }

    static fromJS(data: any): FinancialDataSafeHarbourGroupOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialDataSafeHarbourGroupOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.points)) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item.toJSON());
        }
        data["hasWritePermission"] = this.hasWritePermission;
        data["rowExpandDisabled"] = this.rowExpandDisabled;
        data["safeHarbourGroupId"] = this.safeHarbourGroupId;
        data["deMinimisCheckResult"] = this.deMinimisCheckResult ? this.deMinimisCheckResult.toJSON() : <any>undefined;
        data["setrCheckResult"] = this.setrCheckResult ? this.setrCheckResult.toJSON() : <any>undefined;
        data["routineProfitsCheckResult"] = this.routineProfitsCheckResult ? this.routineProfitsCheckResult.toJSON() : <any>undefined;
        data["testsStatus"] = this.testsStatus;
        data["hasReadPermission"] = this.hasReadPermission;
        data["countryCode"] = this.countryCode;
        data["currency"] = this.currency;
        return data;
    }
}

export interface IFinancialDataSafeHarbourGroupOverviewDto {
    points: FinancialValuePointOverviewDto[] | undefined;
    hasWritePermission: boolean;
    rowExpandDisabled: boolean;
    safeHarbourGroupId: number | undefined;
    deMinimisCheckResult: SafeHarbourCheckResultDto;
    setrCheckResult: SafeHarbourCheckResultDto;
    routineProfitsCheckResult: SafeHarbourCheckResultDto;
    testsStatus: TestsStatus;
    hasReadPermission: boolean;
    countryCode: string | undefined;
    currency: string | undefined;
}

export class FinancialDataTraceBucketDto implements IFinancialDataTraceBucketDto {
    id!: number;
    name!: string | undefined;
    traceBucketType!: FinancialDataTraceBucketType;
    value!: string | undefined;

    constructor(data?: IFinancialDataTraceBucketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.traceBucketType = _data["traceBucketType"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): FinancialDataTraceBucketDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialDataTraceBucketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["traceBucketType"] = this.traceBucketType;
        data["value"] = this.value;
        return data;
    }
}

export interface IFinancialDataTraceBucketDto {
    id: number;
    name: string | undefined;
    traceBucketType: FinancialDataTraceBucketType;
    value: string | undefined;
}

export enum FinancialDataTraceBucketType {
    Initial = 1,
    Delta = 2,
}

export class FinancialDataTraceRevisionDto implements IFinancialDataTraceRevisionDto {
    id!: number;
    value!: string | undefined;
    currency!: string | undefined;
    financialType!: FinancialType;
    traceBuckets!: FinancialDataTraceBucketDto[] | undefined;
    isConfirmed!: boolean;
    hasWritePermission!: boolean;
    revision!: RevisionDto;

    constructor(data?: IFinancialDataTraceRevisionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.currency = _data["currency"];
            this.financialType = _data["financialType"];
            if (Array.isArray(_data["traceBuckets"])) {
                this.traceBuckets = [] as any;
                for (let item of _data["traceBuckets"])
                    this.traceBuckets!.push(FinancialDataTraceBucketDto.fromJS(item));
            }
            this.isConfirmed = _data["isConfirmed"];
            this.hasWritePermission = _data["hasWritePermission"];
            this.revision = _data["revision"] ? RevisionDto.fromJS(_data["revision"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FinancialDataTraceRevisionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialDataTraceRevisionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["currency"] = this.currency;
        data["financialType"] = this.financialType;
        if (Array.isArray(this.traceBuckets)) {
            data["traceBuckets"] = [];
            for (let item of this.traceBuckets)
                data["traceBuckets"].push(item.toJSON());
        }
        data["isConfirmed"] = this.isConfirmed;
        data["hasWritePermission"] = this.hasWritePermission;
        data["revision"] = this.revision ? this.revision.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFinancialDataTraceRevisionDto {
    id: number;
    value: string | undefined;
    currency: string | undefined;
    financialType: FinancialType;
    traceBuckets: FinancialDataTraceBucketDto[] | undefined;
    isConfirmed: boolean;
    hasWritePermission: boolean;
    revision: RevisionDto;
}

export class FinancialDeltaPointDto implements IFinancialDeltaPointDto {
    id!: number;
    financialValuePointId!: number;
    delta!: string | undefined;
    description!: string | undefined;

    constructor(data?: IFinancialDeltaPointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.financialValuePointId = _data["financialValuePointId"];
            this.delta = _data["delta"];
            this.description = _data["description"];
            }
        }

    static fromJS(data: any): FinancialDeltaPointDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialDeltaPointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["financialValuePointId"] = this.financialValuePointId;
        data["delta"] = this.delta;
        data["description"] = this.description;
        return data;
    }
}

export interface IFinancialDeltaPointDto {
    id: number;
    financialValuePointId: number;
    delta: string | undefined;
    description: string | undefined;
}

export class FinancialGroupDataJurisdictionsOverviewDto implements IFinancialGroupDataJurisdictionsOverviewDto {
    taxJurisdictionCountry!: string | undefined;
    isSafeHarboursExisting!: boolean;
    isSafeHarboursApplicable!: boolean;
    isFullScopeCalculationActivated!: boolean;
    deMinimisCheckResult!: SafeHarbourCheckResultDto;
    setrCheckResult!: SafeHarbourCheckResultDto;
    routineProfitsCheckResult!: SafeHarbourCheckResultDto;
    globeIncomeLossPercentage!: number;
    adjustedCoveredTaxesPercentage!: number;
    substanceBasedIncomeExlusionPercentage!: number;
    effectiveTaxRateAndTopUpTaxPercentage!: number;
    hasReadPermission!: boolean;
    hasWritePermission!: boolean;
    rowExpandDisabled!: boolean;
    isSpecialPermissionsActivated!: boolean;
    isWritingActivated!: boolean;

    constructor(data?: IFinancialGroupDataJurisdictionsOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxJurisdictionCountry = _data["taxJurisdictionCountry"];
            this.isSafeHarboursExisting = _data["isSafeHarboursExisting"];
            this.isSafeHarboursApplicable = _data["isSafeHarboursApplicable"];
            this.isFullScopeCalculationActivated = _data["isFullScopeCalculationActivated"];
            this.deMinimisCheckResult = _data["deMinimisCheckResult"] ? SafeHarbourCheckResultDto.fromJS(_data["deMinimisCheckResult"]) : <any>undefined;
            this.setrCheckResult = _data["setrCheckResult"] ? SafeHarbourCheckResultDto.fromJS(_data["setrCheckResult"]) : <any>undefined;
            this.routineProfitsCheckResult = _data["routineProfitsCheckResult"] ? SafeHarbourCheckResultDto.fromJS(_data["routineProfitsCheckResult"]) : <any>undefined;
            this.globeIncomeLossPercentage = _data["globeIncomeLossPercentage"];
            this.adjustedCoveredTaxesPercentage = _data["adjustedCoveredTaxesPercentage"];
            this.substanceBasedIncomeExlusionPercentage = _data["substanceBasedIncomeExlusionPercentage"];
            this.effectiveTaxRateAndTopUpTaxPercentage = _data["effectiveTaxRateAndTopUpTaxPercentage"];
            this.hasReadPermission = _data["hasReadPermission"];
            this.hasWritePermission = _data["hasWritePermission"];
            this.rowExpandDisabled = _data["rowExpandDisabled"];
            this.isSpecialPermissionsActivated = _data["isSpecialPermissionsActivated"];
            this.isWritingActivated = _data["isWritingActivated"];
        }
    }

    static fromJS(data: any): FinancialGroupDataJurisdictionsOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialGroupDataJurisdictionsOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxJurisdictionCountry"] = this.taxJurisdictionCountry;
        data["isSafeHarboursExisting"] = this.isSafeHarboursExisting;
        data["isSafeHarboursApplicable"] = this.isSafeHarboursApplicable;
        data["isFullScopeCalculationActivated"] = this.isFullScopeCalculationActivated;
        data["deMinimisCheckResult"] = this.deMinimisCheckResult ? this.deMinimisCheckResult.toJSON() : <any>undefined;
        data["setrCheckResult"] = this.setrCheckResult ? this.setrCheckResult.toJSON() : <any>undefined;
        data["routineProfitsCheckResult"] = this.routineProfitsCheckResult ? this.routineProfitsCheckResult.toJSON() : <any>undefined;
        data["globeIncomeLossPercentage"] = this.globeIncomeLossPercentage;
        data["adjustedCoveredTaxesPercentage"] = this.adjustedCoveredTaxesPercentage;
        data["substanceBasedIncomeExlusionPercentage"] = this.substanceBasedIncomeExlusionPercentage;
        data["effectiveTaxRateAndTopUpTaxPercentage"] = this.effectiveTaxRateAndTopUpTaxPercentage;
        data["hasReadPermission"] = this.hasReadPermission;
        data["hasWritePermission"] = this.hasWritePermission;
        data["rowExpandDisabled"] = this.rowExpandDisabled;
        data["isSpecialPermissionsActivated"] = this.isSpecialPermissionsActivated;
        data["isWritingActivated"] = this.isWritingActivated;
        return data;
    }
}

export interface IFinancialGroupDataJurisdictionsOverviewDto {
    taxJurisdictionCountry: string | undefined;
    isSafeHarboursExisting: boolean;
    isSafeHarboursApplicable: boolean;
    isFullScopeCalculationActivated: boolean;
    deMinimisCheckResult: SafeHarbourCheckResultDto;
    setrCheckResult: SafeHarbourCheckResultDto;
    routineProfitsCheckResult: SafeHarbourCheckResultDto;
    globeIncomeLossPercentage: number;
    adjustedCoveredTaxesPercentage: number;
    substanceBasedIncomeExlusionPercentage: number;
    effectiveTaxRateAndTopUpTaxPercentage: number;
    hasReadPermission: boolean;
    hasWritePermission: boolean;
    rowExpandDisabled: boolean;
    isSpecialPermissionsActivated: boolean;
    isWritingActivated: boolean;
}

export class FinancialGroupDataOrganizationalEntityOverviewDto implements IFinancialGroupDataOrganizationalEntityOverviewDto {
    organizationalEntityId!: number;
    entityName!: string | undefined;
    entityNumber!: string | undefined;
    blendingCircleSubgroupId!: number | undefined;
    globeIncomeLossStatus!: FinancialGroupDataStatus;
    adjustedCoveredTaxesStatus!: FinancialGroupDataStatus;
    substanceBasedIncomeExlusionStatus!: FinancialGroupDataStatus;
    isWritingActivated!: boolean;

    constructor(data?: IFinancialGroupDataOrganizationalEntityOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.entityName = _data["entityName"];
            this.entityNumber = _data["entityNumber"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.globeIncomeLossStatus = _data["globeIncomeLossStatus"];
            this.adjustedCoveredTaxesStatus = _data["adjustedCoveredTaxesStatus"];
            this.substanceBasedIncomeExlusionStatus = _data["substanceBasedIncomeExlusionStatus"];
            this.isWritingActivated = _data["isWritingActivated"];
        }
    }

    static fromJS(data: any): FinancialGroupDataOrganizationalEntityOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialGroupDataOrganizationalEntityOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["entityName"] = this.entityName;
        data["entityNumber"] = this.entityNumber;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["globeIncomeLossStatus"] = this.globeIncomeLossStatus;
        data["adjustedCoveredTaxesStatus"] = this.adjustedCoveredTaxesStatus;
        data["substanceBasedIncomeExlusionStatus"] = this.substanceBasedIncomeExlusionStatus;
        data["isWritingActivated"] = this.isWritingActivated;
        return data;
    }
}

export interface IFinancialGroupDataOrganizationalEntityOverviewDto {
    organizationalEntityId: number;
    entityName: string | undefined;
    entityNumber: string | undefined;
    blendingCircleSubgroupId: number | undefined;
    globeIncomeLossStatus: FinancialGroupDataStatus;
    adjustedCoveredTaxesStatus: FinancialGroupDataStatus;
    substanceBasedIncomeExlusionStatus: FinancialGroupDataStatus;
    isWritingActivated: boolean;
}

export class FinancialGroupDataOverviewByBlendingCircleSubgroupInput implements IFinancialGroupDataOverviewByBlendingCircleSubgroupInput {
    projectId!: number;
    blendingCircleSubgroupId!: number;

    constructor(data?: IFinancialGroupDataOverviewByBlendingCircleSubgroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
        }
    }

    static fromJS(data: any): FinancialGroupDataOverviewByBlendingCircleSubgroupInput {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialGroupDataOverviewByBlendingCircleSubgroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        return data;
    }
}

export interface IFinancialGroupDataOverviewByBlendingCircleSubgroupInput {
    projectId: number;
    blendingCircleSubgroupId: number;
}

export class FinancialGroupDataOverviewInput implements IFinancialGroupDataOverviewInput {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    projectId!: number;
    filter!: string | undefined;

    constructor(data?: IFinancialGroupDataOverviewInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.projectId = _data["projectId"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FinancialGroupDataOverviewInput {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialGroupDataOverviewInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["projectId"] = this.projectId;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IFinancialGroupDataOverviewInput {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    projectId: number;
    filter: string | undefined;
}

export enum FinancialGroupDataStatus {
    NoData = 1,
    SomeData = 2,
    AllData = 3,
    AllDataConfirmed = 4,
}

export class FinancialGroupDto implements IFinancialGroupDto {
    name!: string | undefined;
    isConfirmed!: boolean;
    footerName!: string | undefined;
    currentValue!: FinancialValueDto;
    prevoiusValue!: string | undefined;
    isApplicationOfTheSubstanceBasedIncomeExclusionRuleForachJurisdictionApplicable!: boolean;
    financialNodes!: FinancialNodeDto[] | undefined;
    hasReadPermission!: boolean;
    hasWritePermission!: boolean;
    sumOfGlobeIncomeLoss!: FinancialValueDto;
    sumOfAdjustedCoveredTaxes!: FinancialValueDto;
    isSpecialPermissionsActivated!: boolean;
    isWritingActivated!: boolean;
    presentationCurrency!: string | undefined;
    entityCurrency!: string | undefined;
    hasAccountingCurrencyValue!: boolean;
    hasWarningNode!: boolean;

    constructor(data?: IFinancialGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isConfirmed = _data["isConfirmed"];
            this.footerName = _data["footerName"];
            this.currentValue = _data["currentValue"] ? FinancialValueDto.fromJS(_data["currentValue"]) : <any>undefined;
            this.prevoiusValue = _data["prevoiusValue"];
            this.isApplicationOfTheSubstanceBasedIncomeExclusionRuleForachJurisdictionApplicable = _data["isApplicationOfTheSubstanceBasedIncomeExclusionRuleForachJurisdictionApplicable"];
            if (Array.isArray(_data["financialNodes"])) {
                this.financialNodes = [] as any;
                for (let item of _data["financialNodes"])
                    this.financialNodes!.push(FinancialNodeDto.fromJS(item));
            }
            this.hasReadPermission = _data["hasReadPermission"];
            this.hasWritePermission = _data["hasWritePermission"];
            this.sumOfGlobeIncomeLoss = _data["sumOfGlobeIncomeLoss"] ? FinancialValueDto.fromJS(_data["sumOfGlobeIncomeLoss"]) : <any>undefined;
            this.sumOfAdjustedCoveredTaxes = _data["sumOfAdjustedCoveredTaxes"] ? FinancialValueDto.fromJS(_data["sumOfAdjustedCoveredTaxes"]) : <any>undefined;
            this.isSpecialPermissionsActivated = _data["isSpecialPermissionsActivated"];
            this.isWritingActivated = _data["isWritingActivated"];
            this.presentationCurrency = _data["presentationCurrency"];
            this.entityCurrency = _data["entityCurrency"];
            this.hasAccountingCurrencyValue = _data["hasAccountingCurrencyValue"];
            this.hasWarningNode = _data["hasWarningNode"];
        }
    }

    static fromJS(data: any): FinancialGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isConfirmed"] = this.isConfirmed;
        data["footerName"] = this.footerName;
        data["currentValue"] = this.currentValue ? this.currentValue.toJSON() : <any>undefined;
        data["prevoiusValue"] = this.prevoiusValue;
        data["isApplicationOfTheSubstanceBasedIncomeExclusionRuleForachJurisdictionApplicable"] = this.isApplicationOfTheSubstanceBasedIncomeExclusionRuleForachJurisdictionApplicable;
        if (Array.isArray(this.financialNodes)) {
            data["financialNodes"] = [];
            for (let item of this.financialNodes)
                data["financialNodes"].push(item.toJSON());
        }
        data["hasReadPermission"] = this.hasReadPermission;
        data["hasWritePermission"] = this.hasWritePermission;
        data["sumOfGlobeIncomeLoss"] = this.sumOfGlobeIncomeLoss ? this.sumOfGlobeIncomeLoss.toJSON() : <any>undefined;
        data["sumOfAdjustedCoveredTaxes"] = this.sumOfAdjustedCoveredTaxes ? this.sumOfAdjustedCoveredTaxes.toJSON() : <any>undefined;
        data["isSpecialPermissionsActivated"] = this.isSpecialPermissionsActivated;
        data["isWritingActivated"] = this.isWritingActivated;
        data["presentationCurrency"] = this.presentationCurrency;
        data["entityCurrency"] = this.entityCurrency;
        data["hasAccountingCurrencyValue"] = this.hasAccountingCurrencyValue;
        data["hasWarningNode"] = this.hasWarningNode;
        return data;
    }
}

export interface IFinancialGroupDto {
    name: string | undefined;
    isConfirmed: boolean;
    footerName: string | undefined;
    currentValue: FinancialValueDto;
    prevoiusValue: string | undefined;
    isApplicationOfTheSubstanceBasedIncomeExclusionRuleForachJurisdictionApplicable: boolean;
    financialNodes: FinancialNodeDto[] | undefined;
    hasReadPermission: boolean;
    hasWritePermission: boolean;
    sumOfGlobeIncomeLoss: FinancialValueDto;
    sumOfAdjustedCoveredTaxes: FinancialValueDto;
    isSpecialPermissionsActivated: boolean;
    isWritingActivated: boolean;
    presentationCurrency: string | undefined;
    entityCurrency: string | undefined;
    hasAccountingCurrencyValue: boolean;
    hasWarningNode: boolean;
}

export enum FinancialGroupType {
    Overview = 1,
    GlobeIncomeLoss = 2,
    SubstanceBasedIncomeExlusion = 3,
    AdjustedCoveredTaxes = 4,
    EtrAndTut = 5,
}

export class FinancialNodeDto implements IFinancialNodeDto {
    id!: string | undefined;
    referenceId!: number;
    isSendingEntity!: boolean | undefined;
    anotherEntityId!: number | undefined;
    path!: string[] | undefined;
    financialNodeType!: FinancialNodeType;
    name!: string | undefined;
    financialType!: string | undefined;
    financialNodeGroupType!: string | undefined;
    localizationKey!: string | undefined;
    localizationParameters!: string[] | undefined;
    readonly footerName!: string | undefined;
    basisForAdjustments!: BasisForAdjustmentsType;
    lossCarryBack!: FinancialValueDto;
    maxTaxRateOfMainEntityJurisdiction!: string | undefined;
    passiveIncomeOfCEOrHybridEntity!: FinancialValueDto;
    domesticTaxRate!: FinancialValueDto;
    nonEligibleEmployeeCostsPreliminary!: FinancialValueDto;
    nonEligibleTangibleAssetsAveragePreliminary!: FinancialValueDto;
    percentageRateWorkingTimeInJurisdiction!: string | undefined;
    percentageRateOfLocationTimeInJurisdiction!: string | undefined;
    fiscalYearBeginning!: FinancialValueDto;
    fiscalYearEnd!: FinancialValueDto;
    warning!: string | undefined;
    hideWarningWhenExpanded!: boolean;
    initialValueWarning!: string | undefined;
    valueToMatch!: string | undefined;
    currentValueLabel!: string | undefined;
    currentValueDescription!: string | undefined;
    otherEntityLabel!: string | undefined;
    fiscalYearBeginningLabel!: string | undefined;
    fiscalYearEndLabel!: string | undefined;
    fiscalYearAverageLabel!: string | undefined;
    calculatedCurrent!: FinancialValueDto;
    calculatedFinal!: FinancialValueDto;
    financialYear!: FinancialYearType;
    currentValue!: ConfirmableDtoOfFinancialValueDto;
    previousValue!: ConfirmableDtoOfFinancialValueDto;
    isDisabled!: boolean;
    isActivated!: boolean;
    validationLogic!: FinancialTraceValidationLogic;
    multipleNodeGroupId!: number | undefined;
    financialValueTracePointAdditionalInfo!: FinancialValueTracePointAdditionalDto;
    isManualCorrectionIncoming!: boolean;
    hasDeletePermission!: boolean;
    crossAllocationOfTaxesRecalculationWarningDto!: CrossAllocationOfTaxesRecalculationWarningDto;
    crossAllocationOfTaxes434RecalculationWarningDto!: CrossAllocationOfTaxes434RecalculationWarningDto;
    country!: string | undefined;
    blendingCircleSubgroupType!: string | undefined;
    blendingCircleSubgroupId!: number | undefined;

    constructor(data?: IFinancialNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.referenceId = _data["referenceId"];
            this.isSendingEntity = _data["isSendingEntity"];
            this.anotherEntityId = _data["anotherEntityId"];
            if (Array.isArray(_data["path"])) {
                this.path = [] as any;
                for (let item of _data["path"])
                    this.path!.push(item);
            }
            this.financialNodeType = _data["financialNodeType"];
            this.name = _data["name"];
            this.financialType = _data["financialType"];
            this.financialNodeGroupType = _data["financialNodeGroupType"];
            this.localizationKey = _data["localizationKey"];
            if (Array.isArray(_data["localizationParameters"])) {
                this.localizationParameters = [] as any;
                for (let item of _data["localizationParameters"])
                    this.localizationParameters!.push(item);
            }
            (<any>this).footerName = _data["footerName"];
            this.basisForAdjustments = _data["basisForAdjustments"];
            this.lossCarryBack = _data["lossCarryBack"] ? FinancialValueDto.fromJS(_data["lossCarryBack"]) : <any>undefined;
            this.maxTaxRateOfMainEntityJurisdiction = _data["maxTaxRateOfMainEntityJurisdiction"];
            this.passiveIncomeOfCEOrHybridEntity = _data["passiveIncomeOfCEOrHybridEntity"] ? FinancialValueDto.fromJS(_data["passiveIncomeOfCEOrHybridEntity"]) : <any>undefined;
            this.domesticTaxRate = _data["domesticTaxRate"] ? FinancialValueDto.fromJS(_data["domesticTaxRate"]) : <any>undefined;
            this.nonEligibleEmployeeCostsPreliminary = _data["nonEligibleEmployeeCostsPreliminary"] ? FinancialValueDto.fromJS(_data["nonEligibleEmployeeCostsPreliminary"]) : <any>undefined;
            this.nonEligibleTangibleAssetsAveragePreliminary = _data["nonEligibleTangibleAssetsAveragePreliminary"] ? FinancialValueDto.fromJS(_data["nonEligibleTangibleAssetsAveragePreliminary"]) : <any>undefined;
            this.percentageRateWorkingTimeInJurisdiction = _data["percentageRateWorkingTimeInJurisdiction"];
            this.percentageRateOfLocationTimeInJurisdiction = _data["percentageRateOfLocationTimeInJurisdiction"];
            this.fiscalYearBeginning = _data["fiscalYearBeginning"] ? FinancialValueDto.fromJS(_data["fiscalYearBeginning"]) : <any>undefined;
            this.fiscalYearEnd = _data["fiscalYearEnd"] ? FinancialValueDto.fromJS(_data["fiscalYearEnd"]) : <any>undefined;
            this.warning = _data["warning"];
            this.hideWarningWhenExpanded = _data["hideWarningWhenExpanded"];
            this.initialValueWarning = _data["initialValueWarning"];
            this.valueToMatch = _data["valueToMatch"];
            this.currentValueLabel = _data["currentValueLabel"];
            this.currentValueDescription = _data["currentValueDescription"];
            this.otherEntityLabel = _data["otherEntityLabel"];
            this.fiscalYearBeginningLabel = _data["fiscalYearBeginningLabel"];
            this.fiscalYearEndLabel = _data["fiscalYearEndLabel"];
            this.fiscalYearAverageLabel = _data["fiscalYearAverageLabel"];
            this.calculatedCurrent = _data["calculatedCurrent"] ? FinancialValueDto.fromJS(_data["calculatedCurrent"]) : <any>undefined;
            this.calculatedFinal = _data["calculatedFinal"] ? FinancialValueDto.fromJS(_data["calculatedFinal"]) : <any>undefined;
            this.financialYear = _data["financialYear"];
            this.currentValue = _data["currentValue"] ? ConfirmableDtoOfFinancialValueDto.fromJS(_data["currentValue"]) : <any>undefined;
            this.previousValue = _data["previousValue"] ? ConfirmableDtoOfFinancialValueDto.fromJS(_data["previousValue"]) : <any>undefined;
            this.isDisabled = _data["isDisabled"];
            this.isActivated = _data["isActivated"];
            this.validationLogic = _data["validationLogic"] ? FinancialTraceValidationLogic.fromJS(_data["validationLogic"]) : <any>undefined;
            this.multipleNodeGroupId = _data["multipleNodeGroupId"];
            this.financialValueTracePointAdditionalInfo = _data["financialValueTracePointAdditionalInfo"] ? FinancialValueTracePointAdditionalDto.fromJS(_data["financialValueTracePointAdditionalInfo"]) : <any>undefined;
            this.isManualCorrectionIncoming = _data["isManualCorrectionIncoming"];
            this.hasDeletePermission = _data["hasDeletePermission"];
            this.crossAllocationOfTaxesRecalculationWarningDto = _data["crossAllocationOfTaxesRecalculationWarningDto"] ? CrossAllocationOfTaxesRecalculationWarningDto.fromJS(_data["crossAllocationOfTaxesRecalculationWarningDto"]) : <any>undefined;
            this.crossAllocationOfTaxes434RecalculationWarningDto = _data["crossAllocationOfTaxes434RecalculationWarningDto"] ? CrossAllocationOfTaxes434RecalculationWarningDto.fromJS(_data["crossAllocationOfTaxes434RecalculationWarningDto"]) : <any>undefined;
            this.country = _data["country"];
            this.blendingCircleSubgroupType = _data["blendingCircleSubgroupType"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
        }
    }

    static fromJS(data: any): FinancialNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["referenceId"] = this.referenceId;
        data["isSendingEntity"] = this.isSendingEntity;
        data["anotherEntityId"] = this.anotherEntityId;
        if (Array.isArray(this.path)) {
            data["path"] = [];
            for (let item of this.path)
                data["path"].push(item);
        }
        data["financialNodeType"] = this.financialNodeType;
        data["name"] = this.name;
        data["financialType"] = this.financialType;
        data["financialNodeGroupType"] = this.financialNodeGroupType;
        data["localizationKey"] = this.localizationKey;
        if (Array.isArray(this.localizationParameters)) {
            data["localizationParameters"] = [];
            for (let item of this.localizationParameters)
                data["localizationParameters"].push(item);
        }
        data["footerName"] = this.footerName;
        data["basisForAdjustments"] = this.basisForAdjustments;
        data["lossCarryBack"] = this.lossCarryBack ? this.lossCarryBack.toJSON() : <any>undefined;
        data["maxTaxRateOfMainEntityJurisdiction"] = this.maxTaxRateOfMainEntityJurisdiction;
        data["passiveIncomeOfCEOrHybridEntity"] = this.passiveIncomeOfCEOrHybridEntity ? this.passiveIncomeOfCEOrHybridEntity.toJSON() : <any>undefined;
        data["domesticTaxRate"] = this.domesticTaxRate ? this.domesticTaxRate.toJSON() : <any>undefined;
        data["nonEligibleEmployeeCostsPreliminary"] = this.nonEligibleEmployeeCostsPreliminary ? this.nonEligibleEmployeeCostsPreliminary.toJSON() : <any>undefined;
        data["nonEligibleTangibleAssetsAveragePreliminary"] = this.nonEligibleTangibleAssetsAveragePreliminary ? this.nonEligibleTangibleAssetsAveragePreliminary.toJSON() : <any>undefined;
        data["percentageRateWorkingTimeInJurisdiction"] = this.percentageRateWorkingTimeInJurisdiction;
        data["percentageRateOfLocationTimeInJurisdiction"] = this.percentageRateOfLocationTimeInJurisdiction;
        data["fiscalYearBeginning"] = this.fiscalYearBeginning ? this.fiscalYearBeginning.toJSON() : <any>undefined;
        data["fiscalYearEnd"] = this.fiscalYearEnd ? this.fiscalYearEnd.toJSON() : <any>undefined;
        data["warning"] = this.warning;
        data["hideWarningWhenExpanded"] = this.hideWarningWhenExpanded;
        data["initialValueWarning"] = this.initialValueWarning;
        data["valueToMatch"] = this.valueToMatch;
        data["currentValueLabel"] = this.currentValueLabel;
        data["currentValueDescription"] = this.currentValueDescription;
        data["otherEntityLabel"] = this.otherEntityLabel;
        data["fiscalYearBeginningLabel"] = this.fiscalYearBeginningLabel;
        data["fiscalYearEndLabel"] = this.fiscalYearEndLabel;
        data["fiscalYearAverageLabel"] = this.fiscalYearAverageLabel;
        data["calculatedCurrent"] = this.calculatedCurrent ? this.calculatedCurrent.toJSON() : <any>undefined;
        data["calculatedFinal"] = this.calculatedFinal ? this.calculatedFinal.toJSON() : <any>undefined;
        data["financialYear"] = this.financialYear;
        data["currentValue"] = this.currentValue ? this.currentValue.toJSON() : <any>undefined;
        data["previousValue"] = this.previousValue ? this.previousValue.toJSON() : <any>undefined;
        data["isDisabled"] = this.isDisabled;
        data["isActivated"] = this.isActivated;
        data["validationLogic"] = this.validationLogic ? this.validationLogic.toJSON() : <any>undefined;
        data["multipleNodeGroupId"] = this.multipleNodeGroupId;
        data["financialValueTracePointAdditionalInfo"] = this.financialValueTracePointAdditionalInfo ? this.financialValueTracePointAdditionalInfo.toJSON() : <any>undefined;
        data["isManualCorrectionIncoming"] = this.isManualCorrectionIncoming;
        data["hasDeletePermission"] = this.hasDeletePermission;
        data["crossAllocationOfTaxesRecalculationWarningDto"] = this.crossAllocationOfTaxesRecalculationWarningDto ? this.crossAllocationOfTaxesRecalculationWarningDto.toJSON() : <any>undefined;
        data["crossAllocationOfTaxes434RecalculationWarningDto"] = this.crossAllocationOfTaxes434RecalculationWarningDto ? this.crossAllocationOfTaxes434RecalculationWarningDto.toJSON() : <any>undefined;
        data["country"] = this.country;
        data["blendingCircleSubgroupType"] = this.blendingCircleSubgroupType;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        return data;
    }
}

export interface IFinancialNodeDto {
    id: string | undefined;
    referenceId: number;
    isSendingEntity: boolean | undefined;
    anotherEntityId: number | undefined;
    path: string[] | undefined;
    financialNodeType: FinancialNodeType;
    name: string | undefined;
    financialType: string | undefined;
    financialNodeGroupType: string | undefined;
    localizationKey: string | undefined;
    localizationParameters: string[] | undefined;
    footerName: string | undefined;
    basisForAdjustments: BasisForAdjustmentsType;
    lossCarryBack: FinancialValueDto;
    maxTaxRateOfMainEntityJurisdiction: string | undefined;
    passiveIncomeOfCEOrHybridEntity: FinancialValueDto;
    domesticTaxRate: FinancialValueDto;
    nonEligibleEmployeeCostsPreliminary: FinancialValueDto;
    nonEligibleTangibleAssetsAveragePreliminary: FinancialValueDto;
    percentageRateWorkingTimeInJurisdiction: string | undefined;
    percentageRateOfLocationTimeInJurisdiction: string | undefined;
    fiscalYearBeginning: FinancialValueDto;
    fiscalYearEnd: FinancialValueDto;
    warning: string | undefined;
    hideWarningWhenExpanded: boolean;
    initialValueWarning: string | undefined;
    valueToMatch: string | undefined;
    currentValueLabel: string | undefined;
    currentValueDescription: string | undefined;
    otherEntityLabel: string | undefined;
    fiscalYearBeginningLabel: string | undefined;
    fiscalYearEndLabel: string | undefined;
    fiscalYearAverageLabel: string | undefined;
    calculatedCurrent: FinancialValueDto;
    calculatedFinal: FinancialValueDto;
    financialYear: FinancialYearType;
    currentValue: ConfirmableDtoOfFinancialValueDto;
    previousValue: ConfirmableDtoOfFinancialValueDto;
    isDisabled: boolean;
    isActivated: boolean;
    validationLogic: FinancialTraceValidationLogic;
    multipleNodeGroupId: number | undefined;
    financialValueTracePointAdditionalInfo: FinancialValueTracePointAdditionalDto;
    isManualCorrectionIncoming: boolean;
    hasDeletePermission: boolean;
    crossAllocationOfTaxesRecalculationWarningDto: CrossAllocationOfTaxesRecalculationWarningDto;
    crossAllocationOfTaxes434RecalculationWarningDto: CrossAllocationOfTaxes434RecalculationWarningDto;
    country: string | undefined;
    blendingCircleSubgroupType: string | undefined;
    blendingCircleSubgroupId: number | undefined;
}

export enum FinancialNodeGroupType {
    ACTDeferredTaxesRelatedToGloBEExclIncomeAndLosses = 1,
    ACTDeferredTaxExpenseRelatedToDisallowedAccruals = 2,
    ACTDeferredTaxExpenseRelatedToUnclaimedAccruals = 3,
    ACTDeferredTaxValuationAdjustment = 4,
    ACTRemeasurmentRelatedToChangesInTaxRate = 5,
    ACTGenerationAndUseOfTaxCredits = 6,
    ACTDeemedSubstituteLCF = 7,
    ACTDisallowedAccrualsOrUnclaimedAccrualsPaidDuringFY = 8,
    ACTRecaptureDTLiabilityPaidDuringFY = 9,
    ACTRecognitionOfDeemedDTA = 10,
    ACTDTEAdjustmentInCaseOfIncreaseOfTaxRate = 11,
    EtrAndTutAdditionalCurrentTutOther = 12,
    GloBEArmsLengthAdjustmentValue = 13,
    GloBEArmsLengthAdjustmentLoss = 14,
}

export enum FinancialNodeType {
    GroupType = 1,
    SingleValueType = 2,
    GroupShiftType = 3,
    ShiftType = 4,
    MultipleNodeGroupType = 5,
    SingleNodeGroupType = 6,
    FinancialReadonlyType = 7,
    MultipleShiftNodeGroupType = 8,
    GroupValueType = 11,
    MultipleValueTypes = 22,
}

export enum FinancialShiftType {
    GloBEItemsBookedOtherLevel = 1,
    GloBEAllocationIncomeLossMainPeAndFte = 2,
    GloBEAllocationIncomeLoss = 3,
    GloBEArmsLengthAdjustmentValue = 4,
    GloBEArmsLengthAdjustmentLoss = 5,
    GloBEValueArmsLengthAdjustmentValue = 6,
    GloBEValueArmsLengthAdjustmentLoss = 7,
    GloBEManualInvestmentOrInsuranceInvestmentAdjustment74 = 8,
    GloBEManualInvestmentOrInsuranceInvestmentAdjustment75 = 9,
    GloBEManualInvestmentOrInsuranceInvestmentAdjustment76 = 10,
    ACTCrossAllocationOfTaxes = 11,
    ACTManualInvestmentOrInsuranceInvestmentAdjustment74 = 12,
    ACTManualInvestmentOrInsuranceInvestmentAdjustment75 = 13,
    ACTManualInvestmentOrInsuranceInvestmentAdjustment76 = 14,
    SBIECrossAllocationOfPayrollCostsPe = 15,
    SBIECrossAllocationPayrollCostsForFlowThroughEntitiesThatAreNotTheUPE = 16,
    SBIECrossAllocationEligibleTangibleAssetsPeAverage = 17,
    SBIECrossAllocationEligibleTangibleAssetsFlowThroughNonUPE = 18,
}

export class FinancialTraceValidationLogic implements IFinancialTraceValidationLogic {
    currentValueRules!: ValidationRuleType[] | undefined;

    constructor(data?: IFinancialTraceValidationLogic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["currentValueRules"])) {
                this.currentValueRules = [] as any;
                for (let item of _data["currentValueRules"])
                    this.currentValueRules!.push(item);
            }
        }
    }

    static fromJS(data: any): FinancialTraceValidationLogic {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialTraceValidationLogic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.currentValueRules)) {
            data["currentValueRules"] = [];
            for (let item of this.currentValueRules)
                data["currentValueRules"].push(item);
        }
        return data;
    }
}

export interface IFinancialTraceValidationLogic {
    currentValueRules: ValidationRuleType[] | undefined;
}

export enum FinancialType {
    Revenue = 1,
    ProfitLoss = 2,
    IncomeTax = 3,
    DeferredTax = 4,
    TangibleAssetsEnd = 5,
    TangibleAssetsBegin = 6,
    Payroll = 7,
}

export class FinancialValueDto implements IFinancialValueDto {
    readonly decimalValue!: number | undefined;
    readonly accountingFunctionalCurrency!: string | undefined;
    warning!: string | undefined;
    readonly displayValue!: string | undefined;
    readonly convertedDecimalValue!: number | undefined;
    readonly presentationCurrency!: string | undefined;
    readonly convertedDisplayValue!: string | undefined;
    decimals!: number;
    readonly rate!: number | undefined;

    constructor(data?: IFinancialValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).decimalValue = _data["decimalValue"];
            (<any>this).accountingFunctionalCurrency = _data["accountingFunctionalCurrency"];
            this.warning = _data["warning"];
            (<any>this).displayValue = _data["displayValue"];
            (<any>this).convertedDecimalValue = _data["convertedDecimalValue"];
            (<any>this).presentationCurrency = _data["presentationCurrency"];
            (<any>this).convertedDisplayValue = _data["convertedDisplayValue"];
            this.decimals = _data["decimals"];
            (<any>this).rate = _data["rate"];
        }
    }

    static fromJS(data: any): FinancialValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["decimalValue"] = this.decimalValue;
        data["accountingFunctionalCurrency"] = this.accountingFunctionalCurrency;
        data["warning"] = this.warning;
        data["displayValue"] = this.displayValue;
        data["convertedDecimalValue"] = this.convertedDecimalValue;
        data["presentationCurrency"] = this.presentationCurrency;
        data["convertedDisplayValue"] = this.convertedDisplayValue;
        data["decimals"] = this.decimals;
        data["rate"] = this.rate;
        return data;
    }
}

export interface IFinancialValueDto {
    decimalValue: number | undefined;
    accountingFunctionalCurrency: string | undefined;
    warning: string | undefined;
    displayValue: string | undefined;
    convertedDecimalValue: number | undefined;
    presentationCurrency: string | undefined;
    convertedDisplayValue: string | undefined;
    decimals: number;
    rate: number | undefined;
}

export class FinancialValuePointDto implements IFinancialValuePointDto {
    id!: number;
    financialType!: FinancialType;
    value!: string | undefined;
    isConfirmed!: boolean;
    currency!: string | undefined;
    hasWritePermission!: boolean;
    deltaPoints!: FinancialDeltaPointDto[] | undefined;

    constructor(data?: IFinancialValuePointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.financialType = _data["financialType"];
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
            this.currency = _data["currency"];
            this.hasWritePermission = _data["hasWritePermission"];
            if (Array.isArray(_data["deltaPoints"])) {
                this.deltaPoints = [] as any;
                for (let item of _data["deltaPoints"])
                    this.deltaPoints!.push(FinancialDeltaPointDto.fromJS(item));
        }
    }
    }

    static fromJS(data: any): FinancialValuePointDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialValuePointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["financialType"] = this.financialType;
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        data["currency"] = this.currency;
        data["hasWritePermission"] = this.hasWritePermission;
        if (Array.isArray(this.deltaPoints)) {
            data["deltaPoints"] = [];
            for (let item of this.deltaPoints)
                data["deltaPoints"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFinancialValuePointDto {
    id: number;
    financialType: FinancialType;
    value: string | undefined;
    isConfirmed: boolean;
    currency: string | undefined;
    hasWritePermission: boolean;
    deltaPoints: FinancialDeltaPointDto[] | undefined;
}

export class FinancialValuePointOverviewDto implements IFinancialValuePointOverviewDto {
    id!: number;
    value!: string | undefined;
    financialType!: FinancialType;
    isConfirmed!: boolean;
    hasPlausibility!: boolean;
    hasAutomaticCalculatedValue!: boolean;
    warningMessage!: string | undefined;

    constructor(data?: IFinancialValuePointOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.financialType = _data["financialType"];
            this.isConfirmed = _data["isConfirmed"];
            this.hasPlausibility = _data["hasPlausibility"];
            this.hasAutomaticCalculatedValue = _data["hasAutomaticCalculatedValue"];
            this.warningMessage = _data["warningMessage"];
        }
    }

    static fromJS(data: any): FinancialValuePointOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialValuePointOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["financialType"] = this.financialType;
        data["isConfirmed"] = this.isConfirmed;
        data["hasPlausibility"] = this.hasPlausibility;
        data["hasAutomaticCalculatedValue"] = this.hasAutomaticCalculatedValue;
        data["warningMessage"] = this.warningMessage;
        return data;
    }
}

export interface IFinancialValuePointOverviewDto {
    id: number;
    value: string | undefined;
    financialType: FinancialType;
    isConfirmed: boolean;
    hasPlausibility: boolean;
    hasAutomaticCalculatedValue: boolean;
    warningMessage: string | undefined;
}

export class FinancialValuePointWithFlatValueInput implements IFinancialValuePointWithFlatValueInput {
    financialType!: FinancialType;
    value!: string | undefined;
    hasAutomaticCalculatedValue!: boolean;

    constructor(data?: IFinancialValuePointWithFlatValueInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financialType = _data["financialType"];
            this.value = _data["value"];
            this.hasAutomaticCalculatedValue = _data["hasAutomaticCalculatedValue"];
        }
    }

    static fromJS(data: any): FinancialValuePointWithFlatValueInput {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialValuePointWithFlatValueInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialType"] = this.financialType;
        data["value"] = this.value;
        data["hasAutomaticCalculatedValue"] = this.hasAutomaticCalculatedValue;
        return data;
    }
}

export interface IFinancialValuePointWithFlatValueInput {
    financialType: FinancialType;
    value: string | undefined;
    hasAutomaticCalculatedValue: boolean;
}

export class FinancialValueTracePointAdditionalDto implements IFinancialValueTracePointAdditionalDto {
    financialYear!: FinancialYearType;
    basisForAdjustments!: BasisForAdjustmentsType;
    financialAccountingStandard!: FinancialAccountingStandard;

    constructor(data?: IFinancialValueTracePointAdditionalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financialYear = _data["financialYear"];
            this.basisForAdjustments = _data["basisForAdjustments"];
            this.financialAccountingStandard = _data["financialAccountingStandard"];
        }
    }

    static fromJS(data: any): FinancialValueTracePointAdditionalDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialValueTracePointAdditionalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialYear"] = this.financialYear;
        data["basisForAdjustments"] = this.basisForAdjustments;
        data["financialAccountingStandard"] = this.financialAccountingStandard;
        return data;
    }
}

export interface IFinancialValueTracePointAdditionalDto {
    financialYear: FinancialYearType;
    basisForAdjustments: BasisForAdjustmentsType;
    financialAccountingStandard: FinancialAccountingStandard;
}

export enum FinancialValueType {
    GloBEFanilInit = 1,
    GloBEPurchasePriceAccounting = 2,
    GloBEArmsLengthAdjustmentAccounting = 3,
    GloBECorrectionArmsLengthAdjustmentValue = 4,
    GloBECorrectionArmsLengthAdjustmentLoss = 5,
    GloBETaxCreditAccounting = 6,
    GloBENetTaxesExpense = 7,
    GloBENetTaxesExpenseCorrection = 8,
    GloBECoveredTaxesAboveTaxLine = 9,
    GloBEExcludedDividends = 10,
    GloBEExcludedEquityGainOrLoss = 11,
    GloBERevaluationMethod = 12,
    GloBEReorgEffects = 13,
    GloBEAsymmetricForeignCurrencyPL = 14,
    GloBEPolicyDisallowedExpenses = 15,
    GloBEChangesInAccountingPrinciples = 16,
    GloBEAccruedPensionExpense = 17,
    GloBEDebtRelease = 18,
    GloBEStockBasedCompensationTaxPurposes = 19,
    GloBEStockBasedCompensationFinancialStatements = 20,
    GloBEStockBasedCompensationExpiredWithoutExercise = 21,
    GloBEStockBasedCompensationOptInOutAdjustment = 22,
    GloBEQualifiedRefundableTaxCredits = 23,
    GloBENonQualifyingTaxCredit = 24,
    GloBEPLAttributableFairValueAccounting = 25,
    GloBEPLAttributableRealisationPrinciple = 26,
    GloBEAdjustedAmountRevocation = 27,
    GloBEAssetGainPL = 28,
    GloBEAmountActualYear = 29,
    GloBEIntragroupFinancingAgreementExpense = 30,
    GloBETaxGroupICTransactions = 31,
    GloBECorrectionRevocationYear = 32,
    ACTInit = 33,
    ACTCurrentTaxExpenseWithRespectToCoveredTaxesAfterAllocations = 34,
    ACTAdditions = 35,
    ACTReductions = 36,
    ACTCoveredTaxBeforeAllocations = 37,
    ACTCoveredTaxesBookedAboveTheLine = 38,
    ACTGloBELossElection = 39,
    ACTUTPTaxesPaidForPriorYears = 40,
    ACTQualifiedRefundableTaxCredits = 41,
    ACTQualifiedFlowThroughTaxBenefits = 42,
    ACTAnyOtherTaxAmountInConnectionWithGloBEIncomeAdjustment = 43,
    ACTNonQualifiedTaxCredit = 44,
    ACTTaxRefundsNotTreatedAsAnAdjustementToCurrentTaxExpense = 45,
    ACTTaxCurrentTaxExpenseRelatedToUTP = 46,
    ACTCurrentTaxesNotExpectedToBePaidWithin3Years = 47,
    ACTCurrentTaxesNotPaidWithin3Years = 48,
    ACTCurrentTaxExpense = 49,
    ACTCurrentTaxCorrection = 50,
    ACTCurrentTaxesCorrection = 51,
    ACTGloBETaxes = 52,
    ACTDisqualifiedRefundableImputationTax = 53,
    ACTFurtherCorrections = 54,
    ACTDeferredTaxesAndOtherAdjustments = 55,
    ACTPostFilingAdjustmentsAndTaxLossCarryBacks = 56,
    ACTPostFilingAdjustment = 57,
    ACTTaxLossCarryBacksTLCB = 58,
    ACTCoveredTaxRefundForTLCBForEachCarryBackYears = 59,
    ACTDeemedDeferredTaxAssetForEachCarryBackYear = 60,
    ACTMinusSumOfDeemedDeferredTaxAssetForEachCarryBackYear = 61,
    ACTCoveredTaxesRelatingToNetAssetGainOrNetAssetLoss = 62,
    ACTDeferredTaxExpenseAmount = 63,
    ACTTaxRateDeferredTaxCalculationUsed = 64,
    ACTDTARecastForGloBELoss = 65,
    ACTDeferredTaxExpenseRecast = 66,
    ACTValueAccordingToFinancialStatements = 67,
    ACTAdaptedTaxRate = 68,
    ACTRecastCompensation = 69,
    ACTValueIncludedInComputation = 70,
    ACTDTEAdjustmentInCaseOfReductionOfTaxRate = 71,
    ACTDeemedDeferredTaxAssetInCaseOfTLCB = 72,
    ACTIncreaseOrDecreaseInCoveredTaxesRecordedEquityOrOCI = 73,
    SBIESubstanceBasedIncomeExlusion = 74,
    SBIEPayrollCarveOut = 75,
    SBIEEligiblePayrollCosts = 76,
    SBIEEligiblePayrollCostsBeforeAllocation = 77,
    SBIEPayrollCosts = 78,
    SBIECorrectionIndependantContractors = 79,
    SBIENonEligibleEmployeeCosts = 80,
    SBIENonEligiblePayrollCosts = 81,
    SBIECorrectionCapitalisedCosts = 82,
    SBIEOtherCorrectionPayrollCosts = 83,
    SBIEEligiblePayrollCostsAfterAllocationToFlowThroughEntities = 84,
    SBIERelevantMarkUpEligiblePayrollCostsPercentage = 85,
    SBIETangibleAssetCarveOut = 86,
    SBIECarryingValueOfEligibleTangibleAssets = 87,
    SBIECarryingValueOfEligibleTangibleAssetsBeforeAllocation = 88,
    SBIETangibleAssetsAverage = 89,
    SBIEAdditionsToTangibleAssetsAverage = 90,
    SBIENonEligibleTangibleAssetsValue = 91,
    SBIELeasingAdjustmentsAverage = 92,
    SBIEOtherCorrectionTangibleAssetsAverage = 93,
    SBIECrossAllocationEligibleTangibleAssetsPeAverage = 94,
    SBIERelevantMarkUpEligibleTangibleAssetPercentage = 95,
    SBIESumOfExcludedEligiblePayrollCostsOfFTE = 96,
    SBIESumOfExcludedCarryingValueOfEligibleTangibleAssetsOfFTE = 97,
    EtrAndTutReductionBecauseOfTLCB = 98,
    EtrAndTutReductionBecauseOfTLCBAddTut = 99,
    EtrAndTutEtrAdjustmentArt = 100,
    EtrAndTutYear = 101,
    EtrAndTutPrevReportedNetGloBEIncomeLoss = 102,
    EtrAndTutRecalcNetGloBEIncomeLoss = 103,
    EtrAndTutPrevReportedACT = 104,
    EtrAndTutRecalcACT = 105,
    EtrAndTutPrevReportedEtr = 106,
    EtrAndTutRecalcEtr = 107,
    EtrAndTutPrevReportedExcessProfit = 108,
    EtrAndTutRecalcExcessProfit = 109,
    EtrAndTutPrevReportedTutPercentage = 110,
    EtrAndTutRecalcTutPercentage = 111,
    EtrAndTutPrevReportedTut = 112,
    EtrAndTutRecalcTut = 113,
    EtrAndTutAdditionalCurrentTutOther = 114,
    EtrAndTutQDMTT = 115,
    EtrAndTutFinancialAccountingStandard = 116,
}

export enum FinancialYearType {
    FinancialYear1 = 1,
    FinancialYear2 = 2,
    FinancialYear3 = 3,
    FinancialYear4 = 4,
    FinancialYear5 = 5,
}

export class FreeAllowanceToProfitDto implements IFreeAllowanceToProfitDto {
    jurisdiction!: string | undefined;
    safeHarbourGroupType!: SafeHarbourGroupType;
    number!: number | undefined;
    freeAllowanceByProfitLoss!: number | undefined;

    constructor(data?: IFreeAllowanceToProfitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jurisdiction = _data["jurisdiction"];
            this.safeHarbourGroupType = _data["safeHarbourGroupType"];
            this.number = _data["number"];
            this.freeAllowanceByProfitLoss = _data["freeAllowanceByProfitLoss"];
        }
    }

    static fromJS(data: any): FreeAllowanceToProfitDto {
        data = typeof data === 'object' ? data : {};
        let result = new FreeAllowanceToProfitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jurisdiction"] = this.jurisdiction;
        data["safeHarbourGroupType"] = this.safeHarbourGroupType;
        data["number"] = this.number;
        data["freeAllowanceByProfitLoss"] = this.freeAllowanceByProfitLoss;
        return data;
    }
}

export interface IFreeAllowanceToProfitDto {
    jurisdiction: string | undefined;
    safeHarbourGroupType: SafeHarbourGroupType;
    number: number | undefined;
    freeAllowanceByProfitLoss: number | undefined;
}

export class FullProjectManagementDto implements IFullProjectManagementDto {
    assignedUser!: AssignableUserDto;
    criticality!: Criticality;
    priority!: Priority;
    effort!: number | undefined;
    plannedStart!: DateTime | undefined;
    plannedEnd!: DateTime | undefined;

    constructor(data?: IFullProjectManagementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignedUser = _data["assignedUser"] ? AssignableUserDto.fromJS(_data["assignedUser"]) : <any>undefined;
            this.criticality = _data["criticality"];
            this.priority = _data["priority"];
            this.effort = _data["effort"];
            this.plannedStart = _data["plannedStart"] ? DateTime.fromISO(_data["plannedStart"].toString()) : <any>undefined;
            this.plannedEnd = _data["plannedEnd"] ? DateTime.fromISO(_data["plannedEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FullProjectManagementDto {
        data = typeof data === 'object' ? data : {};
        let result = new FullProjectManagementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : <any>undefined;
        data["criticality"] = this.criticality;
        data["priority"] = this.priority;
        data["effort"] = this.effort;
        data["plannedStart"] = this.plannedStart ? this.plannedStart.toString() : <any>undefined;
        data["plannedEnd"] = this.plannedEnd ? this.plannedEnd.toString() : <any>undefined;
        return data;
    }
}

export interface IFullProjectManagementDto {
    assignedUser: AssignableUserDto;
    criticality: Criticality;
    priority: Priority;
    effort: number | undefined;
    plannedStart: DateTime | undefined;
    plannedEnd: DateTime | undefined;
}

export class FullProjectManagementInput implements IFullProjectManagementInput {
    assignedUser!: AssignableUserInput;
    criticality!: Criticality;
    priority!: Priority;
    effort!: number | undefined;
    plannedStart!: DateTime | undefined;
    plannedEnd!: DateTime | undefined;

    constructor(data?: IFullProjectManagementInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignedUser = _data["assignedUser"] ? AssignableUserInput.fromJS(_data["assignedUser"]) : <any>undefined;
            this.criticality = _data["criticality"];
            this.priority = _data["priority"];
            this.effort = _data["effort"];
            this.plannedStart = _data["plannedStart"] ? DateTime.fromISO(_data["plannedStart"].toString()) : <any>undefined;
            this.plannedEnd = _data["plannedEnd"] ? DateTime.fromISO(_data["plannedEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FullProjectManagementInput {
        data = typeof data === 'object' ? data : {};
        let result = new FullProjectManagementInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : <any>undefined;
        data["criticality"] = this.criticality;
        data["priority"] = this.priority;
        data["effort"] = this.effort;
        data["plannedStart"] = this.plannedStart ? this.plannedStart.toString() : <any>undefined;
        data["plannedEnd"] = this.plannedEnd ? this.plannedEnd.toString() : <any>undefined;
        return data;
    }
}

export interface IFullProjectManagementInput {
    assignedUser: AssignableUserInput;
    criticality: Criticality;
    priority: Priority;
    effort: number | undefined;
    plannedStart: DateTime | undefined;
    plannedEnd: DateTime | undefined;
}

export class FullScopeCalculationsOverviewDto implements IFullScopeCalculationsOverviewDto {
    blendingCircleSubgroupId!: number | undefined;
    taxJurisdictionCountry!: string | undefined;
    subgroupType!: BlendingCircleSubgroupType;
    number!: number | undefined;

    constructor(data?: IFullScopeCalculationsOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.taxJurisdictionCountry = _data["taxJurisdictionCountry"];
            this.subgroupType = _data["subgroupType"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): FullScopeCalculationsOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new FullScopeCalculationsOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["taxJurisdictionCountry"] = this.taxJurisdictionCountry;
        data["subgroupType"] = this.subgroupType;
        data["number"] = this.number;
        return data;
    }
}

export interface IFullScopeCalculationsOverviewDto {
    blendingCircleSubgroupId: number | undefined;
    taxJurisdictionCountry: string | undefined;
    subgroupType: BlendingCircleSubgroupType;
    number: number | undefined;
}

export class GeneraInput implements IGeneraInput {
    name!: string | undefined;
    note!: string | undefined;
    tags!: TagDto[] | undefined;

    constructor(data?: IGeneraInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.note = _data["note"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GeneraInput {
        data = typeof data === 'object' ? data : {};
        let result = new GeneraInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["note"] = this.note;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGeneraInput {
    name: string | undefined;
    note: string | undefined;
    tags: TagDto[] | undefined;
}

export class GeneralDto implements IGeneralDto {
    name!: string | undefined;
    note!: string | undefined;
    tags!: TagDto[] | undefined;

    constructor(data?: IGeneralDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.note = _data["note"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GeneralDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["note"] = this.note;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGeneralDto {
    name: string | undefined;
    note: string | undefined;
    tags: TagDto[] | undefined;
}

export class GenerateProjectReportInput implements IGenerateProjectReportInput {
    projectId!: number;
    reportType!: ProjectReportType;

    constructor(data?: IGenerateProjectReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.reportType = _data["reportType"];
        }
    }

    static fromJS(data: any): GenerateProjectReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateProjectReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["reportType"] = this.reportType;
        return data;
    }
}

export interface IGenerateProjectReportInput {
    projectId: number;
    reportType: ProjectReportType;
}

export class GetFinancialDataOrganizationalEntityByIdsOverviewInput implements IGetFinancialDataOrganizationalEntityByIdsOverviewInput {
    projectId!: number;
    organizationalEntityIds!: number[] | undefined;
    isNotConsidered!: boolean;

    constructor(data?: IGetFinancialDataOrganizationalEntityByIdsOverviewInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["organizationalEntityIds"])) {
                this.organizationalEntityIds = [] as any;
                for (let item of _data["organizationalEntityIds"])
                    this.organizationalEntityIds!.push(item);
            }
            this.isNotConsidered = _data["isNotConsidered"];
        }
    }

    static fromJS(data: any): GetFinancialDataOrganizationalEntityByIdsOverviewInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFinancialDataOrganizationalEntityByIdsOverviewInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        if (Array.isArray(this.organizationalEntityIds)) {
            data["organizationalEntityIds"] = [];
            for (let item of this.organizationalEntityIds)
                data["organizationalEntityIds"].push(item);
        }
        data["isNotConsidered"] = this.isNotConsidered;
        return data;
    }
}

export interface IGetFinancialDataOrganizationalEntityByIdsOverviewInput {
    projectId: number;
    organizationalEntityIds: number[] | undefined;
    isNotConsidered: boolean;
}

export class GetFinancialDataSafeHarbourGroupOverviewInput implements IGetFinancialDataSafeHarbourGroupOverviewInput {
    projectId!: number;
    organizationalEntityIds!: number[] | undefined;
    safeHarbourGroupId!: number | undefined;
    blendingCircleCountry!: string | undefined;

    constructor(data?: IGetFinancialDataSafeHarbourGroupOverviewInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["organizationalEntityIds"])) {
                this.organizationalEntityIds = [] as any;
                for (let item of _data["organizationalEntityIds"])
                    this.organizationalEntityIds!.push(item);
            }
            this.safeHarbourGroupId = _data["safeHarbourGroupId"];
            this.blendingCircleCountry = _data["blendingCircleCountry"];
        }
    }

    static fromJS(data: any): GetFinancialDataSafeHarbourGroupOverviewInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFinancialDataSafeHarbourGroupOverviewInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        if (Array.isArray(this.organizationalEntityIds)) {
            data["organizationalEntityIds"] = [];
            for (let item of this.organizationalEntityIds)
                data["organizationalEntityIds"].push(item);
        }
        data["safeHarbourGroupId"] = this.safeHarbourGroupId;
        data["blendingCircleCountry"] = this.blendingCircleCountry;
        return data;
    }
}

export interface IGetFinancialDataSafeHarbourGroupOverviewInput {
    projectId: number;
    organizationalEntityIds: number[] | undefined;
    safeHarbourGroupId: number | undefined;
    blendingCircleCountry: string | undefined;
}

export class GetFinancialDeltaPointChangeDto implements IGetFinancialDeltaPointChangeDto {
    entityId!: string | undefined;
    delta!: string | undefined;
    description!: string | undefined;

    constructor(data?: IGetFinancialDeltaPointChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.delta = _data["delta"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): GetFinancialDeltaPointChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFinancialDeltaPointChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["delta"] = this.delta;
        data["description"] = this.description;
        return data;
    }
}

export interface IGetFinancialDeltaPointChangeDto {
    entityId: string | undefined;
    delta: string | undefined;
    description: string | undefined;
}

export class GetFinancialValuePointChangeDto implements IGetFinancialValuePointChangeDto {
    user!: UserDetailsDto;
    changeTime!: DateTime;
    newInitialValue!: string | undefined;
    newDeltaValues!: GetFinancialDeltaPointChangeDto[] | undefined;
    isConfirmed!: boolean;
    comment!: string | undefined;

    constructor(data?: IGetFinancialValuePointChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserDetailsDto.fromJS(_data["user"]) : <any>undefined;
            this.changeTime = _data["changeTime"] ? DateTime.fromISO(_data["changeTime"].toString()) : <any>undefined;
            this.newInitialValue = _data["newInitialValue"];
            if (Array.isArray(_data["newDeltaValues"])) {
                this.newDeltaValues = [] as any;
                for (let item of _data["newDeltaValues"])
                    this.newDeltaValues!.push(GetFinancialDeltaPointChangeDto.fromJS(item));
            }
            this.isConfirmed = _data["isConfirmed"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): GetFinancialValuePointChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFinancialValuePointChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["changeTime"] = this.changeTime ? this.changeTime.toString() : <any>undefined;
        data["newInitialValue"] = this.newInitialValue;
        if (Array.isArray(this.newDeltaValues)) {
            data["newDeltaValues"] = [];
            for (let item of this.newDeltaValues)
                data["newDeltaValues"].push(item.toJSON());
        }
        data["isConfirmed"] = this.isConfirmed;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IGetFinancialValuePointChangeDto {
    user: UserDetailsDto;
    changeTime: DateTime;
    newInitialValue: string | undefined;
    newDeltaValues: GetFinancialDeltaPointChangeDto[] | undefined;
    isConfirmed: boolean;
    comment: string | undefined;
}

export class GetOrganizationalChartInput implements IGetOrganizationalChartInput {
    projectId!: number;
    jurisdictionsFilter!: string[] | undefined;
    organizationalEntitiesFilter!: number[] | undefined;

    constructor(data?: IGetOrganizationalChartInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["jurisdictionsFilter"])) {
                this.jurisdictionsFilter = [] as any;
                for (let item of _data["jurisdictionsFilter"])
                    this.jurisdictionsFilter!.push(item);
            }
            if (Array.isArray(_data["organizationalEntitiesFilter"])) {
                this.organizationalEntitiesFilter = [] as any;
                for (let item of _data["organizationalEntitiesFilter"])
                    this.organizationalEntitiesFilter!.push(item);
            }
        }
    }

    static fromJS(data: any): GetOrganizationalChartInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganizationalChartInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        if (Array.isArray(this.jurisdictionsFilter)) {
            data["jurisdictionsFilter"] = [];
            for (let item of this.jurisdictionsFilter)
                data["jurisdictionsFilter"].push(item);
        }
        if (Array.isArray(this.organizationalEntitiesFilter)) {
            data["organizationalEntitiesFilter"] = [];
            for (let item of this.organizationalEntitiesFilter)
                data["organizationalEntitiesFilter"].push(item);
        }
        return data;
    }
}

export interface IGetOrganizationalChartInput {
    projectId: number;
    jurisdictionsFilter: string[] | undefined;
    organizationalEntitiesFilter: number[] | undefined;
}

export class GetSafeHarbourGroupOverviewInput implements IGetSafeHarbourGroupOverviewInput {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    filter!: string | undefined;
    jurisdictionsFilter!: string[] | undefined;
    deMinimisStatuses!: CheckResultStatus[] | undefined;
    setrStatuses!: CheckResultStatus[] | undefined;
    rptStatuses!: CheckResultStatus[] | undefined;
    isChartRequest!: boolean;
    projectId!: number;

    constructor(data?: IGetSafeHarbourGroupOverviewInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.filter = _data["filter"];
            if (Array.isArray(_data["jurisdictionsFilter"])) {
                this.jurisdictionsFilter = [] as any;
                for (let item of _data["jurisdictionsFilter"])
                    this.jurisdictionsFilter!.push(item);
            }
            if (Array.isArray(_data["deMinimisStatuses"])) {
                this.deMinimisStatuses = [] as any;
                for (let item of _data["deMinimisStatuses"])
                    this.deMinimisStatuses!.push(item);
            }
            if (Array.isArray(_data["setrStatuses"])) {
                this.setrStatuses = [] as any;
                for (let item of _data["setrStatuses"])
                    this.setrStatuses!.push(item);
            }
            if (Array.isArray(_data["rptStatuses"])) {
                this.rptStatuses = [] as any;
                for (let item of _data["rptStatuses"])
                    this.rptStatuses!.push(item);
            }
            this.isChartRequest = _data["isChartRequest"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): GetSafeHarbourGroupOverviewInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSafeHarbourGroupOverviewInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["filter"] = this.filter;
        if (Array.isArray(this.jurisdictionsFilter)) {
            data["jurisdictionsFilter"] = [];
            for (let item of this.jurisdictionsFilter)
                data["jurisdictionsFilter"].push(item);
        }
        if (Array.isArray(this.deMinimisStatuses)) {
            data["deMinimisStatuses"] = [];
            for (let item of this.deMinimisStatuses)
                data["deMinimisStatuses"].push(item);
        }
        if (Array.isArray(this.setrStatuses)) {
            data["setrStatuses"] = [];
            for (let item of this.setrStatuses)
                data["setrStatuses"].push(item);
        }
        if (Array.isArray(this.rptStatuses)) {
            data["rptStatuses"] = [];
            for (let item of this.rptStatuses)
                data["rptStatuses"].push(item);
        }
        data["isChartRequest"] = this.isChartRequest;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IGetSafeHarbourGroupOverviewInput {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    filter: string | undefined;
    jurisdictionsFilter: string[] | undefined;
    deMinimisStatuses: CheckResultStatus[] | undefined;
    setrStatuses: CheckResultStatus[] | undefined;
    rptStatuses: CheckResultStatus[] | undefined;
    isChartRequest: boolean;
    projectId: number;
}

export class GetUserOrOrganizationalUnitBulkPermissionsInput implements IGetUserOrOrganizationalUnitBulkPermissionsInput {
    projectId!: number;
    organizationalEntityIds!: number[] | undefined;
    countryCodes!: string[] | undefined;
    updateInput!: UpdateAccessManagementInput;

    constructor(data?: IGetUserOrOrganizationalUnitBulkPermissionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["organizationalEntityIds"])) {
                this.organizationalEntityIds = [] as any;
                for (let item of _data["organizationalEntityIds"])
                    this.organizationalEntityIds!.push(item);
            }
            if (Array.isArray(_data["countryCodes"])) {
                this.countryCodes = [] as any;
                for (let item of _data["countryCodes"])
                    this.countryCodes!.push(item);
            }
            this.updateInput = _data["updateInput"] ? UpdateAccessManagementInput.fromJS(_data["updateInput"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserOrOrganizationalUnitBulkPermissionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserOrOrganizationalUnitBulkPermissionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        if (Array.isArray(this.organizationalEntityIds)) {
            data["organizationalEntityIds"] = [];
            for (let item of this.organizationalEntityIds)
                data["organizationalEntityIds"].push(item);
        }
        if (Array.isArray(this.countryCodes)) {
            data["countryCodes"] = [];
            for (let item of this.countryCodes)
                data["countryCodes"].push(item);
        }
        data["updateInput"] = this.updateInput ? this.updateInput.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetUserOrOrganizationalUnitBulkPermissionsInput {
    projectId: number;
    organizationalEntityIds: number[] | undefined;
    countryCodes: string[] | undefined;
    updateInput: UpdateAccessManagementInput;
}

export class GetUserOrOrganizationalUnitPermissionDto implements IGetUserOrOrganizationalUnitPermissionDto {
    isActivated!: boolean;
    inheritedFromCountryCode!: string | undefined;
    allUsersWithPermission!: UserOrOrganizationUnitDto[] | undefined;
    selectedUsersOrOrganizationUnits!: UserOrOrganizationUnitDto[] | undefined;
    availableUsersOrOrganizationUnits!: UserOrOrganizationUnitDto[] | undefined;

    constructor(data?: IGetUserOrOrganizationalUnitPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActivated = _data["isActivated"];
            this.inheritedFromCountryCode = _data["inheritedFromCountryCode"];
            if (Array.isArray(_data["allUsersWithPermission"])) {
                this.allUsersWithPermission = [] as any;
                for (let item of _data["allUsersWithPermission"])
                    this.allUsersWithPermission!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
            if (Array.isArray(_data["selectedUsersOrOrganizationUnits"])) {
                this.selectedUsersOrOrganizationUnits = [] as any;
                for (let item of _data["selectedUsersOrOrganizationUnits"])
                    this.selectedUsersOrOrganizationUnits!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
            if (Array.isArray(_data["availableUsersOrOrganizationUnits"])) {
                this.availableUsersOrOrganizationUnits = [] as any;
                for (let item of _data["availableUsersOrOrganizationUnits"])
                    this.availableUsersOrOrganizationUnits!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserOrOrganizationalUnitPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserOrOrganizationalUnitPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActivated"] = this.isActivated;
        data["inheritedFromCountryCode"] = this.inheritedFromCountryCode;
        if (Array.isArray(this.allUsersWithPermission)) {
            data["allUsersWithPermission"] = [];
            for (let item of this.allUsersWithPermission)
                data["allUsersWithPermission"].push(item.toJSON());
        }
        if (Array.isArray(this.selectedUsersOrOrganizationUnits)) {
            data["selectedUsersOrOrganizationUnits"] = [];
            for (let item of this.selectedUsersOrOrganizationUnits)
                data["selectedUsersOrOrganizationUnits"].push(item.toJSON());
        }
        if (Array.isArray(this.availableUsersOrOrganizationUnits)) {
            data["availableUsersOrOrganizationUnits"] = [];
            for (let item of this.availableUsersOrOrganizationUnits)
                data["availableUsersOrOrganizationUnits"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserOrOrganizationalUnitPermissionDto {
    isActivated: boolean;
    inheritedFromCountryCode: string | undefined;
    allUsersWithPermission: UserOrOrganizationUnitDto[] | undefined;
    selectedUsersOrOrganizationUnits: UserOrOrganizationUnitDto[] | undefined;
    availableUsersOrOrganizationUnits: UserOrOrganizationUnitDto[] | undefined;
}

export class GetUserOrOrganizationalUnitPermissionsDto implements IGetUserOrOrganizationalUnitPermissionsDto {
    readingPermission!: GetUserOrOrganizationalUnitPermissionDto;
    writingPermission!: GetUserOrOrganizationalUnitPermissionDto;

    constructor(data?: IGetUserOrOrganizationalUnitPermissionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.readingPermission = _data["readingPermission"] ? GetUserOrOrganizationalUnitPermissionDto.fromJS(_data["readingPermission"]) : <any>undefined;
            this.writingPermission = _data["writingPermission"] ? GetUserOrOrganizationalUnitPermissionDto.fromJS(_data["writingPermission"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserOrOrganizationalUnitPermissionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserOrOrganizationalUnitPermissionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["readingPermission"] = this.readingPermission ? this.readingPermission.toJSON() : <any>undefined;
        data["writingPermission"] = this.writingPermission ? this.writingPermission.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetUserOrOrganizationalUnitPermissionsDto {
    readingPermission: GetUserOrOrganizationalUnitPermissionDto;
    writingPermission: GetUserOrOrganizationalUnitPermissionDto;
}

export class GetUserOrOrganizationalUnitPermissionsInput implements IGetUserOrOrganizationalUnitPermissionsInput {
    projectId!: number;
    organizationalEntityId!: number | undefined;
    countryCode!: string | undefined;
    updateInput!: UpdateAccessManagementInput;

    constructor(data?: IGetUserOrOrganizationalUnitPermissionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.countryCode = _data["countryCode"];
            this.updateInput = _data["updateInput"] ? UpdateAccessManagementInput.fromJS(_data["updateInput"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserOrOrganizationalUnitPermissionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserOrOrganizationalUnitPermissionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["countryCode"] = this.countryCode;
        data["updateInput"] = this.updateInput ? this.updateInput.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetUserOrOrganizationalUnitPermissionsInput {
    projectId: number;
    organizationalEntityId: number | undefined;
    countryCode: string | undefined;
    updateInput: UpdateAccessManagementInput;
}

export enum GloBEStatus {
    UltimateParentEntity = 1,
    ConstituentEntity = 2,
    FlowThroughEntityTaxTransparent = 3,
    FlowThroughEntityReverseHybrid = 5,
    HybridEntity = 6,
    PermanentEstablishment = 7,
    MainEntity = 8,
    MinorityOwnedParentEntity = 9,
    MinorityOwnedSubsidiary = 10,
    MinorityOwnedConstituentEntity = 11,
    InvestmentEntity = 12,
    InsuranceInvestmentEntity = 13,
    JointVenture = 14,
    JointVentureSubsidiary = 15,
    ExcludedEntity = 16,
    PartiallyOwnedParentEntity = 17,
}

export class ImportOverviewDto implements IImportOverviewDto {
    id!: number;
    fileName!: string | undefined;
    tags!: TagDto[] | undefined;
    creationTime!: DateTime;
    author!: string | undefined;
    creatorUserId!: number | undefined;

    constructor(data?: IImportOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.author = _data["author"];
            this.creatorUserId = _data["creatorUserId"];
        }
    }

    static fromJS(data: any): ImportOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["author"] = this.author;
        data["creatorUserId"] = this.creatorUserId;
        return data;
    }
}

export interface IImportOverviewDto {
    id: number;
    fileName: string | undefined;
    tags: TagDto[] | undefined;
    creationTime: DateTime;
    author: string | undefined;
    creatorUserId: number | undefined;
}

export class ImportReportInput implements IImportReportInput {
    fileToken!: string | undefined;
    comment!: string | undefined;
    projectId!: number;
    addNewData!: boolean;
    deleteExistingData!: boolean;
    emptyValues!: boolean;
    ignoreInapplicableValues!: boolean;
    confirmAllData!: boolean;
    tags!: TagDto[] | undefined;

    constructor(data?: IImportReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileToken = _data["fileToken"];
            this.comment = _data["comment"];
            this.projectId = _data["projectId"];
            this.addNewData = _data["addNewData"];
            this.deleteExistingData = _data["deleteExistingData"];
            this.emptyValues = _data["emptyValues"];
            this.ignoreInapplicableValues = _data["ignoreInapplicableValues"];
            this.confirmAllData = _data["confirmAllData"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new ImportReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileToken"] = this.fileToken;
        data["comment"] = this.comment;
        data["projectId"] = this.projectId;
        data["addNewData"] = this.addNewData;
        data["deleteExistingData"] = this.deleteExistingData;
        data["emptyValues"] = this.emptyValues;
        data["ignoreInapplicableValues"] = this.ignoreInapplicableValues;
        data["confirmAllData"] = this.confirmAllData;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IImportReportInput {
    fileToken: string | undefined;
    comment: string | undefined;
    projectId: number;
    addNewData: boolean;
    deleteExistingData: boolean;
    emptyValues: boolean;
    ignoreInapplicableValues: boolean;
    confirmAllData: boolean;
    tags: TagDto[] | undefined;
}

export class InitiateEmailConversationInput implements IInitiateEmailConversationInput {
    channelId!: number;
    referenceId!: number;

    constructor(data?: IInitiateEmailConversationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelId = _data["channelId"];
            this.referenceId = _data["referenceId"];
        }
    }

    static fromJS(data: any): InitiateEmailConversationInput {
        data = typeof data === 'object' ? data : {};
        let result = new InitiateEmailConversationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelId"] = this.channelId;
        data["referenceId"] = this.referenceId;
        return data;
    }
}

export interface IInitiateEmailConversationInput {
    channelId: number;
    referenceId: number;
}

export enum InvestmentElectionType {
    SevenPointFive = 75,
    SevenPointSix = 76,
            }

export class JurisdictionOverviewDto implements IJurisdictionOverviewDto {
    id!: number;
    taxJurisdictionCountry!: string | undefined;
    hasReadPermission!: boolean;
    hasWritePermission!: boolean;
    rowExpandDisabled!: boolean;

    constructor(data?: IJurisdictionOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taxJurisdictionCountry = _data["taxJurisdictionCountry"];
            this.hasReadPermission = _data["hasReadPermission"];
            this.hasWritePermission = _data["hasWritePermission"];
            this.rowExpandDisabled = _data["rowExpandDisabled"];
        }
    }

    static fromJS(data: any): JurisdictionOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new JurisdictionOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taxJurisdictionCountry"] = this.taxJurisdictionCountry;
        data["hasReadPermission"] = this.hasReadPermission;
        data["hasWritePermission"] = this.hasWritePermission;
        data["rowExpandDisabled"] = this.rowExpandDisabled;
        return data;
    }
}

export interface IJurisdictionOverviewDto {
    id: number;
    taxJurisdictionCountry: string | undefined;
    hasReadPermission: boolean;
    hasWritePermission: boolean;
    rowExpandDisabled: boolean;
}

export class ListResultDtoOfFinancialDataOrganizationalEntityOverviewDto implements IListResultDtoOfFinancialDataOrganizationalEntityOverviewDto {
    items!: FinancialDataOrganizationalEntityOverviewDto[] | undefined;

    constructor(data?: IListResultDtoOfFinancialDataOrganizationalEntityOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FinancialDataOrganizationalEntityOverviewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfFinancialDataOrganizationalEntityOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfFinancialDataOrganizationalEntityOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfFinancialDataOrganizationalEntityOverviewDto {
    items: FinancialDataOrganizationalEntityOverviewDto[] | undefined;
}

export class ListResultDtoOfFinancialGroupDataOrganizationalEntityOverviewDto implements IListResultDtoOfFinancialGroupDataOrganizationalEntityOverviewDto {
    items!: FinancialGroupDataOrganizationalEntityOverviewDto[] | undefined;

    constructor(data?: IListResultDtoOfFinancialGroupDataOrganizationalEntityOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FinancialGroupDataOrganizationalEntityOverviewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfFinancialGroupDataOrganizationalEntityOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfFinancialGroupDataOrganizationalEntityOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfFinancialGroupDataOrganizationalEntityOverviewDto {
    items: FinancialGroupDataOrganizationalEntityOverviewDto[] | undefined;
}

export class ListResultDtoOfOrganizationalEntityOverviewDto implements IListResultDtoOfOrganizationalEntityOverviewDto {
    items!: OrganizationalEntityOverviewDto[] | undefined;

    constructor(data?: IListResultDtoOfOrganizationalEntityOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationalEntityOverviewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfOrganizationalEntityOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfOrganizationalEntityOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfOrganizationalEntityOverviewDto {
    items: OrganizationalEntityOverviewDto[] | undefined;
}

export class ListResultDtoOfOrganizationalEntityReferenceDto implements IListResultDtoOfOrganizationalEntityReferenceDto {
    items!: OrganizationalEntityReferenceDto[] | undefined;

    constructor(data?: IListResultDtoOfOrganizationalEntityReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationalEntityReferenceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfOrganizationalEntityReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfOrganizationalEntityReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfOrganizationalEntityReferenceDto {
    items: OrganizationalEntityReferenceDto[] | undefined;
}

export class ListResultDtoOfUserOrOrganizationUnitDto implements IListResultDtoOfUserOrOrganizationUnitDto {
    items!: UserOrOrganizationUnitDto[] | undefined;

    constructor(data?: IListResultDtoOfUserOrOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfUserOrOrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfUserOrOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfUserOrOrganizationUnitDto {
    items: UserOrOrganizationUnitDto[] | undefined;
}

export class ManageTagsDetailsDto implements IManageTagsDetailsDto {
    uniformTags!: TagDto[] | undefined;
    nonUniformTags!: string[] | undefined;
    availableTags!: string[] | undefined;

    constructor(data?: IManageTagsDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["uniformTags"])) {
                this.uniformTags = [] as any;
                for (let item of _data["uniformTags"])
                    this.uniformTags!.push(TagDto.fromJS(item));
            }
            if (Array.isArray(_data["nonUniformTags"])) {
                this.nonUniformTags = [] as any;
                for (let item of _data["nonUniformTags"])
                    this.nonUniformTags!.push(item);
        }
            if (Array.isArray(_data["availableTags"])) {
                this.availableTags = [] as any;
                for (let item of _data["availableTags"])
                    this.availableTags!.push(item);
    }
        }
    }

    static fromJS(data: any): ManageTagsDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManageTagsDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.uniformTags)) {
            data["uniformTags"] = [];
            for (let item of this.uniformTags)
                data["uniformTags"].push(item.toJSON());
        }
        if (Array.isArray(this.nonUniformTags)) {
            data["nonUniformTags"] = [];
            for (let item of this.nonUniformTags)
                data["nonUniformTags"].push(item);
        }
        if (Array.isArray(this.availableTags)) {
            data["availableTags"] = [];
            for (let item of this.availableTags)
                data["availableTags"].push(item);
        }
        return data;
    }
}

export interface IManageTagsDetailsDto {
    uniformTags: TagDto[] | undefined;
    nonUniformTags: string[] | undefined;
    availableTags: string[] | undefined;
}

export class ManageTagsInput implements IManageTagsInput {
    ids!: number[] | undefined;
    tags!: TagDto[] | undefined;

    constructor(data?: IManageTagsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
        }
    }
    }

    static fromJS(data: any): ManageTagsInput {
        data = typeof data === 'object' ? data : {};
        let result = new ManageTagsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IManageTagsInput {
    ids: number[] | undefined;
    tags: TagDto[] | undefined;
}

export class MazarsColumnDefinitionDto implements IMazarsColumnDefinitionDto {
    field!: string | undefined;
    isDefault!: boolean;
    visible!: boolean;
    localizationKey!: string | undefined;
    localizationSource!: string | undefined;
    localizedField!: string | undefined;
    width!: number;
    canBeChanged!: boolean;
    order!: number;

    constructor(data?: IMazarsColumnDefinitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.isDefault = _data["isDefault"];
            this.visible = _data["visible"];
            this.localizationKey = _data["localizationKey"];
            this.localizationSource = _data["localizationSource"];
            this.localizedField = _data["localizedField"];
            this.width = _data["width"];
            this.canBeChanged = _data["canBeChanged"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): MazarsColumnDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MazarsColumnDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["isDefault"] = this.isDefault;
        data["visible"] = this.visible;
        data["localizationKey"] = this.localizationKey;
        data["localizationSource"] = this.localizationSource;
        data["localizedField"] = this.localizedField;
        data["width"] = this.width;
        data["canBeChanged"] = this.canBeChanged;
        data["order"] = this.order;
        return data;
    }
}

export interface IMazarsColumnDefinitionDto {
    field: string | undefined;
    isDefault: boolean;
    visible: boolean;
    localizationKey: string | undefined;
    localizationSource: string | undefined;
    localizedField: string | undefined;
    width: number;
    canBeChanged: boolean;
    order: number;
}

export class MazarsColumnDefinitionInput implements IMazarsColumnDefinitionInput {
    field!: string | undefined;
    isDefault!: boolean;
    visible!: boolean;
    localizationKey!: string | undefined;
    localizationSource!: string | undefined;
    width!: number;
    canBeChanged!: boolean;

    constructor(data?: IMazarsColumnDefinitionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.isDefault = _data["isDefault"];
            this.visible = _data["visible"];
            this.localizationKey = _data["localizationKey"];
            this.localizationSource = _data["localizationSource"];
            this.width = _data["width"];
            this.canBeChanged = _data["canBeChanged"];
        }
    }

    static fromJS(data: any): MazarsColumnDefinitionInput {
        data = typeof data === 'object' ? data : {};
        let result = new MazarsColumnDefinitionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["isDefault"] = this.isDefault;
        data["visible"] = this.visible;
        data["localizationKey"] = this.localizationKey;
        data["localizationSource"] = this.localizationSource;
        data["width"] = this.width;
        data["canBeChanged"] = this.canBeChanged;
        return data;
    }
}

export interface IMazarsColumnDefinitionInput {
    field: string | undefined;
    isDefault: boolean;
    visible: boolean;
    localizationKey: string | undefined;
    localizationSource: string | undefined;
    width: number;
    canBeChanged: boolean;
}

export class MazarsColumnDefinitionSettings implements IMazarsColumnDefinitionSettings {
    haveGeneralInfo!: boolean;
    haveName!: boolean;
    isTaggable!: boolean;
    haveFullProjectManagementInfo!: boolean;
    haveAssignedUser!: boolean;
    havePlanDates!: boolean;
    haveProjectInfo!: boolean;
    haveCreatedInfo!: boolean;
    haveUpdateInfo!: boolean;

    constructor(data?: IMazarsColumnDefinitionSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.haveGeneralInfo = _data["haveGeneralInfo"];
            this.haveName = _data["haveName"];
            this.isTaggable = _data["isTaggable"];
            this.haveFullProjectManagementInfo = _data["haveFullProjectManagementInfo"];
            this.haveAssignedUser = _data["haveAssignedUser"];
            this.havePlanDates = _data["havePlanDates"];
            this.haveProjectInfo = _data["haveProjectInfo"];
            this.haveCreatedInfo = _data["haveCreatedInfo"];
            this.haveUpdateInfo = _data["haveUpdateInfo"];
        }
    }

    static fromJS(data: any): MazarsColumnDefinitionSettings {
        data = typeof data === 'object' ? data : {};
        let result = new MazarsColumnDefinitionSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["haveGeneralInfo"] = this.haveGeneralInfo;
        data["haveName"] = this.haveName;
        data["isTaggable"] = this.isTaggable;
        data["haveFullProjectManagementInfo"] = this.haveFullProjectManagementInfo;
        data["haveAssignedUser"] = this.haveAssignedUser;
        data["havePlanDates"] = this.havePlanDates;
        data["haveProjectInfo"] = this.haveProjectInfo;
        data["haveCreatedInfo"] = this.haveCreatedInfo;
        data["haveUpdateInfo"] = this.haveUpdateInfo;
        return data;
    }
}

export interface IMazarsColumnDefinitionSettings {
    haveGeneralInfo: boolean;
    haveName: boolean;
    isTaggable: boolean;
    haveFullProjectManagementInfo: boolean;
    haveAssignedUser: boolean;
    havePlanDates: boolean;
    haveProjectInfo: boolean;
    haveCreatedInfo: boolean;
    haveUpdateInfo: boolean;
}

export class MazarsGridDefinitionDto implements IMazarsGridDefinitionDto {
    tableId!: string | undefined;
    settings!: MazarsColumnDefinitionSettings;
    configuration!: MazarsColumnDefinitionDto[] | undefined;

    constructor(data?: IMazarsGridDefinitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tableId = _data["tableId"];
            this.settings = _data["settings"] ? MazarsColumnDefinitionSettings.fromJS(_data["settings"]) : <any>undefined;
            if (Array.isArray(_data["configuration"])) {
                this.configuration = [] as any;
                for (let item of _data["configuration"])
                    this.configuration!.push(MazarsColumnDefinitionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MazarsGridDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MazarsGridDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableId"] = this.tableId;
        data["settings"] = this.settings ? this.settings.toJSON() : <any>undefined;
        if (Array.isArray(this.configuration)) {
            data["configuration"] = [];
            for (let item of this.configuration)
                data["configuration"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMazarsGridDefinitionDto {
    tableId: string | undefined;
    settings: MazarsColumnDefinitionSettings;
    configuration: MazarsColumnDefinitionDto[] | undefined;
}

export class MazarsGridDefinitionInput implements IMazarsGridDefinitionInput {
    tableId!: string | undefined;
    configuration!: MazarsColumnDefinitionInput[] | undefined;

    constructor(data?: IMazarsGridDefinitionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tableId = _data["tableId"];
            if (Array.isArray(_data["configuration"])) {
                this.configuration = [] as any;
                for (let item of _data["configuration"])
                    this.configuration!.push(MazarsColumnDefinitionInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MazarsGridDefinitionInput {
        data = typeof data === 'object' ? data : {};
        let result = new MazarsGridDefinitionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableId"] = this.tableId;
        if (Array.isArray(this.configuration)) {
            data["configuration"] = [];
            for (let item of this.configuration)
                data["configuration"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMazarsGridDefinitionInput {
    tableId: string | undefined;
    configuration: MazarsColumnDefinitionInput[] | undefined;
}

export class OrganizationalChartDto implements IOrganizationalChartDto {
    projectId!: number;
    chartTitle!: string | undefined;
    nodes!: OrganizationalNodeDto[] | undefined;
    links!: OrganizationalLinkDto[] | undefined;

    constructor(data?: IOrganizationalChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.chartTitle = _data["chartTitle"];
            if (Array.isArray(_data["nodes"])) {
                this.nodes = [] as any;
                for (let item of _data["nodes"])
                    this.nodes!.push(OrganizationalNodeDto.fromJS(item));
            }
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(OrganizationalLinkDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationalChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalChartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["chartTitle"] = this.chartTitle;
        if (Array.isArray(this.nodes)) {
            data["nodes"] = [];
            for (let item of this.nodes)
                data["nodes"].push(item.toJSON());
        }
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrganizationalChartDto {
    projectId: number;
    chartTitle: string | undefined;
    nodes: OrganizationalNodeDto[] | undefined;
    links: OrganizationalLinkDto[] | undefined;
}

export enum OrganizationalChartNodeType {
    Default = 0,
    FTE = 1,
    PE = 2,
    HE = 3,
    RHE = 4,
    TP = 5,
}

export class OrganizationalEntityDto implements IOrganizationalEntityDto {
    id!: number;
    entityNumber!: ConfirmableDtoOfString;
    legalName!: ConfirmableDtoOfString;
    gloBEStatus!: ConfirmableDtoOfIListOfGloBEStatus;
    tin!: ConfirmableDtoOfString;
    taxJurisdictionCountry!: ConfirmableDtoOfString;
    taxTreatment!: ConfirmableDtoOfNullableOfTaxTreatment;
    isInvestmentEntity!: ConfirmableDtoOfNullableOfBoolean;
    isConsideredAsExcluded!: ConfirmableDtoOfNullableOfBoolean;
    isHeldForSale!: ConfirmableDtoOfNullableOfBoolean;
    isJointVenture!: ConfirmableDtoOfNullableOfBoolean;
    isPermanentEstablishment!: ConfirmableDtoOfNullableOfBoolean;
    isInsuranceEntity!: ConfirmableDtoOfNullableOfBoolean;
    isNMCE!: ConfirmableDtoOfNullableOfBoolean;
    isCeInCFCRegime!: ConfirmableDtoOfNullableOfBoolean;
    mainEntityId!: ConfirmableDtoOfNullableOfInt64;
    cfcOwnerId!: ConfirmableDtoOfNullableOfInt64;
    taxFunctionalCurrency!: ConfirmableDtoOfString;
    accountingFunctionalCurrency!: ConfirmableDtoOfString;
    numberOfMonthsOfOwnership!: ConfirmableDtoOfInt32;
    designatedLocalEntityId!: ConfirmableDtoOfNullableOfInt64;
    isMemberOfAFiscalUnity!: ConfirmableDtoOfNullableOfBoolean;
    consolidationMethod!: ConfirmableDtoOfNullableOfConsolidationMethod;
    financialAccountingStandard!: ConfirmableDtoOfNullableOfFinancialAccountingStandard;
    isElectionRightTaxTransparency!: ConfirmableDtoOfNullableOfBoolean;
    blendingCircleCountry!: ConfirmableDtoOfString;
    blendingCircleSubgroupDisplayName!: ConfirmableDtoOfString;
    controllingInterestEntityId!: number | undefined;
    shareholders!: ShareholdersDto;
    hasWritePermission!: boolean;
    blendingCircle!: BlendingCircleDto;
    groupShare!: OrganizationalEntityGroupShareDto;

    constructor(data?: IOrganizationalEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityNumber = _data["entityNumber"] ? ConfirmableDtoOfString.fromJS(_data["entityNumber"]) : <any>undefined;
            this.legalName = _data["legalName"] ? ConfirmableDtoOfString.fromJS(_data["legalName"]) : <any>undefined;
            this.gloBEStatus = _data["gloBEStatus"] ? ConfirmableDtoOfIListOfGloBEStatus.fromJS(_data["gloBEStatus"]) : <any>undefined;
            this.tin = _data["tin"] ? ConfirmableDtoOfString.fromJS(_data["tin"]) : <any>undefined;
            this.taxJurisdictionCountry = _data["taxJurisdictionCountry"] ? ConfirmableDtoOfString.fromJS(_data["taxJurisdictionCountry"]) : <any>undefined;
            this.taxTreatment = _data["taxTreatment"] ? ConfirmableDtoOfNullableOfTaxTreatment.fromJS(_data["taxTreatment"]) : <any>undefined;
            this.isInvestmentEntity = _data["isInvestmentEntity"] ? ConfirmableDtoOfNullableOfBoolean.fromJS(_data["isInvestmentEntity"]) : <any>undefined;
            this.isConsideredAsExcluded = _data["isConsideredAsExcluded"] ? ConfirmableDtoOfNullableOfBoolean.fromJS(_data["isConsideredAsExcluded"]) : <any>undefined;
            this.isHeldForSale = _data["isHeldForSale"] ? ConfirmableDtoOfNullableOfBoolean.fromJS(_data["isHeldForSale"]) : <any>undefined;
            this.isJointVenture = _data["isJointVenture"] ? ConfirmableDtoOfNullableOfBoolean.fromJS(_data["isJointVenture"]) : <any>undefined;
            this.isPermanentEstablishment = _data["isPermanentEstablishment"] ? ConfirmableDtoOfNullableOfBoolean.fromJS(_data["isPermanentEstablishment"]) : <any>undefined;
            this.isInsuranceEntity = _data["isInsuranceEntity"] ? ConfirmableDtoOfNullableOfBoolean.fromJS(_data["isInsuranceEntity"]) : <any>undefined;
            this.isNMCE = _data["isNMCE"] ? ConfirmableDtoOfNullableOfBoolean.fromJS(_data["isNMCE"]) : <any>undefined;
            this.isCeInCFCRegime = _data["isCeInCFCRegime"] ? ConfirmableDtoOfNullableOfBoolean.fromJS(_data["isCeInCFCRegime"]) : <any>undefined;
            this.mainEntityId = _data["mainEntityId"] ? ConfirmableDtoOfNullableOfInt64.fromJS(_data["mainEntityId"]) : <any>undefined;
            this.cfcOwnerId = _data["cfcOwnerId"] ? ConfirmableDtoOfNullableOfInt64.fromJS(_data["cfcOwnerId"]) : <any>undefined;
            this.taxFunctionalCurrency = _data["taxFunctionalCurrency"] ? ConfirmableDtoOfString.fromJS(_data["taxFunctionalCurrency"]) : <any>undefined;
            this.accountingFunctionalCurrency = _data["accountingFunctionalCurrency"] ? ConfirmableDtoOfString.fromJS(_data["accountingFunctionalCurrency"]) : <any>undefined;
            this.numberOfMonthsOfOwnership = _data["numberOfMonthsOfOwnership"] ? ConfirmableDtoOfInt32.fromJS(_data["numberOfMonthsOfOwnership"]) : <any>undefined;
            this.designatedLocalEntityId = _data["designatedLocalEntityId"] ? ConfirmableDtoOfNullableOfInt64.fromJS(_data["designatedLocalEntityId"]) : <any>undefined;
            this.isMemberOfAFiscalUnity = _data["isMemberOfAFiscalUnity"] ? ConfirmableDtoOfNullableOfBoolean.fromJS(_data["isMemberOfAFiscalUnity"]) : <any>undefined;
            this.consolidationMethod = _data["consolidationMethod"] ? ConfirmableDtoOfNullableOfConsolidationMethod.fromJS(_data["consolidationMethod"]) : <any>undefined;
            this.financialAccountingStandard = _data["financialAccountingStandard"] ? ConfirmableDtoOfNullableOfFinancialAccountingStandard.fromJS(_data["financialAccountingStandard"]) : <any>undefined;
            this.isElectionRightTaxTransparency = _data["isElectionRightTaxTransparency"] ? ConfirmableDtoOfNullableOfBoolean.fromJS(_data["isElectionRightTaxTransparency"]) : <any>undefined;
            this.blendingCircleCountry = _data["blendingCircleCountry"] ? ConfirmableDtoOfString.fromJS(_data["blendingCircleCountry"]) : <any>undefined;
            this.blendingCircleSubgroupDisplayName = _data["blendingCircleSubgroupDisplayName"] ? ConfirmableDtoOfString.fromJS(_data["blendingCircleSubgroupDisplayName"]) : <any>undefined;
            this.controllingInterestEntityId = _data["controllingInterestEntityId"];
            this.shareholders = _data["shareholders"] ? ShareholdersDto.fromJS(_data["shareholders"]) : <any>undefined;
            this.hasWritePermission = _data["hasWritePermission"];
            this.blendingCircle = _data["blendingCircle"] ? BlendingCircleDto.fromJS(_data["blendingCircle"]) : <any>undefined;
            this.groupShare = _data["groupShare"] ? OrganizationalEntityGroupShareDto.fromJS(_data["groupShare"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrganizationalEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityNumber"] = this.entityNumber ? this.entityNumber.toJSON() : <any>undefined;
        data["legalName"] = this.legalName ? this.legalName.toJSON() : <any>undefined;
        data["gloBEStatus"] = this.gloBEStatus ? this.gloBEStatus.toJSON() : <any>undefined;
        data["tin"] = this.tin ? this.tin.toJSON() : <any>undefined;
        data["taxJurisdictionCountry"] = this.taxJurisdictionCountry ? this.taxJurisdictionCountry.toJSON() : <any>undefined;
        data["taxTreatment"] = this.taxTreatment ? this.taxTreatment.toJSON() : <any>undefined;
        data["isInvestmentEntity"] = this.isInvestmentEntity ? this.isInvestmentEntity.toJSON() : <any>undefined;
        data["isConsideredAsExcluded"] = this.isConsideredAsExcluded ? this.isConsideredAsExcluded.toJSON() : <any>undefined;
        data["isHeldForSale"] = this.isHeldForSale ? this.isHeldForSale.toJSON() : <any>undefined;
        data["isJointVenture"] = this.isJointVenture ? this.isJointVenture.toJSON() : <any>undefined;
        data["isPermanentEstablishment"] = this.isPermanentEstablishment ? this.isPermanentEstablishment.toJSON() : <any>undefined;
        data["isInsuranceEntity"] = this.isInsuranceEntity ? this.isInsuranceEntity.toJSON() : <any>undefined;
        data["isNMCE"] = this.isNMCE ? this.isNMCE.toJSON() : <any>undefined;
        data["isCeInCFCRegime"] = this.isCeInCFCRegime ? this.isCeInCFCRegime.toJSON() : <any>undefined;
        data["mainEntityId"] = this.mainEntityId ? this.mainEntityId.toJSON() : <any>undefined;
        data["cfcOwnerId"] = this.cfcOwnerId ? this.cfcOwnerId.toJSON() : <any>undefined;
        data["taxFunctionalCurrency"] = this.taxFunctionalCurrency ? this.taxFunctionalCurrency.toJSON() : <any>undefined;
        data["accountingFunctionalCurrency"] = this.accountingFunctionalCurrency ? this.accountingFunctionalCurrency.toJSON() : <any>undefined;
        data["numberOfMonthsOfOwnership"] = this.numberOfMonthsOfOwnership ? this.numberOfMonthsOfOwnership.toJSON() : <any>undefined;
        data["designatedLocalEntityId"] = this.designatedLocalEntityId ? this.designatedLocalEntityId.toJSON() : <any>undefined;
        data["isMemberOfAFiscalUnity"] = this.isMemberOfAFiscalUnity ? this.isMemberOfAFiscalUnity.toJSON() : <any>undefined;
        data["consolidationMethod"] = this.consolidationMethod ? this.consolidationMethod.toJSON() : <any>undefined;
        data["financialAccountingStandard"] = this.financialAccountingStandard ? this.financialAccountingStandard.toJSON() : <any>undefined;
        data["isElectionRightTaxTransparency"] = this.isElectionRightTaxTransparency ? this.isElectionRightTaxTransparency.toJSON() : <any>undefined;
        data["blendingCircleCountry"] = this.blendingCircleCountry ? this.blendingCircleCountry.toJSON() : <any>undefined;
        data["blendingCircleSubgroupDisplayName"] = this.blendingCircleSubgroupDisplayName ? this.blendingCircleSubgroupDisplayName.toJSON() : <any>undefined;
        data["controllingInterestEntityId"] = this.controllingInterestEntityId;
        data["shareholders"] = this.shareholders ? this.shareholders.toJSON() : <any>undefined;
        data["hasWritePermission"] = this.hasWritePermission;
        data["blendingCircle"] = this.blendingCircle ? this.blendingCircle.toJSON() : <any>undefined;
        data["groupShare"] = this.groupShare ? this.groupShare.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOrganizationalEntityDto {
    id: number;
    entityNumber: ConfirmableDtoOfString;
    legalName: ConfirmableDtoOfString;
    gloBEStatus: ConfirmableDtoOfIListOfGloBEStatus;
    tin: ConfirmableDtoOfString;
    taxJurisdictionCountry: ConfirmableDtoOfString;
    taxTreatment: ConfirmableDtoOfNullableOfTaxTreatment;
    isInvestmentEntity: ConfirmableDtoOfNullableOfBoolean;
    isConsideredAsExcluded: ConfirmableDtoOfNullableOfBoolean;
    isHeldForSale: ConfirmableDtoOfNullableOfBoolean;
    isJointVenture: ConfirmableDtoOfNullableOfBoolean;
    isPermanentEstablishment: ConfirmableDtoOfNullableOfBoolean;
    isInsuranceEntity: ConfirmableDtoOfNullableOfBoolean;
    isNMCE: ConfirmableDtoOfNullableOfBoolean;
    isCeInCFCRegime: ConfirmableDtoOfNullableOfBoolean;
    mainEntityId: ConfirmableDtoOfNullableOfInt64;
    cfcOwnerId: ConfirmableDtoOfNullableOfInt64;
    taxFunctionalCurrency: ConfirmableDtoOfString;
    accountingFunctionalCurrency: ConfirmableDtoOfString;
    numberOfMonthsOfOwnership: ConfirmableDtoOfInt32;
    designatedLocalEntityId: ConfirmableDtoOfNullableOfInt64;
    isMemberOfAFiscalUnity: ConfirmableDtoOfNullableOfBoolean;
    consolidationMethod: ConfirmableDtoOfNullableOfConsolidationMethod;
    financialAccountingStandard: ConfirmableDtoOfNullableOfFinancialAccountingStandard;
    isElectionRightTaxTransparency: ConfirmableDtoOfNullableOfBoolean;
    blendingCircleCountry: ConfirmableDtoOfString;
    blendingCircleSubgroupDisplayName: ConfirmableDtoOfString;
    controllingInterestEntityId: number | undefined;
    shareholders: ShareholdersDto;
    hasWritePermission: boolean;
    blendingCircle: BlendingCircleDto;
    groupShare: OrganizationalEntityGroupShareDto;
}

export class OrganizationalEntityElectionInput implements IOrganizationalEntityElectionInput {
    id!: number;
    projectId!: number;
    electionType!: ElectionType;
    value!: boolean | undefined;
    year!: number | undefined;
    organizationalEntityId!: number;

    constructor(data?: IOrganizationalEntityElectionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.electionType = _data["electionType"];
            this.value = _data["value"];
            this.year = _data["year"];
            this.organizationalEntityId = _data["organizationalEntityId"];
        }
    }

    static fromJS(data: any): OrganizationalEntityElectionInput {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalEntityElectionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["electionType"] = this.electionType;
        data["value"] = this.value;
        data["year"] = this.year;
        data["organizationalEntityId"] = this.organizationalEntityId;
        return data;
    }
}

export interface IOrganizationalEntityElectionInput {
    id: number;
    projectId: number;
    electionType: ElectionType;
    value: boolean | undefined;
    year: number | undefined;
    organizationalEntityId: number;
}

export class OrganizationalEntityGroupShareDto implements IOrganizationalEntityGroupShareDto {
    groupShareValue!: number | undefined;
    canCalculateGroupShare!: boolean;
    localizedErrorMessages!: string[] | undefined;

    constructor(data?: IOrganizationalEntityGroupShareDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupShareValue = _data["groupShareValue"];
            this.canCalculateGroupShare = _data["canCalculateGroupShare"];
            if (Array.isArray(_data["localizedErrorMessages"])) {
                this.localizedErrorMessages = [] as any;
                for (let item of _data["localizedErrorMessages"])
                    this.localizedErrorMessages!.push(item);
            }
        }
    }

    static fromJS(data: any): OrganizationalEntityGroupShareDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalEntityGroupShareDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupShareValue"] = this.groupShareValue;
        data["canCalculateGroupShare"] = this.canCalculateGroupShare;
        if (Array.isArray(this.localizedErrorMessages)) {
            data["localizedErrorMessages"] = [];
            for (let item of this.localizedErrorMessages)
                data["localizedErrorMessages"].push(item);
        }
        return data;
    }
}

export interface IOrganizationalEntityGroupShareDto {
    groupShareValue: number | undefined;
    canCalculateGroupShare: boolean;
    localizedErrorMessages: string[] | undefined;
}

export class OrganizationalEntityOverviewDto implements IOrganizationalEntityOverviewDto {
    id!: number;
    entityNumber!: ConfirmableDtoOfString;
    legalName!: ConfirmableDtoOfString;
    gloBEStatus!: ConfirmableDtoOfIListOfGloBEStatus;
    tin!: ConfirmableDtoOfString;
    taxJurisdictionCountry!: ConfirmableDtoOfString;
    taxTreatment!: ConfirmableDtoOfNullableOfTaxTreatment;
    isInvestmentEntity!: ConfirmableDtoOfNullableOfBoolean;
    isConsideredAsExcluded!: ConfirmableDtoOfNullableOfBoolean;
    isHeldForSale!: ConfirmableDtoOfNullableOfBoolean;
    isJointVenture!: ConfirmableDtoOfNullableOfBoolean;
    isPermanentEstablishment!: ConfirmableDtoOfNullableOfBoolean;
    isInsuranceEntity!: ConfirmableDtoOfNullableOfBoolean;
    isNMCE!: ConfirmableDtoOfNullableOfBoolean;
    isCeInCFCRegime!: ConfirmableDtoOfNullableOfBoolean;
    mainEntityId!: ConfirmableDtoOfNullableOfInt64;
    cfcOwnerId!: ConfirmableDtoOfNullableOfInt64;
    taxFunctionalCurrency!: ConfirmableDtoOfString;
    accountingFunctionalCurrency!: ConfirmableDtoOfString;
    numberOfMonthsOfOwnership!: ConfirmableDtoOfInt32;
    designatedLocalEntityId!: ConfirmableDtoOfNullableOfInt64;
    isMemberOfAFiscalUnity!: ConfirmableDtoOfNullableOfBoolean;
    consolidationMethod!: ConfirmableDtoOfNullableOfConsolidationMethod;
    financialAccountingStandard!: ConfirmableDtoOfNullableOfFinancialAccountingStandard;
    isElectionRightTaxTransparency!: ConfirmableDtoOfNullableOfBoolean;
    blendingCircleCountry!: ConfirmableDtoOfString;
    blendingCircleSubgroupDisplayName!: ConfirmableDtoOfString;
    controllingInterestEntityId!: number | undefined;
    shareholders!: ShareholdersDto;
    hasWritePermission!: boolean;

    constructor(data?: IOrganizationalEntityOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityNumber = _data["entityNumber"] ? ConfirmableDtoOfString.fromJS(_data["entityNumber"]) : <any>undefined;
            this.legalName = _data["legalName"] ? ConfirmableDtoOfString.fromJS(_data["legalName"]) : <any>undefined;
            this.gloBEStatus = _data["gloBEStatus"] ? ConfirmableDtoOfIListOfGloBEStatus.fromJS(_data["gloBEStatus"]) : <any>undefined;
            this.tin = _data["tin"] ? ConfirmableDtoOfString.fromJS(_data["tin"]) : <any>undefined;
            this.taxJurisdictionCountry = _data["taxJurisdictionCountry"] ? ConfirmableDtoOfString.fromJS(_data["taxJurisdictionCountry"]) : <any>undefined;
            this.taxTreatment = _data["taxTreatment"] ? ConfirmableDtoOfNullableOfTaxTreatment.fromJS(_data["taxTreatment"]) : <any>undefined;
            this.isInvestmentEntity = _data["isInvestmentEntity"] ? ConfirmableDtoOfNullableOfBoolean.fromJS(_data["isInvestmentEntity"]) : <any>undefined;
            this.isConsideredAsExcluded = _data["isConsideredAsExcluded"] ? ConfirmableDtoOfNullableOfBoolean.fromJS(_data["isConsideredAsExcluded"]) : <any>undefined;
            this.isHeldForSale = _data["isHeldForSale"] ? ConfirmableDtoOfNullableOfBoolean.fromJS(_data["isHeldForSale"]) : <any>undefined;
            this.isJointVenture = _data["isJointVenture"] ? ConfirmableDtoOfNullableOfBoolean.fromJS(_data["isJointVenture"]) : <any>undefined;
            this.isPermanentEstablishment = _data["isPermanentEstablishment"] ? ConfirmableDtoOfNullableOfBoolean.fromJS(_data["isPermanentEstablishment"]) : <any>undefined;
            this.isInsuranceEntity = _data["isInsuranceEntity"] ? ConfirmableDtoOfNullableOfBoolean.fromJS(_data["isInsuranceEntity"]) : <any>undefined;
            this.isNMCE = _data["isNMCE"] ? ConfirmableDtoOfNullableOfBoolean.fromJS(_data["isNMCE"]) : <any>undefined;
            this.isCeInCFCRegime = _data["isCeInCFCRegime"] ? ConfirmableDtoOfNullableOfBoolean.fromJS(_data["isCeInCFCRegime"]) : <any>undefined;
            this.mainEntityId = _data["mainEntityId"] ? ConfirmableDtoOfNullableOfInt64.fromJS(_data["mainEntityId"]) : <any>undefined;
            this.cfcOwnerId = _data["cfcOwnerId"] ? ConfirmableDtoOfNullableOfInt64.fromJS(_data["cfcOwnerId"]) : <any>undefined;
            this.taxFunctionalCurrency = _data["taxFunctionalCurrency"] ? ConfirmableDtoOfString.fromJS(_data["taxFunctionalCurrency"]) : <any>undefined;
            this.accountingFunctionalCurrency = _data["accountingFunctionalCurrency"] ? ConfirmableDtoOfString.fromJS(_data["accountingFunctionalCurrency"]) : <any>undefined;
            this.numberOfMonthsOfOwnership = _data["numberOfMonthsOfOwnership"] ? ConfirmableDtoOfInt32.fromJS(_data["numberOfMonthsOfOwnership"]) : <any>undefined;
            this.designatedLocalEntityId = _data["designatedLocalEntityId"] ? ConfirmableDtoOfNullableOfInt64.fromJS(_data["designatedLocalEntityId"]) : <any>undefined;
            this.isMemberOfAFiscalUnity = _data["isMemberOfAFiscalUnity"] ? ConfirmableDtoOfNullableOfBoolean.fromJS(_data["isMemberOfAFiscalUnity"]) : <any>undefined;
            this.consolidationMethod = _data["consolidationMethod"] ? ConfirmableDtoOfNullableOfConsolidationMethod.fromJS(_data["consolidationMethod"]) : <any>undefined;
            this.financialAccountingStandard = _data["financialAccountingStandard"] ? ConfirmableDtoOfNullableOfFinancialAccountingStandard.fromJS(_data["financialAccountingStandard"]) : <any>undefined;
            this.isElectionRightTaxTransparency = _data["isElectionRightTaxTransparency"] ? ConfirmableDtoOfNullableOfBoolean.fromJS(_data["isElectionRightTaxTransparency"]) : <any>undefined;
            this.blendingCircleCountry = _data["blendingCircleCountry"] ? ConfirmableDtoOfString.fromJS(_data["blendingCircleCountry"]) : <any>undefined;
            this.blendingCircleSubgroupDisplayName = _data["blendingCircleSubgroupDisplayName"] ? ConfirmableDtoOfString.fromJS(_data["blendingCircleSubgroupDisplayName"]) : <any>undefined;
            this.controllingInterestEntityId = _data["controllingInterestEntityId"];
            this.shareholders = _data["shareholders"] ? ShareholdersDto.fromJS(_data["shareholders"]) : <any>undefined;
            this.hasWritePermission = _data["hasWritePermission"];
        }
    }

    static fromJS(data: any): OrganizationalEntityOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalEntityOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityNumber"] = this.entityNumber ? this.entityNumber.toJSON() : <any>undefined;
        data["legalName"] = this.legalName ? this.legalName.toJSON() : <any>undefined;
        data["gloBEStatus"] = this.gloBEStatus ? this.gloBEStatus.toJSON() : <any>undefined;
        data["tin"] = this.tin ? this.tin.toJSON() : <any>undefined;
        data["taxJurisdictionCountry"] = this.taxJurisdictionCountry ? this.taxJurisdictionCountry.toJSON() : <any>undefined;
        data["taxTreatment"] = this.taxTreatment ? this.taxTreatment.toJSON() : <any>undefined;
        data["isInvestmentEntity"] = this.isInvestmentEntity ? this.isInvestmentEntity.toJSON() : <any>undefined;
        data["isConsideredAsExcluded"] = this.isConsideredAsExcluded ? this.isConsideredAsExcluded.toJSON() : <any>undefined;
        data["isHeldForSale"] = this.isHeldForSale ? this.isHeldForSale.toJSON() : <any>undefined;
        data["isJointVenture"] = this.isJointVenture ? this.isJointVenture.toJSON() : <any>undefined;
        data["isPermanentEstablishment"] = this.isPermanentEstablishment ? this.isPermanentEstablishment.toJSON() : <any>undefined;
        data["isInsuranceEntity"] = this.isInsuranceEntity ? this.isInsuranceEntity.toJSON() : <any>undefined;
        data["isNMCE"] = this.isNMCE ? this.isNMCE.toJSON() : <any>undefined;
        data["isCeInCFCRegime"] = this.isCeInCFCRegime ? this.isCeInCFCRegime.toJSON() : <any>undefined;
        data["mainEntityId"] = this.mainEntityId ? this.mainEntityId.toJSON() : <any>undefined;
        data["cfcOwnerId"] = this.cfcOwnerId ? this.cfcOwnerId.toJSON() : <any>undefined;
        data["taxFunctionalCurrency"] = this.taxFunctionalCurrency ? this.taxFunctionalCurrency.toJSON() : <any>undefined;
        data["accountingFunctionalCurrency"] = this.accountingFunctionalCurrency ? this.accountingFunctionalCurrency.toJSON() : <any>undefined;
        data["numberOfMonthsOfOwnership"] = this.numberOfMonthsOfOwnership ? this.numberOfMonthsOfOwnership.toJSON() : <any>undefined;
        data["designatedLocalEntityId"] = this.designatedLocalEntityId ? this.designatedLocalEntityId.toJSON() : <any>undefined;
        data["isMemberOfAFiscalUnity"] = this.isMemberOfAFiscalUnity ? this.isMemberOfAFiscalUnity.toJSON() : <any>undefined;
        data["consolidationMethod"] = this.consolidationMethod ? this.consolidationMethod.toJSON() : <any>undefined;
        data["financialAccountingStandard"] = this.financialAccountingStandard ? this.financialAccountingStandard.toJSON() : <any>undefined;
        data["isElectionRightTaxTransparency"] = this.isElectionRightTaxTransparency ? this.isElectionRightTaxTransparency.toJSON() : <any>undefined;
        data["blendingCircleCountry"] = this.blendingCircleCountry ? this.blendingCircleCountry.toJSON() : <any>undefined;
        data["blendingCircleSubgroupDisplayName"] = this.blendingCircleSubgroupDisplayName ? this.blendingCircleSubgroupDisplayName.toJSON() : <any>undefined;
        data["controllingInterestEntityId"] = this.controllingInterestEntityId;
        data["shareholders"] = this.shareholders ? this.shareholders.toJSON() : <any>undefined;
        data["hasWritePermission"] = this.hasWritePermission;
        return data;
    }
}

export interface IOrganizationalEntityOverviewDto {
    id: number;
    entityNumber: ConfirmableDtoOfString;
    legalName: ConfirmableDtoOfString;
    gloBEStatus: ConfirmableDtoOfIListOfGloBEStatus;
    tin: ConfirmableDtoOfString;
    taxJurisdictionCountry: ConfirmableDtoOfString;
    taxTreatment: ConfirmableDtoOfNullableOfTaxTreatment;
    isInvestmentEntity: ConfirmableDtoOfNullableOfBoolean;
    isConsideredAsExcluded: ConfirmableDtoOfNullableOfBoolean;
    isHeldForSale: ConfirmableDtoOfNullableOfBoolean;
    isJointVenture: ConfirmableDtoOfNullableOfBoolean;
    isPermanentEstablishment: ConfirmableDtoOfNullableOfBoolean;
    isInsuranceEntity: ConfirmableDtoOfNullableOfBoolean;
    isNMCE: ConfirmableDtoOfNullableOfBoolean;
    isCeInCFCRegime: ConfirmableDtoOfNullableOfBoolean;
    mainEntityId: ConfirmableDtoOfNullableOfInt64;
    cfcOwnerId: ConfirmableDtoOfNullableOfInt64;
    taxFunctionalCurrency: ConfirmableDtoOfString;
    accountingFunctionalCurrency: ConfirmableDtoOfString;
    numberOfMonthsOfOwnership: ConfirmableDtoOfInt32;
    designatedLocalEntityId: ConfirmableDtoOfNullableOfInt64;
    isMemberOfAFiscalUnity: ConfirmableDtoOfNullableOfBoolean;
    consolidationMethod: ConfirmableDtoOfNullableOfConsolidationMethod;
    financialAccountingStandard: ConfirmableDtoOfNullableOfFinancialAccountingStandard;
    isElectionRightTaxTransparency: ConfirmableDtoOfNullableOfBoolean;
    blendingCircleCountry: ConfirmableDtoOfString;
    blendingCircleSubgroupDisplayName: ConfirmableDtoOfString;
    controllingInterestEntityId: number | undefined;
    shareholders: ShareholdersDto;
    hasWritePermission: boolean;
}

export class OrganizationalEntityReferenceDataDto implements IOrganizationalEntityReferenceDataDto {
    id!: number;
    text!: string | undefined;

    constructor(data?: IOrganizationalEntityReferenceDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): OrganizationalEntityReferenceDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalEntityReferenceDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        return data;
    }
}

export interface IOrganizationalEntityReferenceDataDto {
    id: number;
    text: string | undefined;
}

export class OrganizationalEntityReferenceDto implements IOrganizationalEntityReferenceDto {
    id!: number;
    legalName!: string | undefined;
    entityNumber!: string | undefined;

    constructor(data?: IOrganizationalEntityReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.legalName = _data["legalName"];
            this.entityNumber = _data["entityNumber"];
        }
    }

    static fromJS(data: any): OrganizationalEntityReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalEntityReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["legalName"] = this.legalName;
        data["entityNumber"] = this.entityNumber;
        return data;
    }
}

export interface IOrganizationalEntityReferenceDto {
    id: number;
    legalName: string | undefined;
    entityNumber: string | undefined;
}

export class OrganizationalEntityShareholderDto implements IOrganizationalEntityShareholderDto {
    id!: number;
    interestValue!: ConfirmableDtoOfString;
    holdingOrganizationalEntityId!: ConfirmableDtoOfInt64;
    taxTreatment!: ConfirmableDtoOfNullableOfTaxTreatment;
    investmentElection!: ConfirmableDtoOfNullableOfInvestmentElectionType;

    constructor(data?: IOrganizationalEntityShareholderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.interestValue = _data["interestValue"] ? ConfirmableDtoOfString.fromJS(_data["interestValue"]) : <any>undefined;
            this.holdingOrganizationalEntityId = _data["holdingOrganizationalEntityId"] ? ConfirmableDtoOfInt64.fromJS(_data["holdingOrganizationalEntityId"]) : <any>undefined;
            this.taxTreatment = _data["taxTreatment"] ? ConfirmableDtoOfNullableOfTaxTreatment.fromJS(_data["taxTreatment"]) : <any>undefined;
            this.investmentElection = _data["investmentElection"] ? ConfirmableDtoOfNullableOfInvestmentElectionType.fromJS(_data["investmentElection"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrganizationalEntityShareholderDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalEntityShareholderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["interestValue"] = this.interestValue ? this.interestValue.toJSON() : <any>undefined;
        data["holdingOrganizationalEntityId"] = this.holdingOrganizationalEntityId ? this.holdingOrganizationalEntityId.toJSON() : <any>undefined;
        data["taxTreatment"] = this.taxTreatment ? this.taxTreatment.toJSON() : <any>undefined;
        data["investmentElection"] = this.investmentElection ? this.investmentElection.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOrganizationalEntityShareholderDto {
    id: number;
    interestValue: ConfirmableDtoOfString;
    holdingOrganizationalEntityId: ConfirmableDtoOfInt64;
    taxTreatment: ConfirmableDtoOfNullableOfTaxTreatment;
    investmentElection: ConfirmableDtoOfNullableOfInvestmentElectionType;
}

export class OrganizationalEntityShareholderInput implements IOrganizationalEntityShareholderInput {
    id!: number | undefined;
    interestValue!: ConfirmableInputOfString;
    holdingOrganizationalEntityId!: ConfirmableInputOfInt64;
    taxTreatment!: ConfirmableInputOfNullableOfTaxTreatment;
    investmentElection!: ConfirmableInputOfNullableOfInvestmentElectionType;

    constructor(data?: IOrganizationalEntityShareholderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.interestValue = _data["interestValue"] ? ConfirmableInputOfString.fromJS(_data["interestValue"]) : <any>undefined;
            this.holdingOrganizationalEntityId = _data["holdingOrganizationalEntityId"] ? ConfirmableInputOfInt64.fromJS(_data["holdingOrganizationalEntityId"]) : <any>undefined;
            this.taxTreatment = _data["taxTreatment"] ? ConfirmableInputOfNullableOfTaxTreatment.fromJS(_data["taxTreatment"]) : <any>undefined;
            this.investmentElection = _data["investmentElection"] ? ConfirmableInputOfNullableOfInvestmentElectionType.fromJS(_data["investmentElection"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrganizationalEntityShareholderInput {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalEntityShareholderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["interestValue"] = this.interestValue ? this.interestValue.toJSON() : <any>undefined;
        data["holdingOrganizationalEntityId"] = this.holdingOrganizationalEntityId ? this.holdingOrganizationalEntityId.toJSON() : <any>undefined;
        data["taxTreatment"] = this.taxTreatment ? this.taxTreatment.toJSON() : <any>undefined;
        data["investmentElection"] = this.investmentElection ? this.investmentElection.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOrganizationalEntityShareholderInput {
    id: number | undefined;
    interestValue: ConfirmableInputOfString;
    holdingOrganizationalEntityId: ConfirmableInputOfInt64;
    taxTreatment: ConfirmableInputOfNullableOfTaxTreatment;
    investmentElection: ConfirmableInputOfNullableOfInvestmentElectionType;
}

export class OrganizationalLinkDto implements IOrganizationalLinkDto {
    id!: string | undefined;
    from!: string | undefined;
    to!: string | undefined;
    label!: string | undefined;
    levelAs!: string | undefined;

    constructor(data?: IOrganizationalLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.from = _data["from"];
            this.to = _data["to"];
            this.label = _data["label"];
            this.levelAs = _data["levelAs"];
        }
    }

    static fromJS(data: any): OrganizationalLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["from"] = this.from;
        data["to"] = this.to;
        data["label"] = this.label;
        data["levelAs"] = this.levelAs;
        return data;
    }
}

export interface IOrganizationalLinkDto {
    id: string | undefined;
    from: string | undefined;
    to: string | undefined;
    label: string | undefined;
    levelAs: string | undefined;
}

export class OrganizationalNodeDto implements IOrganizationalNodeDto {
    id!: string | undefined;
    title!: string | undefined;
    type!: OrganizationalChartNodeType;
    entityId!: number | undefined;
    name!: string | undefined;
    countryCode!: string | undefined;
    gloBEStatus!: GloBEStatus[] | undefined;
    level!: number | undefined;

    constructor(data?: IOrganizationalNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.type = _data["type"];
            this.entityId = _data["entityId"];
            this.name = _data["name"];
            this.countryCode = _data["countryCode"];
            if (Array.isArray(_data["gloBEStatus"])) {
                this.gloBEStatus = [] as any;
                for (let item of _data["gloBEStatus"])
                    this.gloBEStatus!.push(item);
            }
            this.level = _data["level"];
        }
    }

    static fromJS(data: any): OrganizationalNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["type"] = this.type;
        data["entityId"] = this.entityId;
        data["name"] = this.name;
        data["countryCode"] = this.countryCode;
        if (Array.isArray(this.gloBEStatus)) {
            data["gloBEStatus"] = [];
            for (let item of this.gloBEStatus)
                data["gloBEStatus"].push(item);
        }
        data["level"] = this.level;
        return data;
    }
}

export interface IOrganizationalNodeDto {
    id: string | undefined;
    title: string | undefined;
    type: OrganizationalChartNodeType;
    entityId: number | undefined;
    name: string | undefined;
    countryCode: string | undefined;
    gloBEStatus: GloBEStatus[] | undefined;
    level: number | undefined;
}

export class PagedResultDtoOfAttachmentOverviewDto implements IPagedResultDtoOfAttachmentOverviewDto {
    items!: AttachmentOverviewDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfAttachmentOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AttachmentOverviewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfAttachmentOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAttachmentOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfAttachmentOverviewDto {
    items: AttachmentOverviewDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfFullScopeCalculationsOverviewDto implements IPagedResultDtoOfFullScopeCalculationsOverviewDto {
    items!: FullScopeCalculationsOverviewDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfFullScopeCalculationsOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FullScopeCalculationsOverviewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfFullScopeCalculationsOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFullScopeCalculationsOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfFullScopeCalculationsOverviewDto {
    items: FullScopeCalculationsOverviewDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfImportOverviewDto implements IPagedResultDtoOfImportOverviewDto {
    items!: ImportOverviewDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfImportOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ImportOverviewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfImportOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfImportOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfImportOverviewDto {
    items: ImportOverviewDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfJurisdictionOverviewDto implements IPagedResultDtoOfJurisdictionOverviewDto {
    items!: JurisdictionOverviewDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfJurisdictionOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(JurisdictionOverviewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfJurisdictionOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfJurisdictionOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfJurisdictionOverviewDto {
    items: JurisdictionOverviewDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfProjectOverviewDto implements IPagedResultDtoOfProjectOverviewDto {
    items!: ProjectOverviewDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfProjectOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectOverviewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfProjectOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfProjectOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfProjectOverviewDto {
    items: ProjectOverviewDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfReportOverviewDto implements IPagedResultDtoOfReportOverviewDto {
    items!: ReportOverviewDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfReportOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReportOverviewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfReportOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfReportOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfReportOverviewDto {
    items: ReportOverviewDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfSafeHarbourGroupOverviewDto implements IPagedResultDtoOfSafeHarbourGroupOverviewDto {
    items!: SafeHarbourGroupOverviewDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfSafeHarbourGroupOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SafeHarbourGroupOverviewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfSafeHarbourGroupOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSafeHarbourGroupOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfSafeHarbourGroupOverviewDto {
    items: SafeHarbourGroupOverviewDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfTopUpTaxAssignmentDto implements IPagedResultDtoOfTopUpTaxAssignmentDto {
    items!: TopUpTaxAssignmentDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTopUpTaxAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TopUpTaxAssignmentDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTopUpTaxAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTopUpTaxAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTopUpTaxAssignmentDto {
    items: TopUpTaxAssignmentDto[] | undefined;
    totalCount: number;
}

export class Pillar2AdminSettingsDto implements IPillar2AdminSettingsDto {
    isAccessRestriction!: boolean;
    chancelleryViewAdminSettings!: ChancelleryViewAdminSettings;
    isEditProject!: boolean;
    isSubmissionProject!: boolean;
    isReviewProject!: boolean;
    isAdditionalForReviewProject!: boolean;
    isReviewProjectFourEyes!: boolean;
    isSpecialPermission!: boolean;

    constructor(data?: IPillar2AdminSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAccessRestriction = _data["isAccessRestriction"];
            this.chancelleryViewAdminSettings = _data["chancelleryViewAdminSettings"] ? ChancelleryViewAdminSettings.fromJS(_data["chancelleryViewAdminSettings"]) : <any>undefined;
            this.isEditProject = _data["isEditProject"];
            this.isSubmissionProject = _data["isSubmissionProject"];
            this.isReviewProject = _data["isReviewProject"];
            this.isAdditionalForReviewProject = _data["isAdditionalForReviewProject"];
            this.isReviewProjectFourEyes = _data["isReviewProjectFourEyes"];
            this.isSpecialPermission = _data["isSpecialPermission"];
        }
    }

    static fromJS(data: any): Pillar2AdminSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new Pillar2AdminSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAccessRestriction"] = this.isAccessRestriction;
        data["chancelleryViewAdminSettings"] = this.chancelleryViewAdminSettings ? this.chancelleryViewAdminSettings.toJSON() : <any>undefined;
        data["isEditProject"] = this.isEditProject;
        data["isSubmissionProject"] = this.isSubmissionProject;
        data["isReviewProject"] = this.isReviewProject;
        data["isAdditionalForReviewProject"] = this.isAdditionalForReviewProject;
        data["isReviewProjectFourEyes"] = this.isReviewProjectFourEyes;
        data["isSpecialPermission"] = this.isSpecialPermission;
        return data;
    }
}

export interface IPillar2AdminSettingsDto {
    isAccessRestriction: boolean;
    chancelleryViewAdminSettings: ChancelleryViewAdminSettings;
    isEditProject: boolean;
    isSubmissionProject: boolean;
    isReviewProject: boolean;
    isAdditionalForReviewProject: boolean;
    isReviewProjectFourEyes: boolean;
    isSpecialPermission: boolean;
}

export class Pillar2AdminSettingsInput implements IPillar2AdminSettingsInput {
    isAccessRestriction!: boolean;
    chancelleryViewAdminSettings!: ChancelleryViewAdminSettings;
    isEditProject!: boolean;
    isSubmissionProject!: boolean;
    isReviewProject!: boolean;
    isReviewProjectFourEyes!: boolean;
    isAdditionalForReviewProject!: boolean;
    isSpecialPermission!: boolean;

    constructor(data?: IPillar2AdminSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAccessRestriction = _data["isAccessRestriction"];
            this.chancelleryViewAdminSettings = _data["chancelleryViewAdminSettings"] ? ChancelleryViewAdminSettings.fromJS(_data["chancelleryViewAdminSettings"]) : <any>undefined;
            this.isEditProject = _data["isEditProject"];
            this.isSubmissionProject = _data["isSubmissionProject"];
            this.isReviewProject = _data["isReviewProject"];
            this.isReviewProjectFourEyes = _data["isReviewProjectFourEyes"];
            this.isAdditionalForReviewProject = _data["isAdditionalForReviewProject"];
            this.isSpecialPermission = _data["isSpecialPermission"];
        }
    }

    static fromJS(data: any): Pillar2AdminSettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new Pillar2AdminSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAccessRestriction"] = this.isAccessRestriction;
        data["chancelleryViewAdminSettings"] = this.chancelleryViewAdminSettings ? this.chancelleryViewAdminSettings.toJSON() : <any>undefined;
        data["isEditProject"] = this.isEditProject;
        data["isSubmissionProject"] = this.isSubmissionProject;
        data["isReviewProject"] = this.isReviewProject;
        data["isReviewProjectFourEyes"] = this.isReviewProjectFourEyes;
        data["isAdditionalForReviewProject"] = this.isAdditionalForReviewProject;
        data["isSpecialPermission"] = this.isSpecialPermission;
        return data;
    }
}

export interface IPillar2AdminSettingsInput {
    isAccessRestriction: boolean;
    chancelleryViewAdminSettings: ChancelleryViewAdminSettings;
    isEditProject: boolean;
    isSubmissionProject: boolean;
    isReviewProject: boolean;
    isReviewProjectFourEyes: boolean;
    isAdditionalForReviewProject: boolean;
    isSpecialPermission: boolean;
}

export enum Priority {
    One = 1,
    Two = 2,
    Three = 3,
    Four = 4,
}

export class ProcessDto implements IProcessDto {
    stateType!: string | undefined;
    name!: string | undefined;

    constructor(data?: IProcessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stateType = _data["stateType"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ProcessDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stateType"] = this.stateType;
        data["name"] = this.name;
        return data;
    }
}

export interface IProcessDto {
    stateType: string | undefined;
    name: string | undefined;
}

export class ProjectAccessAndPermissionDto implements IProjectAccessAndPermissionDto {
    accessRestrictionPossibleUsers!: UserOrOrganizationUnitDto[] | undefined;
    selectedAccessRestrictionPossibleUsers!: UserOrOrganizationUnitDto[] | undefined;
    isAccessRestrictionActive!: boolean;
    customPermissions!: EntityPermissionDto[] | undefined;
    isWorkflowReviewFourEyes!: boolean;
    isReviewDataPreparation!: boolean;
    isReviewDataPreparationFourEyes!: boolean;
    isReviewMapping!: boolean;
    isReviewMappingFourEyes!: boolean;
    isSpecialPermissionActive!: boolean;

    constructor(data?: IProjectAccessAndPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessRestrictionPossibleUsers"])) {
                this.accessRestrictionPossibleUsers = [] as any;
                for (let item of _data["accessRestrictionPossibleUsers"])
                    this.accessRestrictionPossibleUsers!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
            if (Array.isArray(_data["selectedAccessRestrictionPossibleUsers"])) {
                this.selectedAccessRestrictionPossibleUsers = [] as any;
                for (let item of _data["selectedAccessRestrictionPossibleUsers"])
                    this.selectedAccessRestrictionPossibleUsers!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
            this.isAccessRestrictionActive = _data["isAccessRestrictionActive"];
            if (Array.isArray(_data["customPermissions"])) {
                this.customPermissions = [] as any;
                for (let item of _data["customPermissions"])
                    this.customPermissions!.push(EntityPermissionDto.fromJS(item));
            }
            this.isWorkflowReviewFourEyes = _data["isWorkflowReviewFourEyes"];
            this.isReviewDataPreparation = _data["isReviewDataPreparation"];
            this.isReviewDataPreparationFourEyes = _data["isReviewDataPreparationFourEyes"];
            this.isReviewMapping = _data["isReviewMapping"];
            this.isReviewMappingFourEyes = _data["isReviewMappingFourEyes"];
            this.isSpecialPermissionActive = _data["isSpecialPermissionActive"];
        }
    }

    static fromJS(data: any): ProjectAccessAndPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectAccessAndPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessRestrictionPossibleUsers)) {
            data["accessRestrictionPossibleUsers"] = [];
            for (let item of this.accessRestrictionPossibleUsers)
                data["accessRestrictionPossibleUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.selectedAccessRestrictionPossibleUsers)) {
            data["selectedAccessRestrictionPossibleUsers"] = [];
            for (let item of this.selectedAccessRestrictionPossibleUsers)
                data["selectedAccessRestrictionPossibleUsers"].push(item.toJSON());
        }
        data["isAccessRestrictionActive"] = this.isAccessRestrictionActive;
        if (Array.isArray(this.customPermissions)) {
            data["customPermissions"] = [];
            for (let item of this.customPermissions)
                data["customPermissions"].push(item.toJSON());
        }
        data["isWorkflowReviewFourEyes"] = this.isWorkflowReviewFourEyes;
        data["isReviewDataPreparation"] = this.isReviewDataPreparation;
        data["isReviewDataPreparationFourEyes"] = this.isReviewDataPreparationFourEyes;
        data["isReviewMapping"] = this.isReviewMapping;
        data["isReviewMappingFourEyes"] = this.isReviewMappingFourEyes;
        data["isSpecialPermissionActive"] = this.isSpecialPermissionActive;
        return data;
    }
}

export interface IProjectAccessAndPermissionDto {
    accessRestrictionPossibleUsers: UserOrOrganizationUnitDto[] | undefined;
    selectedAccessRestrictionPossibleUsers: UserOrOrganizationUnitDto[] | undefined;
    isAccessRestrictionActive: boolean;
    customPermissions: EntityPermissionDto[] | undefined;
    isWorkflowReviewFourEyes: boolean;
    isReviewDataPreparation: boolean;
    isReviewDataPreparationFourEyes: boolean;
    isReviewMapping: boolean;
    isReviewMappingFourEyes: boolean;
    isSpecialPermissionActive: boolean;
}

export class ProjectAccessAndPermissionInput implements IProjectAccessAndPermissionInput {
    accessRestriction!: CustomGrantsForPermissionInput;
    customPermissions!: CustomGrantsForPermissionInput[] | undefined;

    constructor(data?: IProjectAccessAndPermissionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessRestriction = _data["accessRestriction"] ? CustomGrantsForPermissionInput.fromJS(_data["accessRestriction"]) : <any>undefined;
            if (Array.isArray(_data["customPermissions"])) {
                this.customPermissions = [] as any;
                for (let item of _data["customPermissions"])
                    this.customPermissions!.push(CustomGrantsForPermissionInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectAccessAndPermissionInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectAccessAndPermissionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessRestriction"] = this.accessRestriction ? this.accessRestriction.toJSON() : <any>undefined;
        if (Array.isArray(this.customPermissions)) {
            data["customPermissions"] = [];
            for (let item of this.customPermissions)
                data["customPermissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectAccessAndPermissionInput {
    accessRestriction: CustomGrantsForPermissionInput;
    customPermissions: CustomGrantsForPermissionInput[] | undefined;
}

export class ProjectAccessRestrictedUsersDto implements IProjectAccessRestrictedUsersDto {
    userOrOrganizations!: UserOrOrganizationUnitDto[] | undefined;
    isAccessRestrictionActive!: boolean;

    constructor(data?: IProjectAccessRestrictedUsersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userOrOrganizations"])) {
                this.userOrOrganizations = [] as any;
                for (let item of _data["userOrOrganizations"])
                    this.userOrOrganizations!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
            this.isAccessRestrictionActive = _data["isAccessRestrictionActive"];
        }
    }

    static fromJS(data: any): ProjectAccessRestrictedUsersDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectAccessRestrictedUsersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userOrOrganizations)) {
            data["userOrOrganizations"] = [];
            for (let item of this.userOrOrganizations)
                data["userOrOrganizations"].push(item.toJSON());
        }
        data["isAccessRestrictionActive"] = this.isAccessRestrictionActive;
        return data;
    }
}

export interface IProjectAccessRestrictedUsersDto {
    userOrOrganizations: UserOrOrganizationUnitDto[] | undefined;
    isAccessRestrictionActive: boolean;
}

export class ProjectCurrencyRateOverviewDto implements IProjectCurrencyRateOverviewDto {
    id!: number;
    sourceCurrency!: string | undefined;
    targetCurrency!: string | undefined;
    rate!: ConfirmableDtoOfString;
    currencyRateType!: ProjectCurrencyRateType;
    comment!: string | undefined;
    currencyRateInfo!: string | undefined;

    constructor(data?: IProjectCurrencyRateOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sourceCurrency = _data["sourceCurrency"];
            this.targetCurrency = _data["targetCurrency"];
            this.rate = _data["rate"] ? ConfirmableDtoOfString.fromJS(_data["rate"]) : <any>undefined;
            this.currencyRateType = _data["currencyRateType"];
            this.comment = _data["comment"];
            this.currencyRateInfo = _data["currencyRateInfo"];
        }
    }

    static fromJS(data: any): ProjectCurrencyRateOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectCurrencyRateOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceCurrency"] = this.sourceCurrency;
        data["targetCurrency"] = this.targetCurrency;
        data["rate"] = this.rate ? this.rate.toJSON() : <any>undefined;
        data["currencyRateType"] = this.currencyRateType;
        data["comment"] = this.comment;
        data["currencyRateInfo"] = this.currencyRateInfo;
        return data;
    }
}

export interface IProjectCurrencyRateOverviewDto {
    id: number;
    sourceCurrency: string | undefined;
    targetCurrency: string | undefined;
    rate: ConfirmableDtoOfString;
    currencyRateType: ProjectCurrencyRateType;
    comment: string | undefined;
    currencyRateInfo: string | undefined;
}

export enum ProjectCurrencyRateType {
    AverageFiscalYear = 1,
    SpotRateFirstDayFiscalYear = 2,
    SpotRateLastDayFiscalYear = 3,
    AverageDecemberBeforeFiscalYear = 4,
}

export class ProjectDataExcelExportInput implements IProjectDataExcelExportInput {
    templateType!: ProjectTemplateType;
    scopingType!: ProjectScopingDataType;
    projectId!: number;

    constructor(data?: IProjectDataExcelExportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateType = _data["templateType"];
            this.scopingType = _data["scopingType"];
            this.projectId = _data["projectId"];
            }
        }

    static fromJS(data: any): ProjectDataExcelExportInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDataExcelExportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateType"] = this.templateType;
        data["scopingType"] = this.scopingType;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IProjectDataExcelExportInput {
    templateType: ProjectTemplateType;
    scopingType: ProjectScopingDataType;
    projectId: number;
}

export class ProjectDto implements IProjectDto {
    id!: number;
    general!: GeneralDto;
    accessAndPermission!: ProjectAccessAndPermissionDto;
    projectManagement!: FullProjectManagementDto;
    specifics!: ProjectSpecificDto;

    constructor(data?: IProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.general = _data["general"] ? GeneralDto.fromJS(_data["general"]) : <any>undefined;
            this.accessAndPermission = _data["accessAndPermission"] ? ProjectAccessAndPermissionDto.fromJS(_data["accessAndPermission"]) : <any>undefined;
            this.projectManagement = _data["projectManagement"] ? FullProjectManagementDto.fromJS(_data["projectManagement"]) : <any>undefined;
            this.specifics = _data["specifics"] ? ProjectSpecificDto.fromJS(_data["specifics"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["accessAndPermission"] = this.accessAndPermission ? this.accessAndPermission.toJSON() : <any>undefined;
        data["projectManagement"] = this.projectManagement ? this.projectManagement.toJSON() : <any>undefined;
        data["specifics"] = this.specifics ? this.specifics.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProjectDto {
    id: number;
    general: GeneralDto;
    accessAndPermission: ProjectAccessAndPermissionDto;
    projectManagement: FullProjectManagementDto;
    specifics: ProjectSpecificDto;
}

export enum ProjectImportType {
    Unknown = 0,
    EntityJurisdictionImport = 1,
    FullScopeImport = 2,
}

export class ProjectOverviewDto implements IProjectOverviewDto {
    id!: number;
    fiscalYearPeriod!: DateTime[] | undefined;
    groupName!: string | undefined;
    name!: string | undefined;
    creationDate!: DateTime;
    assignedUser!: AssignableUserDto;
    tags!: TagDto[] | undefined;
    permissions!: string[] | undefined;
    isAccessRestrictionActive!: boolean;
    lastModifier!: string | undefined;
    lastModifierUserId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    chancelleryDetails!: ChancelleryDetailsDto;

    constructor(data?: IProjectOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["fiscalYearPeriod"])) {
                this.fiscalYearPeriod = [] as any;
                for (let item of _data["fiscalYearPeriod"])
                    this.fiscalYearPeriod!.push(DateTime.fromISO(item));
            }
            this.groupName = _data["groupName"];
            this.name = _data["name"];
            this.creationDate = _data["creationDate"] ? DateTime.fromISO(_data["creationDate"].toString()) : <any>undefined;
            this.assignedUser = _data["assignedUser"] ? AssignableUserDto.fromJS(_data["assignedUser"]) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.isAccessRestrictionActive = _data["isAccessRestrictionActive"];
            this.lastModifier = _data["lastModifier"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.chancelleryDetails = _data["chancelleryDetails"] ? ChancelleryDetailsDto.fromJS(_data["chancelleryDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProjectOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.fiscalYearPeriod)) {
            data["fiscalYearPeriod"] = [];
            for (let item of this.fiscalYearPeriod)
                data["fiscalYearPeriod"].push(item.toString());
        }
        data["groupName"] = this.groupName;
        data["name"] = this.name;
        data["creationDate"] = this.creationDate ? this.creationDate.toString() : <any>undefined;
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["isAccessRestrictionActive"] = this.isAccessRestrictionActive;
        data["lastModifier"] = this.lastModifier;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["chancelleryDetails"] = this.chancelleryDetails ? this.chancelleryDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProjectOverviewDto {
    id: number;
    fiscalYearPeriod: DateTime[] | undefined;
    groupName: string | undefined;
    name: string | undefined;
    creationDate: DateTime;
    assignedUser: AssignableUserDto;
    tags: TagDto[] | undefined;
    permissions: string[] | undefined;
    isAccessRestrictionActive: boolean;
    lastModifier: string | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: DateTime | undefined;
    chancelleryDetails: ChancelleryDetailsDto;
}

export class ProjectReferenceChannelDto implements IProjectReferenceChannelDto {
    title!: string | undefined;
    communications!: ProjectReferenceCommentsDto[] | undefined;

    constructor(data?: IProjectReferenceChannelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            if (Array.isArray(_data["communications"])) {
                this.communications = [] as any;
                for (let item of _data["communications"])
                    this.communications!.push(ProjectReferenceCommentsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectReferenceChannelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectReferenceChannelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        if (Array.isArray(this.communications)) {
            data["communications"] = [];
            for (let item of this.communications)
                data["communications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectReferenceChannelDto {
    title: string | undefined;
    communications: ProjectReferenceCommentsDto[] | undefined;
}

export class ProjectReferenceCommentsDto implements IProjectReferenceCommentsDto {
    creatorUserId!: number | undefined;
    creationTime!: DateTime;
    content!: string | undefined;
    userDetails!: UserDetailsDto[] | undefined;

    constructor(data?: IProjectReferenceCommentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.content = _data["content"];
            if (Array.isArray(_data["userDetails"])) {
                this.userDetails = [] as any;
                for (let item of _data["userDetails"])
                    this.userDetails!.push(UserDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectReferenceCommentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectReferenceCommentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["content"] = this.content;
        if (Array.isArray(this.userDetails)) {
            data["userDetails"] = [];
            for (let item of this.userDetails)
                data["userDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectReferenceCommentsDto {
    creatorUserId: number | undefined;
    creationTime: DateTime;
    content: string | undefined;
    userDetails: UserDetailsDto[] | undefined;
}

export enum ProjectReportType {
    SafeHarbourReport = 0,
    TopUpTaxReport = 1,
}

export enum ProjectScopingDataType {
    EntireImportExport = 0,
    EntitiesOnly = 1,
    FinancialDataOnly = 2,
}

export class ProjectSpecificDto implements IProjectSpecificDto {
    groupName!: string | undefined;
    engagementLetterDated!: DateTime | undefined;
    fiscalYearPeriod!: DateTime[] | undefined;
    globeRulesApplicableAsOf!: number | undefined;
    currency!: string | undefined;
    chancelleryDetails!: ChancelleryDetailsDto;
    isSpecialPermissionActive!: boolean;

    constructor(data?: IProjectSpecificDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupName = _data["groupName"];
            this.engagementLetterDated = _data["engagementLetterDated"] ? DateTime.fromISO(_data["engagementLetterDated"].toString()) : <any>undefined;
            if (Array.isArray(_data["fiscalYearPeriod"])) {
                this.fiscalYearPeriod = [] as any;
                for (let item of _data["fiscalYearPeriod"])
                    this.fiscalYearPeriod!.push(DateTime.fromISO(item));
            }
            this.globeRulesApplicableAsOf = _data["globeRulesApplicableAsOf"];
            this.currency = _data["currency"];
            this.chancelleryDetails = _data["chancelleryDetails"] ? ChancelleryDetailsDto.fromJS(_data["chancelleryDetails"]) : <any>undefined;
            this.isSpecialPermissionActive = _data["isSpecialPermissionActive"];
        }
    }

    static fromJS(data: any): ProjectSpecificDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectSpecificDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupName"] = this.groupName;
        data["engagementLetterDated"] = this.engagementLetterDated ? this.engagementLetterDated.toString() : <any>undefined;
        if (Array.isArray(this.fiscalYearPeriod)) {
            data["fiscalYearPeriod"] = [];
            for (let item of this.fiscalYearPeriod)
                data["fiscalYearPeriod"].push(item.toString());
        }
        data["globeRulesApplicableAsOf"] = this.globeRulesApplicableAsOf;
        data["currency"] = this.currency;
        data["chancelleryDetails"] = this.chancelleryDetails ? this.chancelleryDetails.toJSON() : <any>undefined;
        data["isSpecialPermissionActive"] = this.isSpecialPermissionActive;
        return data;
    }
}

export interface IProjectSpecificDto {
    groupName: string | undefined;
    engagementLetterDated: DateTime | undefined;
    fiscalYearPeriod: DateTime[] | undefined;
    globeRulesApplicableAsOf: number | undefined;
    currency: string | undefined;
    chancelleryDetails: ChancelleryDetailsDto;
    isSpecialPermissionActive: boolean;
}

export class ProjectSpecificInput implements IProjectSpecificInput {
    groupName!: string | undefined;
    fiscalYearPeriod!: DateTime[] | undefined;
    engagementLetterDated!: DateTime | undefined;
    globeRulesApplicableAsOf!: number | undefined;
    currency!: string | undefined;
    chancelleryDetails!: ChancelleryDetailsInput;

    constructor(data?: IProjectSpecificInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupName = _data["groupName"];
            if (Array.isArray(_data["fiscalYearPeriod"])) {
                this.fiscalYearPeriod = [] as any;
                for (let item of _data["fiscalYearPeriod"])
                    this.fiscalYearPeriod!.push(DateTime.fromISO(item));
            }
            this.engagementLetterDated = _data["engagementLetterDated"] ? DateTime.fromISO(_data["engagementLetterDated"].toString()) : <any>undefined;
            this.globeRulesApplicableAsOf = _data["globeRulesApplicableAsOf"];
            this.currency = _data["currency"];
            this.chancelleryDetails = _data["chancelleryDetails"] ? ChancelleryDetailsInput.fromJS(_data["chancelleryDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProjectSpecificInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectSpecificInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupName"] = this.groupName;
        if (Array.isArray(this.fiscalYearPeriod)) {
            data["fiscalYearPeriod"] = [];
            for (let item of this.fiscalYearPeriod)
                data["fiscalYearPeriod"].push(item.toString());
        }
        data["engagementLetterDated"] = this.engagementLetterDated ? this.engagementLetterDated.toString() : <any>undefined;
        data["globeRulesApplicableAsOf"] = this.globeRulesApplicableAsOf;
        data["currency"] = this.currency;
        data["chancelleryDetails"] = this.chancelleryDetails ? this.chancelleryDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProjectSpecificInput {
    groupName: string | undefined;
    fiscalYearPeriod: DateTime[] | undefined;
    engagementLetterDated: DateTime | undefined;
    globeRulesApplicableAsOf: number | undefined;
    currency: string | undefined;
    chancelleryDetails: ChancelleryDetailsInput;
}

export enum ProjectTemplateType {
    ScopingData = 0,
    SafeHarbourGroupData = 1,
    FullScopeData = 2,
}

export class ProjectUserSettingsDto implements IProjectUserSettingsDto {
    viewUnconfirmed!: boolean;
    viewConfirmed!: boolean;

    constructor(data?: IProjectUserSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.viewUnconfirmed = _data["viewUnconfirmed"];
            this.viewConfirmed = _data["viewConfirmed"];
        }
    }

    static fromJS(data: any): ProjectUserSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectUserSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["viewUnconfirmed"] = this.viewUnconfirmed;
        data["viewConfirmed"] = this.viewConfirmed;
        return data;
    }
}

export interface IProjectUserSettingsDto {
    viewUnconfirmed: boolean;
    viewConfirmed: boolean;
}

export class ProjectWidgetDto implements IProjectWidgetDto {
    safeHarbourChecks!: SafeHarbourChecksDto;
    scopingStatus!: ScopingStatusDto;
    worldMap!: FinancialDataSafeHarbourGroupOverviewDto[] | undefined;

    constructor(data?: IProjectWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.safeHarbourChecks = _data["safeHarbourChecks"] ? SafeHarbourChecksDto.fromJS(_data["safeHarbourChecks"]) : <any>undefined;
            this.scopingStatus = _data["scopingStatus"] ? ScopingStatusDto.fromJS(_data["scopingStatus"]) : <any>undefined;
            if (Array.isArray(_data["worldMap"])) {
                this.worldMap = [] as any;
                for (let item of _data["worldMap"])
                    this.worldMap!.push(FinancialDataSafeHarbourGroupOverviewDto.fromJS(item));
        }
    }
    }

    static fromJS(data: any): ProjectWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["safeHarbourChecks"] = this.safeHarbourChecks ? this.safeHarbourChecks.toJSON() : <any>undefined;
        data["scopingStatus"] = this.scopingStatus ? this.scopingStatus.toJSON() : <any>undefined;
        if (Array.isArray(this.worldMap)) {
            data["worldMap"] = [];
            for (let item of this.worldMap)
                data["worldMap"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectWidgetDto {
    safeHarbourChecks: SafeHarbourChecksDto;
    scopingStatus: ScopingStatusDto;
    worldMap: FinancialDataSafeHarbourGroupOverviewDto[] | undefined;
}

export class PurchasePriceAccountingApplicable implements IPurchasePriceAccountingApplicable {
    businessWereAcquiredUsingPurchaseAccounting!: boolean | undefined;
    businessWereAcquiredUsingPurchaseAccountingAndNoSufficientRecordsAvailable!: boolean | undefined;
    readonly isApplicable!: boolean;

    constructor(data?: IPurchasePriceAccountingApplicable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessWereAcquiredUsingPurchaseAccounting = _data["businessWereAcquiredUsingPurchaseAccounting"];
            this.businessWereAcquiredUsingPurchaseAccountingAndNoSufficientRecordsAvailable = _data["businessWereAcquiredUsingPurchaseAccountingAndNoSufficientRecordsAvailable"];
            (<any>this).isApplicable = _data["isApplicable"];
        }
    }

    static fromJS(data: any): PurchasePriceAccountingApplicable {
        data = typeof data === 'object' ? data : {};
        let result = new PurchasePriceAccountingApplicable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessWereAcquiredUsingPurchaseAccounting"] = this.businessWereAcquiredUsingPurchaseAccounting;
        data["businessWereAcquiredUsingPurchaseAccountingAndNoSufficientRecordsAvailable"] = this.businessWereAcquiredUsingPurchaseAccountingAndNoSufficientRecordsAvailable;
        data["isApplicable"] = this.isApplicable;
        return data;
    }
}

export interface IPurchasePriceAccountingApplicable {
    businessWereAcquiredUsingPurchaseAccounting: boolean | undefined;
    businessWereAcquiredUsingPurchaseAccountingAndNoSufficientRecordsAvailable: boolean | undefined;
    isApplicable: boolean;
}

export class ReportOverviewDto implements IReportOverviewDto {
    id!: number;
    fileName!: string | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    author!: string | undefined;

    constructor(data?: IReportOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.author = _data["author"];
        }
    }

    static fromJS(data: any): ReportOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["author"] = this.author;
        return data;
    }
}

export interface IReportOverviewDto {
    id: number;
    fileName: string | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    author: string | undefined;
}

export class RequestBlendingCircleSubgroups implements IRequestBlendingCircleSubgroups {
    projectId!: number;
    entityNumber!: ConfirmableInputOfString;
    legalName!: ConfirmableInputOfString;
    gloBEStatus!: ConfirmableInputOfIListOfGloBEStatus;
    tin!: ConfirmableInputOfString;
    taxJurisdictionCountry!: ConfirmableInputOfString;
    taxTreatment!: ConfirmableInputOfNullableOfTaxTreatment;
    isInvestmentEntity!: ConfirmableInputOfNullableOfBoolean;
    isConsideredAsExcluded!: ConfirmableInputOfNullableOfBoolean;
    isHeldForSale!: ConfirmableInputOfNullableOfBoolean;
    isJointVenture!: ConfirmableInputOfNullableOfBoolean;
    isPermanentEstablishment!: ConfirmableInputOfNullableOfBoolean;
    isInsuranceEntity!: ConfirmableInputOfNullableOfBoolean;
    isNMCE!: ConfirmableInputOfNullableOfBoolean;
    isCeInCFCRegime!: ConfirmableInputOfNullableOfBoolean;
    mainEntityId!: ConfirmableInputOfNullableOfInt64;
    cfcOwnerId!: ConfirmableInputOfNullableOfInt64;
    taxFunctionalCurrency!: ConfirmableInputOfString;
    accountingFunctionalCurrency!: ConfirmableInputOfString;
    numberOfMonthsOfOwnership!: ConfirmableInputOfInt32;
    designatedLocalEntityId!: ConfirmableInputOfNullableOfInt64;
    isMemberOfAFiscalUnity!: ConfirmableInputOfNullableOfBoolean;
    financialAccountingStandard!: ConfirmableInputOfNullableOfFinancialAccountingStandard;
    consolidationMethod!: ConfirmableInputOfNullableOfConsolidationMethod;
    isElectionRightTaxTransparency!: ConfirmableInputOfNullableOfBoolean;
    controllingInterestEntityId!: number | undefined;
    shareholders!: ShareholderInput;
    blendingCircleInput!: BlendingCircleInput;
    organizationalEntityId!: number;
    blendingCircleTaxJurisdiction!: string | undefined;

    constructor(data?: IRequestBlendingCircleSubgroups) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.entityNumber = _data["entityNumber"] ? ConfirmableInputOfString.fromJS(_data["entityNumber"]) : <any>undefined;
            this.legalName = _data["legalName"] ? ConfirmableInputOfString.fromJS(_data["legalName"]) : <any>undefined;
            this.gloBEStatus = _data["gloBEStatus"] ? ConfirmableInputOfIListOfGloBEStatus.fromJS(_data["gloBEStatus"]) : <any>undefined;
            this.tin = _data["tin"] ? ConfirmableInputOfString.fromJS(_data["tin"]) : <any>undefined;
            this.taxJurisdictionCountry = _data["taxJurisdictionCountry"] ? ConfirmableInputOfString.fromJS(_data["taxJurisdictionCountry"]) : <any>undefined;
            this.taxTreatment = _data["taxTreatment"] ? ConfirmableInputOfNullableOfTaxTreatment.fromJS(_data["taxTreatment"]) : <any>undefined;
            this.isInvestmentEntity = _data["isInvestmentEntity"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isInvestmentEntity"]) : <any>undefined;
            this.isConsideredAsExcluded = _data["isConsideredAsExcluded"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isConsideredAsExcluded"]) : <any>undefined;
            this.isHeldForSale = _data["isHeldForSale"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isHeldForSale"]) : <any>undefined;
            this.isJointVenture = _data["isJointVenture"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isJointVenture"]) : <any>undefined;
            this.isPermanentEstablishment = _data["isPermanentEstablishment"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isPermanentEstablishment"]) : <any>undefined;
            this.isInsuranceEntity = _data["isInsuranceEntity"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isInsuranceEntity"]) : <any>undefined;
            this.isNMCE = _data["isNMCE"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isNMCE"]) : <any>undefined;
            this.isCeInCFCRegime = _data["isCeInCFCRegime"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isCeInCFCRegime"]) : <any>undefined;
            this.mainEntityId = _data["mainEntityId"] ? ConfirmableInputOfNullableOfInt64.fromJS(_data["mainEntityId"]) : <any>undefined;
            this.cfcOwnerId = _data["cfcOwnerId"] ? ConfirmableInputOfNullableOfInt64.fromJS(_data["cfcOwnerId"]) : <any>undefined;
            this.taxFunctionalCurrency = _data["taxFunctionalCurrency"] ? ConfirmableInputOfString.fromJS(_data["taxFunctionalCurrency"]) : <any>undefined;
            this.accountingFunctionalCurrency = _data["accountingFunctionalCurrency"] ? ConfirmableInputOfString.fromJS(_data["accountingFunctionalCurrency"]) : <any>undefined;
            this.numberOfMonthsOfOwnership = _data["numberOfMonthsOfOwnership"] ? ConfirmableInputOfInt32.fromJS(_data["numberOfMonthsOfOwnership"]) : <any>undefined;
            this.designatedLocalEntityId = _data["designatedLocalEntityId"] ? ConfirmableInputOfNullableOfInt64.fromJS(_data["designatedLocalEntityId"]) : <any>undefined;
            this.isMemberOfAFiscalUnity = _data["isMemberOfAFiscalUnity"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isMemberOfAFiscalUnity"]) : <any>undefined;
            this.financialAccountingStandard = _data["financialAccountingStandard"] ? ConfirmableInputOfNullableOfFinancialAccountingStandard.fromJS(_data["financialAccountingStandard"]) : <any>undefined;
            this.consolidationMethod = _data["consolidationMethod"] ? ConfirmableInputOfNullableOfConsolidationMethod.fromJS(_data["consolidationMethod"]) : <any>undefined;
            this.isElectionRightTaxTransparency = _data["isElectionRightTaxTransparency"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isElectionRightTaxTransparency"]) : <any>undefined;
            this.controllingInterestEntityId = _data["controllingInterestEntityId"];
            this.shareholders = _data["shareholders"] ? ShareholderInput.fromJS(_data["shareholders"]) : <any>undefined;
            this.blendingCircleInput = _data["blendingCircleInput"] ? BlendingCircleInput.fromJS(_data["blendingCircleInput"]) : <any>undefined;
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.blendingCircleTaxJurisdiction = _data["blendingCircleTaxJurisdiction"];
        }
    }

    static fromJS(data: any): RequestBlendingCircleSubgroups {
        data = typeof data === 'object' ? data : {};
        let result = new RequestBlendingCircleSubgroups();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["entityNumber"] = this.entityNumber ? this.entityNumber.toJSON() : <any>undefined;
        data["legalName"] = this.legalName ? this.legalName.toJSON() : <any>undefined;
        data["gloBEStatus"] = this.gloBEStatus ? this.gloBEStatus.toJSON() : <any>undefined;
        data["tin"] = this.tin ? this.tin.toJSON() : <any>undefined;
        data["taxJurisdictionCountry"] = this.taxJurisdictionCountry ? this.taxJurisdictionCountry.toJSON() : <any>undefined;
        data["taxTreatment"] = this.taxTreatment ? this.taxTreatment.toJSON() : <any>undefined;
        data["isInvestmentEntity"] = this.isInvestmentEntity ? this.isInvestmentEntity.toJSON() : <any>undefined;
        data["isConsideredAsExcluded"] = this.isConsideredAsExcluded ? this.isConsideredAsExcluded.toJSON() : <any>undefined;
        data["isHeldForSale"] = this.isHeldForSale ? this.isHeldForSale.toJSON() : <any>undefined;
        data["isJointVenture"] = this.isJointVenture ? this.isJointVenture.toJSON() : <any>undefined;
        data["isPermanentEstablishment"] = this.isPermanentEstablishment ? this.isPermanentEstablishment.toJSON() : <any>undefined;
        data["isInsuranceEntity"] = this.isInsuranceEntity ? this.isInsuranceEntity.toJSON() : <any>undefined;
        data["isNMCE"] = this.isNMCE ? this.isNMCE.toJSON() : <any>undefined;
        data["isCeInCFCRegime"] = this.isCeInCFCRegime ? this.isCeInCFCRegime.toJSON() : <any>undefined;
        data["mainEntityId"] = this.mainEntityId ? this.mainEntityId.toJSON() : <any>undefined;
        data["cfcOwnerId"] = this.cfcOwnerId ? this.cfcOwnerId.toJSON() : <any>undefined;
        data["taxFunctionalCurrency"] = this.taxFunctionalCurrency ? this.taxFunctionalCurrency.toJSON() : <any>undefined;
        data["accountingFunctionalCurrency"] = this.accountingFunctionalCurrency ? this.accountingFunctionalCurrency.toJSON() : <any>undefined;
        data["numberOfMonthsOfOwnership"] = this.numberOfMonthsOfOwnership ? this.numberOfMonthsOfOwnership.toJSON() : <any>undefined;
        data["designatedLocalEntityId"] = this.designatedLocalEntityId ? this.designatedLocalEntityId.toJSON() : <any>undefined;
        data["isMemberOfAFiscalUnity"] = this.isMemberOfAFiscalUnity ? this.isMemberOfAFiscalUnity.toJSON() : <any>undefined;
        data["financialAccountingStandard"] = this.financialAccountingStandard ? this.financialAccountingStandard.toJSON() : <any>undefined;
        data["consolidationMethod"] = this.consolidationMethod ? this.consolidationMethod.toJSON() : <any>undefined;
        data["isElectionRightTaxTransparency"] = this.isElectionRightTaxTransparency ? this.isElectionRightTaxTransparency.toJSON() : <any>undefined;
        data["controllingInterestEntityId"] = this.controllingInterestEntityId;
        data["shareholders"] = this.shareholders ? this.shareholders.toJSON() : <any>undefined;
        data["blendingCircleInput"] = this.blendingCircleInput ? this.blendingCircleInput.toJSON() : <any>undefined;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["blendingCircleTaxJurisdiction"] = this.blendingCircleTaxJurisdiction;
        return data;
    }
}

export interface IRequestBlendingCircleSubgroups {
    projectId: number;
    entityNumber: ConfirmableInputOfString;
    legalName: ConfirmableInputOfString;
    gloBEStatus: ConfirmableInputOfIListOfGloBEStatus;
    tin: ConfirmableInputOfString;
    taxJurisdictionCountry: ConfirmableInputOfString;
    taxTreatment: ConfirmableInputOfNullableOfTaxTreatment;
    isInvestmentEntity: ConfirmableInputOfNullableOfBoolean;
    isConsideredAsExcluded: ConfirmableInputOfNullableOfBoolean;
    isHeldForSale: ConfirmableInputOfNullableOfBoolean;
    isJointVenture: ConfirmableInputOfNullableOfBoolean;
    isPermanentEstablishment: ConfirmableInputOfNullableOfBoolean;
    isInsuranceEntity: ConfirmableInputOfNullableOfBoolean;
    isNMCE: ConfirmableInputOfNullableOfBoolean;
    isCeInCFCRegime: ConfirmableInputOfNullableOfBoolean;
    mainEntityId: ConfirmableInputOfNullableOfInt64;
    cfcOwnerId: ConfirmableInputOfNullableOfInt64;
    taxFunctionalCurrency: ConfirmableInputOfString;
    accountingFunctionalCurrency: ConfirmableInputOfString;
    numberOfMonthsOfOwnership: ConfirmableInputOfInt32;
    designatedLocalEntityId: ConfirmableInputOfNullableOfInt64;
    isMemberOfAFiscalUnity: ConfirmableInputOfNullableOfBoolean;
    financialAccountingStandard: ConfirmableInputOfNullableOfFinancialAccountingStandard;
    consolidationMethod: ConfirmableInputOfNullableOfConsolidationMethod;
    isElectionRightTaxTransparency: ConfirmableInputOfNullableOfBoolean;
    controllingInterestEntityId: number | undefined;
    shareholders: ShareholderInput;
    blendingCircleInput: BlendingCircleInput;
    organizationalEntityId: number;
    blendingCircleTaxJurisdiction: string | undefined;
}

export class RequestCalculateFinalArticle432Input implements IRequestCalculateFinalArticle432Input {
    projectId!: number;
    organizationalEntityId!: number;
    value!: string | undefined;
    initialValue!: string | undefined;
    basisForAdjustments!: BasisForAdjustmentsType;
    targetOrganizationalEntityId!: number | undefined;
    pointId!: number | undefined;

    constructor(data?: IRequestCalculateFinalArticle432Input) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.value = _data["value"];
            this.initialValue = _data["initialValue"];
            this.basisForAdjustments = _data["basisForAdjustments"];
            this.targetOrganizationalEntityId = _data["targetOrganizationalEntityId"];
            this.pointId = _data["pointId"];
        }
    }

    static fromJS(data: any): RequestCalculateFinalArticle432Input {
        data = typeof data === 'object' ? data : {};
        let result = new RequestCalculateFinalArticle432Input();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["value"] = this.value;
        data["initialValue"] = this.initialValue;
        data["basisForAdjustments"] = this.basisForAdjustments;
        data["targetOrganizationalEntityId"] = this.targetOrganizationalEntityId;
        data["pointId"] = this.pointId;
        return data;
    }
}

export interface IRequestCalculateFinalArticle432Input {
    projectId: number;
    organizationalEntityId: number;
    value: string | undefined;
    initialValue: string | undefined;
    basisForAdjustments: BasisForAdjustmentsType;
    targetOrganizationalEntityId: number | undefined;
    pointId: number | undefined;
}

export class RevenueToProfitLossCoparisonDto implements IRevenueToProfitLossCoparisonDto {
    jurisdiction!: string | undefined;
    safeHarbourGroupType!: SafeHarbourGroupType;
    number!: number | undefined;
    revenue!: number | undefined;
    profitLoss!: number | undefined;
    ratioOfRevenueToThreshold!: number | undefined;
    ratioOfProfitLossToThreshold!: number | undefined;

    constructor(data?: IRevenueToProfitLossCoparisonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jurisdiction = _data["jurisdiction"];
            this.safeHarbourGroupType = _data["safeHarbourGroupType"];
            this.number = _data["number"];
            this.revenue = _data["revenue"];
            this.profitLoss = _data["profitLoss"];
            this.ratioOfRevenueToThreshold = _data["ratioOfRevenueToThreshold"];
            this.ratioOfProfitLossToThreshold = _data["ratioOfProfitLossToThreshold"];
        }
    }

    static fromJS(data: any): RevenueToProfitLossCoparisonDto {
        data = typeof data === 'object' ? data : {};
        let result = new RevenueToProfitLossCoparisonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jurisdiction"] = this.jurisdiction;
        data["safeHarbourGroupType"] = this.safeHarbourGroupType;
        data["number"] = this.number;
        data["revenue"] = this.revenue;
        data["profitLoss"] = this.profitLoss;
        data["ratioOfRevenueToThreshold"] = this.ratioOfRevenueToThreshold;
        data["ratioOfProfitLossToThreshold"] = this.ratioOfProfitLossToThreshold;
        return data;
    }
}

export interface IRevenueToProfitLossCoparisonDto {
    jurisdiction: string | undefined;
    safeHarbourGroupType: SafeHarbourGroupType;
    number: number | undefined;
    revenue: number | undefined;
    profitLoss: number | undefined;
    ratioOfRevenueToThreshold: number | undefined;
    ratioOfProfitLossToThreshold: number | undefined;
}

export class RevisionDto implements IRevisionDto {
    id!: number;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    comment!: string | undefined;
    userDetails!: UserDetailsDto;

    constructor(data?: IRevisionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.comment = _data["comment"];
            this.userDetails = _data["userDetails"] ? UserDetailsDto.fromJS(_data["userDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RevisionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RevisionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["comment"] = this.comment;
        data["userDetails"] = this.userDetails ? this.userDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRevisionDto {
    id: number;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    comment: string | undefined;
    userDetails: UserDetailsDto;
}

export class RiskIndicationDataDto implements IRiskIndicationDataDto {
    jurisdiction!: string | undefined;
    safeHarbourGroupType!: SafeHarbourGroupType;
    number!: number | undefined;
    totalPoints!: number;
    riskIndicationType!: RiskIndicationType;

    constructor(data?: IRiskIndicationDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jurisdiction = _data["jurisdiction"];
            this.safeHarbourGroupType = _data["safeHarbourGroupType"];
            this.number = _data["number"];
            this.totalPoints = _data["totalPoints"];
            this.riskIndicationType = _data["riskIndicationType"];
        }
    }

    static fromJS(data: any): RiskIndicationDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new RiskIndicationDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jurisdiction"] = this.jurisdiction;
        data["safeHarbourGroupType"] = this.safeHarbourGroupType;
        data["number"] = this.number;
        data["totalPoints"] = this.totalPoints;
        data["riskIndicationType"] = this.riskIndicationType;
        return data;
    }
}

export interface IRiskIndicationDataDto {
    jurisdiction: string | undefined;
    safeHarbourGroupType: SafeHarbourGroupType;
    number: number | undefined;
    totalPoints: number;
    riskIndicationType: RiskIndicationType;
}

export enum RiskIndicationType {
    Low = 1,
    Medium = 2,
    High = 3,
}

export class SafeHarbourCheckResultDto implements ISafeHarbourCheckResultDto {
    checkResultStatus!: CheckResultStatus;
    resultReasons!: string[] | undefined;

    constructor(data?: ISafeHarbourCheckResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkResultStatus = _data["checkResultStatus"];
            if (Array.isArray(_data["resultReasons"])) {
                this.resultReasons = [] as any;
                for (let item of _data["resultReasons"])
                    this.resultReasons!.push(item);
            }
        }
    }

    static fromJS(data: any): SafeHarbourCheckResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SafeHarbourCheckResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkResultStatus"] = this.checkResultStatus;
        if (Array.isArray(this.resultReasons)) {
            data["resultReasons"] = [];
            for (let item of this.resultReasons)
                data["resultReasons"].push(item);
        }
        return data;
    }
}

export interface ISafeHarbourCheckResultDto {
    checkResultStatus: CheckResultStatus;
    resultReasons: string[] | undefined;
}

export class SafeHarbourChecksDto implements ISafeHarbourChecksDto {
    jurisdictions!: number;
    applicableJurisdictions!: number;

    constructor(data?: ISafeHarbourChecksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jurisdictions = _data["jurisdictions"];
            this.applicableJurisdictions = _data["applicableJurisdictions"];
        }
    }

    static fromJS(data: any): SafeHarbourChecksDto {
        data = typeof data === 'object' ? data : {};
        let result = new SafeHarbourChecksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jurisdictions"] = this.jurisdictions;
        data["applicableJurisdictions"] = this.applicableJurisdictions;
        return data;
    }
}

export interface ISafeHarbourChecksDto {
    jurisdictions: number;
    applicableJurisdictions: number;
}

export class SafeHarbourGroupOverviewDto implements ISafeHarbourGroupOverviewDto {
    safeHarbourGroupId!: number | undefined;
    safeHarbourGroupType!: SafeHarbourGroupType;
    number!: number | undefined;
    readonly blendingCircleSubgroupId!: number | undefined;
    blendingCircleCountry!: string | undefined;
    organizationalEntityIds!: number[] | undefined;

    constructor(data?: ISafeHarbourGroupOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.safeHarbourGroupId = _data["safeHarbourGroupId"];
            this.safeHarbourGroupType = _data["safeHarbourGroupType"];
            this.number = _data["number"];
            (<any>this).blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.blendingCircleCountry = _data["blendingCircleCountry"];
            if (Array.isArray(_data["organizationalEntityIds"])) {
                this.organizationalEntityIds = [] as any;
                for (let item of _data["organizationalEntityIds"])
                    this.organizationalEntityIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SafeHarbourGroupOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new SafeHarbourGroupOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["safeHarbourGroupId"] = this.safeHarbourGroupId;
        data["safeHarbourGroupType"] = this.safeHarbourGroupType;
        data["number"] = this.number;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["blendingCircleCountry"] = this.blendingCircleCountry;
        if (Array.isArray(this.organizationalEntityIds)) {
            data["organizationalEntityIds"] = [];
            for (let item of this.organizationalEntityIds)
                data["organizationalEntityIds"].push(item);
        }
        return data;
    }
}

export interface ISafeHarbourGroupOverviewDto {
    safeHarbourGroupId: number | undefined;
    safeHarbourGroupType: SafeHarbourGroupType;
    number: number | undefined;
    blendingCircleSubgroupId: number | undefined;
    blendingCircleCountry: string | undefined;
    organizationalEntityIds: number[] | undefined;
}

export enum SafeHarbourGroupType {
    StandardPlus = 1,
    JointVenture = 2,
    NotConsidered = 3,
}

export class SafeHarbourHistoryDto implements ISafeHarbourHistoryDto {
    safeHarbourGroupId!: number | undefined;
    safeHarbourGroupName!: string | undefined;
    entityName!: string | undefined;
    entityNumber!: string | undefined;
    jurisdiction!: string | undefined;
    organizationalEntityId!: number | undefined;
    data!: FinancialDataHistoryDto[] | undefined;
    organizationalEntityHistoriesDto!: SafeHarbourHistoryDto[] | undefined;

    constructor(data?: ISafeHarbourHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.safeHarbourGroupId = _data["safeHarbourGroupId"];
            this.safeHarbourGroupName = _data["safeHarbourGroupName"];
            this.entityName = _data["entityName"];
            this.entityNumber = _data["entityNumber"];
            this.jurisdiction = _data["jurisdiction"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FinancialDataHistoryDto.fromJS(item));
            }
            if (Array.isArray(_data["organizationalEntityHistoriesDto"])) {
                this.organizationalEntityHistoriesDto = [] as any;
                for (let item of _data["organizationalEntityHistoriesDto"])
                    this.organizationalEntityHistoriesDto!.push(SafeHarbourHistoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SafeHarbourHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SafeHarbourHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["safeHarbourGroupId"] = this.safeHarbourGroupId;
        data["safeHarbourGroupName"] = this.safeHarbourGroupName;
        data["entityName"] = this.entityName;
        data["entityNumber"] = this.entityNumber;
        data["jurisdiction"] = this.jurisdiction;
        data["organizationalEntityId"] = this.organizationalEntityId;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.organizationalEntityHistoriesDto)) {
            data["organizationalEntityHistoriesDto"] = [];
            for (let item of this.organizationalEntityHistoriesDto)
                data["organizationalEntityHistoriesDto"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISafeHarbourHistoryDto {
    safeHarbourGroupId: number | undefined;
    safeHarbourGroupName: string | undefined;
    entityName: string | undefined;
    entityNumber: string | undefined;
    jurisdiction: string | undefined;
    organizationalEntityId: number | undefined;
    data: FinancialDataHistoryDto[] | undefined;
    organizationalEntityHistoriesDto: SafeHarbourHistoryDto[] | undefined;
}

export class SaveAllItems implements ISaveAllItems {
    channelId!: number;
    email!: string;
    id!: number | undefined;

    constructor(data?: ISaveAllItems) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelId = _data["channelId"];
            this.email = _data["email"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SaveAllItems {
        data = typeof data === 'object' ? data : {};
        let result = new SaveAllItems();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelId"] = this.channelId;
        data["email"] = this.email;
        data["id"] = this.id;
        return data;
    }
}

export interface ISaveAllItems {
    channelId: number;
    email: string;
    id: number | undefined;
}

export class SaveAllWhiteListInput implements ISaveAllWhiteListInput {
    channelId!: number;
    items!: SaveAllItems[] | undefined;

    constructor(data?: ISaveAllWhiteListInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelId = _data["channelId"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SaveAllItems.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveAllWhiteListInput {
        data = typeof data === 'object' ? data : {};
        let result = new SaveAllWhiteListInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelId"] = this.channelId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveAllWhiteListInput {
    channelId: number;
    items: SaveAllItems[] | undefined;
}

export class ScopingStatusDto implements IScopingStatusDto {
    confirmedProjectFields!: number;
    filledNotConfirmedProjectFields!: number;
    missingValueNotConfirmedFields!: number;

    constructor(data?: IScopingStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.confirmedProjectFields = _data["confirmedProjectFields"];
            this.filledNotConfirmedProjectFields = _data["filledNotConfirmedProjectFields"];
            this.missingValueNotConfirmedFields = _data["missingValueNotConfirmedFields"];
        }
    }

    static fromJS(data: any): ScopingStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScopingStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["confirmedProjectFields"] = this.confirmedProjectFields;
        data["filledNotConfirmedProjectFields"] = this.filledNotConfirmedProjectFields;
        data["missingValueNotConfirmedFields"] = this.missingValueNotConfirmedFields;
        return data;
    }
}

export interface IScopingStatusDto {
    confirmedProjectFields: number;
    filledNotConfirmedProjectFields: number;
    missingValueNotConfirmedFields: number;
}

export class SearchCommunicationDto implements ISearchCommunicationDto {
    id!: number;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    title!: string | undefined;
    isRead!: boolean;
    communications!: CommunicationDto[] | undefined;

    constructor(data?: ISearchCommunicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.isRead = _data["isRead"];
            if (Array.isArray(_data["communications"])) {
                this.communications = [] as any;
                for (let item of _data["communications"])
                    this.communications!.push(CommunicationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchCommunicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCommunicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["title"] = this.title;
        data["isRead"] = this.isRead;
        if (Array.isArray(this.communications)) {
            data["communications"] = [];
            for (let item of this.communications)
                data["communications"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchCommunicationDto {
    id: number;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    title: string | undefined;
    isRead: boolean;
    communications: CommunicationDto[] | undefined;
}

export class SetAssignedUserInput implements ISetAssignedUserInput {
    assignedUserId!: number | undefined;
    referenceId!: number;
    rootEntityId!: number | undefined;

    constructor(data?: ISetAssignedUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignedUserId = _data["assignedUserId"];
            this.referenceId = _data["referenceId"];
            this.rootEntityId = _data["rootEntityId"];
        }
    }

    static fromJS(data: any): SetAssignedUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new SetAssignedUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedUserId"] = this.assignedUserId;
        data["referenceId"] = this.referenceId;
        data["rootEntityId"] = this.rootEntityId;
        return data;
    }
}

export interface ISetAssignedUserInput {
    assignedUserId: number | undefined;
    referenceId: number;
    rootEntityId: number | undefined;
}

export class SetrCheckDataDto implements ISetrCheckDataDto {
    jurisdiction!: string | undefined;
    safeHarbourGroupType!: SafeHarbourGroupType;
    number!: number | undefined;
    setrPercentage!: number | undefined;

    constructor(data?: ISetrCheckDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jurisdiction = _data["jurisdiction"];
            this.safeHarbourGroupType = _data["safeHarbourGroupType"];
            this.number = _data["number"];
            this.setrPercentage = _data["setrPercentage"];
        }
    }

    static fromJS(data: any): SetrCheckDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetrCheckDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jurisdiction"] = this.jurisdiction;
        data["safeHarbourGroupType"] = this.safeHarbourGroupType;
        data["number"] = this.number;
        data["setrPercentage"] = this.setrPercentage;
        return data;
    }
}

export interface ISetrCheckDataDto {
    jurisdiction: string | undefined;
    safeHarbourGroupType: SafeHarbourGroupType;
    number: number | undefined;
    setrPercentage: number | undefined;
}

export class ShareholderInput implements IShareholderInput {
    organizationalEntityShareholders!: OrganizationalEntityShareholderInput[] | undefined;
    thirdPartyShareholders!: ThirdPartyShareholderInput[] | undefined;
    thirdPartyParticipations!: ThirdPartyParticipationInput[] | undefined;
    interestValue!: ConfirmableInputOfString;

    constructor(data?: IShareholderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organizationalEntityShareholders"])) {
                this.organizationalEntityShareholders = [] as any;
                for (let item of _data["organizationalEntityShareholders"])
                    this.organizationalEntityShareholders!.push(OrganizationalEntityShareholderInput.fromJS(item));
            }
            if (Array.isArray(_data["thirdPartyShareholders"])) {
                this.thirdPartyShareholders = [] as any;
                for (let item of _data["thirdPartyShareholders"])
                    this.thirdPartyShareholders!.push(ThirdPartyShareholderInput.fromJS(item));
            }
            if (Array.isArray(_data["thirdPartyParticipations"])) {
                this.thirdPartyParticipations = [] as any;
                for (let item of _data["thirdPartyParticipations"])
                    this.thirdPartyParticipations!.push(ThirdPartyParticipationInput.fromJS(item));
            }
            this.interestValue = _data["interestValue"] ? ConfirmableInputOfString.fromJS(_data["interestValue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ShareholderInput {
        data = typeof data === 'object' ? data : {};
        let result = new ShareholderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organizationalEntityShareholders)) {
            data["organizationalEntityShareholders"] = [];
            for (let item of this.organizationalEntityShareholders)
                data["organizationalEntityShareholders"].push(item.toJSON());
        }
        if (Array.isArray(this.thirdPartyShareholders)) {
            data["thirdPartyShareholders"] = [];
            for (let item of this.thirdPartyShareholders)
                data["thirdPartyShareholders"].push(item.toJSON());
        }
        if (Array.isArray(this.thirdPartyParticipations)) {
            data["thirdPartyParticipations"] = [];
            for (let item of this.thirdPartyParticipations)
                data["thirdPartyParticipations"].push(item.toJSON());
        }
        data["interestValue"] = this.interestValue ? this.interestValue.toJSON() : <any>undefined;
        return data;
    }
}

export interface IShareholderInput {
    organizationalEntityShareholders: OrganizationalEntityShareholderInput[] | undefined;
    thirdPartyShareholders: ThirdPartyShareholderInput[] | undefined;
    thirdPartyParticipations: ThirdPartyParticipationInput[] | undefined;
    interestValue: ConfirmableInputOfString;
}

export class ShareholdersDto implements IShareholdersDto {
    organizationalEntityShareholders!: OrganizationalEntityShareholderDto[] | undefined;
    thirdPartyShareholders!: ThirdPartyShareholderDto[] | undefined;
    thirdPartyParticipations!: ThirdPartyParticipationDto[] | undefined;
    interestValue!: ConfirmableDtoOfString;

    constructor(data?: IShareholdersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organizationalEntityShareholders"])) {
                this.organizationalEntityShareholders = [] as any;
                for (let item of _data["organizationalEntityShareholders"])
                    this.organizationalEntityShareholders!.push(OrganizationalEntityShareholderDto.fromJS(item));
            }
            if (Array.isArray(_data["thirdPartyShareholders"])) {
                this.thirdPartyShareholders = [] as any;
                for (let item of _data["thirdPartyShareholders"])
                    this.thirdPartyShareholders!.push(ThirdPartyShareholderDto.fromJS(item));
            }
            if (Array.isArray(_data["thirdPartyParticipations"])) {
                this.thirdPartyParticipations = [] as any;
                for (let item of _data["thirdPartyParticipations"])
                    this.thirdPartyParticipations!.push(ThirdPartyParticipationDto.fromJS(item));
            }
            this.interestValue = _data["interestValue"] ? ConfirmableDtoOfString.fromJS(_data["interestValue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ShareholdersDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShareholdersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organizationalEntityShareholders)) {
            data["organizationalEntityShareholders"] = [];
            for (let item of this.organizationalEntityShareholders)
                data["organizationalEntityShareholders"].push(item.toJSON());
        }
        if (Array.isArray(this.thirdPartyShareholders)) {
            data["thirdPartyShareholders"] = [];
            for (let item of this.thirdPartyShareholders)
                data["thirdPartyShareholders"].push(item.toJSON());
        }
        if (Array.isArray(this.thirdPartyParticipations)) {
            data["thirdPartyParticipations"] = [];
            for (let item of this.thirdPartyParticipations)
                data["thirdPartyParticipations"].push(item.toJSON());
        }
        data["interestValue"] = this.interestValue ? this.interestValue.toJSON() : <any>undefined;
        return data;
    }
}

export interface IShareholdersDto {
    organizationalEntityShareholders: OrganizationalEntityShareholderDto[] | undefined;
    thirdPartyShareholders: ThirdPartyShareholderDto[] | undefined;
    thirdPartyParticipations: ThirdPartyParticipationDto[] | undefined;
    interestValue: ConfirmableDtoOfString;
}

export class SurveyLookupDto implements ISurveyLookupDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: ISurveyLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SurveyLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ISurveyLookupDto {
    id: number;
    name: string | undefined;
}

export class TagDto implements ITagDto {
    name!: string | undefined;

    constructor(data?: ITagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TagDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ITagDto {
    name: string | undefined;
}

export class TaskDto implements ITaskDto {
    id!: number;
    moduleName!: string | undefined;
    taskName!: string | undefined;
    isUrgent!: boolean;
    dueDate!: DateTime | undefined;
    process!: ProcessDto;

    constructor(data?: ITaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.moduleName = _data["moduleName"];
            this.taskName = _data["taskName"];
            this.isUrgent = _data["isUrgent"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.process = _data["process"] ? ProcessDto.fromJS(_data["process"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["moduleName"] = this.moduleName;
        data["taskName"] = this.taskName;
        data["isUrgent"] = this.isUrgent;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        data["process"] = this.process ? this.process.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITaskDto {
    id: number;
    moduleName: string | undefined;
    taskName: string | undefined;
    isUrgent: boolean;
    dueDate: DateTime | undefined;
    process: ProcessDto;
}

export class TaxCreditApplicable implements ITaxCreditApplicable {
    taxCredit!: boolean | undefined;
    readonly isApplicable!: boolean;

    constructor(data?: ITaxCreditApplicable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxCredit = _data["taxCredit"];
            (<any>this).isApplicable = _data["isApplicable"];
        }
    }

    static fromJS(data: any): TaxCreditApplicable {
        data = typeof data === 'object' ? data : {};
        let result = new TaxCreditApplicable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxCredit"] = this.taxCredit;
        data["isApplicable"] = this.isApplicable;
        return data;
    }
}

export interface ITaxCreditApplicable {
    taxCredit: boolean | undefined;
    isApplicable: boolean;
}

export class TaxJurisdictionCountryReferenceDataDto implements ITaxJurisdictionCountryReferenceDataDto {
    id!: string | undefined;
    text!: string | undefined;

    constructor(data?: ITaxJurisdictionCountryReferenceDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): TaxJurisdictionCountryReferenceDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxJurisdictionCountryReferenceDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        return data;
    }
}

export interface ITaxJurisdictionCountryReferenceDataDto {
    id: string | undefined;
    text: string | undefined;
}

export enum TaxTreatment {
    Opaque = 1,
    Transparent = 2,
}

export enum TestsStatus {
    Green = 1,
    Red = 2,
    Blue = 3,
}

export class ThirdPartyParticipationDto implements IThirdPartyParticipationDto {
    id!: number | undefined;
    interestParticipation!: number;
    thirdPartyShareholderRelationshipId!: number;
    organizationalEntityId!: number;

    constructor(data?: IThirdPartyParticipationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.interestParticipation = _data["interestParticipation"];
            this.thirdPartyShareholderRelationshipId = _data["thirdPartyShareholderRelationshipId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
        }
    }

    static fromJS(data: any): ThirdPartyParticipationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThirdPartyParticipationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["interestParticipation"] = this.interestParticipation;
        data["thirdPartyShareholderRelationshipId"] = this.thirdPartyShareholderRelationshipId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        return data;
    }
}

export interface IThirdPartyParticipationDto {
    id: number | undefined;
    interestParticipation: number;
    thirdPartyShareholderRelationshipId: number;
    organizationalEntityId: number;
}

export class ThirdPartyParticipationInput implements IThirdPartyParticipationInput {
    id!: number | undefined;
    interestParticipation!: number;
    thirdPartyShareholderRelationshipId!: number;
    organizationalEntityId!: number;

    constructor(data?: IThirdPartyParticipationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.interestParticipation = _data["interestParticipation"];
            this.thirdPartyShareholderRelationshipId = _data["thirdPartyShareholderRelationshipId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
        }
    }

    static fromJS(data: any): ThirdPartyParticipationInput {
        data = typeof data === 'object' ? data : {};
        let result = new ThirdPartyParticipationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["interestParticipation"] = this.interestParticipation;
        data["thirdPartyShareholderRelationshipId"] = this.thirdPartyShareholderRelationshipId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        return data;
    }
}

export interface IThirdPartyParticipationInput {
    id: number | undefined;
    interestParticipation: number;
    thirdPartyShareholderRelationshipId: number;
    organizationalEntityId: number;
}

export class ThirdPartyShareholderDto implements IThirdPartyShareholderDto {
    id!: number;
    interestValue!: ConfirmableDtoOfString;
    thirdPartyName!: ConfirmableDtoOfString;

    constructor(data?: IThirdPartyShareholderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.interestValue = _data["interestValue"] ? ConfirmableDtoOfString.fromJS(_data["interestValue"]) : <any>undefined;
            this.thirdPartyName = _data["thirdPartyName"] ? ConfirmableDtoOfString.fromJS(_data["thirdPartyName"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ThirdPartyShareholderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThirdPartyShareholderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["interestValue"] = this.interestValue ? this.interestValue.toJSON() : <any>undefined;
        data["thirdPartyName"] = this.thirdPartyName ? this.thirdPartyName.toJSON() : <any>undefined;
        return data;
    }
}

export interface IThirdPartyShareholderDto {
    id: number;
    interestValue: ConfirmableDtoOfString;
    thirdPartyName: ConfirmableDtoOfString;
}

export class ThirdPartyShareholderInput implements IThirdPartyShareholderInput {
    id!: number | undefined;
    interestValue!: ConfirmableInputOfString;
    thirdPartyName!: ConfirmableInputOfString;

    constructor(data?: IThirdPartyShareholderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.interestValue = _data["interestValue"] ? ConfirmableInputOfString.fromJS(_data["interestValue"]) : <any>undefined;
            this.thirdPartyName = _data["thirdPartyName"] ? ConfirmableInputOfString.fromJS(_data["thirdPartyName"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ThirdPartyShareholderInput {
        data = typeof data === 'object' ? data : {};
        let result = new ThirdPartyShareholderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["interestValue"] = this.interestValue ? this.interestValue.toJSON() : <any>undefined;
        data["thirdPartyName"] = this.thirdPartyName ? this.thirdPartyName.toJSON() : <any>undefined;
        return data;
    }
}

export interface IThirdPartyShareholderInput {
    id: number | undefined;
    interestValue: ConfirmableInputOfString;
    thirdPartyName: ConfirmableInputOfString;
}

export class ToggleFullScopeCalculationInput implements IToggleFullScopeCalculationInput {
    id!: number | undefined;
    projectId!: number;
    taxJurisdictionCountry!: string | undefined;
    organizationalEntityId!: number;
    isConfirmed!: boolean;
    subgroupType!: BlendingCircleSubgroupType;
    number!: number | undefined;
    isActive!: boolean;

    constructor(data?: IToggleFullScopeCalculationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.taxJurisdictionCountry = _data["taxJurisdictionCountry"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.isConfirmed = _data["isConfirmed"];
            this.subgroupType = _data["subgroupType"];
            this.number = _data["number"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ToggleFullScopeCalculationInput {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleFullScopeCalculationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["taxJurisdictionCountry"] = this.taxJurisdictionCountry;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["isConfirmed"] = this.isConfirmed;
        data["subgroupType"] = this.subgroupType;
        data["number"] = this.number;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IToggleFullScopeCalculationInput {
    id: number | undefined;
    projectId: number;
    taxJurisdictionCountry: string | undefined;
    organizationalEntityId: number;
    isConfirmed: boolean;
    subgroupType: BlendingCircleSubgroupType;
    number: number | undefined;
    isActive: boolean;
}

export class TopUpTaxAssignmentDto implements ITopUpTaxAssignmentDto {
    assignedPercentage!: string | undefined;
    assignedTopUpTax!: string | undefined;
    topUpTaxCurrency!: string | undefined;
    assignedEntityLegalName!: string | undefined;
    assignedEntityJurisdiction!: string | undefined;
    originEntityLegalName!: string | undefined;
    originEntityJurisdiction!: string | undefined;
    topUpTaxAssignmentReason!: string | undefined;

    constructor(data?: ITopUpTaxAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignedPercentage = _data["assignedPercentage"];
            this.assignedTopUpTax = _data["assignedTopUpTax"];
            this.topUpTaxCurrency = _data["topUpTaxCurrency"];
            this.assignedEntityLegalName = _data["assignedEntityLegalName"];
            this.assignedEntityJurisdiction = _data["assignedEntityJurisdiction"];
            this.originEntityLegalName = _data["originEntityLegalName"];
            this.originEntityJurisdiction = _data["originEntityJurisdiction"];
            this.topUpTaxAssignmentReason = _data["topUpTaxAssignmentReason"];
        }
    }

    static fromJS(data: any): TopUpTaxAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new TopUpTaxAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedPercentage"] = this.assignedPercentage;
        data["assignedTopUpTax"] = this.assignedTopUpTax;
        data["topUpTaxCurrency"] = this.topUpTaxCurrency;
        data["assignedEntityLegalName"] = this.assignedEntityLegalName;
        data["assignedEntityJurisdiction"] = this.assignedEntityJurisdiction;
        data["originEntityLegalName"] = this.originEntityLegalName;
        data["originEntityJurisdiction"] = this.originEntityJurisdiction;
        data["topUpTaxAssignmentReason"] = this.topUpTaxAssignmentReason;
        return data;
    }
}

export interface ITopUpTaxAssignmentDto {
    assignedPercentage: string | undefined;
    assignedTopUpTax: string | undefined;
    topUpTaxCurrency: string | undefined;
    assignedEntityLegalName: string | undefined;
    assignedEntityJurisdiction: string | undefined;
    originEntityLegalName: string | undefined;
    originEntityJurisdiction: string | undefined;
    topUpTaxAssignmentReason: string | undefined;
}

export class TutBlendingCirclesOverviewDto implements ITutBlendingCirclesOverviewDto {
    columns!: TutOverviewColumnsDto[] | undefined;
    tutOverviewDtos!: TutOverviewDto[] | undefined;

    constructor(data?: ITutBlendingCirclesOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(TutOverviewColumnsDto.fromJS(item));
            }
            if (Array.isArray(_data["tutOverviewDtos"])) {
                this.tutOverviewDtos = [] as any;
                for (let item of _data["tutOverviewDtos"])
                    this.tutOverviewDtos!.push(TutOverviewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TutBlendingCirclesOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new TutBlendingCirclesOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        if (Array.isArray(this.tutOverviewDtos)) {
            data["tutOverviewDtos"] = [];
            for (let item of this.tutOverviewDtos)
                data["tutOverviewDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITutBlendingCirclesOverviewDto {
    columns: TutOverviewColumnsDto[] | undefined;
    tutOverviewDtos: TutOverviewDto[] | undefined;
}

export class TutCurrentValueDto implements ITutCurrentValueDto {
    value!: FinancialValueDto;
    isConfirmed!: boolean;
    country!: string | undefined;
    blendingCircleSubgroupType!: string | undefined;
    blendingCircleSubgroupId!: number | undefined;
    financialValueTracePointAdditionalInfo!: FinancialValueTracePointAdditionalDto;
    localizationKey!: string | undefined;

    constructor(data?: ITutCurrentValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? FinancialValueDto.fromJS(_data["value"]) : <any>undefined;
            this.isConfirmed = _data["isConfirmed"];
            this.country = _data["country"];
            this.blendingCircleSubgroupType = _data["blendingCircleSubgroupType"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.financialValueTracePointAdditionalInfo = _data["financialValueTracePointAdditionalInfo"] ? FinancialValueTracePointAdditionalDto.fromJS(_data["financialValueTracePointAdditionalInfo"]) : <any>undefined;
            this.localizationKey = _data["localizationKey"];
        }
    }

    static fromJS(data: any): TutCurrentValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new TutCurrentValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        data["isConfirmed"] = this.isConfirmed;
        data["country"] = this.country;
        data["blendingCircleSubgroupType"] = this.blendingCircleSubgroupType;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["financialValueTracePointAdditionalInfo"] = this.financialValueTracePointAdditionalInfo ? this.financialValueTracePointAdditionalInfo.toJSON() : <any>undefined;
        data["localizationKey"] = this.localizationKey;
        return data;
    }
}

export interface ITutCurrentValueDto {
    value: FinancialValueDto;
    isConfirmed: boolean;
    country: string | undefined;
    blendingCircleSubgroupType: string | undefined;
    blendingCircleSubgroupId: number | undefined;
    financialValueTracePointAdditionalInfo: FinancialValueTracePointAdditionalDto;
    localizationKey: string | undefined;
}

export class TutForBlendingCircleSubgroupDto implements ITutForBlendingCircleSubgroupDto {
    tutValues!: TutForOrganizationalEntityDto[] | undefined;
    totalTutForEntitiesWithoutAccess!: string | undefined;
    hasReadPermissionForCountry!: boolean;

    constructor(data?: ITutForBlendingCircleSubgroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tutValues"])) {
                this.tutValues = [] as any;
                for (let item of _data["tutValues"])
                    this.tutValues!.push(TutForOrganizationalEntityDto.fromJS(item));
            }
            this.totalTutForEntitiesWithoutAccess = _data["totalTutForEntitiesWithoutAccess"];
            this.hasReadPermissionForCountry = _data["hasReadPermissionForCountry"];
        }
    }

    static fromJS(data: any): TutForBlendingCircleSubgroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new TutForBlendingCircleSubgroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tutValues)) {
            data["tutValues"] = [];
            for (let item of this.tutValues)
                data["tutValues"].push(item.toJSON());
        }
        data["totalTutForEntitiesWithoutAccess"] = this.totalTutForEntitiesWithoutAccess;
        data["hasReadPermissionForCountry"] = this.hasReadPermissionForCountry;
        return data;
    }
}

export interface ITutForBlendingCircleSubgroupDto {
    tutValues: TutForOrganizationalEntityDto[] | undefined;
    totalTutForEntitiesWithoutAccess: string | undefined;
    hasReadPermissionForCountry: boolean;
}

export class TutForOrganizationalEntityDto implements ITutForOrganizationalEntityDto {
    isGlobeIncomePositive!: boolean;
    tutValue!: string | undefined;
    legalName!: string | undefined;
    tutCurrency!: string | undefined;

    constructor(data?: ITutForOrganizationalEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isGlobeIncomePositive = _data["isGlobeIncomePositive"];
            this.tutValue = _data["tutValue"];
            this.legalName = _data["legalName"];
            this.tutCurrency = _data["tutCurrency"];
        }
    }

    static fromJS(data: any): TutForOrganizationalEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new TutForOrganizationalEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isGlobeIncomePositive"] = this.isGlobeIncomePositive;
        data["tutValue"] = this.tutValue;
        data["legalName"] = this.legalName;
        data["tutCurrency"] = this.tutCurrency;
        return data;
    }
}

export interface ITutForOrganizationalEntityDto {
    isGlobeIncomePositive: boolean;
    tutValue: string | undefined;
    legalName: string | undefined;
    tutCurrency: string | undefined;
}

export class TutOverviewColumnsDto implements ITutOverviewColumnsDto {
    country!: string | undefined;
    label!: string | undefined;
    subgroup!: string | undefined;

    constructor(data?: ITutOverviewColumnsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"];
            this.label = _data["label"];
            this.subgroup = _data["subgroup"];
        }
    }

    static fromJS(data: any): TutOverviewColumnsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TutOverviewColumnsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        data["label"] = this.label;
        data["subgroup"] = this.subgroup;
        return data;
    }
}

export interface ITutOverviewColumnsDto {
    country: string | undefined;
    label: string | undefined;
    subgroup: string | undefined;
}

export class TutOverviewDto implements ITutOverviewDto {
    id!: string | undefined;
    path!: string[] | undefined;
    financialNodeType!: FinancialNodeType;
    name!: string | undefined;
    footerName!: string | undefined;
    localizationKey!: string | undefined;
    validationLogic!: FinancialTraceValidationLogic;
    currentValue!: TutCurrentValueDto[] | undefined;

    constructor(data?: ITutOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["path"])) {
                this.path = [] as any;
                for (let item of _data["path"])
                    this.path!.push(item);
            }
            this.financialNodeType = _data["financialNodeType"];
            this.name = _data["name"];
            this.footerName = _data["footerName"];
            this.localizationKey = _data["localizationKey"];
            this.validationLogic = _data["validationLogic"] ? FinancialTraceValidationLogic.fromJS(_data["validationLogic"]) : <any>undefined;
            if (Array.isArray(_data["currentValue"])) {
                this.currentValue = [] as any;
                for (let item of _data["currentValue"])
                    this.currentValue!.push(TutCurrentValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TutOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new TutOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.path)) {
            data["path"] = [];
            for (let item of this.path)
                data["path"].push(item);
        }
        data["financialNodeType"] = this.financialNodeType;
        data["name"] = this.name;
        data["footerName"] = this.footerName;
        data["localizationKey"] = this.localizationKey;
        data["validationLogic"] = this.validationLogic ? this.validationLogic.toJSON() : <any>undefined;
        if (Array.isArray(this.currentValue)) {
            data["currentValue"] = [];
            for (let item of this.currentValue)
                data["currentValue"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITutOverviewDto {
    id: string | undefined;
    path: string[] | undefined;
    financialNodeType: FinancialNodeType;
    name: string | undefined;
    footerName: string | undefined;
    localizationKey: string | undefined;
    validationLogic: FinancialTraceValidationLogic;
    currentValue: TutCurrentValueDto[] | undefined;
}

export class UpdateAccessManagementInput implements IUpdateAccessManagementInput {
    projectId!: number;
    isReadingActivated!: boolean;
    readingCountryCodeInherited!: string | undefined;
    readingUsersAndOrganizationUnits!: UserOrOrganizationUnitInput[] | undefined;
    isWritingActivated!: boolean;
    writingCountryCodeInherited!: string | undefined;
    writingUsersAndOrganizationUnits!: UserOrOrganizationUnitInput[] | undefined;
    organizationalEntityId!: number | undefined;
    countryCode!: string | undefined;

    constructor(data?: IUpdateAccessManagementInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.isReadingActivated = _data["isReadingActivated"];
            this.readingCountryCodeInherited = _data["readingCountryCodeInherited"];
            if (Array.isArray(_data["readingUsersAndOrganizationUnits"])) {
                this.readingUsersAndOrganizationUnits = [] as any;
                for (let item of _data["readingUsersAndOrganizationUnits"])
                    this.readingUsersAndOrganizationUnits!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
            this.isWritingActivated = _data["isWritingActivated"];
            this.writingCountryCodeInherited = _data["writingCountryCodeInherited"];
            if (Array.isArray(_data["writingUsersAndOrganizationUnits"])) {
                this.writingUsersAndOrganizationUnits = [] as any;
                for (let item of _data["writingUsersAndOrganizationUnits"])
                    this.writingUsersAndOrganizationUnits!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): UpdateAccessManagementInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAccessManagementInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["isReadingActivated"] = this.isReadingActivated;
        data["readingCountryCodeInherited"] = this.readingCountryCodeInherited;
        if (Array.isArray(this.readingUsersAndOrganizationUnits)) {
            data["readingUsersAndOrganizationUnits"] = [];
            for (let item of this.readingUsersAndOrganizationUnits)
                data["readingUsersAndOrganizationUnits"].push(item.toJSON());
        }
        data["isWritingActivated"] = this.isWritingActivated;
        data["writingCountryCodeInherited"] = this.writingCountryCodeInherited;
        if (Array.isArray(this.writingUsersAndOrganizationUnits)) {
            data["writingUsersAndOrganizationUnits"] = [];
            for (let item of this.writingUsersAndOrganizationUnits)
                data["writingUsersAndOrganizationUnits"].push(item.toJSON());
        }
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["countryCode"] = this.countryCode;
        return data;
    }
}

export interface IUpdateAccessManagementInput {
    projectId: number;
    isReadingActivated: boolean;
    readingCountryCodeInherited: string | undefined;
    readingUsersAndOrganizationUnits: UserOrOrganizationUnitInput[] | undefined;
    isWritingActivated: boolean;
    writingCountryCodeInherited: string | undefined;
    writingUsersAndOrganizationUnits: UserOrOrganizationUnitInput[] | undefined;
    organizationalEntityId: number | undefined;
    countryCode: string | undefined;
}

export class UpdateAttachmentInput implements IUpdateAttachmentInput {
    note!: string | undefined;
    dateOfAttachment!: DateTime | undefined;
    tags!: TagDto[] | undefined;
    id!: number;
    referenceId!: number;

    constructor(data?: IUpdateAttachmentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.note = _data["note"];
            this.dateOfAttachment = _data["dateOfAttachment"] ? DateTime.fromISO(_data["dateOfAttachment"].toString()) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            this.id = _data["id"];
            this.referenceId = _data["referenceId"];
        }
    }

    static fromJS(data: any): UpdateAttachmentInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAttachmentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note;
        data["dateOfAttachment"] = this.dateOfAttachment ? this.dateOfAttachment.toString() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["referenceId"] = this.referenceId;
        return data;
    }
}

export interface IUpdateAttachmentInput {
    note: string | undefined;
    dateOfAttachment: DateTime | undefined;
    tags: TagDto[] | undefined;
    id: number;
    referenceId: number;
}

export class UpdateDataPointStatusInput implements IUpdateDataPointStatusInput {
    projectId!: number;
    dataPointId!: number;
    isConfirmed!: boolean;

    constructor(data?: IUpdateDataPointStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.dataPointId = _data["dataPointId"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): UpdateDataPointStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDataPointStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["dataPointId"] = this.dataPointId;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IUpdateDataPointStatusInput {
    projectId: number;
    dataPointId: number;
    isConfirmed: boolean;
}

export class UpdateFinancialDeltaPointInput implements IUpdateFinancialDeltaPointInput {
    id!: number;
    financialValuePointId!: number;
    delta!: string | undefined;
    description!: string | undefined;

    constructor(data?: IUpdateFinancialDeltaPointInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.financialValuePointId = _data["financialValuePointId"];
            this.delta = _data["delta"];
            this.description = _data["description"];
            }
        }

    static fromJS(data: any): UpdateFinancialDeltaPointInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFinancialDeltaPointInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["financialValuePointId"] = this.financialValuePointId;
        data["delta"] = this.delta;
        data["description"] = this.description;
        return data;
    }
}

export interface IUpdateFinancialDeltaPointInput {
    id: number;
    financialValuePointId: number;
    delta: string | undefined;
    description: string | undefined;
}

export class UpdateFinancialGroupConfirmationInput implements IUpdateFinancialGroupConfirmationInput {
    projectId!: number;
    blendingCircleCountry!: string | undefined;
    blendingCircleSubgroupId!: number;
    organizationalEntityId!: number | undefined;
    financialGroupType!: FinancialGroupType;
    isConfirmed!: boolean;

    constructor(data?: IUpdateFinancialGroupConfirmationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.blendingCircleCountry = _data["blendingCircleCountry"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.financialGroupType = _data["financialGroupType"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): UpdateFinancialGroupConfirmationInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFinancialGroupConfirmationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["blendingCircleCountry"] = this.blendingCircleCountry;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["financialGroupType"] = this.financialGroupType;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IUpdateFinancialGroupConfirmationInput {
    projectId: number;
    blendingCircleCountry: string | undefined;
    blendingCircleSubgroupId: number;
    organizationalEntityId: number | undefined;
    financialGroupType: FinancialGroupType;
    isConfirmed: boolean;
}

export class UpdateFinancialShiftInput implements IUpdateFinancialShiftInput {
    projectId!: number;
    value!: string | undefined;
    comment!: string | undefined;
    isConfirmed!: boolean;
    financialShiftType!: FinancialShiftType;
    targetOrganizationalEntityId!: number | undefined;
    basisForAdjustments!: BasisForAdjustmentsType;
    maxTaxRateOfMainEntityJurisdiction!: string | undefined;
    passiveIncomeOfCEOrHybridEntity!: string | undefined;
    fiscalYearBeginning!: string | undefined;
    fiscalYearEnd!: string | undefined;
    id!: number;
    organizationalEntityId!: number;

    constructor(data?: IUpdateFinancialShiftInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.value = _data["value"];
            this.comment = _data["comment"];
            this.isConfirmed = _data["isConfirmed"];
            this.financialShiftType = _data["financialShiftType"];
            this.targetOrganizationalEntityId = _data["targetOrganizationalEntityId"];
            this.basisForAdjustments = _data["basisForAdjustments"];
            this.maxTaxRateOfMainEntityJurisdiction = _data["maxTaxRateOfMainEntityJurisdiction"];
            this.passiveIncomeOfCEOrHybridEntity = _data["passiveIncomeOfCEOrHybridEntity"];
            this.fiscalYearBeginning = _data["fiscalYearBeginning"];
            this.fiscalYearEnd = _data["fiscalYearEnd"];
            this.id = _data["id"];
            this.organizationalEntityId = _data["organizationalEntityId"];
        }
    }

    static fromJS(data: any): UpdateFinancialShiftInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFinancialShiftInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["value"] = this.value;
        data["comment"] = this.comment;
        data["isConfirmed"] = this.isConfirmed;
        data["financialShiftType"] = this.financialShiftType;
        data["targetOrganizationalEntityId"] = this.targetOrganizationalEntityId;
        data["basisForAdjustments"] = this.basisForAdjustments;
        data["maxTaxRateOfMainEntityJurisdiction"] = this.maxTaxRateOfMainEntityJurisdiction;
        data["passiveIncomeOfCEOrHybridEntity"] = this.passiveIncomeOfCEOrHybridEntity;
        data["fiscalYearBeginning"] = this.fiscalYearBeginning;
        data["fiscalYearEnd"] = this.fiscalYearEnd;
        data["id"] = this.id;
        data["organizationalEntityId"] = this.organizationalEntityId;
        return data;
    }
}

export interface IUpdateFinancialShiftInput {
    projectId: number;
    value: string | undefined;
    comment: string | undefined;
    isConfirmed: boolean;
    financialShiftType: FinancialShiftType;
    targetOrganizationalEntityId: number | undefined;
    basisForAdjustments: BasisForAdjustmentsType;
    maxTaxRateOfMainEntityJurisdiction: string | undefined;
    passiveIncomeOfCEOrHybridEntity: string | undefined;
    fiscalYearBeginning: string | undefined;
    fiscalYearEnd: string | undefined;
    id: number;
    organizationalEntityId: number;
}

export class UpdateFinancialValueInput implements IUpdateFinancialValueInput {
    projectId!: number;
    organizationalEntityId!: number | undefined;
    blendingCircleSubgroupId!: number | undefined;
    financialValueType!: FinancialValueType;
    value!: string | undefined;
    isConfirmed!: boolean;
    comment!: string | undefined;
    financialYear!: FinancialYearType;
    lossCarryBack!: string | undefined;
    domesticTaxRate!: string | undefined;
    nonEligibleEmployeeCostsPreliminary!: string | undefined;
    percentageRateWorkingTimeInJurisdiction!: number | undefined;
    percentageRateOfLocationTimeInJurisdiction!: number | undefined;
    fiscalYearBeginning!: string | undefined;
    fiscalYearEnd!: string | undefined;
    financialNodeGroupType!: FinancialNodeGroupType;
    multipleNodeGroupId!: number | undefined;
    financialValueTracePointAdditionalInput!: UpdateFinancialValueTracePointAdditionalInput;
    id!: number;

    constructor(data?: IUpdateFinancialValueInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.blendingCircleSubgroupId = _data["blendingCircleSubgroupId"];
            this.financialValueType = _data["financialValueType"];
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
            this.comment = _data["comment"];
            this.financialYear = _data["financialYear"];
            this.lossCarryBack = _data["lossCarryBack"];
            this.domesticTaxRate = _data["domesticTaxRate"];
            this.nonEligibleEmployeeCostsPreliminary = _data["nonEligibleEmployeeCostsPreliminary"];
            this.percentageRateWorkingTimeInJurisdiction = _data["percentageRateWorkingTimeInJurisdiction"];
            this.percentageRateOfLocationTimeInJurisdiction = _data["percentageRateOfLocationTimeInJurisdiction"];
            this.fiscalYearBeginning = _data["fiscalYearBeginning"];
            this.fiscalYearEnd = _data["fiscalYearEnd"];
            this.financialNodeGroupType = _data["financialNodeGroupType"];
            this.multipleNodeGroupId = _data["multipleNodeGroupId"];
            this.financialValueTracePointAdditionalInput = _data["financialValueTracePointAdditionalInput"] ? UpdateFinancialValueTracePointAdditionalInput.fromJS(_data["financialValueTracePointAdditionalInput"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateFinancialValueInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFinancialValueInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["blendingCircleSubgroupId"] = this.blendingCircleSubgroupId;
        data["financialValueType"] = this.financialValueType;
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        data["comment"] = this.comment;
        data["financialYear"] = this.financialYear;
        data["lossCarryBack"] = this.lossCarryBack;
        data["domesticTaxRate"] = this.domesticTaxRate;
        data["nonEligibleEmployeeCostsPreliminary"] = this.nonEligibleEmployeeCostsPreliminary;
        data["percentageRateWorkingTimeInJurisdiction"] = this.percentageRateWorkingTimeInJurisdiction;
        data["percentageRateOfLocationTimeInJurisdiction"] = this.percentageRateOfLocationTimeInJurisdiction;
        data["fiscalYearBeginning"] = this.fiscalYearBeginning;
        data["fiscalYearEnd"] = this.fiscalYearEnd;
        data["financialNodeGroupType"] = this.financialNodeGroupType;
        data["multipleNodeGroupId"] = this.multipleNodeGroupId;
        data["financialValueTracePointAdditionalInput"] = this.financialValueTracePointAdditionalInput ? this.financialValueTracePointAdditionalInput.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateFinancialValueInput {
    projectId: number;
    organizationalEntityId: number | undefined;
    blendingCircleSubgroupId: number | undefined;
    financialValueType: FinancialValueType;
    value: string | undefined;
    isConfirmed: boolean;
    comment: string | undefined;
    financialYear: FinancialYearType;
    lossCarryBack: string | undefined;
    domesticTaxRate: string | undefined;
    nonEligibleEmployeeCostsPreliminary: string | undefined;
    percentageRateWorkingTimeInJurisdiction: number | undefined;
    percentageRateOfLocationTimeInJurisdiction: number | undefined;
    fiscalYearBeginning: string | undefined;
    fiscalYearEnd: string | undefined;
    financialNodeGroupType: FinancialNodeGroupType;
    multipleNodeGroupId: number | undefined;
    financialValueTracePointAdditionalInput: UpdateFinancialValueTracePointAdditionalInput;
    id: number;
}

export class UpdateFinancialValuePointInput implements IUpdateFinancialValuePointInput {
    projectId!: number;
    traceId!: number;
    safeHarbourGroupId!: number | undefined;
    organizationalEntityId!: number | undefined;
    value!: string | undefined;
    isConfirmed!: boolean;
    comment!: string | undefined;
    deltaPoints!: UpdateFinancialDeltaPointInput[] | undefined;

    constructor(data?: IUpdateFinancialValuePointInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.traceId = _data["traceId"];
            this.safeHarbourGroupId = _data["safeHarbourGroupId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.value = _data["value"];
            this.isConfirmed = _data["isConfirmed"];
            this.comment = _data["comment"];
            if (Array.isArray(_data["deltaPoints"])) {
                this.deltaPoints = [] as any;
                for (let item of _data["deltaPoints"])
                    this.deltaPoints!.push(UpdateFinancialDeltaPointInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateFinancialValuePointInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFinancialValuePointInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["traceId"] = this.traceId;
        data["safeHarbourGroupId"] = this.safeHarbourGroupId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["value"] = this.value;
        data["isConfirmed"] = this.isConfirmed;
        data["comment"] = this.comment;
        if (Array.isArray(this.deltaPoints)) {
            data["deltaPoints"] = [];
            for (let item of this.deltaPoints)
                data["deltaPoints"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateFinancialValuePointInput {
    projectId: number;
    traceId: number;
    safeHarbourGroupId: number | undefined;
    organizationalEntityId: number | undefined;
    value: string | undefined;
    isConfirmed: boolean;
    comment: string | undefined;
    deltaPoints: UpdateFinancialDeltaPointInput[] | undefined;
}

export class UpdateFinancialValuePointStatusInput implements IUpdateFinancialValuePointStatusInput {
    projectId!: number;
    financialValuePointId!: number;
    isConfirmed!: boolean;
    automaticCalculatedValue!: string | undefined;

    constructor(data?: IUpdateFinancialValuePointStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.financialValuePointId = _data["financialValuePointId"];
            this.isConfirmed = _data["isConfirmed"];
            this.automaticCalculatedValue = _data["automaticCalculatedValue"];
        }
    }

    static fromJS(data: any): UpdateFinancialValuePointStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFinancialValuePointStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["financialValuePointId"] = this.financialValuePointId;
        data["isConfirmed"] = this.isConfirmed;
        data["automaticCalculatedValue"] = this.automaticCalculatedValue;
        return data;
    }
}

export interface IUpdateFinancialValuePointStatusInput {
    projectId: number;
    financialValuePointId: number;
    isConfirmed: boolean;
    automaticCalculatedValue: string | undefined;
}

export class UpdateFinancialValueTracePointAdditionalInput implements IUpdateFinancialValueTracePointAdditionalInput {
    financialYear!: FinancialYearType;
    basisForAdjustments!: BasisForAdjustmentsType;
    financialAccountingStandard!: FinancialAccountingStandard;

    constructor(data?: IUpdateFinancialValueTracePointAdditionalInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financialYear = _data["financialYear"];
            this.basisForAdjustments = _data["basisForAdjustments"];
            this.financialAccountingStandard = _data["financialAccountingStandard"];
        }
    }

    static fromJS(data: any): UpdateFinancialValueTracePointAdditionalInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFinancialValueTracePointAdditionalInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialYear"] = this.financialYear;
        data["basisForAdjustments"] = this.basisForAdjustments;
        data["financialAccountingStandard"] = this.financialAccountingStandard;
        return data;
    }
}

export interface IUpdateFinancialValueTracePointAdditionalInput {
    financialYear: FinancialYearType;
    basisForAdjustments: BasisForAdjustmentsType;
    financialAccountingStandard: FinancialAccountingStandard;
}

export class UpdateOrganizationalEntityFieldStatusInput implements IUpdateOrganizationalEntityFieldStatusInput {
    projectId!: number;
    organizationalEntityId!: number;
    field!: string | undefined;
    isConfirmed!: boolean;

    constructor(data?: IUpdateOrganizationalEntityFieldStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.organizationalEntityId = _data["organizationalEntityId"];
            this.field = _data["field"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): UpdateOrganizationalEntityFieldStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganizationalEntityFieldStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["organizationalEntityId"] = this.organizationalEntityId;
        data["field"] = this.field;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IUpdateOrganizationalEntityFieldStatusInput {
    projectId: number;
    organizationalEntityId: number;
    field: string | undefined;
    isConfirmed: boolean;
}

export class UpdateOrganizationalEntityInput implements IUpdateOrganizationalEntityInput {
    projectId!: number;
    entityNumber!: ConfirmableInputOfString;
    legalName!: ConfirmableInputOfString;
    gloBEStatus!: ConfirmableInputOfIListOfGloBEStatus;
    tin!: ConfirmableInputOfString;
    taxJurisdictionCountry!: ConfirmableInputOfString;
    taxTreatment!: ConfirmableInputOfNullableOfTaxTreatment;
    isInvestmentEntity!: ConfirmableInputOfNullableOfBoolean;
    isConsideredAsExcluded!: ConfirmableInputOfNullableOfBoolean;
    isHeldForSale!: ConfirmableInputOfNullableOfBoolean;
    isJointVenture!: ConfirmableInputOfNullableOfBoolean;
    isPermanentEstablishment!: ConfirmableInputOfNullableOfBoolean;
    isInsuranceEntity!: ConfirmableInputOfNullableOfBoolean;
    isNMCE!: ConfirmableInputOfNullableOfBoolean;
    isCeInCFCRegime!: ConfirmableInputOfNullableOfBoolean;
    mainEntityId!: ConfirmableInputOfNullableOfInt64;
    cfcOwnerId!: ConfirmableInputOfNullableOfInt64;
    taxFunctionalCurrency!: ConfirmableInputOfString;
    accountingFunctionalCurrency!: ConfirmableInputOfString;
    numberOfMonthsOfOwnership!: ConfirmableInputOfInt32;
    designatedLocalEntityId!: ConfirmableInputOfNullableOfInt64;
    isMemberOfAFiscalUnity!: ConfirmableInputOfNullableOfBoolean;
    financialAccountingStandard!: ConfirmableInputOfNullableOfFinancialAccountingStandard;
    consolidationMethod!: ConfirmableInputOfNullableOfConsolidationMethod;
    isElectionRightTaxTransparency!: ConfirmableInputOfNullableOfBoolean;
    controllingInterestEntityId!: number | undefined;
    shareholders!: ShareholderInput;
    blendingCircleInput!: BlendingCircleInput;
    organizationalEntityId!: number;

    constructor(data?: IUpdateOrganizationalEntityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.entityNumber = _data["entityNumber"] ? ConfirmableInputOfString.fromJS(_data["entityNumber"]) : <any>undefined;
            this.legalName = _data["legalName"] ? ConfirmableInputOfString.fromJS(_data["legalName"]) : <any>undefined;
            this.gloBEStatus = _data["gloBEStatus"] ? ConfirmableInputOfIListOfGloBEStatus.fromJS(_data["gloBEStatus"]) : <any>undefined;
            this.tin = _data["tin"] ? ConfirmableInputOfString.fromJS(_data["tin"]) : <any>undefined;
            this.taxJurisdictionCountry = _data["taxJurisdictionCountry"] ? ConfirmableInputOfString.fromJS(_data["taxJurisdictionCountry"]) : <any>undefined;
            this.taxTreatment = _data["taxTreatment"] ? ConfirmableInputOfNullableOfTaxTreatment.fromJS(_data["taxTreatment"]) : <any>undefined;
            this.isInvestmentEntity = _data["isInvestmentEntity"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isInvestmentEntity"]) : <any>undefined;
            this.isConsideredAsExcluded = _data["isConsideredAsExcluded"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isConsideredAsExcluded"]) : <any>undefined;
            this.isHeldForSale = _data["isHeldForSale"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isHeldForSale"]) : <any>undefined;
            this.isJointVenture = _data["isJointVenture"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isJointVenture"]) : <any>undefined;
            this.isPermanentEstablishment = _data["isPermanentEstablishment"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isPermanentEstablishment"]) : <any>undefined;
            this.isInsuranceEntity = _data["isInsuranceEntity"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isInsuranceEntity"]) : <any>undefined;
            this.isNMCE = _data["isNMCE"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isNMCE"]) : <any>undefined;
            this.isCeInCFCRegime = _data["isCeInCFCRegime"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isCeInCFCRegime"]) : <any>undefined;
            this.mainEntityId = _data["mainEntityId"] ? ConfirmableInputOfNullableOfInt64.fromJS(_data["mainEntityId"]) : <any>undefined;
            this.cfcOwnerId = _data["cfcOwnerId"] ? ConfirmableInputOfNullableOfInt64.fromJS(_data["cfcOwnerId"]) : <any>undefined;
            this.taxFunctionalCurrency = _data["taxFunctionalCurrency"] ? ConfirmableInputOfString.fromJS(_data["taxFunctionalCurrency"]) : <any>undefined;
            this.accountingFunctionalCurrency = _data["accountingFunctionalCurrency"] ? ConfirmableInputOfString.fromJS(_data["accountingFunctionalCurrency"]) : <any>undefined;
            this.numberOfMonthsOfOwnership = _data["numberOfMonthsOfOwnership"] ? ConfirmableInputOfInt32.fromJS(_data["numberOfMonthsOfOwnership"]) : <any>undefined;
            this.designatedLocalEntityId = _data["designatedLocalEntityId"] ? ConfirmableInputOfNullableOfInt64.fromJS(_data["designatedLocalEntityId"]) : <any>undefined;
            this.isMemberOfAFiscalUnity = _data["isMemberOfAFiscalUnity"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isMemberOfAFiscalUnity"]) : <any>undefined;
            this.financialAccountingStandard = _data["financialAccountingStandard"] ? ConfirmableInputOfNullableOfFinancialAccountingStandard.fromJS(_data["financialAccountingStandard"]) : <any>undefined;
            this.consolidationMethod = _data["consolidationMethod"] ? ConfirmableInputOfNullableOfConsolidationMethod.fromJS(_data["consolidationMethod"]) : <any>undefined;
            this.isElectionRightTaxTransparency = _data["isElectionRightTaxTransparency"] ? ConfirmableInputOfNullableOfBoolean.fromJS(_data["isElectionRightTaxTransparency"]) : <any>undefined;
            this.controllingInterestEntityId = _data["controllingInterestEntityId"];
            this.shareholders = _data["shareholders"] ? ShareholderInput.fromJS(_data["shareholders"]) : <any>undefined;
            this.blendingCircleInput = _data["blendingCircleInput"] ? BlendingCircleInput.fromJS(_data["blendingCircleInput"]) : <any>undefined;
            this.organizationalEntityId = _data["organizationalEntityId"];
        }
    }

    static fromJS(data: any): UpdateOrganizationalEntityInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganizationalEntityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["entityNumber"] = this.entityNumber ? this.entityNumber.toJSON() : <any>undefined;
        data["legalName"] = this.legalName ? this.legalName.toJSON() : <any>undefined;
        data["gloBEStatus"] = this.gloBEStatus ? this.gloBEStatus.toJSON() : <any>undefined;
        data["tin"] = this.tin ? this.tin.toJSON() : <any>undefined;
        data["taxJurisdictionCountry"] = this.taxJurisdictionCountry ? this.taxJurisdictionCountry.toJSON() : <any>undefined;
        data["taxTreatment"] = this.taxTreatment ? this.taxTreatment.toJSON() : <any>undefined;
        data["isInvestmentEntity"] = this.isInvestmentEntity ? this.isInvestmentEntity.toJSON() : <any>undefined;
        data["isConsideredAsExcluded"] = this.isConsideredAsExcluded ? this.isConsideredAsExcluded.toJSON() : <any>undefined;
        data["isHeldForSale"] = this.isHeldForSale ? this.isHeldForSale.toJSON() : <any>undefined;
        data["isJointVenture"] = this.isJointVenture ? this.isJointVenture.toJSON() : <any>undefined;
        data["isPermanentEstablishment"] = this.isPermanentEstablishment ? this.isPermanentEstablishment.toJSON() : <any>undefined;
        data["isInsuranceEntity"] = this.isInsuranceEntity ? this.isInsuranceEntity.toJSON() : <any>undefined;
        data["isNMCE"] = this.isNMCE ? this.isNMCE.toJSON() : <any>undefined;
        data["isCeInCFCRegime"] = this.isCeInCFCRegime ? this.isCeInCFCRegime.toJSON() : <any>undefined;
        data["mainEntityId"] = this.mainEntityId ? this.mainEntityId.toJSON() : <any>undefined;
        data["cfcOwnerId"] = this.cfcOwnerId ? this.cfcOwnerId.toJSON() : <any>undefined;
        data["taxFunctionalCurrency"] = this.taxFunctionalCurrency ? this.taxFunctionalCurrency.toJSON() : <any>undefined;
        data["accountingFunctionalCurrency"] = this.accountingFunctionalCurrency ? this.accountingFunctionalCurrency.toJSON() : <any>undefined;
        data["numberOfMonthsOfOwnership"] = this.numberOfMonthsOfOwnership ? this.numberOfMonthsOfOwnership.toJSON() : <any>undefined;
        data["designatedLocalEntityId"] = this.designatedLocalEntityId ? this.designatedLocalEntityId.toJSON() : <any>undefined;
        data["isMemberOfAFiscalUnity"] = this.isMemberOfAFiscalUnity ? this.isMemberOfAFiscalUnity.toJSON() : <any>undefined;
        data["financialAccountingStandard"] = this.financialAccountingStandard ? this.financialAccountingStandard.toJSON() : <any>undefined;
        data["consolidationMethod"] = this.consolidationMethod ? this.consolidationMethod.toJSON() : <any>undefined;
        data["isElectionRightTaxTransparency"] = this.isElectionRightTaxTransparency ? this.isElectionRightTaxTransparency.toJSON() : <any>undefined;
        data["controllingInterestEntityId"] = this.controllingInterestEntityId;
        data["shareholders"] = this.shareholders ? this.shareholders.toJSON() : <any>undefined;
        data["blendingCircleInput"] = this.blendingCircleInput ? this.blendingCircleInput.toJSON() : <any>undefined;
        data["organizationalEntityId"] = this.organizationalEntityId;
        return data;
    }
}

export interface IUpdateOrganizationalEntityInput {
    projectId: number;
    entityNumber: ConfirmableInputOfString;
    legalName: ConfirmableInputOfString;
    gloBEStatus: ConfirmableInputOfIListOfGloBEStatus;
    tin: ConfirmableInputOfString;
    taxJurisdictionCountry: ConfirmableInputOfString;
    taxTreatment: ConfirmableInputOfNullableOfTaxTreatment;
    isInvestmentEntity: ConfirmableInputOfNullableOfBoolean;
    isConsideredAsExcluded: ConfirmableInputOfNullableOfBoolean;
    isHeldForSale: ConfirmableInputOfNullableOfBoolean;
    isJointVenture: ConfirmableInputOfNullableOfBoolean;
    isPermanentEstablishment: ConfirmableInputOfNullableOfBoolean;
    isInsuranceEntity: ConfirmableInputOfNullableOfBoolean;
    isNMCE: ConfirmableInputOfNullableOfBoolean;
    isCeInCFCRegime: ConfirmableInputOfNullableOfBoolean;
    mainEntityId: ConfirmableInputOfNullableOfInt64;
    cfcOwnerId: ConfirmableInputOfNullableOfInt64;
    taxFunctionalCurrency: ConfirmableInputOfString;
    accountingFunctionalCurrency: ConfirmableInputOfString;
    numberOfMonthsOfOwnership: ConfirmableInputOfInt32;
    designatedLocalEntityId: ConfirmableInputOfNullableOfInt64;
    isMemberOfAFiscalUnity: ConfirmableInputOfNullableOfBoolean;
    financialAccountingStandard: ConfirmableInputOfNullableOfFinancialAccountingStandard;
    consolidationMethod: ConfirmableInputOfNullableOfConsolidationMethod;
    isElectionRightTaxTransparency: ConfirmableInputOfNullableOfBoolean;
    controllingInterestEntityId: number | undefined;
    shareholders: ShareholderInput;
    blendingCircleInput: BlendingCircleInput;
    organizationalEntityId: number;
}

export class UpdateProjectCurrencyRateInput implements IUpdateProjectCurrencyRateInput {
    id!: number;
    projectId!: number;
    rate!: ConfirmableInputOfString;
    comment!: string | undefined;

    constructor(data?: IUpdateProjectCurrencyRateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.rate = _data["rate"] ? ConfirmableInputOfString.fromJS(_data["rate"]) : <any>undefined;
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): UpdateProjectCurrencyRateInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectCurrencyRateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["rate"] = this.rate ? this.rate.toJSON() : <any>undefined;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IUpdateProjectCurrencyRateInput {
    id: number;
    projectId: number;
    rate: ConfirmableInputOfString;
    comment: string | undefined;
}

export class UpdateProjectInput implements IUpdateProjectInput {
    general!: GeneraInput;
    accessAndPermission!: ProjectAccessAndPermissionInput;
    projectManagement!: FullProjectManagementInput;
    specifics!: ProjectSpecificInput;
    id!: number;

    constructor(data?: IUpdateProjectInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneraInput.fromJS(_data["general"]) : <any>undefined;
            this.accessAndPermission = _data["accessAndPermission"] ? ProjectAccessAndPermissionInput.fromJS(_data["accessAndPermission"]) : <any>undefined;
            this.projectManagement = _data["projectManagement"] ? FullProjectManagementInput.fromJS(_data["projectManagement"]) : <any>undefined;
            this.specifics = _data["specifics"] ? ProjectSpecificInput.fromJS(_data["specifics"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateProjectInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["accessAndPermission"] = this.accessAndPermission ? this.accessAndPermission.toJSON() : <any>undefined;
        data["projectManagement"] = this.projectManagement ? this.projectManagement.toJSON() : <any>undefined;
        data["specifics"] = this.specifics ? this.specifics.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateProjectInput {
    general: GeneraInput;
    accessAndPermission: ProjectAccessAndPermissionInput;
    projectManagement: FullProjectManagementInput;
    specifics: ProjectSpecificInput;
    id: number;
}

export class UpdateProjectUserConfigurationInput implements IUpdateProjectUserConfigurationInput {
    projectId!: number;
    viewUnconfirmed!: boolean;
    viewConfirmed!: boolean;

    constructor(data?: IUpdateProjectUserConfigurationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.viewUnconfirmed = _data["viewUnconfirmed"];
            this.viewConfirmed = _data["viewConfirmed"];
        }
    }

    static fromJS(data: any): UpdateProjectUserConfigurationInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectUserConfigurationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["viewUnconfirmed"] = this.viewUnconfirmed;
        data["viewConfirmed"] = this.viewConfirmed;
        return data;
    }
}

export interface IUpdateProjectUserConfigurationInput {
    projectId: number;
    viewUnconfirmed: boolean;
    viewConfirmed: boolean;
}

export class UserDetailsDto implements IUserDetailsDto {
    id!: number;
    fullName!: string | undefined;
    email!: string | undefined;
    profilePicture!: string | undefined;

    constructor(data?: IUserDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.profilePicture = _data["profilePicture"];
        }
    }

    static fromJS(data: any): UserDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["profilePicture"] = this.profilePicture;
        return data;
    }
}

export interface IUserDetailsDto {
    id: number;
    fullName: string | undefined;
    email: string | undefined;
    profilePicture: string | undefined;
}

export class UserOrOrganizationUnitDto implements IUserOrOrganizationUnitDto {
    type!: string | undefined;
    userOrOrganizationId!: number;
    displayName!: string | undefined;

    constructor(data?: IUserOrOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.userOrOrganizationId = _data["userOrOrganizationId"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): UserOrOrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserOrOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["userOrOrganizationId"] = this.userOrOrganizationId;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IUserOrOrganizationUnitDto {
    type: string | undefined;
    userOrOrganizationId: number;
    displayName: string | undefined;
}

export class UserOrOrganizationUnitInput implements IUserOrOrganizationUnitInput {
    type!: string | undefined;
    userOrOrganizationId!: number;

    constructor(data?: IUserOrOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.userOrOrganizationId = _data["userOrOrganizationId"];
        }
    }

    static fromJS(data: any): UserOrOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UserOrOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["userOrOrganizationId"] = this.userOrOrganizationId;
        return data;
    }
}

export interface IUserOrOrganizationUnitInput {
    type: string | undefined;
    userOrOrganizationId: number;
}

export class UserReferenceDataDto implements IUserReferenceDataDto {
    id!: number;
    text!: string | undefined;

    constructor(data?: IUserReferenceDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): UserReferenceDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserReferenceDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        return data;
    }
}

export interface IUserReferenceDataDto {
    id: number;
    text: string | undefined;
}

export enum ValidationRuleType {
    Required = 1,
    ZeroOrBigger = 2,
    FinancialYearNotDuplicated = 3,
    InitialValueShouldMatch = 4,
    InitialValueIsPercent = 5,
    ZeroOrLower = 6,
}

export class WhiteListOverviewDto implements IWhiteListOverviewDto {
    id!: number;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    email!: string | undefined;
    source!: string | undefined;

    constructor(data?: IWhiteListOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): WhiteListOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new WhiteListOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["email"] = this.email;
        data["source"] = this.source;
        return data;
    }
}

export interface IWhiteListOverviewDto {
    id: number;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    email: string | undefined;
    source: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
